<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main transition="scroll-y-reverse-transition">
      <div class="new-background-color col-md-12 ml-sm-auto col-lg-12">
        <v-row class="no-gutters">
          <v-col cols="6" md="6" lg="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs" id="v-step-4"></v-breadcrumbs>
          </v-col>
          <v-col style="text-align: end;" v-if="resCol === 'xs'">
            <v-btn
              class="text-white mb-2"
              :color="showOnsite === 'ไม่แสดง' ? 'error' : 'teal'"
              style="border-radius: 20px !important;box-shadow: 0px 1px 2px rgba(255, 255, 255, 0.4), 0px 5px 15px rgba(162, 171, 198, 0.6);"
              @click="checkShowDataOnsiteSet(showOnsite)"
            >
              <v-icon color="white" left>{{
                showOnsite === "ไม่แสดง" ? "mdi-eye-remove" : "mdi-eye-check"
              }}</v-icon>
              {{ showOnsite }} Onsite
              <!-- <template v-if="loadingRefresh">
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template> -->
            </v-btn>
            <v-btn
              :disabled="loadingRefresh"
              color="warning"
              style="border-radius: 20px !important;margin-right: 0px;box-shadow: 0px 1px 2px rgba(255, 255, 255, 0.4), 0px 5px 15px rgba(162, 171, 198, 0.6);"
              @click="
                getDataDefault(),
                  (searchOther = ''),
                  (showColorSearch = false),
                  (statusSearch = 'no')
              "
            >
              <v-icon color="white" left>mdi-refresh-circle</v-icon>
              รีเฟรชข้อมูล
              <template v-if="loadingRefresh">
                <span class="custom-loader">
                  <v-icon light>mdi-cached</v-icon>
                </span>
              </template>
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            md="6"
            lg="6"
            class="v-margit_button text-right pr-0"
            style="background-color: #f2f7ff !important;"
            v-if="
              resCol === 'md' ||
                resCol === 'lg' ||
                resCol === 'xl' ||
                resCol === 'sm'
            "
          >
            <v-btn-toggle style="background-color: #f2f7ff">
              <v-btn
                class="text-white"
                :loading="loadingRefresh"
                :disabled="loadingRefresh"
                :color="showOnsite === 'ไม่แสดง' ? 'error' : 'teal'"
                style="border-radius: 20px !important;margin-right: 10px;box-shadow: 0px 1px 2px rgba(255, 255, 255, 0.4), 0px 5px 15px rgba(162, 171, 198, 0.6);"
                @click="checkShowDataOnsiteSet(showOnsite)"
              >
                <v-icon color="white" left>{{
                  showOnsite === "ไม่แสดง" ? "mdi-eye-remove" : "mdi-eye-check"
                }}</v-icon>
                {{ showOnsite }} Onsite
                <template v-if="loadingRefresh">
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template>
              </v-btn>
              <v-btn
                :loading="loadingRefresh"
                :disabled="loadingRefresh"
                color="warning"
                style="border-radius: 20px !important;margin-right: 0px;box-shadow: 0px 1px 2px rgba(255, 255, 255, 0.4), 0px 5px 15px rgba(162, 171, 198, 0.6);"
                @click="
                  getDataDefault(),
                    (searchOther = ''),
                    (showColorSearch = false),
                    (statusSearch = 'no')
                "
              >
                <v-icon color="white" left>mdi-refresh-circle</v-icon>
                รีเฟรชข้อมูล
                <template v-if="loadingRefresh">
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template>
              </v-btn>
              <!-- <v-btn
                color="teal"
                style="z-index:8;"
                id="v-step-0"
                dark
                depressed
                @click="(dialogExport = true), validate('EXPORT')"
              >
                <v-icon left>mdi-download</v-icon>
                Export Data
              </v-btn> -->
            </v-btn-toggle>
            <!-- </v-overlay> -->
          </v-col>
        </v-row>
        <v-row v-if="resCol === 'xs'" style="margin-bottom: 10px;">
          <v-col cols="12" class="text-left">
            <template v-if="changeBackgroundColor">
              <v-row class="test px-2">
                <v-row style="justify-content: space-around;">
                  <v-col
                    cols="6"
                    style="display: flex;justify-content: center;"
                  >
                    <v-card
                      style="padding: 10px; width: 230px;"
                      :color="getSelectText === 'wait' ? '#F9DBB2' : 'white'"
                      dense
                      elevation="0"
                      prominent
                      @click="
                        getSelect('wait', countWaiting, filterCloseJobValue)
                      "
                    >
                      <div>
                        <div class="text-center">
                          <v-avatar size="70" class="pa-3" color="#FEAE34">
                            <v-icon
                              dark
                              size="30"
                              class="iconify"
                              data-icon="ps:warning"
                            >
                              mdi-alarm
                            </v-icon>
                          </v-avatar>
                        </div>
                        <div style="margin: auto 0;text-align: center;">
                          <strong>{{ dataTypeProcess1 }}</strong>
                          <div>จำนวน : <span class="notranslate">{{ countWaiting }}</span></div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col
                    cols="12"
                    style="display: flex;justify-content: center;"
                  >
                    <v-card
                      style="padding: 10px; width: 230px;"
                      :color="getSelectText === 'confirm' ? '#C9F2DC' : 'white'"
                      dense
                      icon="mdi-email-check"
                      prominent
                      elevation="0"
                      @click="
                        getSelect('confirm', countConfirm, filterCloseJobValue)
                      "
                    >
                      <div>
                        <div class="text-center">
                          <v-avatar
                            size="70"
                            color="#97DDBB"
                            style="padding:13px"
                          >
                            <v-icon
                              dark
                              size="40"
                              class="iconify"
                              data-icon="quill:mail-subbed"
                            >
                              mdi-alarm
                            </v-icon>
                          </v-avatar>
                        </div>
                        <div style="margin: auto 0;text-align: center;">
                          <strong>{{ dataTypeProcess2 }}</strong>
                          <div>จำนวน : <span class="notranslate">{{ countConfirm }}</span></div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col
                    cols="6"
                    style="display: flex;justify-content: center;"
                  >
                    <v-card
                      style="padding: 10px; width: 230px;"
                      :color="
                        getSelectText === 'confirmJob' ? '#F9E8F5' : 'white'
                      "
                      dense
                      icon="mdi-account-check"
                      prominent
                      elevation="0"
                      @click="
                        getSelect('confirmJob', countJob, filterCloseJobValue)
                      "
                    >
                      <div>
                        <div class="text-center">
                          <v-avatar color="#E5B5D8" size="70" class="pa-3">
                            <v-icon
                              dark
                              size="40"
                              class="iconify"
                              data-icon="bi:people"
                            >
                              mdi-alarm
                            </v-icon>
                          </v-avatar>
                        </div>
                        <div style="margin: auto 0;text-align: center;">
                          <strong>{{ dataTypeProcess4 }}</strong>
                          <div style="text-align: center;">
                            จำนวน : <span class="notranslate">{{ countJob }}</span>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col
                    cols="6"
                    style="display: flex;justify-content: center;"
                  >
                    <v-card
                      style="padding: 10px; width: 230px;"
                      :color="
                        getSelectText === 'confirmSum' ? '#D7E8F9' : 'white'
                      "
                      dense
                      elevation="0"
                      icon="mdi-expand-all"
                      @click="
                        getSelect(
                          'confirmSum',
                          (countConfirm + countJob, filterCloseJobValue)
                        )
                      "
                    >
                      <div
                        style="display: flex;justify-content: space-around;flex-wrap: wrap;"
                      >
                        <div class="text-center">
                          <v-avatar color="#76ABE5" size="70" class="pa-3">
                            <v-icon
                              dark
                              size="40"
                              class="iconify"
                              data-icon="bi:folder-plus"
                            >
                            </v-icon>
                          </v-avatar>
                        </div>
                        <div style="margin: auto 0;text-align: center;">
                          <strong>รวมผู้เข้ารับบริการ</strong>
                          <div style="text-align: center;">
                            รวม : <span class="notranslate">{{ countConfirm + countJob }}</span>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col
                    cols="6"
                    style="display: flex;justify-content: center;"
                  >
                    <v-card
                      style="padding: 10px; width: 230px;"
                      :color="getSelectText === 'cancel' ? '#F9CACA' : 'white'"
                      dense
                      elevation="0"
                      icon="mdi-calendar-remove"
                      prominent
                      @click="
                        getSelect('cancel', countCancel, filterCloseJobValue)
                      "
                    >
                      <div>
                        <div class="text-center">
                          <v-avatar size="70" class="pa-3" color="#B72929">
                            <v-icon
                              dark
                              size="40"
                              class="iconify"
                              data-icon="carbon:rule-cancelled"
                            >
                              mdi-alarm
                            </v-icon>
                          </v-avatar>
                        </div>
                        <div style="margin: auto 0;text-align: center;">
                          <strong>{{ dataTypeProcess3 }}</strong>
                          <div>จำนวน : <span class="notranslate">{{ countCancel }}</span></div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-row>
            </template>
          </v-col>
        </v-row>
        <v-row style="margin-bottom: 29px;" v-if="resCol !== 'xs'">
          <v-col cols="12" class="text-left">
            <template v-if="changeBackgroundColor">
              <v-row class="test">
                <!-- <v-col cols="3" class="text-center" align="left">
                <div>
                  <v-col cols="12" class="pt-0 mb-5" style="border-right: 4px solid #25318C;">
                    <v-card
                      style="padding: 18px;
                              color:black;
                              border-top-right-radius: 20px;
                              border-top-left-radius: 20px;
                              border-bottom-left-radius: 20px;
                              border-bottom-right-radius: 20px;"
                      :color="(getSelectText === 'wait') ? '#F9DBB2' : 'white'"
                      dense
                      elevation="0"
                      prominent
                      @click="getSelect('wait',countWaiting)"
                    >
                      <div style="display: flex;justify-content: space-around;flex-wrap: wrap;">
                        <div class="text-center">
                          <v-avatar
                            size="70"
                            class="pa-3"
                            color="#FEAE34"
                          >
                            <v-icon dark size="30" class="iconify" data-icon="ps:warning">
                              mdi-alarm
                            </v-icon>
                          </v-avatar>
                        </div>
                        <div style="margin: auto 0;">
                          <strong>{{dataTypeProcess1}}</strong>
                          <div>จำนวน : {{countWaiting}}</div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12" style="border-right: 4px solid #25318C;">
                    <v-card
                    style="padding: 18px;
                              border-top-right-radius: 20px;
                              border-top-left-radius: 20px;
                              border-bottom-left-radius: 20px;
                              border-bottom-right-radius: 20px;"
                      :color="(getSelectText === 'cancel') ? '#F9CACA' : 'white'"
                      dense
                      elevation="0"
                      icon="mdi-calendar-remove"
                      prominent
                      @click="getSelect('cancel',countCancel)"
                    >
                    <div style="display: flex;justify-content: space-around;flex-wrap: wrap;">
                      <div class="text-center">
                        <v-avatar
                          size="70"
                          class="pa-3"
                          color="#B72929"
                        >
                          <v-icon dark size="40" class="iconify" data-icon="carbon:rule-cancelled">
                            mdi-alarm
                          </v-icon>
                        </v-avatar>
                      </div>
                      <div style="margin: auto 0;">
                        <strong>{{dataTypeProcess3}}</strong>
                         <div>จำนวน : {{countCancel}}</div>
                      </div>
                    </div>
                    </v-card>
                  </v-col>
                </div>
              </v-col> -->
                <!-- <div v-if="">test</div> -->
                <v-row style="justify-content: space-around;">
                  <v-col
                    :cols="resCol === 'md' ? '2' : 'auto'"
                    style="display: flex;justify-content: center;"
                  >
                    <v-card
                      :style="
                        resCol === 'sm'
                          ? 'padding: 10px; width: 130px;'
                          : 'padding: 10px; width: 230px;'
                      "
                      :color="getSelectText === 'wait' ? '#F9DBB2' : 'white'"
                      dense
                      elevation="0"
                      prominent
                      @click="
                        getSelect('wait', countWaiting, filterCloseJobValue)
                      "
                    >
                      <div
                        :style="
                          resCol === 'lg'
                            ? 'display: flex;justify-content: space-around;flex-wrap: wrap;'
                            : resCol === 'md'
                            ? ''
                            : ''
                        "
                      >
                        <div class="text-center">
                          <v-avatar size="70" class="pa-3" color="#FEAE34">
                            <v-icon
                              dark
                              size="30"
                              class="iconify"
                              data-icon="ps:warning"
                            >
                              mdi-alarm
                            </v-icon>
                          </v-avatar>
                        </div>
                        <div
                          :style="
                            resCol === 'md'
                              ? 'text-align: center;'
                              : resCol === 'sm'
                              ? 'text-align: center;'
                              : 'margin: auto 0;'
                          "
                        >
                          <strong>{{ dataTypeProcess1 }}</strong>
                          <div>จำนวน : <span class="notranslate">{{ countWaiting }}</span></div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col
                    :cols="resCol === 'md' ? '2' : 'auto'"
                    style="display: flex;justify-content: center;"
                  >
                    <v-card
                      :style="
                        resCol === 'sm'
                          ? 'padding: 10px; width: 130px;'
                          : 'padding: 10px; width: 230px;'
                      "
                      :color="getSelectText === 'confirm' ? '#C9F2DC' : 'white'"
                      dense
                      icon="mdi-email-check"
                      prominent
                      elevation="0"
                      @click="
                        getSelect('confirm', countConfirm, filterCloseJobValue)
                      "
                    >
                      <div
                        :style="
                          resCol === 'lg'
                            ? 'display: flex;justify-content: space-around;flex-wrap: wrap;'
                            : resCol === 'md'
                            ? ''
                            : ''
                        "
                      >
                        <div class="text-center">
                          <v-avatar
                            size="70"
                            color="#97DDBB"
                            style="padding:13px"
                          >
                            <v-icon
                              dark
                              size="40"
                              class="iconify"
                              data-icon="quill:mail-subbed"
                            >
                              mdi-alarm
                            </v-icon>
                          </v-avatar>
                        </div>
                        <div
                          :style="
                            resCol === 'md'
                              ? 'text-align: center;'
                              : resCol === 'sm'
                              ? 'text-align: center;'
                              : 'margin: auto 0;'
                          "
                        >
                          <strong>{{ dataTypeProcess2 }}</strong>
                          <div>จำนวน : <span class="notranslate">{{ countConfirm }}</span></div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col
                    :cols="resCol === 'md' ? '2' : 'auto'"
                    style="display: flex;justify-content: center;"
                  >
                    <v-card
                      :style="
                        resCol === 'sm'
                          ? 'padding: 10px; width: 130px;'
                          : 'padding: 10px; width: 230px;'
                      "
                      :color="
                        getSelectText === 'confirmJob' ? '#F9E8F5' : 'white'
                      "
                      dense
                      icon="mdi-account-check"
                      prominent
                      elevation="0"
                      @click="
                        getSelect('confirmJob', countJob, filterCloseJobValue)
                      "
                    >
                      <div
                        :style="
                          resCol === 'lg'
                            ? 'display: flex;justify-content: space-around;flex-wrap: wrap;'
                            : resCol === 'md'
                            ? ''
                            : ''
                        "
                      >
                        <div class="text-center">
                          <v-avatar color="#E5B5D8" size="70" class="pa-3">
                            <v-icon
                              dark
                              size="40"
                              class="iconify"
                              data-icon="bi:people"
                            >
                              mdi-alarm
                            </v-icon>
                          </v-avatar>
                        </div>
                        <div
                          :style="
                            resCol === 'md'
                              ? 'text-align: center;'
                              : resCol === 'sm'
                              ? 'text-align: center;'
                              : 'margin: auto 0;'
                          "
                        >
                          <strong>{{ dataTypeProcess4 }}</strong>
                          <div
                            :style="
                              resCol === 'md'
                                ? 'text-align: center;'
                                : 'text-align: left;'
                            "
                          >
                            จำนวน : <span class="notranslate">{{ countJob }}</span>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col
                    :cols="resCol === 'md' ? '2' : 'auto'"
                    style="display: flex;justify-content: center;"
                  >
                    <v-card
                      :style="
                        resCol === 'sm'
                          ? 'padding: 10px; width: 130px;'
                          : 'padding: 10px; width: 230px;'
                      "
                      :color="
                        getSelectText === 'confirmSum' ? '#D7E8F9' : 'white'
                      "
                      dense
                      elevation="0"
                      icon="mdi-expand-all"
                      @click="
                        getSelect(
                          'confirmSum',
                          countConfirm + countJob,
                          filterCloseJobValue
                        )
                      "
                    >
                      <div
                        :style="
                          resCol === 'lg'
                            ? 'display: flex;justify-content: space-around;flex-wrap: wrap;'
                            : resCol === 'md'
                            ? ''
                            : ''
                        "
                      >
                        <div class="text-center">
                          <v-avatar color="#76ABE5" size="70" class="pa-3">
                            <v-icon
                              dark
                              size="40"
                              class="iconify"
                              data-icon="bi:folder-plus"
                            >
                            </v-icon>
                          </v-avatar>
                        </div>
                        <div
                          :style="
                            resCol === 'md'
                              ? 'text-align: center;'
                              : resCol === 'sm'
                              ? 'text-align: center;'
                              : 'margin: auto 0;'
                          "
                        >
                          <strong>รวมผู้เข้ารับบริการ</strong>
                          <div
                            :style="
                              resCol === 'md'
                                ? 'text-align: center;'
                                : 'text-align: left;'
                            "
                          >
                            รวม : <span class="notranslate">{{ countConfirm + countJob }}</span>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col
                    :cols="resCol === 'md' ? '2' : 'auto'"
                    style="display: flex;justify-content: center;"
                  >
                    <v-card
                      :style="
                        resCol === 'sm'
                          ? 'padding: 10px; width: 130px;'
                          : 'padding: 10px; width: 230px;'
                      "
                      :color="getSelectText === 'cancel' ? '#F9CACA' : 'white'"
                      dense
                      elevation="0"
                      icon="mdi-calendar-remove"
                      prominent
                      @click="
                        getSelect('cancel', countCancel, filterCloseJobValue)
                      "
                    >
                      <div
                        :style="
                          resCol === 'lg'
                            ? 'display: flex;justify-content: space-around;flex-wrap: wrap;'
                            : resCol === 'md'
                            ? ''
                            : ''
                        "
                      >
                        <div class="text-center">
                          <v-avatar size="70" class="pa-3" color="#B72929">
                            <v-icon
                              dark
                              size="40"
                              class="iconify"
                              data-icon="carbon:rule-cancelled"
                            >
                              mdi-alarm
                            </v-icon>
                          </v-avatar>
                        </div>
                        <div
                          :style="
                            resCol === 'md'
                              ? 'text-align: center;'
                              : resCol === 'sm'
                              ? 'text-align: center;'
                              : 'margin: auto 0;'
                          "
                        >
                          <strong>{{ dataTypeProcess3 }}</strong>
                          <div>จำนวน : <span class="notranslate">{{ countCancel }}</span></div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-row>
              <!-- <v-row>
              <v-col cols="6" class="text-center pb-0">
                <v-alert
                  :color="'orange ' + ((getSelectText === 'wait') ? '' : 'lighten-4')"
                  :dark="((getSelectText === 'wait') ? true : false)"
                  dense
                  icon="mdi-phone-ring"
                  prominent
                  @click="getSelect('wait',countWaiting)"
                >
                  <div>
                    <strong>{{dataTypeProcess1}}</strong>
                  </div>
                  <div>จำนวน : {{countWaiting}}</div>
                </v-alert>
              </v-col>
              <v-col cols="6" class="text-center pb-0">
                <v-alert
                  :color="'green ' + ((getSelectText === 'confirm') ? '' : 'lighten-4')"
                  :dark="((getSelectText === 'confirm') ? true : false)"
                  dense
                  icon="mdi-phone-check"
                  prominent
                  @click="getSelect('confirm',countConfirm)"
                >
                  <div>
                    <strong>{{dataTypeProcess2}}</strong>
                  </div>
                  <div>จำนวน : {{countConfirm}}</div>
                </v-alert>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="text-center pb-0">
                <v-alert
                  :color="'red ' + ((getSelectText === 'cancel') ? '' : 'lighten-4')"
                  :dark="((getSelectText === 'cancel') ? true : false)"
                  dense
                  icon="mdi-phone-cancel"
                  prominent
                  @click="getSelect('cancel',countCancel)"
                >
                  <div>
                    <strong>{{dataTypeProcess3}}</strong>
                  </div>
                  <div>จำนวน : {{countCancel}}</div>
                </v-alert>
              </v-col>
              <v-col cols="6" class="text-center pb-0">
                <v-alert
                  :color="'blue ' + ((getSelectText === 'confirmJob') ? '' : 'lighten-4')"
                  :dark="((getSelectText === 'confirmJob') ? true : false)"
                  dense
                  icon="mdi-car-cog"
                  prominent
                  @click="getSelect('confirmJob',countJob)"
                >
                   <div>
                    <strong>{{dataTypeProcess4}}</strong>
                  </div>
                  <div>จำนวน : {{countJob}}</div>
                </v-alert>
              </v-col>
            </v-row> -->
              <!-- <v-row>
              <v-col cols="12" class="text-center pb-0  pt-0">
                <v-btn
                  color="blue-grey"
                  dense
                  dark
                  rounded
                  block
                  class="ma-2 white--text"
                  @click="getSelect('all',countAll)"
                >
                  ทั้งหมด จำนวน : {{countAll}}
                  <v-icon
                    right
                    dark
                  >
                    mdi-database-arrow-down
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row> -->
            </template>
          </v-col>
        </v-row>
        <v-divider v-if="resCol === 'xs'"></v-divider>
        <div class="pa-2 mb-4" v-if="resCol === 'xs'">
          <div style="text-align: end;margin-bottom: 10px;">
            <v-btn
              class="bottomAdd"
              style="margin-right: 0px;border-radius: 15px;color: white;box-shadow: 0px 1px 2px rgba(255, 255, 255, 0.4), 0px 5px 15px rgba(162, 171, 198, 0.6);"
              @click="addDataSet()"
            >
              เพิ่มรายการนัดหมาย
              <v-icon color="white" class="ml-4">mdi-plus-circle</v-icon>
            </v-btn>
          </div>
          <div>
            <v-menu
              ref="menu"
              v-model="menuStart"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  hide-details
                  background-color="white"
                  v-model="dateStart"
                  style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;margin-bottom: 10px;"
                  label="เดือน/ปี"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                >
                  <template #prepend-inner>
                    <v-icon
                      color="#69D1FD"
                      style="background-color: #E0F4FF;padding: 4px;border-radius: 50px;margin-top: -1px;margin-right: 3px;margin-bottom: 3px;"
                    >
                      mdi-calendar
                    </v-icon>
                  </template></v-text-field
                >
              </template>
              <v-date-picker
                @input="
                  (menuStart = false), (dataReady = false), getBookingList()
                "
                v-model="dateStart"
                type="month"
                no-title
                scrollable
              >
              </v-date-picker>
            </v-menu>
            <v-autocomplete
              v-model="masBranchID"
              background-color="white"
              style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;margin-bottom: 10px;"
              hide-details
              :items="branch"
              label="สาขา"
              outlined
              dense
              required
              :disabled="statusBranchReadonly"
              @change="(dataReady = false), (flowSelect = ''), getBookingList()"
              ><template #prepend-inner>
                <v-icon
                  color="#69D1FD"
                  style="background-color: #E0F4FF;padding: 4px;border-radius: 50px;margin-top: -1px;margin-right: 3px;margin-bottom: 3px;"
                >
                  mdi-map-marker-outline
                </v-icon>
              </template></v-autocomplete
            >
            <v-autocomplete
              style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;margin-bottom: 10px;"
              v-model="flowSelect"
              hide-details
              background-color="white"
              :items="DataFlowName"
              label="ประเภทบริการ"
              outlined
              dense
              @change="(dataReady = false), getBookingList()"
            >
              <template #prepend-inner>
                <v-icon
                  color="#69D1FD"
                  style="background-color: #E0F4FF;padding: 4px;border-radius: 50px;margin-top: -1px;margin-right: 3px;margin-bottom: 3px;"
                >
                  mdi-note-text-outline
                </v-icon>
              </template></v-autocomplete
            >
            <v-text-field
              class="textserch"
              background-color="white"
              style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;margin-bottom: 10px;"
              label="ค้นหาชื่อ และ เบอร์โทรศัพท์ ในตาราง"
              v-model="searchAll2"
              outlined
              hide-details
              dense
              ><template #prepend-inner>
                <v-icon style="margin-top: 0px;">
                  mdi-magnify
                </v-icon>
              </template>
            </v-text-field>
            <v-text-field
              v-if="checkShopSigneture[$session.getAll().data.shopId] == undefined"
              class="textserch"
              background-color="white"
              style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;margin-bottom: 10px;"
              :label="
                $session.getAll().data.category === 'ธุรกิจรถยนต์' ||
                $session.getAll().data.category === '7'
                  ? 'ค้นหาชื่อทั้งหมด หรือ ทะเบียน'
                  : 'ค้นหาชื่อทั้งหมด'
              "
              v-model="searchOther"
              outlined
              hide-details
              dense
              append-icon="mdi-card-search-outline"
              @click:append="searchAny()"
            >
            </v-text-field>
          </div>
        </div>
        <!-- panel -->
        <v-divider v-if="resCol !== 'xs'"></v-divider>
        <div class="pl-5 pb-5 pr-5 pt-0 mb-4" v-if="resCol !== 'xs'">
          <v-row
            style="display: flex;justify-content: space-between;margin-bottom:15px;margin-top:2px;"
          >
            <v-col cols="auto" class="pl-0">
              <h3 style="margin-bottom: 15px;color: black;font-weight: bolder;">
                ตรวจสอบรายการนัดหมาย
              </h3>
            </v-col>
            <v-col cols="auto" style="text-align: end;" class="px-0 pb-0">
              <v-btn
                class="bottomAdd"
                style="margin-right: 0px;border-radius: 15px;color: white;box-shadow: 0px 1px 2px rgba(255, 255, 255, 0.4), 0px 5px 15px rgba(162, 171, 198, 0.6);"
                width="250px"
                x-large
                @click="addDataSet()"
              >
                เพิ่มรายการนัดหมาย
                <v-icon color="white" class="ml-4">mdi-plus-circle</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="resCol === 'sm' ? '3' : '2'" class="pl-0">
              <v-menu
                ref="menu"
                v-model="menuStart"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    hide-details
                    background-color="white"
                    v-model="dateStart"
                    style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;"
                    label="เดือน/ปี"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                  >
                    <template #prepend-inner>
                      <v-icon
                        color="#69D1FD"
                        style="background-color: #E0F4FF;padding: 4px;border-radius: 50px;margin-top: -1px;margin-right: 3px;margin-bottom: 3px;"
                      >
                        mdi-calendar
                      </v-icon>
                    </template></v-text-field
                  >
                </template>
                <v-date-picker
                  @input="
                    (menuStart = false), (dataReady = false), getBookingList()
                  "
                  v-model="dateStart"
                  type="month"
                  no-title
                  scrollable
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col :cols="resCol === 'sm' ? '3' : '2'" class="pl-0">
              <v-autocomplete
                v-model="masBranchID"
                background-color="white"
                style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;"
                hide-details
                :items="branch"
                label="สาขา"
                outlined
                dense
                required
                :disabled="statusBranchReadonly"
                @change="
                  (dataReady = false), (flowSelect = ''), getBookingList()
                "
                ><template #prepend-inner>
                  <v-icon
                    color="#69D1FD"
                    style="background-color: #E0F4FF;padding: 4px;border-radius: 50px;margin-top: -1px;margin-right: 3px;margin-bottom: 3px;"
                  >
                    mdi-map-marker-outline
                  </v-icon>
                </template></v-autocomplete
              >
            </v-col>
            <v-col :cols="resCol === 'sm' ? '3' : '2'" class="pl-0">
              <v-autocomplete
                style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;"
                v-model="flowSelect"
                hide-details
                background-color="white"
                :items="DataFlowName"
                label="ประเภทบริการ"
                outlined
                dense
                @change="(dataReady = false), getBookingList()"
              >
                <template #prepend-inner>
                  <v-icon
                    color="#69D1FD"
                    style="background-color: #E0F4FF;padding: 4px;border-radius: 50px;margin-top: -1px;margin-right: 3px;margin-bottom: 3px;"
                  >
                    mdi-note-text-outline
                  </v-icon>
                </template></v-autocomplete
              >
            </v-col>
            <v-col v-if="resCol !== 'sm'" cols="2"></v-col>
            <v-col :cols="resCol === 'sm' ? '3' : '4'" class="pr-0 pl-0 pt-3">
              <v-text-field
                class="textserch"
                background-color="white"
                style="border-radius: 40px !important;"
                label="ค้นหาชื่อ และ เบอร์โทรศัพท์ ในตาราง"
                v-model="searchAll2"
                outlined
                hide-details
                dense
                ><template #prepend-inner>
                  <v-icon style="margin-top: 0px;">
                    mdi-magnify
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="checkShopSigneture[$session.getAll().data.shopId] == undefined"
            justify="end">
            <v-col :cols="resCol === 'sm' ? '3' : '4'" class="pr-0 pl-0 pt-3">
              <v-text-field
                class="textserch"
                background-color="white"
                style="border-radius: 40px !important;"
                :label="
                  $session.getAll().data.category === 'ธุรกิจรถยนต์' ||
                  $session.getAll().data.category === '7'
                    ? 'ค้นหาชื่อทั้งหมด หรือ ทะเบียน'
                    : 'ค้นหาชื่อทั้งหมด'
                "
                v-model="searchOther"
                outlined
                hide-details
                dense
                prepend-inner-icon="mdi-magnify"
              >
              </v-text-field>
            </v-col>
            <v-col cols="auto" class="pr-0 pl-1 pt-3">
              <v-btn rounded color="primary" dark @click="searchAny()">
                ค้นหา
              </v-btn>
            </v-col>
            <v-col
              cols="auto"
              class="pr-0 pl-1 pt-3"
              v-if="searchOther.length > 1"
            >
              <v-btn
                rounded
                color="error"
                dark
                @click="
                  getDataDefault(),
                    (searchOther = ''),
                    (showColorSearch = false),
                    (statusSearch = 'no')
                "
              >
                clear
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <!-- panel -->
        <v-row>
          <!-- EXPORT -->
          <v-dialog v-model="dialogExport" persistent max-width="70%">
            <v-card class="text-center">
              <v-form ref="form_export" v-model="validExport" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right pa-0">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click="dialogExport = false"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-row justify="center">
                      <v-col
                        cols="5"
                        class="text-center"
                        style="margin: auto 0;"
                      >
                        <v-col class="text-center">
                          <v-img
                            class="v-margit_img_reward"
                            :src="require('@/assets/ExportExcel.svg')"
                            max-width="470.37"
                            max-height="247"
                          ></v-img>
                        </v-col>
                      </v-col>

                      <v-col cols="6" class="v-margit_text_add mt-0 pa-0">
                        <v-col class="text-center pa-3 ml-2">
                          <v-img
                            class="v_text_add"
                            :src="require('@/assets/Grouptitle.svg')"
                          ></v-img>
                        </v-col>
                        <v-col cols="12">
                          <v-row>
                            <v-col cols="6">
                              <p>เลือกสาขา</p>
                              <v-select
                                v-model="masBranchIDExport"
                                :items="branch"
                                label=""
                                outlined
                                :rules="[rules.required]"
                              ></v-select>
                            </v-col>
                            <v-col cols="6">
                              <p>เลือกวันที่</p>
                              <date-range-picker
                                opens="left"
                                :append-to-body="appendBody"
                                ref="picker"
                                :locale-data="localeData"
                                v-model="dateRange"
                                :rules="[rules.required]"
                                @update="updateValuesExport()"
                              >
                                <template #ranges="ranges">
                                  <div class="ranges">
                                    <ul>
                                      <li
                                        v-for="(range, name) in ranges.ranges"
                                        :key="name"
                                        @click="ranges.clickRange(range)"
                                      >
                                        <b v-if="name === 'Today'">วันนี้</b>
                                        <b v-if="name === 'Yesterday'"
                                          >เมื่อวาน</b
                                        >
                                        <b v-if="name === 'This month'"
                                          >เดือนนี้</b
                                        >
                                        <b v-if="name === 'This year'"
                                          >ปีนี้ทั้งปี</b
                                        >
                                        <b v-if="name === 'Last month'"
                                          >เดือนที่แล้ว</b
                                        >
                                      </li>
                                      <!-- <li data-range-key="Today" tabindex="0" class="active" @click="ranges.clickRange('Today')">วันนี้ </li>
                                        <li data-range-key="Yesterday" tabindex="0" class="" @click="ranges.clickRange('Yesterday')">เมื่อวาน </li>
                                        <li data-range-key="This month" tabindex="0" class="" @click="ranges.clickRange('This month')">เดือนนี้ </li>
                                        <li data-range-key="This year" tabindex="0" class="" @click="ranges.clickRange('This year')">ปีนี้ทั้งปี </li>
                                        <li data-range-key="Last month" tabindex="0" class="" @click="ranges.clickRange('Last month')">เดือนที่แล้ว </li> -->
                                    </ul>
                                  </div>
                                </template>
                              </date-range-picker>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-col>
                    </v-row>
                    <div class="text-center" v-if="export_data.length > 0">
                      <v-btn color="yellow-light" @click="dialogExport = false">
                        <v-icon left>mdi-download</v-icon>
                        <download-excel
                          class="btn btn-default"
                          :data="export_data"
                          :fields="export_fields"
                          :type="exportType"
                          :worksheet="exportWorksheet"
                          :name="exportFileName"
                        >
                          Export Data
                        </download-excel>
                      </v-btn>
                    </div>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- end add -->
          <!-- ADD -->
          <v-dialog v-model="dialogAdd" max-width="100%" persistent>
            <v-card class="text-center">
              <v-form ref="form_add" v-model="validAdd" lazy-validation>
                <v-card-text>
                  <v-row justify="center">
                    <v-col
                      v-if="ColsDialogAdd === 'True'"
                      :cols="ColsDialogAdd === 'True' ? 8 : 8"
                    >
                      <v-col class="text-center">
                        <CalendarBooking
                          ref="CalendarBooking"
                          @SelectedFlowId="SelectedFlowId"
                          @SelectedmasBranchName="SelectedmasBranchName"
                        ></CalendarBooking>
                      </v-col>
                    </v-col>

                    <v-col :cols="ColsDialogAdd === 'True' ? 4 : 10">
                      <!-- <v-col cols="12" sm="6" md="6" lg="6" class="v-margit_text_add mt-0 pa-0"> -->
                      <v-row>
                        <v-col cols="8" class="text-left pt-10">
                          <h3><strong>เพิ่มรายการนัดหมาย</strong></h3>
                        </v-col>
                        <v-col cols="4" class="pt-10">
                          <div style="text-align: end;">
                            <v-btn
                              class="mx-2"
                              fab
                              small
                              dark
                              color="white"
                              :style="styleCloseBt"
                              @click="(dialogAdd = false), clearDataAdd()"
                            >
                              X
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                      <v-col cols="12">
                        <v-checkbox
                          v-if="
                            $session.getAll().data.shopId !==
                              'U52928fc4d2ed0bb777f7c1d1c95d6173'
                          "
                          v-model="statusVIP"
                          label="เปิดจองคิวซ้ำได้"
                          false-value="False"
                          true-value="True"
                          :on-icon="'mdi-check-circle'"
                          :off-icon="'mdi-checkbox-blank-circle-outline'"
                          @click="date = ''"
                        ></v-checkbox>
                        <v-autocomplete
                          v-model="formAdd.masBranchID"
                          :items="branch"
                          label="สาขา"
                          outlined
                          dense
                          required
                          :rules="[rules.required]"
                          @change="
                            (priceMenuAdd = 0),
                              (drawerAdd = false),
                              (showMenu = 'False'),
                              getDataCalendaBookingAdd(),
                              setFlowByBranchAdd()
                          "
                        ></v-autocomplete>
                        <v-autocomplete
                          v-if="
                            formAdd.masBranchID !== null &&
                              formAdd.masBranchID !== ''
                          "
                          v-model="formAdd.flowId"
                          :items="dataFlowSelectAdd"
                          label="ประเภทบริการ"
                          outlined
                          dense
                          required
                          @change="
                            (priceMenuAdd = 0),
                              (drawerAdd = false),
                              checkTime(),
                              getDataCalendaBookingAdd(),
                              SetallowedDates(),
                              setFlowAdd(),
                              (date = '')
                          "
                          :rules="[rules.required]"
                        ></v-autocomplete>
                        <template v-if="fieldNameItem">
                          <div
                            v-for="(item, index) in fieldNameItem"
                            :key="index"
                          >
                            <template
                              v-if="
                                item.conditionField === '' ||
                                  item.conditionField === null
                              "
                            >
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'text'"
                              >
                                <v-text-field
                                  v-if="item.fieldName === 'เบอร์โทร'"
                                  v-mask="'###-###-####'"
                                  v-model="item.fieldValue"
                                  :label="item.fieldName"
                                  outlined
                                  dense
                                  required
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                ></v-text-field>
                                <v-text-field
                                  v-else
                                  v-model="item.fieldValue"
                                  :label="item.fieldName"
                                  outlined
                                  dense
                                  required
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'number'"
                              >
                                <v-text-field
                                  v-if="item.fieldName === 'เบอร์โทร'"
                                  v-mask="'###-###-####'"
                                  v-model="item.fieldValue"
                                  :label="item.fieldName"
                                  outlined
                                  dense
                                  required
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required, rules.phoneRules]
                                      : [true]
                                  "
                                ></v-text-field>
                                <v-text-field
                                  v-else
                                  v-model="item.fieldValue"
                                  :label="item.fieldName"
                                  outlined
                                  dense
                                  required
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'dateTime'"
                              >
                                <v-menu
                                  v-model="menuAdd1[item.fieldId]"
                                  :close-on-content-click="false"
                                  :return-value.sync="date"
                                  :rules="[rules.required]"
                                  transition="scale-transition"
                                  offset-y
                                  required
                                  min-width="auto"
                                  :ref="menuAdd1[item.fieldId]"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="item.fieldValue"
                                      readonly
                                      :label="item.fieldName"
                                      outlined
                                      dense
                                      v-bind="attrs"
                                      v-on="on"
                                      required
                                      prepend-inner-icon="mdi-calendar"
                                      :rules="
                                        item.requiredField === 'True'
                                          ? [rules.required]
                                          : [true]
                                      "
                                    >
                                    </v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="item.fieldValue"
                                    no-title
                                    scrollable
                                    @input="
                                      (menuAdd1[item.fieldId] = false),
                                        $refs.menuAdd1[item.fieldId].save(item.fieldValue)
                                    "
                                  >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'Autocompletes'"
                              >
                                <v-autocomplete
                                  v-model="item.fieldValue"
                                  :items="JSON.parse(item.optionField)"
                                  outlined
                                  :label="item.fieldName"
                                  required
                                  dense
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'Selects'"
                              >
                                <v-select
                                  class="mb-6"
                                  v-model="item.fieldValue"
                                  :items="JSON.parse(item.optionField)"
                                  menu-props="auto"
                                  :label="item.fieldName"
                                  clearable
                                  required
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                  dense
                                  outlined
                                ></v-select>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'Radio'"
                                style="padding:0px;"
                              >
                                <v-container fluid style="padding:0px;">
                                  <v-radio-group
                                    column
                                    dense
                                    v-model="item.fieldValue"
                                    style="margin:0px;"
                                  >
                                    <template v-slot:label> </template>
                                    <div
                                      v-for="radios in JSON.parse(
                                        item.optionField
                                      )"
                                      :key="radios.toISOString"
                                    >
                                      <v-radio
                                        :label="radios.text"
                                        dense
                                        :value="radios.value"
                                      ></v-radio>
                                    </div>
                                  </v-radio-group>
                                </v-container>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'Checkbox'"
                                style="padding: 0;"
                              >
                                <div>
                                  <p
                                    style="
                                      text-align: left;
                                      display: block;
                                      font-size: 16px;
                                      margin-bottom: 10px;
                                    "
                                  >
                                    {{ item.fieldName }}
                                  </p>
                                  <div
                                    v-for="(checkbox, index) in JSON.parse(item.optionField)"
                                    :key="checkbox.text"
                                  >
                                    <v-container
                                      fluid
                                      class="pa-0 pt-0"
                                      :class="{
                                        'mb-1': index !== JSON.parse(item.optionField).length - 1, // ระยะปกติ
                                        'mb-5': index === JSON.parse(item.optionField).length - 1, // ตัวสุดท้าย
                                      }"
                                    >
                                      <span style="display: none;">{{ item.fieldValue }}</span>
                                      <v-checkbox
                                        v-model="selected[item.fieldId]"
                                        :label="languageSelect === 0 ? checkbox.text : checkbox.textEng"
                                        :value="checkbox.value"
                                        :rules="item.requiredField === 'True' ? [rules.checkBox] : [true]"
                                        @click="item.fieldValue = JSON.stringify(selected[item.fieldId] || [])"
                                        class="pt-1 mt-2 ps-3"
                                      >
                                      </v-checkbox>
                                    </v-container>
                                  </div>
                                </div>
                              </v-col>
                            </template>
                            <template
                              v-if="
                                item.conditionField !== '' &&
                                  fieldNameItem.filter(row => {
                                    return (
                                      row.fieldId ===
                                      parseInt(item.conditionField)
                                    );
                                  }).length > 0
                              "
                            >
                              <template
                                v-if="
                                  item.conditionValue ===
                                    fieldNameItem.filter(row => {
                                      return (
                                        row.fieldId ===
                                        parseInt(item.conditionField)
                                      );
                                    })[0].fieldValue
                                "
                              >
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'text'"
                                >
                                  <v-text-field
                                    v-if="item.fieldName === 'เบอร์โทร'"
                                    v-mask="'###-###-####'"
                                    v-model="item.fieldValue"
                                    :label="item.fieldName"
                                    outlined
                                    required
                                    dense
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                  ></v-text-field>
                                  <v-text-field
                                    v-else
                                    v-model="item.fieldValue"
                                    :label="item.fieldName"
                                    outlined
                                    required
                                    dense
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'number'"
                                >
                                  <v-text-field
                                    v-if="item.fieldName === 'เบอร์โทร'"
                                    v-mask="'###-###-####'"
                                    v-model="item.fieldValue"
                                    :label="item.fieldName"
                                    outlined
                                    required
                                    dense
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                  ></v-text-field>
                                  <v-text-field
                                    v-else
                                    v-model="item.fieldValue"
                                    :label="item.fieldName"
                                    outlined
                                    required
                                    dense
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'dateTime'"
                                >
                                  <v-menu
                                    v-model="menuAdd2[item.fieldId]"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    :rules="[rules.required]"
                                    transition="scale-transition"
                                    offset-y
                                    required
                                    min-width="auto"
                                    :ref="menuAdd2[item.fieldId]"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="item.fieldValue"
                                        readonly
                                        :label="item.fieldName"
                                        outlined
                                        dense
                                        v-bind="attrs"
                                        v-on="on"
                                        required
                                        prepend-inner-icon="mdi-calendar"
                                        :rules="
                                          item.requiredField === 'True'
                                            ? [rules.required]
                                            : [true]
                                        "
                                      >
                                      </v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="item.fieldValue"
                                      no-title
                                      scrollable
                                      @input="
                                        (menuAdd2[item.fieldId] = false),
                                          $refs.menuAdd2[item.fieldId].save(item.fieldValue)
                                      "
                                    >
                                    </v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'Autocompletes'"
                                >
                                  <v-autocomplete
                                    v-model="item.fieldValue"
                                    :items="JSON.parse(item.optionField)"
                                    outlined
                                    :label="item.fieldName"
                                    required
                                    dense
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                  ></v-autocomplete>
                                </v-col>
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'Selects'"
                                >
                                  <v-select
                                    class="mb-6"
                                    v-model="item.fieldValue"
                                    :items="JSON.parse(item.optionField)"
                                    menu-props="auto"
                                    :label="item.fieldName"
                                    required
                                    dense
                                    clearable
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                    outlined
                                  ></v-select>
                                </v-col>
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'Radio'"
                                  style="padding:0px;"
                                >
                                  <v-container fluid style="padding:0px;">
                                    <v-radio-group
                                      row
                                      dense
                                      v-model="item.fieldValue"
                                      :rules="
                                        item.requiredField === 'True'
                                          ? [rules.required]
                                          : [true]
                                      "
                                      style="margin:0px;"
                                    >
                                      <template v-slot:label> </template>
                                      <div
                                        v-for="radios in JSON.parse(
                                          item.optionField
                                        )"
                                        :key="radios.toISOString"
                                      >
                                        <v-radio
                                          :label="radios.text"
                                          :value="radios.value"
                                          dense
                                        ></v-radio>
                                      </div>
                                    </v-radio-group>
                                  </v-container>
                                </v-col>
                              </template>
                            </template>
                            <template v-if="item.conditionField === 'flow'">
                              <template
                                v-if="
                                  parseInt(item.conditionValue) ===
                                    parseInt(formAdd.flowId)
                                "
                              >
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'text'"
                                >
                                  <v-text-field
                                    v-if="item.fieldName === 'เบอร์โทร'"
                                    v-mask="'###-###-####'"
                                    v-model="item.fieldValue"
                                    :label="item.fieldName"
                                    dense
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                    outlined
                                  ></v-text-field>
                                  <v-text-field
                                    v-else
                                    v-model="item.fieldValue"
                                    :label="item.fieldName"
                                    dense
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                    outlined
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'number'"
                                >
                                  <v-text-field
                                    v-if="item.fieldName === 'เบอร์โทร'"
                                    v-mask="'###-###-####'"
                                    v-model="item.fieldValue"
                                    :label="item.fieldName"
                                    dense
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                    outlined
                                  ></v-text-field>
                                  <v-text-field
                                    v-else
                                    v-model="item.fieldValue"
                                    :label="item.fieldName"
                                    dense
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                    outlined
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'dateTime'"
                                >
                                  <v-menu
                                    v-model="menuAdd3[item.fieldId]"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    :rules="[rules.required]"
                                    transition="scale-transition"
                                    offset-y
                                    required
                                    min-width="auto"
                                    :ref="menuAdd3[item.fieldId]"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="item.fieldValue"
                                        readonly
                                        :label="item.fieldName"
                                        outlined
                                        dense
                                        v-bind="attrs"
                                        v-on="on"
                                        required
                                        prepend-inner-icon="mdi-calendar"
                                        :rules="
                                          item.requiredField === 'True'
                                            ? [rules.required]
                                            : [true]
                                        "
                                      >
                                      </v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="item.fieldValue"
                                      no-title
                                      scrollable
                                      @input="
                                        (menuAdd3[item.fieldId] = false),
                                          $refs.menuAdd3[item.fieldId].save(item.fieldValue)
                                      "
                                    >
                                    </v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'Autocompletes'"
                                >
                                  <v-autocomplete
                                    v-model="item.fieldValue"
                                    :items="JSON.parse(item.optionField)"
                                    dense
                                    filled
                                    :label="item.fieldName"
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                  ></v-autocomplete>
                                </v-col>
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'Selects'"
                                >
                                  <v-select
                                    class="mb-6"
                                    v-model="item.fieldValue"
                                    :items="JSON.parse(item.optionField)"
                                    menu-props="auto"
                                    :label="item.fieldName"
                                    clearable
                                    dense
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                    hide-details
                                    outlined
                                  ></v-select>
                                </v-col>
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType === 'Radio'"
                                  style="padding:0px;"
                                >
                                  <v-container fluid style="padding:0px;">
                                    <v-radio-group
                                      row
                                      v-model="item.fieldValue"
                                      style="margin:0px;"
                                      :rules="
                                        item.requiredField === 'True'
                                          ? [rules.required]
                                          : [true]
                                      "
                                    >
                                      <template v-slot:label> </template>
                                      <div
                                        v-for="radios in JSON.parse(
                                          item.optionField
                                        )"
                                        :key="radios.toISOString"
                                        class="text-center"
                                      >
                                        <v-radio
                                          :label="radios.text"
                                          dense
                                          :value="radios.value"
                                        ></v-radio>
                                      </div>
                                    </v-radio-group>
                                  </v-container>
                                </v-col>
                              </template>
                            </template>
                          </div>
                        </template>
                        <v-row>
                          <v-col class="pb-0 pt-0" v-if="formAdd.flowId">
                            <v-menu
                              ref="menu"
                              v-model="menuDate"
                              :close-on-content-click="false"
                              :return-value.sync="date"
                              :rules="[rules.required]"
                              transition="scale-transition"
                              offset-y
                              required
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="date"
                                  readonly
                                  label="วันที่นัดหมาย"
                                  outlined
                                  dense
                                  v-bind="attrs"
                                  v-on="on"
                                  required
                                  @click="
                                    pickerDate ? getMonth(pickerDate) : null
                                  "
                                  :rules="[rules.required]"
                                >
                                  <template #prepend>
                                    <v-icon right>
                                      mdi-calendar
                                    </v-icon>
                                  </template>
                                </v-text-field>
                              </template>
                              <v-date-picker
                                v-model="date"
                                no-title
                                scrollable
                                :allowed-dates="allowedDates"
                                :picker-date.sync="pickerDate"
                                @change="setLimitBooking(date)"
                                @input="
                                  (menuDate = false), $refs.menu.save(date)
                                "
                                :min="currentDate"
                              >
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col
                            class="pb-0 pt-0"
                            v-if="timeavailable.length > 0 && date !== ''"
                          >
                            <v-autocomplete
                              v-model="time"
                              :items="timeavailable"
                              label="เวลา"
                              item-text="text"
                              item-value="text"
                              persistent-hint
                              return-object
                              outlined
                              dense
                              required
                              :rules="[rules.required]"
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row v-if="showMenu === 'True'">
                          <sideMenu
                            :drawerParent="drawerAdd"
                            :toggleParent="toggleAdd"
                            :languageSelectParent="languageSelect"
                            :dataMenuParent="dataMenuAdd"
                            :priceMenuParent="priceMenuAdd"
                            @updatePriceMenuParent="updatePriceMenuAdd"
                          ></sideMenu>
                          <v-col cols="12" class="pt-0 pb-4">
                            <v-btn block dark @click="toggleAdd">เมนู</v-btn>
                          </v-col>
                          <v-col cols="12" class="pt-0 pb-6">
                            <v-expansion-panels
                              multiple
                              v-model="expansionMenuAdd"
                            >
                              <v-expansion-panel>
                                <v-expansion-panel-header
                                  >รายการและราคา</v-expansion-panel-header
                                >
                                <v-expansion-panel-content>
                                  <div style="align-items: center;width:100%;">
                                    <v-row>
                                      <v-col
                                        cols="12"
                                        v-for="(item, id) in dataMenuAdd.filter(
                                          el => {
                                            return parseInt(el.qty) > 0;
                                          }
                                        )"
                                        :key="id"
                                        style="display: flex;"
                                      >
                                        <v-card class="cardMenu">
                                          <v-img
                                            class="pictureMenu"
                                            :src="item.picture"
                                          ></v-img>
                                          <v-row>
                                            <v-col
                                              cols="8"
                                              class="pt-0 pb-0 textTitelMenu"
                                              >{{ item.name }}</v-col
                                            >
                                            <v-col
                                              cols="8"
                                              style="display: flex;justify-content: flex-start;"
                                              class="pt-0 pb-0 textTitelMenuSub"
                                              >{{ item.qty }} x
                                              {{
                                                formatNumber(item.price)
                                              }}</v-col
                                            >
                                            <v-col
                                              cols="6"
                                              class="pt-0 pb-0 textTitelMenuRemark"
                                              >{{ item.remark }}</v-col
                                            >
                                          </v-row>
                                        </v-card>
                                      </v-col>
                                      <v-col cols="12">
                                        <v-row>
                                          <v-col cols="6"
                                            ><p class="ma-0 textTitelPriceMenu">
                                              รวมราคา
                                            </p></v-col
                                          >
                                          <v-col
                                            cols="6"
                                            style="display: flex;justify-content: flex-end;"
                                            class="textTitelPriceMenu"
                                            >{{
                                              formatNumber(priceMenuAdd)
                                            }}</v-col
                                          >
                                        </v-row>
                                      </v-col>
                                    </v-row>
                                  </div>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </v-col>
                        </v-row>
                        <v-row
                          v-if="
                            $session.getAll().data.shopId !==
                              'U9f316c85400fd716ea8c80d7cd5b61f8'
                          "
                        >
                          <v-col class="pt-0 pb-0">
                            <v-radio-group
                              v-model="formAdd.radiosRemark"
                              row
                              required
                              :rules="[rules.required]"
                            >
                              <v-radio value="ซ่อมปกติ">
                                <template v-slot:label>
                                  <div class="mt-3">
                                    <strong class="primary--text">{{
                                      dataTypeJob1
                                    }}</strong>
                                  </div>
                                </template>
                              </v-radio>
                              <v-radio value="ExtraJob">
                                <template v-slot:label>
                                  <div class="mt-3">
                                    <strong class="error--text">{{
                                      dataTypeJob2
                                    }}</strong>
                                  </div>
                                </template>
                              </v-radio>
                              <v-radio value="FastTrack">
                                <template v-slot:label>
                                  <div class="mt-3">
                                    <strong class="orange--text">{{
                                      dataTypeJob3
                                    }}</strong>
                                  </div>
                                </template>
                              </v-radio>
                            </v-radio-group>
                          </v-col>
                        </v-row>
                        <v-row v-if="checkDepositAdd === 'True'">
                          <v-col cols="12" class="pt-0">
                            <v-checkbox
                              :label="
                                `มีหลักฐานมัดจำหรือไม่ : ${dataDepositAdd.toString()}`
                              "
                              false-value="ไม่มี"
                              true-value="มี"
                              v-model="dataDepositAdd"
                              hide-details
                              @change="
                                dataDepositAdd === 'มี'
                                  ? (panelDeposit = [0])
                                  : (panelDeposit = [])
                              "
                            ></v-checkbox>
                          </v-col>
                          <v-col
                            cols="12"
                            class="pt-0"
                            v-if="dataDepositAdd === 'มี'"
                          >
                            <v-expansion-panels v-model="panelDeposit" multiple>
                              <v-expansion-panel>
                                <v-expansion-panel-header
                                  >อัพเดทหลักฐานเงินมัดจำ</v-expansion-panel-header
                                >
                                <v-expansion-panel-content>
                                  <v-row justify="center">
                                    <v-col cols="12" class="text-center">
                                      <v-img
                                        aspect-ratio="3"
                                        contain
                                        :src="formAdd.pictureUrlPreviewDeposit"
                                      ></v-img>
                                      <br />
                                      <v-file-input
                                        counter
                                        show-size
                                        accept="image/png, image/jpeg, image/bmp"
                                        prepend-icon="mdi-camera"
                                        label="รูปหลักฐานการมัดจำ"
                                        @change="selectImgAdd"
                                        v-model="filesDepositAdd"
                                      ></v-file-input>
                                    </v-col>
                                  </v-row>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </v-col>
                          <v-col cols="12" class="pt-0 pb-0">
                            <VuetifyMoney
                              v-model="formAdd.depositPrice"
                              placeholder="จำนวนเงินมัดจำ"
                              dense
                              label="จำนวนเงินมัดจำ"
                              outlined
                              v-bind:options="options2"
                            />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="pt-0 pb-0">
                            <v-autocomplete
                              v-if="
                                formAdd.masBranchID !== null &&
                                  formAdd.masBranchID !== ''
                              "
                              v-model="empSelectAdd"
                              :items="
                                empSelectStepAdd.filter(
                                  i =>
                                    i.masBranchID === formAdd.masBranchID ||
                                    i.masBranchID === ''
                                )
                              "
                              label="พนักงานที่รับนัดหมาย"
                              outlined
                              required
                              :rules="[rules.required]"
                              dense
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="pt-0">
                            <v-textarea
                              v-model="remark"
                              outlined
                              label="หมายเหตุเพิ่มเติม"
                              auto-grow
                            ></v-textarea>
                          </v-col>
                        </v-row>
                        <v-row v-if="statusShowMap === 'True'">
                          <v-col class="pb-0 pt-0" cols="12">
                            <v-text-field
                              v-model="address"
                              label="ชื่อของที่อยู่"
                              outlined
                              required
                              dense
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-card class="p-3">
                              <v-card-text>
                                <v-row>
                                  <v-col class="pb-0" cols="12">
                                    <h6>ค้นหาที่อยู่ลูกค้า :</h6>
                                  </v-col>
                                  <v-col class="pb-0 pt-0" id="divTest1" cols="12">
                                    <gmap-autocomplete
                                      class="introInput"
                                      placeholder="ค้นหาสถานที่"
                                      @place_changed="updatePlace"
                                      @keydown="testStyleInputGoogleMap('divTest1')"
                                      style="width: 100%; height: 45px; border: 1px solid;padding-left: 8px; border-radius: 4px;">
                                    </gmap-autocomplete>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                              <hr />
                              <!-- <gmap-autocomplete @place_changed="updatePlace"/> -->
                              <v-card-text>
                                <GmapMap
                                  v-if="center !== null"
                                  :center="center"
                                  :zoom="15"
                                  style="width: 100%; height: 200px"
                                  :options="{
                                    disableDefaultUI: true,
                                    fullscreenControl: true,
                                    zoomControl: true,
                                    gestureHandling: 'greedy',
                                  }"
                                >
                                  <GmapMarker
                                    :position="center"
                                    :draggable="true"
                                    @drag="updateCoordinates"
                                  />
                                </GmapMap>
                              </v-card-text>
                            </v-card>
                            <br />
                          </v-col>
                        </v-row>
                        <div class="text-center">
                          <v-btn
                            elevation="2"
                            large
                            color="#173053"
                            :loading="loadingAdd"
                            :disabled="loadingAdd"
                            class="white--text"
                            @click="addData()"
                          >
                            <template v-slot:loader>
                              <span class="custom-loader">
                                <v-icon light>mdi-cached</v-icon>
                              </span>
                            </template>
                            <v-icon color="white" dark left
                              >mdi-checkbox-marked-circle</v-icon
                            >
                            เพิ่ม
                          </v-btn>
                        </div>
                      </v-col>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="400px">
            <v-card>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="6" class="text-left pt-10">
                      <h3><strong>ลบข้อมูลนี้</strong></h3>
                    </v-col>
                    <v-col cols="6" class="pt-10">
                      <div style="text-align: end;">
                        <v-btn
                          class="mx-2"
                          fab
                          small
                          dark
                          color="white"
                          :style="styleCloseBt"
                          @click="dialogDelete = false"
                        >
                          X
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="รหัส Booking No"
                        v-model="formUpdate.bookNo"
                        readonly
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="pt-0">
                      <v-btn
                        elevation="2"
                        large
                        block
                        dark
                        color="#173053"
                        @click="deleteData()"
                      >
                        <v-icon left>mdi-checkbox-marked-circle</v-icon>
                        ลบ
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent :max-width="dialogwidth">
            <v-card class="text-center">
              <v-card-text>
                <v-row>
                  <v-col cols="6" class="text-left pt-10">
                    <h3><strong>นำเข้ากระดานการทำงาน</strong></h3>
                  </v-col>
                  <v-col cols="6" class="pt-10">
                    <div style="text-align: end;">
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        dark
                        color="white"
                        :style="styleCloseBt"
                        @click="
                          (dialogEdit = false),
                            getDataDefault(),
                            (searchOther = ''),
                            (showColorSearch = false),
                            (statusSearch = 'no')
                        "
                      >
                        X
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text v-if="dataEditJobReady && statusConfirmJob">
                <v-container>
                  <v-col
                    class="pb-0 pt-0"
                    cols="12"
                    v-if="
                      dataPackage.filter(el => {
                        return el.balanceAmount > 0;
                      }).length > 0 && dataPackageDefault === false
                    "
                  >
                    <v-card class="pl-1">
                      <v-subheader
                        >ลูกค้ามี
                        {{
                          dataPackage.filter(el => {
                            return el.balanceAmount > 0;
                          }).length
                        }}
                        แพ็คเกจ</v-subheader
                      >
                      <v-subheader v-show="StatusPackage.packageName"
                        >ลูกค้าได้ทำการเลือกแพ็คเกจ
                        {{ StatusPackage.packageName }}</v-subheader
                      >
                      <v-slide-group
                        v-model="modelPackageIndexConfirmJob"
                        center-active
                        show-arrows
                      >
                        <v-slide-item
                          v-for="(item, index) in dataPackage.filter(el => {
                            return el.balanceAmount > 0;
                          })"
                          :key="index"
                        >
                          <v-card
                            class="ma-2 p-1"
                            width="340"
                            height="100"
                            color="#FFFFFF"
                            elevation="6"
                            :style="
                              item.packageId === packageId &&
                              item.token === tokenPackage
                                ? 'border: 1px solid green;'
                                : 'border: 1px solid white;'
                            "
                          >
                            <v-row>
                              <v-col cols="4" class="pr-1">
                                <v-img
                                  contain
                                  max-height="80"
                                  max-width="200"
                                  :src="item.packageImg"
                                ></v-img>
                              </v-col>
                              <v-col cols="8" class="pb-6">
                                <v-row class="font16 headline1">
                                  <v-col class="pl-0 pt-2 pb-0">{{
                                    item.packageName
                                  }}</v-col>
                                  <v-btn
                                    class="mr-4 mt-3"
                                    v-if="
                                      item.packageId !== packageId &&
                                        item.token !== tokenPackage
                                    "
                                    color="green"
                                    outlined
                                    rounded
                                    x-small
                                    @click="
                                      UpdatePackage(
                                        item.packageId,
                                        'ตกลง',
                                        item.packageName,
                                        item,
                                        item.token
                                      ),
                                        (jobCheckPackage = true)
                                    "
                                    >ตกลง</v-btn
                                  >
                                  <v-btn
                                    class="mr-4 mt-3"
                                    v-if="
                                      item.packageId === packageId &&
                                        item.token !== tokenPackage
                                    "
                                    color="green"
                                    outlined
                                    rounded
                                    x-small
                                    @click="
                                      UpdatePackage(
                                        item.packageId,
                                        'ตกลง',
                                        item.packageName,
                                        item,
                                        item.token
                                      ),
                                        (jobCheckPackage = true)
                                    "
                                    >ตกลง</v-btn
                                  >
                                  <v-btn
                                    class="mr-4 mt-3"
                                    v-if="
                                      item.packageId === packageId &&
                                        item.token === tokenPackage
                                    "
                                    color="red"
                                    outlined
                                    rounded
                                    x-small
                                    @click="
                                      UpdatePackage(
                                        item.packageId,
                                        'ยกเลิก',
                                        item.packageName,
                                        item,
                                        item.token
                                      ),
                                        (jobCheckPackage = false)
                                    "
                                    >ยกเลิก</v-btn
                                  >
                                </v-row>
                                <v-row class="font14 headline1">
                                  <v-col class="pl-0 pt-0 pb-0"
                                    >จำนวนการใช้ {{ item.balanceAmount }} /
                                    {{ item.amount }}
                                  </v-col>
                                </v-row>
                                <v-row class="font14 headline1">
                                  <v-col class="pl-0 pt-0 pb-0">
                                    <VueCustomTooltip
                                      label="สามารถใช้ได้"
                                      position="is-top"
                                      v-if="dateTimestamp <= item.expirePackage"
                                    >
                                      <v-icon large color="teal darken-2">
                                        mdi-clock-check
                                      </v-icon>
                                    </VueCustomTooltip>
                                    <VueCustomTooltip
                                      label="หมดอายุแล้ว"
                                      position="is-top"
                                      v-if="dateTimestamp > item.expirePackage"
                                    >
                                      <v-icon large color="red darken-2">
                                        mdi-clock-alert
                                      </v-icon>
                                    </VueCustomTooltip>
                                    >> วันหมดอายุ
                                    {{
                                      new Date(item.expirePackage * 1000)
                                        .toLocaleString()
                                        .substr(0, 9)
                                    }}
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-slide-item>
                      </v-slide-group>
                    </v-card>
                    <br />
                  </v-col>
                  <v-col
                    class="pb-0 pt-0"
                    cols="12"
                    v-if="
                      dataPackage.filter(el => {
                        return el.balanceAmount > 0;
                      }).length > 0 && dataPackageDefault === true
                    "
                  >
                    <v-card class="pl-1">
                      <v-subheader
                        >ลูกค้ามี
                        {{
                          dataPackage.filter(el => {
                            return el.balanceAmount > 0;
                          }).length
                        }}
                        แพ็คเกจ</v-subheader
                      >
                      <v-subheader v-show="StatusPackage.packageName"
                        >ลูกค้าได้ทำการเลือกแพ็คเกจ
                        {{ StatusPackage.packageName }}</v-subheader
                      >
                      <v-slide-group
                        v-model="modelPackageIndexConfirmJob"
                        center-active
                        show-arrows
                      >
                        <v-slide-item
                          v-for="(item, index) in dataPackage.filter(el => {
                            return el.balanceAmount > 0;
                          })"
                          :key="index"
                        >
                          <v-card
                            class="ma-2 p-1"
                            width="340"
                            height="100"
                            color="#FFFFFF"
                            elevation="6"
                            :style="
                              item.packageId === packageId &&
                              item.token === tokenPackage
                                ? 'border: 1px solid green;'
                                : 'border: 1px solid white;'
                            "
                          >
                            <v-row>
                              <v-col cols="4" class="pr-1">
                                <v-img
                                  contain
                                  max-height="80"
                                  max-width="200"
                                  :src="item.packageImg"
                                ></v-img>
                              </v-col>
                              <v-col cols="8" class="pb-6">
                                <v-row class="font16 headline1">
                                  <v-col class="pl-0 pt-2 pb-0">{{
                                    item.packageName
                                  }}</v-col>
                                  <!-- <v-btn class="mr-4 mt-3" v-if="item.packageId !== packageId" color="green" outlined rounded x-small @click="UpdatePackage(item.packageId,'ตกลง',item.packageName, item)">ตกลง</v-btn>
                                    <v-btn class="mr-4 mt-3" v-if="item.packageId === packageId" color="red" outlined rounded x-small @click="UpdatePackage(item.packageId,'ยกเลิก',item.packageName, item)">ยกเลิก</v-btn> -->
                                </v-row>
                                <v-row class="font14 headline1">
                                  <v-col class="pl-0 pt-0 pb-0"
                                    >จำนวนการใช้ {{ item.balanceAmount }} /
                                    {{ item.amount }}
                                  </v-col>
                                </v-row>
                                <v-row class="font14 headline1">
                                  <v-col class="pl-0 pt-0 pb-0">
                                    <VueCustomTooltip
                                      label="สามารถใช้ได้"
                                      position="is-top"
                                      v-if="dateTimestamp <= item.expirePackage"
                                    >
                                      <v-icon large color="teal darken-2">
                                        mdi-clock-check
                                      </v-icon>
                                    </VueCustomTooltip>
                                    <VueCustomTooltip
                                      label="หมดอายุแล้ว"
                                      position="is-top"
                                      v-if="dateTimestamp > item.expirePackage"
                                    >
                                      <v-icon large color="red darken-2">
                                        mdi-clock-alert
                                      </v-icon>
                                    </VueCustomTooltip>
                                    >> วันหมดอายุ
                                    {{
                                      new Date(item.expirePackage * 1000)
                                        .toLocaleString()
                                        .substr(0, 9)
                                    }}
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-slide-item>
                      </v-slide-group>
                    </v-card>
                    <br />
                  </v-col>
                  <v-col
                    v-for="(item, indexitem) in BookingDataItem"
                    :key="indexitem"
                    cols="12"
                    class="pa-0"
                  >
                    <v-text-field
                      v-if="item.fieldType === 'Checkbox'"
                      :label="item.fieldName"
                      :value="parseCheckboxValue(item.fieldValue).join(',')"
                      class="pa-0"
                      outlined
                      dense
                      readonly
                    ></v-text-field>
                    <v-text-field
                      v-else
                      :label="item.fieldName"
                      :value="item.fieldValue"
                      class="pa-0"
                      outlined
                      dense
                      readonly
                    ></v-text-field>
                    <!-- {{item.fieldName}} : {{item.fieldValue}} -->
                  </v-col>
                  <v-form
                    ref="form_update"
                    v-model="validUpdate"
                    lazy-validation
                  >
                    <div v-for="(p, index) in flowfieldNameitem" :key="index">
                      <div class="pa-0" v-if="p.conditionField === ''">
                        <div>
                          <div v-if="p.fieldType == 'text'">
                            <br />
                            <v-text-field
                              v-if="p.fieldName === 'เบอร์โทร'"
                              v-mask="'###-###-####'"
                              v-model="p.fieldValue"
                              :label="p.fieldName"
                              dense
                              :rules="
                                p.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                              outlined
                            ></v-text-field>
                            <v-text-field
                              v-else
                              v-model="p.fieldValue"
                              :label="p.fieldName"
                              dense
                              :rules="
                                p.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                              outlined
                            ></v-text-field>
                          </div>
                          <div v-if="p.fieldType == 'number'">
                            <br />
                            <!-- <p>{{p.fieldName}}</p> -->
                            <v-text-field
                              v-if="p.fieldName === 'เบอร์โทร'"
                              v-mask="'###-###-####'"
                              v-model="p.fieldValue"
                              :label="p.fieldName"
                              dense
                              :rules="
                                p.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                              outlined
                            ></v-text-field>
                            <v-text-field
                              v-else
                              v-model="p.fieldValue"
                              :label="p.fieldName"
                              dense
                              :rules="
                                p.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                              outlined
                            ></v-text-field>
                          </div>
                          <v-row>
                            <v-col
                              cols="12"
                              v-if="p.fieldType == 'Autocompletes'"
                              style="padding-top: 0px;padding-bottom: 0px;"
                            >
                              <br />
                              <v-autocomplete
                                v-model="p.fieldValue"
                                :items="JSON.parse(p.optionField)"
                                dense
                                filled
                                :label="p.fieldName"
                                :rules="
                                  p.requiredField === 'True'
                                    ? [rules.required]
                                    : [true]
                                "
                              ></v-autocomplete>
                            </v-col>
                            <v-col
                              cols="12"
                              v-if="p.fieldType == 'Selects'"
                              style="padding-top: 0px;padding-bottom: 0px;"
                            >
                              <br />
                              <div>
                                <v-select
                                  v-model="p.fieldValue"
                                  :items="JSON.parse(p.optionField)"
                                  menu-props="auto"
                                  :label="p.fieldName"
                                  hide-details
                                  outlined
                                  dense
                                  :rules="
                                    p.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                ></v-select>
                              </div>
                            </v-col>
                          </v-row>
                          <div
                            v-if="p.fieldType == 'Radio'"
                            style="padding:0px;"
                          >
                            <br />
                            <v-container fluid style="padding:0px;">
                              <v-radio-group
                                row
                                v-model="p.fieldValue"
                                style="margin:0px;"
                                :rules="
                                  p.requiredField === 'True'
                                    ? [rules.required]
                                    : [true]
                                "
                              >
                                <template v-slot:label> </template>
                                <div
                                  v-for="radios in JSON.parse(p.optionField)"
                                  :key="radios.toISOString"
                                  class="text-center"
                                >
                                  <v-radio
                                    :label="radios.text"
                                    dense
                                    :value="radios.value"
                                  ></v-radio>
                                </div>
                              </v-radio-group>
                            </v-container>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="
                          p.conditionField !== '' &&
                            flowfieldNameitem.filter(row => {
                              return row.fieldId === parseInt(p.conditionField);
                            }).length > 0
                        "
                      >
                        <div
                          v-if="
                            p.conditionValue ===
                              flowfieldNameitem.filter(row => {
                                return (
                                  row.fieldId === parseInt(p.conditionField)
                                );
                              })[0].fieldValue
                          "
                        >
                          <div cols="12" v-if="p.fieldType == 'Autocompletes'">
                            <v-autocomplete
                              v-model="p.fieldValue"
                              :items="JSON.parse(p.optionField)"
                              dense
                              filled
                              :label="p.fieldName"
                              :rules="
                                p.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                            ></v-autocomplete>
                          </div>
                          <div v-if="p.fieldType == 'Selects'">
                            <v-select
                              v-model="p.fieldValue"
                              :items="JSON.parse(p.optionField)"
                              menu-props="auto"
                              :label="p.fieldName"
                              dense
                              hide-details
                              outlined
                              :rules="
                                p.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                            ></v-select>
                          </div>
                          <div
                            v-if="p.fieldType === 'Radio'"
                            style="padding:0px;"
                          >
                            <br />
                            <v-container fluid style="padding:0px;">
                              <v-radio-group
                                row
                                v-model="p.fieldValue"
                                style="margin:0px;"
                                :rules="
                                  p.requiredField === 'True'
                                    ? [rules.required]
                                    : [true]
                                "
                              >
                                <template v-slot:label> </template>
                                <div
                                  v-for="radios in JSON.parse(p.optionField)"
                                  :key="radios.toISOString"
                                  class="text-center"
                                >
                                  <v-radio
                                    :label="radios.text"
                                    dense
                                    :value="radios.value"
                                  ></v-radio>
                                </div>
                              </v-radio-group>
                            </v-container>
                          </div>
                        </div>
                      </div>
                      <div v-if="p.conditionField === 'flow'">
                        <div
                          v-if="
                            parseInt(p.conditionValue) ===
                              parseInt(formAdd.flowId)
                          "
                        >
                          <div v-if="p.fieldType == 'text'">
                            <br />
                            <v-text-field
                              v-if="p.fieldName === 'เบอร์โทร'"
                              v-mask="'###-###-####'"
                              v-model="p.fieldValue"
                              :label="p.fieldName"
                              dense
                              :rules="
                                p.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                              outlined
                            ></v-text-field>
                            <v-text-field
                              v-else
                              v-model="p.fieldValue"
                              :label="p.fieldName"
                              dense
                              :rules="
                                p.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                              outlined
                            ></v-text-field>
                          </div>
                          <div v-if="p.fieldType == 'number'">
                            <br />
                            <v-text-field
                              v-if="p.fieldName === 'เบอร์โทร'"
                              v-mask="'###-###-####'"
                              v-model="p.fieldValue"
                              :label="p.fieldName"
                              dense
                              :rules="
                                p.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                              outlined
                            ></v-text-field>
                            <v-text-field
                              v-else
                              v-model="p.fieldValue"
                              :label="p.fieldName"
                              dense
                              :rules="
                                p.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                              outlined
                            ></v-text-field>
                          </div>
                          <div cols="12" v-if="p.fieldType == 'Autocompletes'">
                            <v-autocomplete
                              v-model="p.fieldValue"
                              :items="JSON.parse(p.optionField)"
                              dense
                              filled
                              :label="p.fieldName"
                              :rules="
                                p.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                            ></v-autocomplete>
                          </div>
                          <div v-if="p.fieldType == 'Selects'">
                            <v-select
                              v-model="p.fieldValue"
                              :items="JSON.parse(p.optionField)"
                              menu-props="auto"
                              :label="p.fieldName"
                              dense
                              :rules="
                                p.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                              hide-details
                              outlined
                            ></v-select>
                          </div>
                          <div
                            v-if="p.fieldType === 'Radio'"
                            style="padding:0px;"
                          >
                            <br />
                            <v-container fluid style="padding:0px;">
                              <v-radio-group
                                row
                                v-model="p.fieldValue"
                                style="margin:0px;"
                                :rules="
                                  p.requiredField === 'True'
                                    ? [rules.required]
                                    : [true]
                                "
                              >
                                <template v-slot:label> </template>
                                <div
                                  v-for="radios in JSON.parse(p.optionField)"
                                  :key="radios.toISOString"
                                  class="text-center"
                                >
                                  <v-radio
                                    :label="radios.text"
                                    dense
                                    :value="radios.value"
                                  ></v-radio>
                                </div>
                              </v-radio-group>
                            </v-container>
                          </div>
                        </div>
                      </div>
                    </div>
                    <br />
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                        class="pb-0"
                        v-if="statusShowDateConfiremjob"
                      >
                        <v-menu
                          ref="menu"
                          v-model="menu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="endDate"
                              :label="$session.getAll().data.shopId == 'U85573a4fa01c1d9497dfd7dadd311079' ? 'วันที่นัดรับรถ' : 'วันที่คาดว่าจะเสร็จ'"
                              persistent-hint
                              dense
                              outlined
                              required
                              :rules="[rules.required]"
                              prepend-icon="mdi-calendar"
                              v-bind="attrs"
                              v-on="on"
                              readonly
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="endDate"
                            no-title
                            @input="menu = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>

                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                        class="pb-0"
                        v-if="statusShowDateConfiremjob"
                      >
                        <v-autocomplete
                          v-model="endTime"
                          :items="timeavailable"
                          label="เวลา"
                          item-text="text"
                          item-value="text"
                          persistent-hint
                          return-object
                          outlined
                          dense
                          required
                          :rules="[rules.required]"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="12" v-if="$session.getAll().data.shopId == shopNameData.yara">
                        <v-text-field
                          v-model="queueJobFixShop"
                          label="ระบุเลขคิว"
                          outlined
                          required
                          type="number"
                          :rules="[rules.required, rules.integer, rules.positive]"
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <v-autocomplete
                          v-if="
                            masBranchIDAddJob !== null &&
                              masBranchIDAddJob !== ''
                          "
                          v-model="empSelectJob"
                          :items="
                            empSelectStepAdd.filter(
                              i =>
                                i.masBranchID === masBranchIDAddJob ||
                                i.masBranchID === ''
                            )
                          "
                          label="พนักงานที่นำเข้ากระดานทำงาน"
                          menu-props="auto"
                          outlined
                          required
                          :rules="[rules.required]"
                          dense
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-form>
                  <div class="text-center">
                    <v-btn
                      elevation="2"
                      large
                      block
                      dark
                      color="#173053"
                      @click="addDataJob()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      นำเข้าตารางงาน
                    </v-btn>
                  </div>
                </v-container>
              </v-card-text>
              <v-card-text v-if="dataEditJobReady && !statusConfirmJob">
                <strong
                  ><h2>
                    เนื่องจากวันที่นัดหมาย {{ dueDate }} ไม่ตรงกับวันที่ปัจจุบัน
                  </h2></strong
                >
                <strong style="color: red;"
                  ><h3>
                    กรุณาตรวจสอบข้อมูล หรือ เปลี่ยนเวลานัดหมายใหม่
                  </h3></strong
                >
              </v-card-text>
              <v-card-text v-if="!dataEditJobReady">
                <v-container>
                  <div class="text-center">
                    <waitingAlert></waitingAlert>
                  </div>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end -->

          <v-dialog v-model="dialogJob" persistent :max-width="dialogwidth">
            <v-card
              style="background: linear-gradient(180deg, #FFFFFF 0%, #E1F3FF 100%);"
            >
              <v-container>
                <v-row>
                  <v-col cols="12" v-if="checkShowSelectUser">
                    <div class=" text-center">
                      <v-tabs
                        v-model="tabSelectUser"
                        background-color="#1B437C"
                        centered
                        dark
                        icons-and-text
                      >
                        <v-tabs-slider></v-tabs-slider>
                        <v-tab>
                          ลูกค้าที่นัดหมาย
                          <v-icon>mdi-card-account-phone</v-icon>
                        </v-tab>

                        <v-tab>
                          แสกน QR / Skip
                          <v-icon>mdi-qrcode-edit</v-icon>
                        </v-tab>

                        <v-tab-item
                          style="background: linear-gradient(180deg, #FFFFFF 0%, #E1F3FF 100%);"
                        >
                          <br />
                          <v-row justify="center" class="spacer" no-gutters>
                            <v-col cols="4" sm="2" md="1">
                              <v-avatar size="60px">
                                <img
                                  alt="Avatar"
                                  :src="dataSelectUser.picture"
                                />
                              </v-avatar>
                            </v-col>
                            <v-col cols="6" sm="4" md="2"
                              >คุณ {{ dataSelectUser.name }}</v-col
                            >
                          </v-row>
                          <v-row justify="center" class="spacer" no-gutters>
                            <v-col col="12"
                              ><strong>ลูกค้าที่นัดหมาย</strong></v-col
                            >
                          </v-row>
                        </v-tab-item>
                        <v-tab-item
                          style="background: linear-gradient(180deg, #FFFFFF 0%, #E1F3FF 100%);"
                        >
                          <br />
                          <div
                            v-if="jobitem.length > 0 && userId === ''"
                            class="avatar text-center"
                          >
                            <qrcode-vue
                              :value="value"
                              :size="size"
                              level="H"
                              :foreground="foreground"
                            />
                            <v-btn
                              color="#1B437C"
                              small
                              dark
                              @click="FunCopyQrcode(value)"
                            >
                              <v-icon left>mdi-content-copy</v-icon>
                              คัดลอกลิงค์
                            </v-btn>
                            <hr />
                            <v-btn
                              small
                              dark
                              color="#14AE5C"
                              @click="printQrcodeComfirmJob(value, jobitem)"
                              ><v-icon left>mdi-printer</v-icon>Print QR</v-btn
                            >
                          </div>
                        </v-tab-item>
                      </v-tabs>
                    </div>
                  </v-col>
                  <v-col cols="12" v-if="!checkShowSelectUser">
                    <div class=" text-center">
                      <br />
                      <br />
                      <h2 style="font-weight: 900; color:#FFA000">
                        ติดตามสถานะ!
                      </h2>
                      <qrcode-vue
                        v-if="userId === ''"
                        :value="value"
                        :size="size"
                        level="H"
                        :foreground="foreground"
                      />
                      <v-btn
                        v-if="userId === ''"
                        color="#1B437C"
                        small
                        dark
                        @click="FunCopyQrcode(value)"
                      >
                        <v-icon left>mdi-content-copy</v-icon>
                        คัดลอกลิงค์
                      </v-btn>
                      <div v-if="userId === ''">
                        <hr />
                        <v-btn
                          small
                          dark
                          color="#14AE5C"
                          @click="printQrcodeComfirmJob(value, jobitem)"
                          ><v-icon left>mdi-printer</v-icon>Print QR</v-btn
                        >
                      </div>
                      <template v-if="jobitem.length > 0">
                        <div v-if="userId !== ''" class="avatar text-center">
                          <v-avatar
                            v-if="memberPicture !== ''"
                            size="120"
                            style="border:5px solid #FFFFFF;"
                          >
                            <img :src="memberPicture" />
                          </v-avatar>
                          <v-avatar
                            v-if="
                              memberPicture === '' &&
                                userId === 'user-skip' &&
                                jobitem[0].recordStatus === 'D'
                            "
                            size="120"
                            style="border:5px solid #FFFFFF;"
                          >
                            <v-img
                              class="v_text_add"
                              :src="require('@/assets/OtherP.svg')"
                            ></v-img>
                          </v-avatar>
                          <!-- <p class="text-center">{{profile.displayName}}</p> -->
                        </div>
                      </template>
                      <div v-if="jobitem.length > 0" class="avatar text-center">
                        <qrcode-vue
                          v-if="
                            userId === 'user-skip' &&
                              jobitem[0].recordStatus === 'N'
                          "
                          :value="value"
                          :size="size"
                          level="H"
                          :foreground="foreground"
                        />
                        <v-btn
                          v-if="
                            userId === 'user-skip' &&
                              jobitem[0].recordStatus === 'N'
                          "
                          color="#1B437C"
                          small
                          dark
                          @click="FunCopyQrcode(value)"
                        >
                          <v-icon left>mdi-content-copy</v-icon>
                          คัดลอกลิงค์
                        </v-btn>
                        <div
                          v-if="
                            userId === 'user-skip' &&
                              jobitem[0].recordStatus === 'N'
                          "
                        >
                          <hr />
                          <v-btn
                            small
                            dark
                            color="#14AE5C"
                            @click="printQrcodeComfirmJob(value, jobitem)"
                            ><v-icon left>mdi-printer</v-icon>Print QR</v-btn
                          >
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
              <v-row>
                <v-col cols="12">
                  <v-container class="text-center">
                    <v-container>
                      <div v-for="(p, index) in jobitem" :key="index">
                        <h4>{{ p.name }} : {{ p.value }}</h4>
                        <!-- <h4 v-if="p.showCard === 'True' ">{{p.name}} : {{p.value}}</h4> -->
                      </div>
                      <div v-if="jobitem.length > 0">
                        <!-- <v-btn small class="ma-2" color="teal" v-if="jobitem[0].recordStatus === 'D'" @click="setBookingAgain()" dark>
                                  นัดหมายอีกครั้ง
                                <v-icon dark right>
                                  mdi-notebook-check
                                </v-icon>
                              </v-btn> -->
                        <strong
                          style="color: red;"
                          v-if="jobitem[0].recordStatus === 'D'"
                          ><h2>รายการนี้ปิดไปแล้ว</h2></strong
                        >
                      </div>
                      <div>
                        <v-btn
                          v-if="userId !== ''"
                          color="#1B437C"
                          small
                          dark
                          @click="FunCopyQrcode(value)"
                        >
                          <v-icon left>mdi-content-copy</v-icon>
                          คัดลอกลิงค์
                        </v-btn>
                        <v-btn
                          small
                          class="ma-2"
                          color="success"
                          v-if="userId !== '' && recordStatusJob === 'N'"
                          @click="(dialogCloseJob = true), setCloseJob(jobitem)"
                          dark
                        >
                          ปิดงานนี้
                          <v-icon dark right>
                            mdi-cash-usd-outline
                          </v-icon>
                        </v-btn>
                      </div>
                    </v-container>
                    <template v-if="!checkShowSelectUser">
                      <v-btn
                        small
                        class="ma-2"
                        color="success"
                        v-if="userId === ''"
                        @click="pushMsgSelectUser"
                        dark
                      >
                        ส่ง QR Code
                        <v-icon dark right>
                          mdi-checkbox-marked-circle
                        </v-icon>
                      </v-btn>
                      <v-btn
                        small
                        class="ma-2"
                        color="primary"
                        v-if="userId === ''"
                        @click="jobConfirm"
                        dark
                      >
                        SKIP
                        <v-icon dark right>
                          mdi-checkbox-marked-circle
                        </v-icon>
                      </v-btn>
                      <v-btn
                        small
                        class="ma-2"
                        color="error"
                        @click="dialogJob = false"
                        dark
                      >
                        Close
                        <v-icon dark right>
                          mdi-minus-circle
                        </v-icon>
                      </v-btn>
                    </template>
                    <template v-if="checkShowSelectUser">
                      <v-btn
                        small
                        class="ma-2"
                        color="success"
                        v-if="userId === '' && tabSelectUser === 1"
                        @click="pushMsgSelectUser"
                        dark
                      >
                        ส่ง QR Code
                        <v-icon dark right>
                          mdi-checkbox-marked-circle
                        </v-icon>
                      </v-btn>
                      <v-btn
                        small
                        class="ma-2"
                        color="primary"
                        v-if="userId === '' && tabSelectUser === 1"
                        @click="jobConfirm"
                        dark
                      >
                        SKIP
                        <v-icon dark right>
                          mdi-checkbox-marked-circle
                        </v-icon>
                      </v-btn>
                      <v-btn
                        small
                        class="ma-2"
                        color="primary"
                        v-if="tabSelectUser === 0 || tabSelectUser === null"
                        @click="jobConfirmUser"
                        dark
                      >
                        ลูกค้าท่านเดียวกับที่นัดหมาย
                        <v-icon dark right>
                          mdi-checkbox-marked-circle
                        </v-icon>
                      </v-btn>
                      <v-btn
                        small
                        class="ma-2"
                        color="error"
                        @click="dialogJob = false"
                        dark
                      >
                        Close
                        <v-icon dark right>
                          mdi-minus-circle
                        </v-icon>
                      </v-btn>
                    </template>
                  </v-container>
                </v-col>
              </v-row>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogChange" persistent :max-width="dialogwidth">
            <v-card class="text-center">
              <v-form ref="form_change" v-model="validChange" lazy-validation>
                <v-card-text v-if="dataChangeReady">
                  <v-container>
                    <v-row>
                      <v-col cols="6" class="text-left pt-10">
                        <h3><strong>เปลี่ยนเวลานัดหมาย</strong></h3>
                      </v-col>
                      <v-col cols="6" class="pt-10">
                        <div style="text-align: end;">
                          <v-btn
                            class="mx-2"
                            fab
                            small
                            dark
                            color="white"
                            :style="styleCloseBt"
                            @click="dialogChange = false"
                          >
                            X
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-textarea
                          v-model="remark"
                          outlined
                          v-if="checkSelectText === 'confirm'"
                          label="หมายเหตุเพิ่มเติม"
                          auto-grow
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6" lg="6">
                        <v-menu
                          v-model="menuDateChange"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="formChange.date"
                              label="วันที่นัดหมาย"
                              prepend-icon="mdi-calendar"
                              readonly
                              outlined
                              dense
                              v-bind="attrs"
                              v-on="on"
                              required
                              :rules="[rules.required]"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="formChange.date"
                            :picker-date.sync="pickerDateChang"
                            :allowed-dates="allowedDatesChange"
                            @input="
                              (menuDateChange = false),
                                setLimitBookingChange(formChange.date)
                            "
                            :min="
                              new Date(
                                Date.now() -
                                  new Date().getTimezoneOffset() * 60000
                              )
                                .toISOString()
                                .substr(0, 10)
                            "
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                        lg="6"
                        v-if="timeavailable.length > 0"
                      >
                        <v-autocomplete
                          v-model="formChange.time"
                          :items="timeavailable"
                          label="เวลา"
                          item-text="text"
                          item-value="text"
                          persistent-hint
                          return-object
                          outlined
                          dense
                          required
                          @change="setCountTime(dataChange)"
                          :rules="[rules.required]"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        v-if="
                          checkSelectText !== 'cancel' &&
                            checkSelectText !== 'confirmJob' &&
                            $session.getAll().data.shopId !== shopNameData.officeOmbudsman
                        "
                      >
                        <v-btn
                          elevation="2"
                          color="green darken-1"
                          dark
                          large
                          block
                          :disabled="!validChange"
                          @click="changeChk(dataChange, 'confirm')"
                          >เปลี่ยนวันเวลานัดหมาย (ยืนยัน)</v-btn
                        >
                      </v-col>
                      <v-col v-if="checkSelectText !== 'confirm'">
                        <v-btn
                          elevation="2"
                          color="#173053"
                          dark
                          large
                          block
                          :disabled="!validChange"
                          @click="changeChk(dataChange, 'change')"
                          >เปลี่ยนวันเวลานัดหมาย</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <div class="text-center" v-if="!dataChangeReady">
                  <waitingAlert></waitingAlert>
                </div>
                <br />
              </v-form>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogInfo" :max-width="dialogwidth">
            <v-card class="text-center">
              <v-card-title><b>รายละเอียดนัดหมาย</b></v-card-title>
              <v-card-text v-if="dataInfo">
                <v-row>
                  <v-col class="text-right">ประเภทบริการ</v-col>
                  <v-col class="text-left">{{ dataInfo.flowName }}</v-col>
                </v-row>
                <v-row>
                  <v-col class="text-right">วันที่ต้องการเข้ารับบริการ</v-col>
                  <v-col class="text-left">{{ dataInfo.dueDate }}</v-col>
                </v-row>
                <v-row
                  v-for="(row, index) in BookingDataItem"
                  v-bind:key="index"
                >
                  <v-col class="text-right">{{ row.fieldName }}</v-col>
                  <v-col class="text-left">{{ row.fieldValue }}</v-col> </v-row
                ><br />
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogRemove" :max-width="dialogwidth">
            <v-card class="text-center">
              <v-form ref="form_remove" v-model="validRemove" lazy-validation>
                <v-container>
                  <v-card-text v-if="dataCancelReady">
                    <v-row>
                      <v-col cols="6" class="text-left pt-10">
                        <h3><strong>ยกเลิกรายการนี้</strong></h3>
                      </v-col>
                      <v-col cols="6" class="pt-10">
                        <div style="text-align: end;">
                          <v-btn
                            class="mx-2"
                            fab
                            small
                            dark
                            color="white"
                            :style="styleCloseBt"
                            @click="
                              (dialogRemove = false), (sendRemarkRemove = false)
                            "
                          >
                            X
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-checkbox
                          v-model="sendRemarkRemove"
                          label="แจ้งเตือนหมายเหตุในการยกเลิก"
                        ></v-checkbox>
                        <v-textarea
                          v-model="remarkRemove"
                          outlined
                          label="หมายเหตุในการยกเลิก"
                          auto-grow
                          required
                          dense
                          :rules="[rules.required]"
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12" class="pt-0">
                        <v-autocomplete
                          v-model="empSelect"
                          :items="empSelectStep"
                          label="พนักงานที่รับนัดหมาย"
                          outlined
                          dense
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <div class="text-center">
                      <v-btn
                        elevation="2"
                        color="#173053"
                        dark
                        large
                        block
                        @click="cancelChk()"
                        >ยกเลิกรายการนี้</v-btn
                      >
                    </div>
                  </v-card-text>
                  <div class="text-center" v-if="!dataCancelReady">
                    <waitingAlert></waitingAlert>
                  </div>
                </v-container>
              </v-form>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogRemarkReturn" :max-width="dialogwidth">
            <v-card class="text-center">
              <v-card-title>
                หมายเหตุเรียกกลับ
              </v-card-title>
              <!-- <v-form ref="form_remove" v-model="validRemove" lazy-validation> -->
              <v-container>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" class="pb-0">
                      <v-menu
                        ref="menuReturn"
                        v-model="menuReturn"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="dateReturn"
                            label="วันที่เรียกลูกค้ากลับมา"
                            persistent-hint
                            dense
                            outlined
                            prepend-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                            readonly
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="dateReturn"
                          no-title
                          @input="menuReturn = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        v-model="remarkReturn"
                        outlined
                        label="หมายเหตุเรียกกลับ"
                        auto-grow
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <div class="text-center">
                    <v-btn
                      elevation="10"
                      color="#173053"
                      dark
                      small
                      @click="onSaveRemarkReturn()"
                      >อัพเดทหมายเหตุ</v-btn
                    >
                    <v-btn
                      elevation="10"
                      color="#173053"
                      outlined
                      style="background-color:#FFFFFF"
                      small
                      @click="dialogRemarkReturn = false"
                      >ยกเลิก</v-btn
                    >
                  </div>
                </v-card-text>
              </v-container>
              <!-- </v-form> -->
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogRemark" :max-width="dialogwidth">
            <v-card class="text-center">
              <v-container>
                <v-card-text>
                  <v-row>
                    <v-col cols="6" class="text-left pt-10">
                      <h3><strong>หมายเหตุเพิ่มเติม</strong></h3>
                    </v-col>
                    <v-col cols="6" class="pt-10">
                      <div style="text-align: end;">
                        <v-btn
                          class="mx-2"
                          fab
                          small
                          dark
                          color="white"
                          :style="styleCloseBt"
                          @click="dialogRemark = false"
                        >
                          X
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea
                        v-model="remark"
                        outlined
                        label="หมายเหตุเพิ่มเติม"
                        auto-grow
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <div class="text-center">
                    <v-btn
                      elevation="10"
                      color="#173053"
                      dark
                      large
                      block
                      @click="onSaveRemark()"
                      >บันทึก</v-btn
                    >
                  </div>
                </v-card-text>
              </v-container>
              <!-- </v-form> -->
            </v-card>
          </v-dialog>
          <!-- data table -->
          <v-col cols="12">
            <BookingQueue
              :branchParent="branch"
              :masBranchIDParent="masBranchID"
              :drawerParent="drawer"
              :menu1Parent="menu1"
              :timeTableParent="timeTable"
              :rulesParent="rules"
              :masterTimeParent="masterTime"
              :dataItemTimesChangeParent="dataItemTimesChange"
              :getTimesChangeParent="getTimesChange"
              :exportExcelParent="exportExcel"
              :exportExcelMazdaParent="exportExcelMazda"
              :dataRemoveExportParent="dataRemoveExport"
              :exportExcelRemoveParent="exportExcelRemove"
              :toggleParent="toggle"
              @updateTimeTable="updateTimeTablefromChild"
            ></BookingQueue>
            <v-card elevation="0" v-if="dataReady">
              <v-card-text>
                <v-row>
                  <v-col col="auto">
                    <v-expansion-panels
                      dense
                      accordion
                      v-if="resCol === 'xs'"
                      style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;margin-bottom: 10px;"
                    >
                      <v-expansion-panel>
                        <v-expansion-panel-header
                          >รายการตรวจสอบ</v-expansion-panel-header
                        >
                        <v-expansion-panel-content>
                          <v-btn
                            v-if="dataItem.length > 0"
                            color="blue-grey"
                            class="ma-2 white--text"
                            @click="toggle"
                            small
                          >
                            ตรวจสอบคิวจองรายวัน
                            <v-icon right dark>
                              mdi-table-eye
                            </v-icon>
                          </v-btn>
                          <v-btn
                            color="blue-grey"
                            class="ma-2 white--text"
                            small
                            @click="addDataSet()"
                          >
                            ตรวจสอบคิวจองรายเดือน
                          </v-btn>
                          <v-btn
                            v-if="DataFlowNameMenu.length > 0"
                            color="blue-grey"
                            class="ma-2 white--text"
                            small
                            @click="
                              (dialogShowMenuReport = true),
                                (dataShowMenuReport = []),
                                (dateStartShowMenuReport = '')
                            "
                          >
                            ตรวจสอบรายการเมนูรายวัน
                          </v-btn>
                          <v-btn
                            v-if="getSelectText === 'wait' && filteredSelect.length > 0 && $session.getAll().data.shopId !== 'Uc520945108b983b6e739ed0a8cd8dae4'"
                            color="primary"
                            class="ma-2 white--text"
                            small
                            @click="exportExcelWait()"
                          >
                            <v-icon right dark>mdi-microsoft-excel</v-icon>
                            &nbsp;Export Excel
                          </v-btn>
                          <!-- custom ร้านปุ๋ยยาลา url get flow -->
                          <v-btn
                            v-if="getSelectText === 'confirmJob' && filteredSelect.length > 0 && $session.getAll().data.shopId == shopNameData.yara"
                            color="primary"
                            class="ma-2 white--text"
                            small
                            @click="exportConfirmJob()"
                          >
                            <v-icon right dark>mdi-microsoft-excel</v-icon>
                            &nbsp;Export Excel
                          </v-btn>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                    <template v-else>
                      <v-btn
                        v-if="dataItem.length > 0"
                        color="blue-grey"
                        class="ma-2 white--text"
                        @click="toggle"
                        small
                      >
                        ตรวจสอบคิวจองรายวัน
                        <v-icon right dark>
                          mdi-table-eye
                        </v-icon>
                      </v-btn>
                      <v-btn
                        color="blue-grey"
                        class="ma-2 white--text"
                        small
                        @click="addDataSet()"
                      >
                        ตรวจสอบคิวจองรายเดือน
                      </v-btn>
                      <v-btn
                        v-if="DataFlowNameMenu.length > 0"
                        color="blue-grey"
                        class="ma-2 white--text"
                        small
                        @click="
                          (dialogShowMenuReport = true),
                            (dataShowMenuReport = []),
                            (getBookingShowMenuList())
                        "
                      >
                        ตรวจสอบรายการเมนูรายวัน
                      </v-btn>
                      <v-btn
                        v-if="
                          getSelectText === 'wait' &&
                            filteredSelect.length > 0 &&
                            $session.getAll().data.shopId !==
                              'Uc520945108b983b6e739ed0a8cd8dae4'
                        "
                        color="primary"
                        class="ma-2 white--text"
                        small
                        @click="exportExcelWait()"
                      >
                        <v-icon right dark>mdi-microsoft-excel</v-icon>
                        &nbsp;Export Excel
                      </v-btn>
                      <v-btn
                            v-if="getSelectText === 'confirmJob' && filteredSelect.length > 0 && $session.getAll().data.shopId == shopNameData.yara"
                            color="primary"
                            class="ma-2 white--text"
                            small
                            @click="exportConfirmJob()"
                          >
                            <v-icon right dark>mdi-microsoft-excel</v-icon>
                            &nbsp;Export Excel
                          </v-btn>
                    </template>
                  </v-col>
                  <v-col :cols="resCol === 'xs' ? '12' : '3'">
                    <v-select
                      style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;margin-bottom: 5px;"
                      v-model="sortSelect"
                      hide-details
                      background-color="white"
                      :items="
                        getSelectText === 'wait' ? itemsSortWaiting : itemsSort
                      "
                      label="จัดเรียงข้อมูล"
                      outlined
                      dense
                      @change="checkTypeSort(sortSelect)"
                    ></v-select>
                    <v-radio-group v-model="sort" row @change="checkTypeSort()">
                      <v-radio
                        label="มากไปน้อย"
                        value="มากไปน้อย"
                        hide-details
                      ></v-radio>
                      <v-radio
                        label="น้อยไปมาก"
                        value="น้อยไปมาก"
                        hide-details
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                  <!-- <v-col>
                  <v-row>
                    <v-checkbox
                    v-model="ex4"
                    label="มาก"
                    value="red"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="ex4"
                    label="น้อย"
                    value="red"
                    hide-details
                  ></v-checkbox>
                  </v-row>
                </v-col> -->
                  <v-col class="text-right" cols="auto">
                    <template v-if="getSelectText === 'confirmJob'">
                      <v-select
                        v-model="filterCloseJobValue"
                        background-color="white"
                        style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;margin-bottom: 10px;"
                        hide-details
                        :items="listFilterCloseJob"
                        label="สถานะบริการ"
                        outlined
                        dense
                        required
                        @change="
                          getSelect('confirmJob', countJob, filterCloseJobValue)
                        "
                      >
                        <template #prepend-inner>
                          <v-icon
                            class="mr-2 iconify"
                            data-icon="eos-icons:cronjob"
                            color="#69D1FD"
                            style="background-color: #E0F4FF;padding: 4px;border-radius: 50px;margin-top: -1px;margin-right: 3px;margin-bottom: 3px;"
                          >
                          </v-icon>
                        </template>
                      </v-select>
                    </template>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-title>
                <!-- <v-text-field
                  v-model="searchAll2"
                  prepend-icon="mdi-magnify"
                  label="ค้นหาชื่อ และ เบอร์โทรศัพท์"
                  single-line
                  dense
                  hide-details
                ></v-text-field> -->
                <!-- <v-menu
                  v-model="menuDateSearch"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filters"
                      label="ค้นหาจากวันที่นัดหมาย"
                      prepend-icon="mdi-calendar"
                      readonly
                      outlined
                      class="pa-4"
                      append-icon="mdi-magnify"
                      dense
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filters"
                    @input="menuDateSearch = false"
                  ></v-date-picker>
                </v-menu>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="red"
                      fab
                      class="mb-7"
                      dark
                      small
                      @click.stop="filters=''"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon> mdi-calendar-remove </v-icon>
                    </v-btn>
                  </template>
                  <span>เคลียร์ ค้นหาจากวันที่นัดหมาย</span>
                </v-tooltip> -->
                <!-- <v-icon color="#64DD17" small @click="filters=''">call</v-icon> -->
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  v-if="!selectedStatus"
                  :search="searchAll2"
                  :items-per-page="-1"
                >
                  <template v-slot:[`item.cusName`]="{ item }">
                    <a @click.stop="openInfo(item)" style="cursor:hand"
                      ><u>{{ item.cusName }}</u></a
                    >
                  </template>
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_dateNotime(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_dateNotime(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.dueDate`]="{ item }">
                    {{ format_date(item.dueDate) }}
                  </template>
                  <template v-slot:[`item.action2`]="{ item }">
                    <v-row>
                      <v-col>
                        <v-chip
                          filter
                          dark
                          v-if="
                            item.statusBt === 'confirm' ||
                              item.statusBt === 'confirmJob'
                          "
                          :color="
                            item.remarkConfirm1
                              ? 'green darken-2'
                              : 'grey darken-1'
                          "
                          v-model="item.remarkConfirm1"
                          @click.stop="
                            item.remarkConfirm1 = !item.remarkConfirm1;
                            confirmRemark(item, 'inAdvance');
                          "
                        >
                          1 วัน
                        </v-chip>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-slot:[`item.action3`]="{ item }">
                    <v-row>
                      <v-col>
                        <v-chip
                          filter
                          dark
                          :color="
                            item.fastTrack ? 'green darken-2' : 'grey darken-1'
                          "
                          v-model="item.fastTrack"
                          @click.stop="
                            item.fastTrack = !item.fastTrack;
                            confirmRemark(item, 'fastTrack');
                          "
                        >
                          {{ dataTypeJob3 }}
                        </v-chip>
                      </v-col>
                      <v-col>
                        <v-chip
                          filter
                          dark
                          :color="
                            item.extraJob ? 'green darken-2' : 'grey darken-1'
                          "
                          v-model="item.extraJob"
                          @click.stop="
                            item.extraJob = !item.extraJob;
                            confirmRemark(item, 'extraJob');
                          "
                        >
                          {{ dataTypeJob2 }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <!-- confirm -->
                    <v-btn
                      color="success"
                      fab
                      id="v-step-2"
                      v-if="item.statusBt !== 'confirmJob'"
                      :disabled="item.chkConfirm"
                      small
                      @click.stop="confirmChk(item)"
                    >
                      <v-icon dark> mdi-phone-check </v-icon>
                    </v-btn>
                    <v-btn
                      color="error"
                      fab
                      id="v-step-2"
                      v-if="item.statusBt !== 'confirmJob'"
                      small
                      :disabled="item.chkCancel"
                      @click.stop="setDataRemove(item)"
                      title="ยกเลิกนัด"
                    >
                      <v-icon dark> mdi-phone-cancel </v-icon>
                    </v-btn>
                    <v-tooltip bottom v-if="item.statusBt !== 'confirmJob'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-badge
                          avatar
                          bordered
                          overlap
                          :content="item.countChangeTime"
                          color="warning"
                          class="mr-1"
                          style="cursor: pointer"
                        >
                          <v-btn
                            color="warning"
                            fab
                            small
                            @click.stop="setDataChang(item)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon> mdi-calendar-clock </v-icon>
                          </v-btn>
                        </v-badge>
                      </template>
                      <span>เปลี่ยนเวลานัดหมาย</span>
                    </v-tooltip>

                    <v-btn
                      color="primary"
                      fab
                      v-if="item.statusBt === 'confirm'"
                      small
                      @click.stop="
                        (dialogEdit = true),
                          getBookingData(item),
                          checkTimeFlow(item)
                      "
                    >
                      <v-icon dark> mdi-account-plus </v-icon>
                    </v-btn>
                    <v-btn
                      color="red"
                      dark
                      v-if="
                        item.statusBt === 'confirmJob' ||
                          item.statusBt === 'cancel'
                      "
                      fab
                      small
                      @click.stop="(dialogDelete = true), getDataById(item)"
                    >
                      <v-icon> mdi-delete </v-icon>
                    </v-btn>
                    <v-btn
                      color="info"
                      dark
                      v-if="item.statusBt === 'confirmJob'"
                      fab
                      small
                      @click.stop="(dialogJob = true), getjob(item)"
                    >
                      <v-icon> mdi-qrcode-scan </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
                <v-data-table
                  :headers="columnsSelected"
                  :items="filteredSelect"
                  v-if="selectedStatus"
                  :search="searchAll2"
                  min-height="400px"
                  :items-per-page="$session.getAll().data.shopId === 'U9f316c85400fd716ea8c80d7cd5b61f8' ? -1 : 30"
                  :item-class="getRowClass"
                >
                  <!-- :item-class= "getColor" -->
                  <!-- <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_dateNotime(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_dateNotime(item.LAST_DATE) }}
                  </template> -->
                  <template v-slot:[`item.dueDate`]="{ item }">
                    <div>
                      <div>
                        {{
                          item.dueDate.split(" ")[0].split("-")[2] +
                            "/" +
                            item.dueDate.split(" ")[0].split("-")[1] +
                            "/" +
                            item.dueDate.split(" ")[0].split("-")[0]
                        }}
                      </div>
                      <div>{{ item.dueDate.split(" ")[1] }} น.</div>
                    </div>
                  </template>
                  <template v-slot:[`item.cusName`]="{ item }">
                    <v-row>
                      <v-col cols="12">
                        <v-row>
                          <v-col
                            col="auto"
                            class="text-ceter"
                            v-if="
                              item.userId === 'user-skip' ||
                                item.userId === '' ||
                                item.userId === null
                            "
                          >
                            {{ item.cusName }}
                          </v-col>
                          <template v-else>
                            <v-col col="auto" class="text-ceter">
                              <a
                                @click.stop="openHistory(item)"
                                style="cursor:hand"
                                ><u>{{ item.cusName }}</u></a
                              >
                            </v-col>
                            <!-- <v-col col="auto" class="text-left">
                              <v-btn
                                fab
                                dark
                                v-if="item.memberId !== ''"
                                x-small
                                color="teal"
                                @click="getTagData(), dialogTag = true, tagData = item.memberDataTag, bookNo = item.bookNo, memberId = item.memberId"
                              >
                                <v-icon dark>
                                  mdi-tag-plus
                                </v-icon>
                              </v-btn>
                            </v-col> -->
                          </template>
                        </v-row>
                      </v-col>
                      <!-- <v-col cols="12" class="pt-0"  v-if="item.memberDataTag.length > 0">
                        <v-chip-group
                          active-class="primary--text"
                          column
                        >
                          <v-chip
                            text-color="white" color="cyan"
                            v-for="(item , index) in item.tagDataShow" :key="index"
                          >
                            <v-avatar left>
                              <v-icon>mdi-tag-multiple</v-icon>
                            </v-avatar>
                            {{ item.text }}
                          </v-chip>
                        </v-chip-group>
                      </v-col> -->
                    </v-row>
                  </template>
                  <template v-slot:[`item.remarkReturn`]="{ item }">
                    <a
                      v-if="item.remarkReturn !== ''"
                      @click.stop="openRemarkReturn(item)"
                      style="cursor:hand"
                      ><u>{{ item.remarkReturn }}</u></a
                    >
                    <v-btn
                      color="purple"
                      small
                      v-if="item.remarkReturn === ''"
                      dark
                      @click.stop="openRemarkReturn(item)"
                    >
                      <v-icon left dark> mdi-playlist-edit </v-icon>
                      เพิ่มหมายเหตุเรียกกลับ
                    </v-btn>
                  </template>
                  <template v-slot:[`item.remark`]="{ item }">
                    <!-- <v-menu rounded="xl" offset-x open-on-hover :close-on-content-click="false">
                              <template v-slot:activator="{ on, attrs }">
                                <div style="margin: auto;text-decoration: underline;text-decoration-thickness: 2px;" v-bind="attrs" v-on="on">
                                  See more + {{item.tagDataShow.length - 2}}
                                </div>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-for="(item2, index) in item.tagDataShow"
                                  :key="index"
                                >
                                  <v-list-item-title>
                                    <v-icon color="teal">
                                      mdi-tag-plus
                                    </v-icon>{{ item2.text }}</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu> -->
                    <a
                      v-if="item.remark !== ''"
                      @click.stop="openRemark(item)"
                      style="cursor:hand"
                    >
                      <u style="margin-right: 10px">{{
                        item.remark.slice(0, 48)
                      }}</u>
                    </a>
                    <div v-if="item.remark.length >= 50">
                      <v-menu
                        nudge-left="80"
                        rounded="xl"
                        top
                        open-on-hover
                        :close-on-content-click="false"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            rounded
                            outlined
                            x-small
                            v-bind="attrs"
                            v-on="on"
                            style="color: #1363DF;font-weight: bold;"
                          >
                            อ่านเพิ่มเติม<v-icon
                              color="#1363DF"
                              style="font-size: 20px;margin-left: 5px;text-decoration: none;"
                              >mdi-arrow-right</v-icon
                            >
                          </v-btn>
                        </template>
                        <v-card max-width="300">
                          <v-list>
                            <v-list-item width="200px">
                              <v-list-item-content width="200px">
                                {{ item.remark }}</v-list-item-content
                              >
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-menu>
                    </div>
                    <v-btn
                      color="teal"
                      small
                      v-if="item.remark === ''"
                      dark
                      @click.stop="openRemark(item)"
                    >
                      <v-icon left dark> mdi-playlist-edit </v-icon>
                      เพิ่มหมายเหตุ
                    </v-btn>
                  </template>
                  <template v-slot:[`item.action40`]="{ item }">
                    <template v-if="item.depositCheckStatus === 'True' && item.shopId != shopNameData.cJAutoGallery">
                      <v-chip
                        filter
                        dark
                        v-if="item.depositStatus === 'False'"
                        color="grey darken-1"
                        @click="(dialogDeposit = true), (bookNo = item.bookNo)"
                      >
                        <v-icon class="iconify mr-1" color="#FFAB2D"
                          >mdi-script-text-outline</v-icon
                        >
                        <!-- <v-icon class="iconify mr-1" size="70px" color="#FFAB2D" data-icon="flat-color-icons:money-transfer"></v-icon> -->
                        มัดจำ
                      </v-chip>
                      <v-row v-if="item.depositStatus === 'True'">
                        <!-- <v-col col="auto">
                        <v-avatar color="primary" size="40" v-if="item.depositImge !== ''">
                          <img :src="item.depositImge" alt="img"/></v-avatar>
                        <v-avatar color="error" size="40" v-else>
                          <v-icon dark>
                            mdi-image-edit
                          </v-icon>
                        </v-avatar>
                      </v-col> -->
                        <v-col col="auto">
                          <v-chip
                            filter
                            dark
                            color="green darken-1"
                            @click="
                              (dialogDeposit = true),
                                (bookNo = item.bookNo),
                                (statusDeposit = true),
                                (pictureUrlPreviewDeposit =
                                  item.depositImge || '')
                            "
                          >
                            <!-- <v-icon class="iconify mr-1" size="70px" color="#FFAB2D" data-icon="flat-color-icons:money-transfer"></v-icon> -->
                            <v-icon class="iconify mr-1" color="#FFAB2D"
                              >mdi-script-text-outline</v-icon
                            >
                            มัดจำ
                          </v-chip>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-if="item.depositCheckStatus === 'True' && item.shopId == shopNameData.cJAutoGallery">
                      <v-chip
                        filter
                        dark
                        v-if="item.depositStatus === 'False'"
                        color="grey darken-1"
                        @click="(dialogDeposit = true), (bookNo = item.bookNo)"
                      >
                        <v-icon class="iconify mr-1" color="#FFAB2D"
                          >mdi-script-text-outline</v-icon
                        >
                        <!-- <v-icon class="iconify mr-1" size="70px" color="#FFAB2D" data-icon="flat-color-icons:money-transfer"></v-icon> -->
                        มัดจำ
                      </v-chip>
                      <v-row v-if="item.depositStatus === 'True' && item.paymentType != 'creditloyalty'">
                        <v-col col="auto">
                          <v-chip
                            filter
                            dark
                            color="green darken-1"
                            @click="
                              (dialogDeposit = true),
                                (bookNo = item.bookNo),
                                (statusDeposit = true),
                                (pictureUrlPreviewDeposit =
                                  item.depositImge || '')
                            "
                          >
                            <!-- <v-icon class="iconify mr-1" size="70px" color="#FFAB2D" data-icon="flat-color-icons:money-transfer"></v-icon> -->
                            <v-icon class="iconify mr-1" color="#FFAB2D"
                              >mdi-script-text-outline</v-icon
                            >
                            มัดจำ
                          </v-chip>
                        </v-col>
                      </v-row>
                      <v-row v-if="item.depositStatus === 'True' && item.paymentType == 'creditloyalty'">
                        <v-col col="auto">
                          <v-chip
                            filter
                            dark
                            color="green darken-1"
                          >
                            <!-- <v-icon class="iconify mr-1" size="70px" color="#FFAB2D" data-icon="flat-color-icons:money-transfer"></v-icon> -->
                            <v-icon class="iconify mr-1" color="#FFAB2D"
                              >mdi-credit-card</v-icon
                            >
                            เครดิต
                          </v-chip>
                        </v-col>
                      </v-row>
                    </template>
                  </template>
                  <template v-slot:[`item.memberDataTagName`]="{ item }">
                    <div>
                      <v-row
                        v-if="item.memberDataTag.length === 0"
                        style="justify-content: flex-end;margin: auto;"
                      >
                        <div v-if="item.memberId !== ''" style="color:grey;">
                          ไม่มีมีป้ายกำกับ
                        </div>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="ml-1"
                              fab
                              v-bind="attrs"
                              v-on="on"
                              dark
                              icon
                              v-if="item.memberId !== ''"
                              x-small
                              color="teal"
                              @click="
                                getTagData(),
                                  (dialogTag = true),
                                  (tagData = item.memberDataTag),
                                  (bookNo = item.bookNo),
                                  (memberId = item.memberId)
                              "
                            >
                              <v-icon dark>
                                mdi-tag-plus
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>เพิ่มป้ายกำกับ</span>
                        </v-tooltip>
                        <div
                          v-if="item.memberId == ''"
                          style="margin: auto;color: grey;"
                        >
                          ไม่มีป้ายกำกับ
                        </div>
                      </v-row>
                      <v-row
                        style="display: flex;justify-content: center;padding-top: 0px;"
                        align="center"
                        v-if="item.memberDataTag.length > 0"
                      >
                        <div
                          v-if="item.tagDataShow.length === 1"
                          style="font-weight: 600;font-size: 16px;color: #2BC155;"
                        >
                          {{ item.tagDataShow[0].text }}
                        </div>
                        <div
                          v-if="item.tagDataShow.length === 2"
                          style="font-weight: 600;font-size: 16px;color: #2BC155;display: flex;justify-content: center;"
                        >
                          <div class="mr-2">{{ item.tagDataShow[0].text }}</div>
                          <div>{{ item.tagDataShow[1].text }}</div>
                        </div>
                        <div
                          v-if="item.tagDataShow.length > 2"
                          style="font-weight: 600;font-size: 16px;color: #2BC155;display: flex;justify-content: center;margin-bottom: 5px;"
                        >
                          <div class="mr-3">{{ item.tagDataShow[0].text }}</div>
                          <div class="mr-2">{{ item.tagDataShow[1].text }}</div>
                        </div>
                        <div
                          v-if="
                            item.tagDataShow.length === 1 ||
                              item.tagDataShow.length === 2
                          "
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                class="ml-1"
                                fab
                                v-bind="attrs"
                                v-on="on"
                                dark
                                icon
                                v-if="item.memberId !== ''"
                                x-small
                                color="teal"
                                @click="
                                  getTagData(),
                                    (dialogTag = true),
                                    (tagData = item.memberDataTag),
                                    (bookNo = item.bookNo),
                                    (memberId = item.memberId)
                                "
                              >
                                <v-icon dark>
                                  mdi-tag-plus
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>เพิ่มป้ายกำกับ</span>
                          </v-tooltip>
                        </div>
                        <div
                          v-if="item.tagDataShow.length > 2"
                          class="ma-0"
                          style="margin-top: 2 !important;color: grey;font-size: 13px;display:flex"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                class="ml-1"
                                fab
                                v-bind="attrs"
                                v-on="on"
                                dark
                                icon
                                v-if="item.memberId !== ''"
                                x-small
                                color="teal"
                                @click="
                                  getTagData(),
                                    (dialogTag = true),
                                    (tagData = item.memberDataTag),
                                    (bookNo = item.bookNo),
                                    (memberId = item.memberId)
                                "
                              >
                                <v-icon dark>
                                  mdi-tag-plus
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>เพิ่มป้ายกำกับ</span>
                          </v-tooltip>
                          <v-menu
                            rounded="xl"
                            offset-x
                            open-on-hover
                            :close-on-content-click="false"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <div
                                style="margin: auto;text-decoration: underline;text-decoration-thickness: 2px;"
                                v-bind="attrs"
                                v-on="on"
                              >
                                See more + {{ item.tagDataShow.length - 2 }}
                              </div>
                            </template>
                            <v-list>
                              <v-list-item
                                v-for="(item2, index) in item.tagDataShow"
                                :key="index"
                              >
                                <v-list-item-title>
                                  <v-icon color="teal">
                                    mdi-tag-plus </v-icon
                                  >{{ item2.text }}</v-list-item-title
                                >
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </div>
                      </v-row>
                    </div>
                  </template>
                  <template v-slot:[`item.action2`]="{ item }">
                    <v-row>
                      <v-col>
                        <v-chip
                          filter
                          dark
                          v-if="
                            item.statusBt === 'confirm' ||
                              item.statusBt === 'confirmJob'
                          "
                          :color="
                            item.remarkConfirm1
                              ? 'green darken-2'
                              : 'grey darken-1'
                          "
                          v-model="item.remarkConfirm1"
                          @click.stop="
                            item.remarkConfirm1 = !item.remarkConfirm1;
                            confirmRemark(item, 'inAdvance');
                          "
                        >
                          1 วัน
                        </v-chip>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-slot:[`item.action3`]="{ item }">
                    <v-row>
                      <v-col>
                        <v-chip
                          dark
                          :color="
                            item.fastTrack ? 'green darken-2' : 'grey darken-1'
                          "
                          v-model="item.fastTrack"
                          @click.stop="
                            item.fastTrack = !item.fastTrack;
                            confirmRemark(item, 'fastTrack');
                          "
                        >
                          {{ dataTypeJob3 }}
                        </v-chip>
                      </v-col>
                      <v-col>
                        <v-chip
                          dark
                          :color="
                            item.extraJob ? 'green darken-2' : 'grey darken-1'
                          "
                          v-model="item.extraJob"
                          @click.stop="
                            item.extraJob = !item.extraJob;
                            confirmRemark(item, 'extraJob');
                          "
                        >
                          {{ dataTypeJob2 }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <!-- confirm -->
                    <v-menu
                      rounded="xl"
                      offset-y
                      transition="slide-y-transition"
                    >
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          style="background-color: #E0F4FF;border-radius: 10px;font-weight: bold;"
                          class="black--text pa-5"
                          elevation="0"
                          v-bind="attrs"
                          v-on="on"
                        >
                          เมนูจัดการ
                          <v-icon color="#73777B" class="ml-2">
                            mdi-chevron-down
                          </v-icon>
                        </v-btn>
                      </template>
                      <v-list class="menu">
                        <v-hover v-slot:default="{ hover }">
                          <v-list-item
                            @click.stop="
                              (dialogEdit = true),
                                getBookingDataJob(item, 'qrcode')
                            "
                            v-if="
                              item.statusBt === 'confirm' &&
                                showOnsite === 'แสดง'
                            "
                          >
                            <template
                              ><v-expand-transition>
                                <v-overlay
                                  color="green"
                                  absolute
                                  :opacity="0.2"
                                  :value="hover"
                                >
                                </v-overlay>
                              </v-expand-transition>
                              <v-list-item-title
                                ><v-icon
                                  color="#73777B"
                                  class="mr-2 iconify"
                                  data-icon="bi:people"
                                ></v-icon>
                                รับเข้าบริการ
                              </v-list-item-title>
                            </template>
                          </v-list-item>
                        </v-hover>
                        <v-list-item
                          @click.stop="assignEmp(item)"
                          v-if="
                            item.statusBt === 'wait' &&
                              item.shopId === shopNameData.officeOmbudsman
                          "
                        >
                          <v-list-item-title
                            ><v-icon color="#73777B" class="mr-2">
                              mdi-calendar-clock
                            </v-icon>
                            มอบหมายให้เจ้าหน้าที่</v-list-item-title
                          >
                        </v-list-item>
                        <v-hover v-slot:default="{ hover }">
                          <v-list-item
                            style="background-color: lightgreen"
                            @click.stop="confirmChk(item)"
                            v-if="
                              item.statusBt !== 'confirmJob' &&
                                item.statusBt !== 'confirm' &&
                                item.statusBt !== 'cancel'
                            "
                          >
                            <template
                              ><v-expand-transition>
                                <v-overlay
                                  color="green"
                                  absolute
                                  :opacity="0.2"
                                  :value="hover"
                                >
                                </v-overlay>
                              </v-expand-transition>
                              <v-list-item-title
                                ><v-icon
                                  color="#73777B"
                                  class="mr-2 iconify"
                                  data-icon="quill:mail-subbed"
                                ></v-icon>
                                ยืนยันนัดหมาย
                              </v-list-item-title>
                            </template>
                          </v-list-item>
                        </v-hover>
                        <v-list-item
                          @click.stop="setDataChang(item)"
                          v-if="
                            item.statusBt !== 'confirmJob' &&
                              item.statusBt !== 'cancel' && checkShopSigneture[item.shopId] == undefined
                          "
                        >
                          <v-list-item-title
                            ><v-icon color="#73777B" class="mr-2">
                              mdi-calendar-clock
                            </v-icon>
                            เปลี่ยนเวลานัดหมาย
                            {{ item.countChangeTime }} ครั้ง</v-list-item-title
                          >
                        </v-list-item>
                        <v-list-item
                          @click.stop="setDataChang(item)"
                          v-if="
                              item.statusBt !== 'cancel' && item.RECORD_STATUS_Job !== 'D' && item.empFull_NameTH.toUpperCase().search('ADMIN') >= 0 && (checkShopSigneture[item.shopId])
                          "
                        >
                          <v-list-item-title
                            ><v-icon color="#73777B" class="mr-2">
                              mdi-calendar-clock
                            </v-icon>
                            เปลี่ยนเวลานัดหมาย
                            {{ item.countChangeTime }} ครั้ง</v-list-item-title
                          >
                        </v-list-item>
                        <!-- คุณ Joy -->
                        <v-list-item
                          @click.stop="setDataChang(item)"
                          v-if="
                            item.statusBt === 'confirmJob' &&
                              (item.shopId ===
                                'U9f316c85400fd716ea8c80d7cd5b61f8' ||
                                item.shopId ===
                                  'Ucb91b5fb61ff0c01e6d7d4c5f7962c57')
                          "
                        >
                          <v-list-item-title
                            ><v-icon color="#73777B" class="mr-2">
                              mdi-calendar-clock
                            </v-icon>
                            เปลี่ยนเวลานัดหมาย
                            {{ item.countChangeTime }} ครั้ง</v-list-item-title
                          >
                        </v-list-item>
                        <!-- คุณ Joy -->
                        <!-- v-if="(item.statusBt === 'confirm' || item.statusBt === 'wait') && item.menuShowStatus === 'True'" v-if เมนูอันเก่า -->
                        <v-list-item
                          @click.stop="getDataMenu(item)"
                          v-if="item.menuShowStatus === 'True'"
                        >
                          <v-list-item-title
                            ><v-icon color="#73777B" class="mr-2">
                              mdi-microsoft-xbox-controller-menu
                            </v-icon>
                            รายการเมนู
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          @click.stop="getDataMenuConclusion(item)"
                          v-if="item.menuShowStatus === 'True'"
                        >
                          <v-list-item-title
                            ><v-icon color="#73777B" class="mr-2">
                              mdi-microsoft-xbox-controller-menu
                            </v-icon>
                            สรุปรายการ
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          @click.stop="setDataReture(item)"
                          v-if="
                            item.statusBt !== 'confirmJob' &&
                              item.depositStatus === 'True' &&
                              item.depositImge != ''
                          "
                        >
                          <v-list-item-title
                            ><v-icon
                              color="#73777B"
                              class="mr-2 iconify"
                              data-icon="uil:money-withdrawal"
                            ></v-icon>
                            คืนเงินมัดจำ
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          @click.stop="setShowMap(item)"
                          v-if="item.addressLatLong !== null"
                        >
                          <v-list-item-title
                            ><v-icon color="#73777B" class="mr-2">
                              mdi-map-marker-radius-outline
                            </v-icon>
                            ดูแผนที่
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          @click.stop="setDataEdit(item)"
                          v-if="item.RECORD_STATUS_Job !== 'D'"
                        >
                          <v-list-item-title
                            ><v-icon color="#73777B" class="mr-2">
                              mdi-tools
                            </v-icon>
                            แก้ไขข้อมูล
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click.stop="setDataCallLog(item)">
                          <v-list-item-title
                            ><v-icon
                              color="#73777B"
                              class="mr-2 iconify"
                              data-icon="eva:phone-call-fill"
                            >
                            </v-icon>
                            ประวัติการโทร
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click.stop="setDataServiceList(item)">
                          <v-list-item-title
                            ><v-icon
                              color="#73777B"
                              class="mr-2 iconify"
                              data-icon="cil:list-rich"
                            >
                            </v-icon>
                            สรุปรายการ
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          @click.stop="updateStatusBookingTransaction(item)"
                          v-if="item.statusBt === 'confirm'"
                        >
                          <v-list-item-title
                            ><v-icon color="#73777B" class="mr-2">
                              mdi-skip-backward
                            </v-icon>
                            กลับไปสถานะก่อนหน้า
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          @click.stop="
                            getBookingDataJob(item, 'qrcode'),
                              getEmpSelectAddJob(),
                              (dialogOnsite = true)
                          "
                          v-if="
                            item.statusBt === 'confirm' &&
                              showOnsite === 'ไม่แสดง'
                          "
                        >
                          <v-list-item-title
                            ><v-icon color="#73777B" class="mr-2">
                              mdi-account-plus
                            </v-icon>
                            มอบหมายงาน
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          @click.stop="setDataCopyLink(item)"
                          v-if="
                            item.statusBt === 'wait' &&
                              item.depositCheckStatus === 'True'
                          "
                        >
                          <v-list-item-title
                            ><v-icon
                              color="#73777B"
                              class="mr-2 iconify"
                              data-icon="bx:link"
                            ></v-icon>
                            เรียกเก็บค่าบริการเพื่อจอง
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-clipboard:success="onCopySuccess"
                          v-clipboard:copy="
                            'https://liff.line.me/' +
                              dataLineConfig.liffMainID +
                              '/ConfirmUser?bookNo=' +
                              item.bookNo +
                              '&shopId=' +
                              item.shopId
                          "
                          v-if="
                            item.statusBt === 'confirm' &&
                              (item.lineUserId === '' ||
                                item.lineUserId === null)
                          "
                        >
                          <!-- <v-list-item v-clipboard:success="onCopySuccess" v-clipboard:copy="'https://liff.line.me/1656581804-7KRQyqo5/ConfirmUser?bookNo=' + item.bookNo + '&shopId=' + item.shopId" v-if="item.statusBt === 'confirm' && (item.userId === 'user-skip' || item.userId === '' || item.userId === null)"> -->
                          <v-list-item-title
                            ><v-icon color="#73777B" class="mr-2">
                              mdi-content-copy
                            </v-icon>
                            คัดลอกลิงค์ (ผูกลูกค้า)
                          </v-list-item-title>
                        </v-list-item>
                        <v-hover v-slot:default="{ hover }">
                          <v-list-item
                            v-if="
                              item.statusBt !== 'cancel'
                            "
                            :disabled="item.chkCancel"
                            @click.stop="setDataRemove(item);"
                          >
                            <template
                              ><v-expand-transition>
                                <v-overlay
                                  color="red"
                                  absolute
                                  :opacity="0.2"
                                  :value="hover"
                                >
                                </v-overlay>
                              </v-expand-transition>
                              <v-list-item-title
                                ><v-icon
                                  color="#73777B"
                                  class="mr-2 iconify"
                                  data-icon="carbon:rule-cancelled"
                                ></v-icon>
                                ยกเลิกนัดหมาย
                              </v-list-item-title>
                            </template>
                          </v-list-item>
                        </v-hover>
                        <v-list-item
                          v-if="item.statusBt === 'confirmJob'"
                          @click.stop="(dialogJob = true), getjob(item)"
                        >
                          <v-list-item-title
                            ><v-icon color="#73777B" class="mr-2">
                              mdi-qrcode-scan
                            </v-icon>
                            QR Code สำหรับให้ลูกค้า
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="item.statusBt !== 'wait'"
                          @click.stop="setBookingAgain(item)"
                        >
                          <v-list-item-title
                            ><v-icon
                              color="#73777B"
                              class="mr-2 iconify"
                              data-icon="fluent:group-return-24-filled"
                            ></v-icon>
                            นัดหมายอีกครั้ง
                          </v-list-item-title>
                        </v-list-item>
                        <!-- <v-list-item v-if="item.statusBt === 'confirmJob'" @click.stop="(dialogJob = true), getjob(item)">
                            <v-list-item-title><v-icon color="#73777B" class="mr-2 iconify" data-icon="uil:bill"></v-icon> ปิดงานนี้ </v-list-item-title>
                          </v-list-item> -->
                        <v-list-item
                          v-if="item.statusBt === 'confirmJob'"
                          @click.stop="getJobitem(item)"
                        >
                          <v-list-item-title
                            ><v-icon
                              color="#73777B"
                              class="mr-2 iconify"
                              data-icon="ic:twotone-work-history"
                            ></v-icon>
                            ประวัติการทำงาน
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            item.statusBt === 'confirmJob' &&
                              showOnsite === 'ไม่แสดง'
                          "
                          @click="
                            getjobChangeOnsite(item),
                              (dialogChangeOnsite = true)
                          "
                        >
                          <v-list-item-title
                            ><v-icon color="#73777B" class="mr-2">
                              mdi-account-reactivate
                            </v-icon>
                            เปลี่ยนพนักงาน On site
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            item.statusBt === 'confirmJob' &&
                              showOnsite === 'ไม่แสดง'
                          "
                          @click="ShowImg(item)"
                        >
                          <v-list-item-title
                            ><v-icon color="#73777B" class="mr-2">
                              mdi-package-variant-closed
                            </v-icon>
                            ตรวจสอบการทำงาน
                          </v-list-item-title>
                        </v-list-item>
                        <v-hover v-slot:default="{ hover }">
                          <v-list-item
                            v-if="item.statusBt === 'cancel'"
                            @click.stop="
                              (dialogDelete = true), getDataById(item)
                            "
                          >
                            <template
                              ><v-expand-transition>
                                <v-overlay
                                  color="red"
                                  absolute
                                  :opacity="0.2"
                                  :value="hover"
                                >
                                </v-overlay>
                              </v-expand-transition>
                              <v-list-item-title
                                ><v-icon color="#73777B" class="mr-2">
                                  mdi-delete
                                </v-icon>
                                ลบรายการนี้
                              </v-list-item-title>
                            </template>
                          </v-list-item>
                        </v-hover>
                      </v-list>
                    </v-menu>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <waitingAlert></waitingAlert>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
        <v-dialog v-model="dialogShowImg" max-width="600px">
          <v-card class="pa-3" v-if="checkShopSigneture[session.data.shopId]">
            <div
              v-for="(CloseJob, keyCloseJob) in dataCloseJob"
              :key="'a' + keyCloseJob"
            >
              <div
                class="mx-6 pa-3 ma-2"
                v-if="
                  dataCloseJobData.filter(dt => dt.jobNo === CloseJob.jobNo)
                    .length > 0
                "
              >
                <v-row class="pa-5">
                  <v-col
                    cols="3"
                    md="3"
                    sm="12"
                    class="pa-0 ma-0"
                    style="display: flex;align-items: flex-start;justify-content: flex-end;padding-left: 11px !important;"
                  >
                    <v-avatar size="65" v-if="CloseJob.memberPicture">
                      <img
                        :src="CloseJob.memberPicture"
                        onerror="this.onerror=null;this.src='https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2FLINE_ALBUM_220214_0.jpg?alt=media&token=6389daf9-9473-4b5d-8b19-2afb67d015e4';"
                      />
                    </v-avatar>
                    <v-avatar size="65" color="#173053" v-else>
                      <v-icon dark x-large>
                        mdi-account-circle
                      </v-icon>
                    </v-avatar>
                  </v-col>
                  <v-col cols="9" md="9" sm="12" class="pa-0 ma-0 pl-2">
                    <p
                      class="font-weight-bold mb-1 ml-2"
                      v-if="
                        dataCloseJobData.filter(
                          dt =>
                            dt.jobNo === CloseJob.jobNo &&
                            dt.fieldName === 'ชื่อ'
                        ).length > 0
                      "
                      style="font-size:16px;"
                    >
                      {{
                        dataCloseJobData.filter(
                          dt =>
                            dt.jobNo === CloseJob.jobNo &&
                            dt.fieldName === "ชื่อ"
                        )[0].fieldValue
                      }}
                    </p>
                    <!-- <div style="display: flex;justify-content: space-between;align-items: flex-start;">
                      <div style="word-break: break-word;">
                        <p class="font-weight-bold mb-1 ml-2" v-if="dataCloseJobData.filter((dt) => dt.jobNo === CloseJob.jobNo && dt.fieldName === 'ชื่อ').length > 0"
                          style="font-size:20px;">
                          {{dataCloseJobData.filter((dt) => dt.jobNo === CloseJob.jobNo && dt.fieldName === 'ชื่อ')[0].fieldValue}}
                        </p>
                      </div>
                    <v-icon color="rgb(23, 48, 83)" large @click="ChatHistory(CloseJob)">mdi-history</v-icon>
                    </div> -->
                    <div style="display: flex;align-items: flex-start;">
                      <v-icon color="#F48686" class="mx-1"
                        >mdi-square-medium</v-icon
                      >
                      <p
                        class="font-weight-medium mb-1"
                        v-if="CloseJob.flowName !== null"
                        style="font-size:14px"
                      >
                        <!-- <v-icon color="#F48686" class="mx-1">mdi-square-medium</v-icon> -->
                        {{ CloseJob.flowName }}
                      </p>
                    </div>
                    <div
                      style="display: flex;align-items: flex-start;word-break: break-word;"
                      v-if="CloseJob.address !== null"
                    >
                      <v-icon color="#F48686" class="mx-1 mr-2"
                        >mdi-map-marker-radius</v-icon
                      >
                      <p
                        class="font-weight-medium mb-1"
                        style="font-size:14px"
                        v-if="CloseJob.address !== null"
                      >
                        <!-- <v-icon color="#F48686" class="mx-1 mr-2">mdi-map-marker-radius</v-icon> -->
                        {{ CloseJob.address }}
                      </p>
                    </div>
                    <div style="display: flex;align-items: flex-start;">
                      <v-icon
                        color="#24C74D"
                        class="mx-2 mr-2 mt-1 iconify"
                        small
                        data-icon="el:phone-alt"
                      ></v-icon>
                      <p
                        class="font-weight-bold mb-1"
                        v-if="
                          dataCloseJobData.filter(
                            dt =>
                              dt.jobNo === CloseJob.jobNo &&
                              dt.fieldName === 'เบอร์โทร'
                          ).length > 0
                        "
                        style="font-size:14px"
                      >
                        <!-- <v-icon  color="#24C74D" class="mx-2 mr-2 mt-1 iconify" small data-icon="el:phone-alt"></v-icon> -->
                        {{
                          dataCloseJobData.filter(
                            dt =>
                              dt.jobNo === CloseJob.jobNo &&
                              dt.fieldName === "เบอร์โทร"
                          )[0].fieldValue
                        }}
                      </p>
                    </div>
                    <div style="display: flex;align-items: flex-start;">
                      <v-icon color="primary" class="mx-2 mr-2 mt-1" small
                        >mdi-account-circle</v-icon
                      >
                      <p
                        class="font-weight-bold mb-1"
                        v-if="
                          dataCloseJobData.filter(
                            dt => dt.jobNo === CloseJob.jobNo
                          ).length > 0
                        "
                        style="font-size:14px"
                      >
                        <!-- <v-icon  color="#24C74D" class="mx-2 mr-2 mt-1 iconify" small data-icon="el:phone-alt"></v-icon> -->
                        {{
                          dataCloseJobData.filter(
                            dt => dt.jobNo === CloseJob.jobNo
                          )[0].empStep
                        }}
                      </p>
                    </div>
                  </v-col>
                </v-row>
                <div
                  style="display: flex;align-items: center;justify-content: center;"
                  class="mb-2"
                >
                  <v-icon
                    color="#F48686"
                    class="mx-1 mr-2 iconify"
                    data-icon="ic:twotone-access-time"
                  ></v-icon>
                  <p
                    class="font-weight-bold mb-1 text-center"
                    v-if="
                      (CloseJob.dueDate !== null) & (CloseJob.dueDate !== '')
                    "
                    style="font-size:15px"
                  >
                    {{
                      "วันที่นัดหมาย " + momentThaiTextClose(CloseJob.dueDate)
                    }}
                  </p>
                </div>
                <v-row>
                  <v-col
                    cols="6"
                    style="display: flex;
                      align-items: flex-start;
                      padding-left: 25px;
                      flex-direction: column;"
                  >
                    <p
                      class="font-weight-bold mb-1 text-center"
                      v-if="
                        dataCloseJobData.filter(
                          dt => dt.jobNo === CloseJob.jobNo
                        ).length > 0
                      "
                      style="font-size:13px"
                    >
                      {{
                        "วันที่เริ่มงาน " +
                          dataCloseJobData.filter(
                            dt => dt.jobNo === CloseJob.jobNo
                          )[0].CREATE_DATE_DAY
                      }}
                    </p>
                    <p
                      class="font-weight-bold mb-1 text-center"
                      v-if="
                        dataCloseJobData.filter(
                          dt => dt.jobNo === CloseJob.jobNo
                        ).length > 0
                      "
                      style="font-size:13px"
                    >
                      {{
                        "เวลาเริ่มงาน " +
                          dataCloseJobData.filter(
                            dt => dt.jobNo === CloseJob.jobNo
                          )[0].CREATE_DATE_TIME +
                          " น."
                      }}
                    </p>
                  </v-col>
                  <v-divider
                    class="pt-3 mt-3"
                    style="height: 40px;"
                    vertical
                  ></v-divider>
                  <v-col
                    cols="6"
                    style="display: flex;
                      align-items: flex-start;
                      padding-left: 25px;
                      flex-direction: column;"
                  >
                    <p
                      class="font-weight-bold mb-1 text-center"
                      v-if="
                        dataCloseJobData.filter(
                          dt => dt.jobNo === CloseJob.jobNo
                        ).length > 0
                      "
                      style="font-size:13px"
                    >
                      {{
                        "วันที่จบงาน " +
                          dataCloseJobData.filter(
                            dt => dt.jobNo === CloseJob.jobNo
                          )[0].LAST_DATE_DAY
                      }}
                    </p>
                    <p
                      class="font-weight-bold mb-1 text-center"
                      v-if="
                        dataCloseJobData.filter(
                          dt => dt.jobNo === CloseJob.jobNo
                        ).length > 0
                      "
                      style="font-size:13px"
                    >
                      {{
                        "เวลาจบงาน " +
                          dataCloseJobData.filter(
                            dt => dt.jobNo === CloseJob.jobNo
                          )[0].LAST_DATE_TIME +
                          " น."
                      }}
                    </p>
                  </v-col>
                </v-row>
              </div>
            </div>
            <!-- <h5 class="font-weight-bold m-6 mb-5 text-center">ตรวจสอบรูป</h5> -->
            <div
              style="display: flex;justify-content: center;"
              class="mt-3"
              v-if="showImgItem.length > 0"
            >
              <v-btn color="primary" elevation="2" small dark @click="SaveImg()"
                >ดาวน์โหลดรูปภาพทั้งหมด</v-btn
              >
            </div>
            <h6 class="font-weight-bold ml-6">Before</h6>
            <v-slide-group
              v-if="showImgItem"
              class="pa-4 pt-0 mt-n1"
              color="primary"
              show-arrows
            >
              <v-slide-item v-for="(itemImg2, i2) in showImgItem" :key="i2">
                <v-card width="150px" class="ma-2 pa-1" v-if="itemImg2.beforeafter && itemImg2.typeUpload === 'beforeImage'">
                  <v-img
                    :src="itemImg2.beforeafter"
                    max-height="130"
                    aspect-ratio="1.7"
                    contain
                    @click="SelectImg(itemImg2.beforeafter)"
                  ></v-img>
                </v-card>
              </v-slide-item>
            </v-slide-group>
            <h6 class="font-weight-bold ml-6">After</h6>
            <v-slide-group
              v-if="showImgItem"
              class="pa-4 pt-0 mt-n1"
              color="primary"
              show-arrows
            >
              <v-slide-item v-for="(itemImg, i) in showImgItem" :key="i">
                <v-card width="150px" class="ma-2 pa-1" v-if="itemImg.beforeafter && itemImg.typeUpload === 'afterImage'">
                  <v-img
                    :src="itemImg.beforeafter"
                    max-height="130"
                    aspect-ratio="1.7"
                    contain
                    @click="SelectImg(itemImg.beforeafter)"
                  ></v-img>
                </v-card>
              </v-slide-item>
            </v-slide-group>
          </v-card>
          <v-card class="pa-3" v-else>
            <div
              v-for="(CloseJob, keyCloseJob) in dataCloseJob"
              :key="'a' + keyCloseJob"
            >
              <div
                class="mx-6 pa-3 ma-2"
                v-if="
                  dataCloseJobData.filter(dt => dt.jobNo === CloseJob.jobNo)
                    .length > 0
                "
              >
                <v-row class="pa-5">
                  <v-col
                    cols="3"
                    md="3"
                    sm="12"
                    class="pa-0 ma-0"
                    style="display: flex;align-items: flex-start;justify-content: flex-end;padding-left: 11px !important;"
                  >
                    <v-avatar size="65" v-if="CloseJob.memberPicture">
                      <img
                        :src="CloseJob.memberPicture"
                        onerror="this.onerror=null;this.src='https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2FLINE_ALBUM_220214_0.jpg?alt=media&token=6389daf9-9473-4b5d-8b19-2afb67d015e4';"
                      />
                    </v-avatar>
                    <v-avatar size="65" color="#173053" v-else>
                      <v-icon dark x-large>
                        mdi-account-circle
                      </v-icon>
                    </v-avatar>
                  </v-col>
                  <v-col cols="9" md="9" sm="12" class="pa-0 ma-0 pl-2">
                    <p
                      class="font-weight-bold mb-1 ml-2"
                      v-if="
                        dataCloseJobData.filter(
                          dt =>
                            dt.jobNo === CloseJob.jobNo &&
                            dt.fieldName === 'ชื่อ'
                        ).length > 0
                      "
                      style="font-size:16px;"
                    >
                      {{
                        dataCloseJobData.filter(
                          dt =>
                            dt.jobNo === CloseJob.jobNo &&
                            dt.fieldName === "ชื่อ"
                        )[0].fieldValue
                      }}
                    </p>
                    <!-- <div style="display: flex;justify-content: space-between;align-items: flex-start;">
                      <div style="word-break: break-word;">
                        <p class="font-weight-bold mb-1 ml-2" v-if="dataCloseJobData.filter((dt) => dt.jobNo === CloseJob.jobNo && dt.fieldName === 'ชื่อ').length > 0"
                          style="font-size:20px;">
                          {{dataCloseJobData.filter((dt) => dt.jobNo === CloseJob.jobNo && dt.fieldName === 'ชื่อ')[0].fieldValue}}
                        </p>
                      </div>
                    <v-icon color="rgb(23, 48, 83)" large @click="ChatHistory(CloseJob)">mdi-history</v-icon>
                    </div> -->
                    <div style="display: flex;align-items: flex-start;">
                      <v-icon color="#F48686" class="mx-1"
                        >mdi-square-medium</v-icon
                      >
                      <p
                        class="font-weight-medium mb-1"
                        v-if="CloseJob.flowName !== null"
                        style="font-size:14px"
                      >
                        <!-- <v-icon color="#F48686" class="mx-1">mdi-square-medium</v-icon> -->
                        {{ CloseJob.flowName }}
                      </p>
                    </div>
                    <div
                      style="display: flex;align-items: flex-start;word-break: break-word;"
                      v-if="CloseJob.address !== null"
                    >
                      <v-icon color="#F48686" class="mx-1 mr-2"
                        >mdi-map-marker-radius</v-icon
                      >
                      <p
                        class="font-weight-medium mb-1"
                        style="font-size:14px"
                        v-if="CloseJob.address !== null"
                      >
                        <!-- <v-icon color="#F48686" class="mx-1 mr-2">mdi-map-marker-radius</v-icon> -->
                        {{ CloseJob.address }}
                      </p>
                    </div>
                    <div style="display: flex;align-items: flex-start;">
                      <v-icon
                        color="#24C74D"
                        class="mx-2 mr-2 mt-1 iconify"
                        small
                        data-icon="el:phone-alt"
                      ></v-icon>
                      <p
                        class="font-weight-bold mb-1"
                        v-if="
                          dataCloseJobData.filter(
                            dt =>
                              dt.jobNo === CloseJob.jobNo &&
                              dt.fieldName === 'เบอร์โทร'
                          ).length > 0
                        "
                        style="font-size:14px"
                      >
                        <!-- <v-icon  color="#24C74D" class="mx-2 mr-2 mt-1 iconify" small data-icon="el:phone-alt"></v-icon> -->
                        {{
                          dataCloseJobData.filter(
                            dt =>
                              dt.jobNo === CloseJob.jobNo &&
                              dt.fieldName === "เบอร์โทร"
                          )[0].fieldValue
                        }}
                      </p>
                    </div>
                    <div style="display: flex;align-items: flex-start;">
                      <v-icon color="primary" class="mx-2 mr-2 mt-1" small
                        >mdi-account-circle</v-icon
                      >
                      <p
                        class="font-weight-bold mb-1"
                        v-if="
                          dataCloseJobData.filter(
                            dt => dt.jobNo === CloseJob.jobNo
                          ).length > 0
                        "
                        style="font-size:14px"
                      >
                        <!-- <v-icon  color="#24C74D" class="mx-2 mr-2 mt-1 iconify" small data-icon="el:phone-alt"></v-icon> -->
                        {{
                          dataCloseJobData.filter(
                            dt => dt.jobNo === CloseJob.jobNo
                          )[0].empStep
                        }}
                      </p>
                    </div>
                  </v-col>
                </v-row>
                <div
                  style="display: flex;align-items: center;justify-content: center;"
                  class="mb-2"
                >
                  <v-icon
                    color="#F48686"
                    class="mx-1 mr-2 iconify"
                    data-icon="ic:twotone-access-time"
                  ></v-icon>
                  <p
                    class="font-weight-bold mb-1 text-center"
                    v-if="
                      (CloseJob.dueDate !== null) & (CloseJob.dueDate !== '')
                    "
                    style="font-size:15px"
                  >
                    {{
                      "วันที่นัดหมาย " + momentThaiTextClose(CloseJob.dueDate)
                    }}
                  </p>
                </div>
                <v-row>
                  <v-col
                    cols="6"
                    style="display: flex;
                      align-items: flex-start;
                      padding-left: 25px;
                      flex-direction: column;"
                  >
                    <p
                      class="font-weight-bold mb-1 text-center"
                      v-if="
                        dataCloseJobData.filter(
                          dt => dt.jobNo === CloseJob.jobNo
                        ).length > 0
                      "
                      style="font-size:13px"
                    >
                      {{
                        "วันที่เริ่มงาน " +
                          dataCloseJobData.filter(
                            dt => dt.jobNo === CloseJob.jobNo
                          )[0].CREATE_DATE_DAY
                      }}
                    </p>
                    <p
                      class="font-weight-bold mb-1 text-center"
                      v-if="
                        dataCloseJobData.filter(
                          dt => dt.jobNo === CloseJob.jobNo
                        ).length > 0
                      "
                      style="font-size:13px"
                    >
                      {{
                        "เวลาเริ่มงาน " +
                          dataCloseJobData.filter(
                            dt => dt.jobNo === CloseJob.jobNo
                          )[0].CREATE_DATE_TIME +
                          " น."
                      }}
                    </p>
                  </v-col>
                  <v-divider
                    class="pt-3 mt-3"
                    style="height: 40px;"
                    vertical
                  ></v-divider>
                  <v-col
                    cols="6"
                    style="display: flex;
                      align-items: flex-start;
                      padding-left: 25px;
                      flex-direction: column;"
                  >
                    <p
                      class="font-weight-bold mb-1 text-center"
                      v-if="
                        dataCloseJobData.filter(
                          dt => dt.jobNo === CloseJob.jobNo
                        ).length > 0
                      "
                      style="font-size:13px"
                    >
                      {{
                        "วันที่จบงาน " +
                          dataCloseJobData.filter(
                            dt => dt.jobNo === CloseJob.jobNo
                          )[0].LAST_DATE_DAY
                      }}
                    </p>
                    <p
                      class="font-weight-bold mb-1 text-center"
                      v-if="
                        dataCloseJobData.filter(
                          dt => dt.jobNo === CloseJob.jobNo
                        ).length > 0
                      "
                      style="font-size:13px"
                    >
                      {{
                        "เวลาจบงาน " +
                          dataCloseJobData.filter(
                            dt => dt.jobNo === CloseJob.jobNo
                          )[0].LAST_DATE_TIME +
                          " น."
                      }}
                    </p>
                  </v-col>
                </v-row>
              </div>
            </div>
            <!-- <h5 class="font-weight-bold m-6 mb-5 text-center">ตรวจสอบรูป</h5> -->
            <div
              style="display: flex;justify-content: center;"
              class="mt-3"
              v-if="showImgItem.length > 0"
            >
              <v-btn color="primary" elevation="2" small dark @click="SaveImg()"
                >ดาวน์โหลดรูปภาพทั้งหมด</v-btn
              >
            </div>
            <h6 class="font-weight-bold ml-6">Before</h6>
            <v-slide-group
              v-if="showImgItem"
              class="pa-4 pt-0 mt-n1"
              color="primary"
              show-arrows
            >
              <v-slide-item v-for="(itemImg2, i2) in showImgItem" :key="i2">
                <v-card width="150px" class="ma-2 pa-1">
                  <v-img
                    :src="itemImg2.beforeImage"
                    max-height="130"
                    aspect-ratio="1.7"
                    contain
                    @click="SelectImg(itemImg2.beforeImage)"
                  ></v-img>
                </v-card>
              </v-slide-item>
            </v-slide-group>
            <h6 class="font-weight-bold ml-6">After</h6>
            <v-slide-group
              v-if="showImgItem"
              class="pa-4 pt-0 mt-n1"
              color="primary"
              show-arrows
            >
              <v-slide-item v-for="(itemImg, i) in showImgItem" :key="i">
                <v-card width="150px" class="ma-2 pa-1">
                  <v-img
                    :src="itemImg.afterImage"
                    max-height="130"
                    aspect-ratio="1.7"
                    contain
                    @click="SelectImg(itemImg.afterImage)"
                  ></v-img>
                </v-card>
              </v-slide-item>
            </v-slide-group>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogImg" max-width="320px">
          <v-card>
            <v-img :lazy-src="showImg" :src="showImg"></v-img>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogImg2" max-width="320px">
          <v-card>
            <div>
              <img :lazy-src="showImg" :src="showImg" class="div-img-for-save" />
              <v-card-actions class="justify-end">
                <v-btn @click="openImageInNewTab" color="primary">เปิดแท็บใหม่</v-btn>
              </v-card-actions>
            </div>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogHistoryJob" persistent max-width="600">
          <v-card class="pa-3">
            <!-- <v-container>
              <div style="text-align: end;">
                <v-btn
                  fab
                  small
                  dark
                  color="#F3F3F3"
                  @click="dialogHistoryJob = false"
                >
                  <v-icon dark
                  color="#FE4A01 ">
                    mdi-close
                  </v-icon>
                </v-btn>
              </div>
            </v-container> -->
            <v-row>
              <v-col cols="6" class="text-left pt-10">
                <h3>
                  <strong>{{ customerNameJob }}</strong>
                </h3>
              </v-col>
              <v-col cols="6" class="pt-10">
                <div style="text-align: end;">
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    dark
                    color="white"
                    :style="styleCloseBt"
                    @click="dialogHistoryJob = false"
                  >
                    X
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <v-timeline v-if="timelineitem.length > 0">
              <v-timeline-item
                v-for="(item, index) in timelineitem"
                :key="index"
                :color="codeColor[index]"
                small
              >
                <template v-slot:opposite>
                  <span>{{ format_dateNotime(item.DTLAST_DATE) }}</span>
                </template>
                <v-card
                  class="elevation-2 p-2"
                  :style="'border-top: 8px solid ' + codeColor[index] + ';'"
                >
                  <v-card-title class="text-h6" style="color:#173053;">
                  </v-card-title>
                  <v-card-text>
                    <p
                      class="font-weight-black"
                      style="margin-bottom: 0px;color:#000000;"
                    >
                      ขั้นตอน {{ item.stepTitle }}
                    </p>
                    <!-- <p style="margin-bottom: 0px; color:#173053;">ขั้นตอน {{item.stepTitle}}</p> -->
                    <p
                      v-if="item.stepTitle !== 'ปิดจ๊อบ'"
                      class="font-weight-bold"
                      style="margin-bottom: 0px;"
                    >
                      เวลาเริ่ม {{ momenTime(item.DTCREATE_DATE) }}
                    </p>
                    <p
                      v-if="item.stepTitle !== 'ปิดจ๊อบ'"
                      class="font-weight-bold"
                      style="margin-bottom: 0px;"
                    >
                      เวลาสิ้นสุด {{ momenTime(item.DTLAST_DATE) }}
                    </p>
                    <p
                      v-if="item.stepTitle !== 'ปิดจ๊อบ'"
                      class="font-weight-bold"
                      style="margin-bottom: 0px;"
                    >
                      ผู้รับผิดชอบ {{ item.empStep }}
                    </p>
                    <p
                      v-if="item.stepTitle !== 'ปิดจ๊อบ'"
                      class="font-weight-bold"
                      style="margin-bottom: 0px;"
                    >
                      เวลาการทำงาน {{ item.Counttime }} นาที
                    </p>
                    <p
                      v-if="item.stepTitle === 'ปิดจ๊อบ'"
                      class="font-weight-bold"
                      style="margin-bottom: 0px;"
                    >
                      สรุปค่าใช้จ่าย {{ item.totalPrice }} บาท
                    </p>
                    <p class="font-weight-bold" style="margin-bottom: 0px;">
                      ผู้อัปเดต {{ item.LAST_USER_Name }}
                    </p>
                    <!-- <p style="margin-bottom: 0px;">วันที่เปลี่ยน {{format_dateNotime(item.DTLAST_DATE)}}</p> -->
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
            <div class="d-flex justify-center w-100">
              <v-card
                class="elevation-4 p-2"
                style="border-top: 8px solid rgb(224, 247, 250); width: 400px;"
                v-if="timelineitem.some(item => item.stepTitle === 'ปิดจ๊อบ') && ($session.getAll().data.shopId === shopNameData.udon1 || $session.getAll().data.shopId === shopNameData.udon2)"
              >
                  <v-card-title class="text-h6">
                  </v-card-title>
                  <v-card-text dark>
                    <p
                      class="font-weight-black"
                      style="margin-bottom: 0px;color:#000000;"
                    >
                      สรุปการทำงาน
                    </p>
                    <p class="font-weight-bold" style="margin-bottom: 0px;">
                      เวลาเริ่มงาน: {{ timelineitem.length > 0 ? timelineitem[0].DTCREATE_DATE : 'ไม่ระบุ' }}
                    </p>
                    <p class="font-weight-bold" style="margin-bottom: 0px;">
                      เวลาจบงาน: {{ timelineitem.length > 0 ? timelineitem[timelineitem.length - 1].DTLAST_DATE : 'ไม่ระบุ' }}
                    </p>
                    <p class="font-weight-bold" style="margin-bottom: 0px;">
                      ระยะเวลาการทำงานทั้งหมด:  {{timelinetotalTime}}
                    </p>

                    <!-- <p style="margin-bottom: 0px;">วันที่เปลี่ยน {{format_dateNotime(item.DTLAST_DATE)}}</p> -->
                  </v-card-text>
                </v-card>
              </div>
            <br />
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogMap" :max-width="dialogwidth">
          <v-card class="text-center">
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="6" class="text-left pt-10">
                    <h3><strong>แสดงแผนที่</strong></h3>
                  </v-col>
                  <v-col cols="6" class="pt-10">
                    <div style="text-align: end;">
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        dark
                        color="white"
                        :style="styleCloseBt"
                        @click="dialogMap = false"
                      >
                        X
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <v-text-field
                      v-model="address"
                      outlined
                      label="ชื่อของที่อยู่"
                      auto-grow
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="pb-0">
                    <v-card class="text-center">
                      <v-container>
                        <GmapMap
                          v-if="center !== null"
                          :center="center"
                          :zoom="15"
                          style="width: 100%; height: 200px"
                          :options="{ disableDefaultUI: true }"
                        >
                          <GmapMarker @click="gotoMap()" :position="center" />
                          <gmap-info-window
                            :opened="true"
                            :position="center"
                            :options="{
                              pixelOffset: {
                                width: 0,
                                height: -35
                              }
                            }"
                          >
                            กดที่หมุดเพื่อ นำทาง
                          </gmap-info-window>
                        </GmapMap>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogAssignEmp" :max-width="dialogwidth">
          <v-card class="text-center">
            <v-card-text v-if="dataConfirmReady">
              <v-container>
                <v-row>
                  <v-col cols="6" class="text-left pt-10">
                    <h3><strong>มอบหมายงานให้เจ้าหน้าที่</strong></h3>
                  </v-col>
                  <v-col cols="6" class="pt-10">
                    <div style="text-align: end;">
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        dark
                        color="white"
                        :style="styleCloseBt"
                        @click="dialogAssignEmp = false"
                      >
                        X
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <v-autocomplete
                      v-model="empSelect"
                      :items="empSelectStep"
                      label="พนักงานที่รับนัดหมาย"
                      outlined
                      dense
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <div class="text-center">
                  <v-btn
                    elevation="2"
                    color="#173053"
                    dark
                    block
                    large
                    :loading="loadingConfirm"
                    @click="onConfirmSelectEmp(dataConfirm)"
                    >มอบหมายงานให้เจ้าหน้าที่นี้</v-btn
                  >
                </div>
              </v-container>
            </v-card-text>
            <div class="text-center" v-if="!dataConfirmReady">
              <waitingAlert></waitingAlert>
            </div>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogConfirm" :max-width="dialogwidth">
          <v-card class="text-center">
            <v-card-text v-if="dataConfirmReady">
              <v-container>
                <v-row>
                  <v-col cols="6" class="text-left pt-10">
                    <h3><strong>ยืนยันรายการนี้</strong></h3>
                  </v-col>
                  <v-col cols="6" class="pt-10">
                    <div style="text-align: end;">
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        dark
                        color="white"
                        :style="styleCloseBt"
                        @click="dialogConfirm = false"
                      >
                        X
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    class="pb-0 pt-0"
                    cols="12"
                    v-if="
                      dataPackage.filter(el => {
                        return el.balanceAmount > 0;
                      }).length > 0
                    "
                  >
                    <v-card class="pl-1">
                      <v-subheader
                        >ลูกค้ามี
                        {{
                          dataPackage.filter(el => {
                            return el.balanceAmount > 0;
                          }).length
                        }}
                        แพ็คเกจ</v-subheader
                      >
                      <v-subheader v-show="StatusPackage.packageName"
                        >ลูกค้าได้ทำการเลือกแพ็คเกจ
                        {{ StatusPackage.packageName }}</v-subheader
                      >
                      <v-slide-group
                        v-model="modelPackageIndexConfirm"
                        show-arrows
                        center-active
                      >
                        <v-slide-item
                          v-for="(item, index) in dataPackage.filter(el => {
                            return el.balanceAmount > 0;
                          })"
                          :key="index"
                        >
                          <v-card
                            class="ma-2 p-1"
                            width="340"
                            height="100"
                            color="#FFFFFF"
                            elevation="6"
                            :style="
                              item.packageId === packageId &&
                              item.token === tokenPackage
                                ? 'border: 1px solid green;'
                                : 'border: 1px solid white;'
                            "
                          >
                            <!-- <v-card
                            class="ma-2 p-1"
                            width="340"
                            height="100"
                            color="#FFFFFF"
                            elevation="6"
                            :style="item.packageId === packageId && item.token === tokenPackage ? 'border: 1px solid green;' : 'border: 1px solid white;'"
                            > -->
                            <v-row>
                              <v-col cols="4" class="pr-1">
                                <v-img
                                  contain
                                  max-height="80"
                                  max-width="200"
                                  :src="item.packageImg"
                                ></v-img>
                              </v-col>
                              <v-col cols="8" class="pb-6">
                                <v-row class="font16 headline1">
                                  <v-col class="pl-0 pt-2 pb-0">{{
                                    item.packageName
                                  }}</v-col>
                                  <v-btn
                                    class="mr-4 mt-3"
                                    v-if="
                                      item.packageId !== packageId &&
                                        item.token !== tokenPackage
                                    "
                                    color="green"
                                    outlined
                                    rounded
                                    x-small
                                    @click="
                                      UpdatePackage(
                                        item.packageId,
                                        'ตกลง',
                                        item.packageName,
                                        item,
                                        item.token
                                      )
                                    "
                                    >ตกลง</v-btn
                                  >
                                  <v-btn
                                    class="mr-4 mt-3"
                                    v-if="
                                      item.packageId === packageId &&
                                        item.token !== tokenPackage
                                    "
                                    color="green"
                                    outlined
                                    rounded
                                    x-small
                                    @click="
                                      UpdatePackage(
                                        item.packageId,
                                        'ตกลง',
                                        item.packageName,
                                        item,
                                        item.token
                                      )
                                    "
                                    >ตกลง</v-btn
                                  >
                                  <v-btn
                                    class="mr-4 mt-3"
                                    v-if="
                                      item.packageId === packageId &&
                                        item.token === tokenPackage
                                    "
                                    color="red"
                                    outlined
                                    rounded
                                    x-small
                                    @click="
                                      UpdatePackage(
                                        item.packageId,
                                        'ยกเลิก',
                                        item.packageName,
                                        item,
                                        item.token
                                      )
                                    "
                                    >ยกเลิก</v-btn
                                  >
                                </v-row>
                                <v-row class="font14 headline1">
                                  <v-col class="pl-0 pt-0 pb-0"
                                    >จำนวนการใช้ {{ item.balanceAmount }} /
                                    {{ item.amount }}
                                  </v-col>
                                </v-row>
                                <v-row class="font14 headline1">
                                  <v-col class="pl-0 pt-0 pb-0">
                                    <VueCustomTooltip
                                      label="สามารถใช้ได้"
                                      position="is-top"
                                      v-if="dateTimestamp <= item.expirePackage"
                                    >
                                      <v-icon large color="teal darken-2">
                                        mdi-clock-check
                                      </v-icon>
                                    </VueCustomTooltip>
                                    <VueCustomTooltip
                                      label="หมดอายุแล้ว"
                                      position="is-top"
                                      v-if="dateTimestamp > item.expirePackage"
                                    >
                                      <v-icon large color="red darken-2">
                                        mdi-clock-alert
                                      </v-icon>
                                    </VueCustomTooltip>
                                    >> วันหมดอายุ
                                    {{
                                      new Date(item.expirePackage * 1000)
                                        .toLocaleString()
                                        .substr(0, 9)
                                    }}
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-slide-item>
                      </v-slide-group>
                    </v-card>
                    <br />
                  </v-col>
                  <v-col cols="12" class="pb-0">
                    <v-autocomplete
                      v-model="empSelect"
                      :items="empSelectStep"
                      label="พนักงานที่รับนัดหมาย"
                      :disabled="(shopNameData.officeOmbudsman === $session.getAll().data.shopId && dataConfirm.empSelect !== null) ? true : false"
                      outlined
                      dense
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row
                v-if="$session.getAll().data.shopId === shopNameData.udon1 || $session.getAll().data.shopId === shopNameData.udon2">
                <v-col class="pb-0"  cols="12">
                    <v-checkbox
                      style="width:fit-content"
                      v-model="statusPushEndConfirm"
                      label="ส่งยอดค่าใช้จ่ายไปยังลูกค้า"
                      true-value="True"
                      false-value="False"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <v-textarea
                      v-model="remark"
                      outlined
                      label="หมายเหตุเพิ่มเติม"
                      auto-grow
                    ></v-textarea>
                  </v-col>
                </v-row>
                <div class="text-center">
                  <v-btn
                    elevation="2"
                    color="#173053"
                    dark
                    block
                    large
                    :loading="loadingConfirm"
                    @click="onConfirm(dataConfirm)"
                    >ยืนยันรายการนี้</v-btn
                  >
                </div>
              </v-container>
            </v-card-text>
            <div class="text-center" v-if="!dataConfirmReady">
              <waitingAlert></waitingAlert>
            </div>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogEditData" :max-width="dialogwidth">
          <!-- <v-dialog v-model="dialogAdd" persistent max-width="70%"> -->
          <v-card class="text-center">
            <v-card-text>
              <v-row>
                <v-col cols="6" class="text-left pt-10">
                  <h3><strong>แก้ไขข้อมูล</strong></h3>
                </v-col>
                <v-col cols="6" class="pt-10">
                  <div style="text-align: end;">
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      dark
                      color="white"
                      :style="styleCloseBt"
                      @click="
                        (dialogEditData = false), (this.dataEditReady = true)
                      "
                    >
                      X
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="12">
                  <v-col
                    class="pb-0 pt-0"
                    cols="12"
                    v-if="
                      dataPackage.filter(el => {
                        return (
                          el.balanceAmount > 0 &&
                          el.packageId === packageId &&
                          el.token === tokenPackage
                        );
                      }).length > 0 && dataPackageDefault === true
                    "
                  >
                    <v-card class="pl-1">
                      <!-- <v-subheader>ลูกค้ามี {{dataPackage.filter(el => { return el.balanceAmount > 0 && el.packageId === packageId && el.token === tokenPackage }).length}} แพ็คเกจ</v-subheader> -->
                      <v-subheader v-show="StatusPackage.packageName"
                        >ลูกค้าได้ทำการเลือกแพ็คเกจ
                        {{ StatusPackage.packageName }}</v-subheader
                      >
                      <v-slide-group
                        v-model="modelPackageIndexConfirm"
                        center-active
                        show-arrows
                      >
                        <v-slide-item
                          v-for="(item, index) in dataPackage.filter(el => {
                            return (
                              el.balanceAmount > 0 &&
                              el.packageId === packageId &&
                              el.token === tokenPackage
                            );
                          })"
                          :key="index"
                        >
                          <v-card
                            class="ma-2 p-1"
                            width="340"
                            height="100"
                            color="#FFFFFF"
                            elevation="6"
                            :style="
                              item.packageId === packageId &&
                              item.token === tokenPackage
                                ? 'border: 1px solid green;'
                                : 'border: 1px solid white;'
                            "
                          >
                            <v-row>
                              <v-col cols="4" class="pr-1">
                                <v-img
                                  contain
                                  max-height="80"
                                  max-width="200"
                                  :src="item.packageImg"
                                ></v-img>
                              </v-col>
                              <v-col cols="8" class="pb-6">
                                <v-row class="font16 headline1">
                                  <v-col class="pl-0 pt-2 pb-0">{{
                                    item.packageName
                                  }}</v-col>
                                  <!-- <v-btn class="mr-4 mt-3" v-if="item.packageId !== packageId" color="green" outlined rounded x-small @click="UpdatePackage(item.packageId,'ตกลง',item.packageName, item)">ตกลง</v-btn>
                                        <v-btn class="mr-4 mt-3" v-if="item.packageId === packageId" color="red" outlined rounded x-small @click="UpdatePackage(item.packageId,'ยกเลิก',item.packageName, item)">ยกเลิก</v-btn> -->
                                </v-row>
                                <v-row class="font14 headline1">
                                  <v-col class="pl-0 pt-0 pb-0"
                                    >จำนวนการใช้ {{ item.balanceAmount }} /
                                    {{ item.amount }}
                                  </v-col>
                                </v-row>
                                <v-row class="font14 headline1">
                                  <v-col class="pl-0 pt-0 pb-0">
                                    <VueCustomTooltip
                                      label="สามารถใช้ได้"
                                      position="is-top"
                                      v-if="dateTimestamp <= item.expirePackage"
                                    >
                                      <v-icon large color="teal darken-2">
                                        mdi-clock-check
                                      </v-icon>
                                    </VueCustomTooltip>
                                    <VueCustomTooltip
                                      label="หมดอายุแล้ว"
                                      position="is-top"
                                      v-if="dateTimestamp > item.expirePackage"
                                    >
                                      <v-icon large color="red darken-2">
                                        mdi-clock-alert
                                      </v-icon>
                                    </VueCustomTooltip>
                                    >> วันหมดอายุ
                                    {{
                                      new Date(item.expirePackage * 1000)
                                        .toLocaleString()
                                        .substr(0, 9)
                                    }}
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-slide-item>
                      </v-slide-group>
                    </v-card>
                    <br />
                  </v-col>
                  <v-form ref="form_edit" v-model="validEdit" lazy-validation>
                    <v-col cols="12" v-if="dataEditReady">
                      <v-autocomplete
                        v-model="formEdit.masBranchID"
                        :items="branch"
                        label="สาขา"
                        outlined
                        dense
                        required
                        :rules="[rules.required]"
                        @change="setFlowByBranchEdit()"
                      ></v-autocomplete>
                      <v-autocomplete
                        v-model="formEdit.flowId"
                        :items="dataFlowSelectEdit"
                        label="ประเภทบริการ"
                        outlined
                        dense
                        required
                        @change="
                          SetallowedDatesEdit(),
                            checkTimeEdit(),
                            (dateEdit = '')
                        "
                        :rules="[rules.required]"
                      ></v-autocomplete>
                      <template v-if="BookingDataItemEdit">
                        <div
                          v-for="(item, index) in BookingDataItemEdit"
                          :key="index"
                        >
                          <template
                            v-if="
                              item.conditionField === '' ||
                                item.conditionField === null
                            "
                          >
                            <v-col
                              cols="12"
                              class="InputData"
                              v-if="item.fieldType == 'text'"
                            >
                              <v-text-field
                                v-if="item.fieldName === 'เบอร์โทร'"
                                v-mask="'###-###-####'"
                                v-model="item.fieldValue"
                                :label="item.fieldName"
                                outlined
                                dense
                                required
                                :rules="
                                  item.requiredField === 'True'
                                    ? [rules.required]
                                    : [true]
                                "
                               @blur="builValue(item)"
                              ></v-text-field>
                              <v-text-field
                                v-else
                                v-model="item.fieldValue"
                                :label="item.fieldName"
                                outlined
                                dense
                                required
                                :rules="
                                  item.requiredField === 'True'
                                    ? [rules.required]
                                    : [true]
                                "
                              @blur="builValue(item)"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              class="InputData"
                              v-if="item.fieldType == 'number'"
                            >
                              <v-text-field
                                v-if="item.fieldName === 'เบอร์โทร'"
                                v-mask="'###-###-####'"
                                v-model="item.fieldValue"
                                :label="item.fieldName"
                                outlined
                                dense
                                required
                                :rules="
                                  item.requiredField === 'True'
                                    ? [rules.required]
                                    : [true]
                                "
                                @blur="builValue(item)"
                              ></v-text-field>
                              <v-text-field
                                v-else
                                v-model="item.fieldValue"
                                :label="item.fieldName"
                                outlined
                                dense
                                required
                                :rules="
                                  item.requiredField === 'True'
                                    ? [rules.required]
                                    : [true]
                                "
                                @blur="builValue(item)"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              class="InputData"
                              v-if="item.fieldType == 'dateTime'"
                            >
                              <v-menu
                                v-model="menuEdit1"
                                :close-on-content-click="false"
                                :return-value.sync="date"
                                :rules="[rules.required]"
                                transition="scale-transition"
                                offset-y
                                required
                                min-width="auto"
                                ref="menuEdit1"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="item.fieldValue"
                                    readonly
                                    :label="item.fieldName"
                                    outlined
                                    dense
                                    v-bind="attrs"
                                    v-on="on"
                                    required
                                    prepend-inner-icon="mdi-calendar"
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                  >
                                  </v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="item.fieldValue"
                                  no-title
                                  scrollable
                                  @input="
                                    (menuEdit1 = false),
                                      $refs.menuEdit1.save(item.fieldValue)
                                  "
                                >
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col
                              cols="12"
                              class="InputData"
                              v-if="item.fieldType == 'Autocompletes'"
                            >
                              <v-autocomplete
                                v-model="item.fieldValue"
                                :items="JSON.parse(item.optionField)"
                                outlined
                                :label="item.fieldName"
                                required
                                dense
                                :rules="
                                  item.requiredField === 'True'
                                    ? [rules.required]
                                    : [true]
                                "
                                @change="builValue(item)"
                              ></v-autocomplete>
                            </v-col>
                            <v-col
                              cols="12"
                              class="InputData"
                              v-if="item.fieldType == 'Selects'"
                            >
                              <v-select
                                class="mb-6"
                                v-model="item.fieldValue"
                                :items="JSON.parse(item.optionField)"
                                menu-props="auto"
                                :label="item.fieldName"
                                required
                                :rules="
                                  item.requiredField === 'True'
                                    ? [rules.required]
                                    : [true]
                                "
                                dense
                                clearable
                                outlined
                                 @change="builValue(item)"
                              ></v-select>
                            </v-col>
                            <v-col
                              cols="12"
                              class="InputData"
                              v-if="item.fieldType == 'Radio'"
                              style="padding:0px;"
                            >
                              <v-container fluid style="padding:0px;">
                                <v-radio-group
                                  column
                                  dense
                                  v-model="item.fieldValue"
                                  style="margin:0px;"
                                  @change="builValue(item)"
                                >
                                  <template v-slot:label> </template>
                                  <div
                                    v-for="radios in JSON.parse(
                                      item.optionField
                                    )"
                                    :key="radios.toISOString"
                                  >
                                    <v-radio
                                      :label="radios.text"
                                      dense
                                      :value="radios.value"
                                    ></v-radio>
                                  </div>
                                </v-radio-group>
                              </v-container>
                            </v-col>
                            <v-col
                            cols="12"
                            class="InputData"
                            v-if="item.fieldType == 'Checkbox'"
                            style="padding: 0;"
                            >
                              <div>
                                <p
                                  style="
                                    text-align: left;
                                    display: block;
                                    font-size: 16px;
                                    margin-bottom: 10px;
                                  "
                                >
                                  {{ item.fieldName }}
                                </p>
                                <div
                                  v-for="(checkbox, index) in JSON.parse(item.optionField)"
                                  :key="checkbox.text"
                                >
                                  <v-container
                                    fluid
                                    class="pa-0 pt-0"
                                    :class="{
                                      'mb-1': index !== JSON.parse(item.optionField).length - 1, // ระยะปกติ
                                      'mb-5': index === JSON.parse(item.optionField).length - 1, // ตัวสุดท้าย
                                    }"
                                  >
                                    <span style="display: none;">{{ item.fieldValue }}</span>
                                    <v-checkbox
                                      v-model="selected[item.fieldId]"
                                      :label="languageSelect === 0 ? checkbox.text : checkbox.textEng"
                                      :value="checkbox.value"
                                      :rules="item.requiredField === 'True' ? [rules.checkBox] : [true]"
                                      @click="item.fieldValue = JSON.stringify(selected[item.fieldId] || [])"
                                      class="pt-1 mt-2 ps-3"
                                    >
                                    </v-checkbox>
                                  </v-container>
                                </div>
                              </div>
                            </v-col>
                          </template>
                          <template
                            v-if="
                              item.conditionField !== '' &&
                                BookingDataItemEdit.filter(row => {
                                  return (
                                    row.fieldId ===
                                    parseInt(item.conditionField)
                                  );
                                }).length > 0
                            "
                          >
                            <template
                              v-if="
                                item.conditionValue ===
                                  BookingDataItemEdit.filter(row => {
                                    return (
                                      row.fieldId ===
                                      parseInt(item.conditionField)
                                    );
                                  })[0].fieldValue
                              "
                            >
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'text'"
                              >
                                <v-text-field
                                  v-if="item.fieldName === 'เบอร์โทร'"
                                  v-model="item.fieldValue"
                                  :label="item.fieldName"
                                  v-mask="'###-###-####'"
                                  outlined
                                  dense
                                  required
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                  @blur="builValue(item)"
                                ></v-text-field>
                                <v-text-field
                                  v-else
                                  v-model="item.fieldValue"
                                  :label="item.fieldName"
                                  outlined
                                  required
                                  dense
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                  @blur="builValue(item)"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'number'"
                              >
                                <v-text-field
                                  v-if="item.fieldName === 'เบอร์โทร'"
                                  v-mask="'###-###-####'"
                                  v-model="item.fieldValue"
                                  :label="item.fieldName"
                                  outlined
                                  required
                                  dense
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                  @blur="builValue(item)"
                                ></v-text-field>
                                <v-text-field
                                  v-else
                                  v-model="item.fieldValue"
                                  :label="item.fieldName"
                                  outlined
                                  required
                                  dense
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                  @blur="builValue(item)"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'dateTime'"
                              >
                                <v-menu
                                  v-model="menuEdit2[item.fieldId]"
                                  :close-on-content-click="false"
                                  :return-value.sync="date"
                                  :rules="[rules.required]"
                                  transition="scale-transition"
                                  offset-y
                                  required
                                  min-width="auto"
                                  :ref="menuEdit2[item.fieldId]"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="item.fieldValue"
                                      readonly
                                      :label="item.fieldName"
                                      outlined
                                      dense
                                      prepend-inner-icon="mdi-calendar"
                                      v-bind="attrs"
                                      v-on="on"
                                      required
                                      :rules="
                                        item.requiredField === 'True'
                                          ? [rules.required]
                                          : [true]
                                      "
                                    >
                                    </v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="item.fieldValue"
                                    no-title
                                    scrollable
                                    @input="
                                      (menuEdit2[item.fieldId] = false),
                                        $refs.menuEdit2[item.fieldId].save(item.fieldValue)
                                    "
                                  >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'Autocompletes'"
                              >
                                <v-autocomplete
                                  v-model="item.fieldValue"
                                  :items="JSON.parse(item.optionField)"
                                  outlined
                                  :label="item.fieldName"
                                  required
                                  dense
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                               @change="builValue(item)"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'Selects'"
                              >
                                <v-select
                                  class="mb-6"
                                  v-model="item.fieldValue"
                                  :items="JSON.parse(item.optionField)"
                                  menu-props="auto"
                                  :label="item.fieldName"
                                  required
                                  dense
                                  clearable
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                  @change="builValue(item)"
                                  outlined
                                ></v-select>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'Radio'"
                                style="padding:0px;"
                                @change="builValue(item)"
                              >
                                <v-container fluid style="padding:0px;">
                                  <v-radio-group
                                    row
                                    dense
                                    v-model="item.fieldValue"
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                    style="margin:0px;"
                                  >
                                    <template v-slot:label> </template>
                                    <div
                                      v-for="radios in JSON.parse(
                                        item.optionField
                                      )"
                                      :key="radios.toISOString"
                                    >
                                      <v-radio
                                        :label="radios.text"
                                        :value="radios.value"
                                        dense
                                      ></v-radio>
                                    </div>
                                  </v-radio-group>
                                </v-container>
                              </v-col>
                            </template>
                          </template>
                          <template v-if="item.conditionField === 'flow'">
                            <template
                              v-if="
                                parseInt(item.conditionValue) ===
                                  parseInt(formEdit.flowId)
                              "
                            >
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'text'"
                              >
                                <v-text-field
                                  v-if="item.fieldName === 'เบอร์โทร'"
                                  v-mask="'###-###-####'"
                                  v-model="item.fieldValue"
                                  :label="item.fieldName"
                                  dense
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                  outlined
                                  @blur="builValue(item)"
                                ></v-text-field>
                                <v-text-field
                                  v-else
                                  v-model="item.fieldValue"
                                  :label="item.fieldName"
                                  dense
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                  outlined
                                  @blur="builValue(item)"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'number'"
                              >
                                <v-text-field
                                  v-if="item.fieldName === 'เบอร์โทร'"
                                  v-mask="'###-###-####'"
                                  v-model="item.fieldValue"
                                  :label="item.fieldName"
                                  dense
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                  outlined
                                  @blur="builValue(item)"
                                ></v-text-field>
                                <v-text-field
                                  v-else
                                  v-model="item.fieldValue"
                                  :label="item.fieldName"
                                  dense
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                  outlined
                                  @blur="builValue(item)"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'dateTime'"
                              >
                                <v-menu
                                  v-model="menuEdit3[item.fieldId]"
                                  :close-on-content-click="false"
                                  :return-value.sync="date"
                                  :rules="[rules.required]"
                                  transition="scale-transition"
                                  offset-y
                                  required
                                  min-width="auto"
                                  :ref="menuEdit3[item.fieldId]"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="item.fieldValue"
                                      readonly
                                      :label="item.fieldName"
                                      outlined
                                      dense
                                      prepend-inner-icon="mdi-calendar"
                                      v-bind="attrs"
                                      v-on="on"
                                      required
                                      :rules="
                                        item.requiredField === 'True'
                                          ? [rules.required]
                                          : [true]
                                      "
                                      @blur="builValue(item)"
                                    >
                                    </v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="item.fieldValue"
                                    no-title
                                    scrollable
                                    @input="
                                      (menuEdit3[item.fieldId] = false),
                                        $refs.menuEdit3[item.fieldId].save(item.fieldValue)
                                    "
                                  >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'Autocompletes'"
                              >
                                <v-autocomplete
                                  v-model="item.fieldValue"
                                  :items="JSON.parse(item.optionField)"
                                  dense
                                  filled
                                  :label="item.fieldName"
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                 @change="builValue(item)"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'Selects'"
                              >
                                <v-select
                                  class="mb-6"
                                  v-model="item.fieldValue"
                                  :items="JSON.parse(item.optionField)"
                                  menu-props="auto"
                                  :label="item.fieldName"
                                  dense
                                  clearable
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                  hide-details
                                  outlined
                                @change="builValue(item)"
                                ></v-select>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType === 'Radio'"
                                style="padding:0px;"
                                @change="builValue(item)"
                              >
                                <v-container fluid style="padding:0px;">
                                  <v-radio-group
                                    row
                                    v-model="item.fieldValue"
                                    style="margin:0px;"
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                  >
                                    <template v-slot:label> </template>
                                    <div
                                      v-for="radios in JSON.parse(
                                        item.optionField
                                      )"
                                      :key="radios.toISOString"
                                      class="text-center"
                                    >
                                      <v-radio
                                        :label="radios.text"
                                        dense
                                        :value="radios.value"
                                      ></v-radio>
                                    </div>
                                  </v-radio-group>
                                </v-container>
                              </v-col>
                            </template>
                          </template>
                        </div>
                      </template>
                      <v-row v-if="checkSelectText !== 'confirmJob'">
                        <v-col class="pb-0">
                          <v-menu
                            v-model="menuDateEdit"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="dateEdit"
                                label="วันที่นัดหมาย"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                dense
                                outlined
                                v-on="on"
                                required
                                :rules="[rules.required]"
                                @blur="builValue(item)"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="dateEdit"
                              :allowed-dates="allowedDatesEdit"
                              @input="
                                (menuDateEdit = false),
                                  setLimitBookingEdit(dateEdit)
                              "
                              :min="
                                new Date(
                                  Date.now() -
                                    new Date().getTimezoneOffset() * 60000
                                )
                                  .toISOString()
                                  .substr(0, 10)
                              "
                            ></v-date-picker>
                            <!-- <v-date-picker
                                  v-model="dateEdit"
                                  @input="menuDate = false"
                                ></v-date-picker> -->
                          </v-menu>
                        </v-col>
                        <v-col class="pb-0">
                          <!-- <v-select
                              v-model="timeEdit"
                              :items="timeavailable"
                              label="เวลา"
                              menu-props="auto"
                              outlined
                              dense
                            ></v-select> -->
                          <v-autocomplete
                            v-if="dateEdit !== ''"
                            v-model="timeEdit"
                            :items="timeavailable"
                            label="เวลา"
                            item-text="text"
                            item-value="text"
                            persistent-hint
                            return-object
                            outlined
                            dense
                            required
                            :rules="[rules.required]"
                            @change="builValue(item)"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <!-- แก้ไขเวลาสำหรับ joyride -->
                      <v-row
                        v-else-if="
                          $session.getAll().data.shopId ===
                            'U9f316c85400fd716ea8c80d7cd5b61f8'
                        "
                      >
                        <v-col class="pb-0">
                          <v-menu
                            v-model="menuDateEdit"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="dateEdit"
                                label="วันที่นัดหมาย"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                dense
                                outlined
                                v-on="on"
                                required
                                :rules="[rules.required]"
                                @blur="builValue(item)"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="dateEdit"
                              :allowed-dates="allowedDatesEdit"
                              @input="
                                (menuDateEdit = false),
                                  setLimitBookingEdit(dateEdit)
                              "
                              :min="
                                new Date(
                                  Date.now() -
                                    new Date().getTimezoneOffset() * 60000
                                )
                                  .toISOString()
                                  .substr(0, 10)
                              "
                            ></v-date-picker>
                            <!-- <v-date-picker
                                  v-model="dateEdit"
                                  @input="menuDate = false"
                                ></v-date-picker> -->
                          </v-menu>
                        </v-col>
                        <v-col class="pb-0">
                          <!-- <v-select
                              v-model="timeEdit"
                              :items="timeavailable"
                              label="เวลา"
                              menu-props="auto"
                              outlined
                              dense
                            ></v-select> -->
                          <v-autocomplete
                            v-if="dateEdit !== ''"
                            v-model="timeEdit"
                            :items="timeavailable"
                            label="เวลา"
                            item-text="text"
                            item-value="text"
                            persistent-hint
                            return-object
                            outlined
                            dense
                            required
                            :rules="[rules.required]"
                             @change="builValue(item)"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="
                          $session.getAll().data.shopId !==
                            'U9f316c85400fd716ea8c80d7cd5b61f8'
                        "
                      >
                        <v-col class="pt-0 pb-0">
                          <v-radio-group
                            v-model="formEdit.radiosRemark"
                            row
                            required
                            :rules="[rules.required]"
                            @change="builValue(item)"
                          >
                            <v-radio value="ซ่อมปกติ">
                              <template v-slot:label>
                                <div class="mt-3">
                                  <strong class="primary--text">{{
                                    dataTypeJob1
                                  }}</strong>
                                </div>
                              </template>
                            </v-radio>
                            <v-radio value="ExtraJob">
                              <template v-slot:label>
                                <div class="mt-3">
                                  <strong class="error--text">{{
                                    dataTypeJob2
                                  }}</strong>
                                </div>
                              </template>
                            </v-radio>
                            <v-radio value="FastTrack">
                              <template v-slot:label>
                                <div class="mt-3">
                                  <strong class="orange--text">{{
                                    dataTypeJob3
                                  }}</strong>
                                </div>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                      <v-row v-if="checkSelectText !== 'confirmJob'">
                        <v-col class="pt-0">
                          <v-autocomplete
                            v-if="
                              formEdit.masBranchID !== null &&
                                formEdit.masBranchID !== ''
                            "
                            v-model="empSelectEdit"
                            :items="
                              empSelectStepAdd.filter(
                                i =>
                                  i.masBranchID === formEdit.masBranchID ||
                                  i.masBranchID === ''
                              )
                            "
                            label="พนักงานที่รับนัดหมาย"
                            outlined
                            dense
                            @change="builValue(item)"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row v-if="statusShowMap === 'True'">
                        <v-col class="pb-0 pt-0" cols="12">
                          <v-text-field
                            v-model="address"
                            label="ชื่อของที่อยู่"
                            outlined
                            required
                            dense
                            :rules="[rules.required]"
                            @blur="builValue(item)"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-card class="p-3">
                            <v-card-text>
                              <v-row>
                                <v-col class="pb-0" cols="12">
                                  <h6>ค้นหาที่อยู่ลูกค้า :</h6>
                                </v-col>
                                <v-col class="pb-0 pt-0" id="divTest2" cols="12">
                                  <gmap-autocomplete
                                    class="introInput"
                                    placeholder="ค้นหาสถานที่"
                                    @place_changed="updatePlace"
                                    @keydown="testStyleInputGoogleMap('divTest2')"
                                    style="width: 100%; height: 45px; border: 1px solid;padding-left: 8px; border-radius: 4px;">
                                  </gmap-autocomplete>
                                </v-col>
                              </v-row>
                            </v-card-text>
                            <hr />
                            <!-- <gmap-autocomplete @place_changed="updatePlace"/> -->
                            <v-card-text>
                              <GmapMap
                                v-if="center !== null"
                                :center="center"
                                :zoom="15"
                                style="width: 100%; height: 200px"
                                :options="{
                                  disableDefaultUI: true,
                                  fullscreenControl: true,
                                  zoomControl: true,
                                  gestureHandling: 'greedy',
                                }"
                              >
                                <GmapMarker
                                  :position="center"
                                  :draggable="true"
                                  @drag="updateCoordinates"
                                />
                              </GmapMap>
                            </v-card-text>
                          </v-card>
                          <br />
                        </v-col>
                      </v-row>
                      <div class="text-center">
                        <v-btn
                          elevation="2"
                          large
                          color="#173053"
                          block
                          class="text-white"
                          :loading="loadingEdit"
                          :disabled="loadingEdit"
                          @click="editDataSelect()"
                        >
                          <template v-slot:loader>
                            <span class="custom-loader">
                              <v-icon light>mdi-cached</v-icon>
                            </span>
                          </template>
                          <v-icon left>mdi-checkbox-marked-circle</v-icon>
                          แก้ไขข้อมูล
                        </v-btn>
                        <!-- <v-btn
                              elevation="2"
                              large
                              color="red"
                              dark
                              @click="dialogEditData = false"
                            >
                              <v-icon left>mdi-close</v-icon>
                              ปิด
                            </v-btn> -->
                      </div>
                    </v-col>
                  </v-form>
                  <div class="text-center" v-if="!dataEditReady">
                    <waitingAlert></waitingAlert>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogAddCon" persistent max-width="500px">
          <v-card>
            <v-card-title class="text-h5">
              บันทึกข้อมูล
            </v-card-title>
            <v-card-text>ต้องการ บันทึกข้อมูล ใช่หรือไม่?</v-card-text>
            <v-card-actions v-if="dataReadyAdd">
              <v-spacer></v-spacer>
              <v-btn
                dark
                color="red darken-1"
                @click="(dialogAddCon = false), (loadingAdd = false)"
              >
                ตรวจสอบอีกครั้ง
              </v-btn>
              <v-btn dark color="green darken-1" @click="addDataInsert()">
                บันทึกข้อมูล
              </v-btn>
            </v-card-actions>
            <div class="text-center" v-if="!dataReadyAdd">
              <waitingAlert></waitingAlert>
            </div>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogError" persistent max-width="500px">
          <v-card>
            <v-card-title class="text-h5">
              ผิดพลาด
            </v-card-title>
            <v-card-text>{{ textError }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn dark color="red darken-1" @click="dialogError = false">
                ตรวจสอบอีกครั้ง
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogTag" persistent max-width="40%">
          <v-card>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="6" class="text-left pt-10">
                    <h3><strong>อัพเดท Tag</strong></h3>
                  </v-col>
                  <v-col cols="6" class="pt-10">
                    <div style="text-align: end;">
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        dark
                        color="white"
                        :style="styleCloseBt"
                        @click="dialogTag = false"
                      >
                        X
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="tagData"
                      :items="tagItem"
                      outlined
                      dense
                      chips
                      small-chips
                      label="รายการ Tag"
                      multiple
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-btn
                      elevation="2"
                      large
                      block
                      color="wait"
                      text
                      @click="editTagData()"
                      :loading="loadingTag"
                      :disabled="loadingTag"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      อัพเดท
                    </v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-btn
                      elevation="2"
                      large
                      block
                      color="success"
                      text
                      @click="dialogAddTag = true"
                      :loading="loadingTag"
                      :disabled="loadingTag"
                    >
                      <v-icon left>mdi-tag-plus</v-icon>
                      เพิ่ม Tag
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDeposit" persistent max-width="80%">
          <v-card>
            <v-container>
              <v-row style="padding-left: 2%;padding-top: 2%;">
                <v-col cols="6" class="text-left">
                  <h3><strong>อัพเดทหลักฐานเงินมัดจำ</strong></h3>
                </v-col>
                <v-col cols="6">
                  <div style="text-align: end;">
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      dark
                      color="white"
                      :style="styleCloseBt"
                      @click="
                        (dialogDeposit = false),
                          (pictureUrlPreviewDeposit = null),
                          (dataMenu = []),
                          (priceMenu = null)
                      "
                    >
                      X
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-container>
            <v-row>
              <v-col cols="12">
                <!-- <v-col :cols="dataMenu.length > 1 ? 6 : 12"> -->
                <v-card-text v-if="pictureUrlPreviewDeposit === ''">
                  <v-alert dense border="left" type="warning">
                    <strong>ไม่มี รูปหลักฐานการมัดจำ</strong>
                  </v-alert>
                  <v-file-input
                    required
                    :rules="[rules.resizeImag]"
                    counter
                    show-size
                    accept="image/png, image/jpeg, image/bmp"
                    prepend-icon="mdi-camera"
                    label="รูปหลักฐานการมัดจำ"
                    @change="selectImgDeposit"
                    v-model="filesDeposit"
                  ></v-file-input>
                </v-card-text>
                <v-card-text v-else>
                  <v-container>
                    <v-form
                      ref="form_deposit"
                      v-model="valid_deposit"
                      lazy-validation
                    >
                      <v-row justify="center">
                        <v-col cols="12" class="text-center">
                          <v-img
                            aspect-ratio="6"
                            height="500"
                            contain
                            @click="gotoPicture(pictureUrlPreviewDeposit)"
                            :src="pictureUrlPreviewDeposit"
                          ></v-img>
                          <br />
                          <v-file-input
                            required
                            :rules="[rules.resizeImag]"
                            counter
                            show-size
                            accept="image/png, image/jpeg, image/bmp"
                            prepend-icon="mdi-camera"
                            label="รูปหลักฐานการมัดจำ"
                            @change="selectImgDeposit"
                            v-model="filesDeposit"
                          ></v-file-input>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-col>
            </v-row>
            <!-- <v-btn
                  elevation="2"
                  x-large
                  color="red darken-1"
                  text
                  @click="dialogDeposit = false, pictureUrlPreviewDeposit = null"
                  :loading="loadingDeposit"
                  :disabled="loadingDeposit"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn> -->
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                x-large
                color="success"
                text
                @click="editStatusDeposit()"
                :loading="loadingDeposit"
                :disabled="loadingDeposit"
              >
                <v-icon left>mdi-checkbox-marked-circle</v-icon>
                อัพเดท
              </v-btn>
              <v-btn
                v-if="statusDeposit === true"
                elevation="2"
                x-large
                color="error"
                text
                @click="cancelStatusDeposit()"
                :loading="loadingDeposit"
                :disabled="loadingDeposit"
              >
                <v-icon left>mdi-checkbox-marked-circle</v-icon>
                ยกเลิกสถานะเงินมัดจำ
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogAddTag" persistent max-width="40%">
          <v-card>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="6" class="text-left pt-10">
                    <h3><strong>เพิ่ม Tag</strong></h3>
                  </v-col>
                  <v-col cols="6" class="pt-10">
                    <div style="text-align: end;">
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        dark
                        color="white"
                        :style="styleCloseBt"
                        @click="(dialogAddTag = false), (tagName = '')"
                      >
                        X
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="tagName"
                      label="กรอกข้อมูล Tag"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
                <div class="text-center">
                  <v-btn large block color="#173053" dark @click="AddDataTag()">
                    บันทึก
                  </v-btn>
                </div>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialogHistory"
          scrollable
          persistent
          max-width="600px"
        >
          <v-card class="pa-3">
            <v-card-title>
              <span class="headline"></span>
            </v-card-title>
            <v-card-text class="pa-0" style="overflow-x: hidden;">
              <v-row>
                <v-col cols="6" class="text-left pt-10">
                  <h3><strong>ประวัติเข้ารับบริการ</strong></h3>
                </v-col>
                <v-col cols="6" class="pt-10">
                  <div style="text-align: end;">
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      dark
                      color="white"
                      :style="styleCloseBt"
                      @click="dialogHistory = false"
                    >
                      X
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="main" col="12" md="12" sm="12">
                  <v-card class="p-3 " min-height="70vh" rounded>
                    <div class="avatar text-center pt-3">
                      <div
                        style="display:flex;align-items: center;justify-content: center;"
                      >
                        <h4 v-if="memberName">
                          {{ memberName }}
                        </h4>
                        <v-btn
                          v-if="memberName"
                          class="ml-3"
                          dark
                          fab
                          x-small
                          color="blue"
                          @click="coppyLink(memberName)"
                        >
                          <v-icon dark>
                            mdi-content-copy
                          </v-icon>
                        </v-btn>
                      </div>
                      <v-avatar size="120" style="border:5px solid #FFFFFF;">
                        <v-img
                          v-if="pictureUrHistory"
                          :src="pictureUrHistory"
                        ></v-img>
                        <v-icon size="100" color="orange" v-else>
                          mdi-tooltip-account
                        </v-icon>
                      </v-avatar>
                    </div>
                    <div v-if="memberName" class="text-center my-3">
                      <v-btn dark small color="#2BC155" @click="gotoLineOa()">
                        LINE OA
                      </v-btn>
                    </div>
                    <br />
                    <v-select
                      v-model="phonenum"
                      :items="phonenumItem"
                      label="ค้นหาเบอร์โทร"
                      dense
                      solo
                      @change="SelectDataHistory"
                    ></v-select>
                    <v-timeline align-top dense v-if="phonenum.length > 0">
                      <v-timeline-item
                        v-for="(item, index) in HistoryData[0]"
                        :key="index"
                      >
                        <template v-slot:icon>
                          <v-icon small dark> event</v-icon>
                        </template>
                        <div v-for="(item2, index2) in item" :key="index2">
                          <v-card-text class="text-start"
                            ><h6 class="font-weight-bold">
                              {{ format_dateThai(item2[0].dueDate) }}
                            </h6></v-card-text
                          >
                          <v-card-text class="text-start"
                            ><h6 class="font-weight-bold">
                              {{ item2[0].flowName }}
                            </h6></v-card-text
                          >
                          <v-card-text class="text-start"
                            ><h6 class="font-weight-bold">
                              {{ item2[0].masBranchName }}
                            </h6></v-card-text
                          >
                          <div v-for="(item3, index3) in item2" :key="index3">
                            <v-card-text
                              class="text-start"
                              v-if="item3.fieldValue !== ''"
                              ><strong>{{ item3.fieldName }} : </strong>
                              <!-- {{ item3.fieldValue }} -->
                              <span v-if="item3.fieldType === 'Checkbox'">{{ Array.isArray(item3.fieldValue) ? item3.fieldValue.join(', ') : JSON.parse(item3.fieldValue).join(', ') }}</span>
                              <span v-else>{{ item3.fieldValue }}</span>
                            </v-card-text>
                          </div>
                          <div>
                            <v-card-text
                              class="text-start"
                              ><strong>หมายเหตุ : </strong>
                              <span>{{ item2[0].remark }}</span>
                            </v-card-text>
                          </div>
                          <br />
                          <v-card-text
                            v-if="
                              item2[0].depositStatus === 'True' &&
                                (item2[0].depositImge !== '' ||
                                  item2[0].depositImge !== null)
                            "
                          >
                            <v-img
                              aspect-ratio="6"
                              height="500"
                              contain
                              @click="gotoPicture(item2[0].depositImge)"
                              :src="item2[0].depositImge"
                            ></v-img>
                          </v-card-text>
                          <v-card-text
                            v-if="
                              item2[0].statusUpload1 === 'True' ||
                                item2[0].statusUpload2 === 'True'
                            "
                          >
                            <v-row>
                              <v-col
                                cols="auto"
                                v-if="item2[0].statusUpload1 === 'True'"
                              >
                                <v-btn
                                  tile
                                  color="#173053"
                                  dark
                                  small
                                  @click="showFileUpload(item2[0], '1')"
                                >
                                  <v-icon left>
                                    mdi-file-find
                                  </v-icon>
                                  Show File 1
                                </v-btn>
                              </v-col>
                              <v-col
                                cols="auto"
                                v-if="item2[0].statusUpload2 === 'True'"
                              >
                                <v-btn
                                  tile
                                  color="#173053"
                                  dark
                                  small
                                  @click="showFileUpload(item2[0], '2')"
                                >
                                  <v-icon left>
                                    mdi-file-find
                                  </v-icon>
                                  Show File 2
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </div>
                      </v-timeline-item>
                    </v-timeline>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- DIALOG ค่าใช้จ่าย -->
        <v-dialog v-model="dialogCloseJob" persistent max-width="400px">
          <v-card v-if="checkPayment === 'True'">
            <center>
              <v-col>
                <v-img
                  :aspect-ratio="1"
                  width="300"
                  height="100%"
                  :src="require('@/assets/paymentCloseJob.png')"
                ></v-img>
              </v-col>
            </center>
            <v-col class="text-center">
              <span class="headline">ค่าใช้จ่าย</span>
            </v-col>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col class="pb-0" cols="12" v-if="dataCoin.length > 0">
                    <v-subheader>แจกคะแนน Loyalty</v-subheader>
                    <v-select
                      v-model="productExchangeRateId"
                      :items="dataCoin"
                      dense
                      outlined
                      label="เลือกอัตราแลกเปลี่ยน *"
                      clearable
                      item-text="text"
                      item-value="value"
                      return-object
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" class="pb-0 pt-0">
                    <v-subheader>ค่าใช้จ่าย</v-subheader>
                    <VuetifyMoney
                      v-model="formCloseJob.totalPrice"
                      placeholder="ค่าใช้จ่ายทั้งหมด"
                      dense
                      label="ค่าใช้จ่ายทั้งหมด"
                      required
                      outlined
                      :rules="[rules.required]"
                      v-bind:options="options2"
                    />
                  </v-col>
                  <v-col class="pb-0" cols="12">
                    <v-checkbox
                      v-model="statusPushEndStep"
                      label="ส่งข้อความ ขึ้นตอนสุดท้าย ไปยังลูกค้า"
                      true-value="True"
                      false-value="False"
                    ></v-checkbox>
                  </v-col>
                  <v-col class="text-center" cols="12">
                    <v-btn
                      class="white--text"
                      elevation="2"
                      depressed
                      color="#1B437C"
                      :loading="loadingCloseJob"
                      :disabled="loadingCloseJob"
                      @click="closeJob()"
                    >
                      <v-icon dark left>mdi-checkbox-marked-circle</v-icon>
                      ชำระเงิน
                    </v-btn>
                    <v-btn
                      color="primary"
                      :loading="loadingCloseJob"
                      :disabled="loadingCloseJob"
                      depressed
                      @click="dialogCloseJob = false;"
                    >
                      <v-icon left> mdi-cancel</v-icon>
                      ยกเลิก
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
          <v-card v-if="checkPayment === 'False'">
            <center>
              <v-col>
                <v-img
                  :aspect-ratio="1"
                  width="300"
                  height="100%"
                  :src="require('@/assets/closeJob.png')"
                ></v-img>
              </v-col>
            </center>
            <v-col class="text-center">
              <span class="headline">ปิดงานนนี้</span>
            </v-col>
            <v-col class="pb-0" cols="12">
              <v-checkbox
                v-model="statusPushEndStep"
                label="ส่งข้อความ ขึ้นตอนสุดท้าย ไปยังลูกค้า"
                true-value="True"
                false-value="False"
              ></v-checkbox>
            </v-col>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col class="text-center" cols="12">
                    <v-btn
                      dark
                      elevation="2"
                      depressed
                      color="#1B437C"
                      @click="closeJob()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      ปิดงานนนี้
                    </v-btn>
                    <v-btn
                      color="primary"
                      depressed
                      @click="dialogCloseJob = false;"
                    >
                      <v-icon left> mdi-cancel</v-icon>
                      ยกเลิก
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end add -->
        <v-dialog
          v-model="dialogBookingAgain"
          persistent
          :max-width="dialogwidth"
        >
          <v-card class="text-center">
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="6" class="text-left pt-10">
                    <h3><strong>นัดหมายอีกครั้ง</strong></h3>
                  </v-col>
                  <v-col cols="6" class="pt-10">
                    <div style="text-align: end;">
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        dark
                        color="white"
                        :style="styleCloseBt"
                        @click="dialogBookingAgain = false"
                      >
                        X
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12">
                    <v-col
                      class="pb-0 pt-0"
                      cols="12"
                      v-if="
                        dataPackage.filter(el => {
                          return (
                            el.balanceAmount > 0 &&
                            el.packageId === packageId &&
                            el.token === tokenPackage
                          );
                        }).length > 0 && dataPackageDefault === true
                      "
                    >
                      <v-card class="pl-1">
                        <!-- <v-subheader>ลูกค้ามี {{dataPackage.filter(el => { return el.balanceAmount > 0 && el.packageId === packageId && el.token === tokenPackage }).length}} แพ็คเกจ</v-subheader> -->
                        <v-subheader v-show="StatusPackage.packageName"
                          >ลูกค้าได้ทำการเลือกแพ็คเกจ
                          {{ StatusPackage.packageName }}</v-subheader
                        >
                        <v-slide-group
                          v-model="modelPackageIndexConfirm"
                          center-active
                          show-arrows
                        >
                          <v-slide-item
                            v-for="(item, index) in dataPackage.filter(el => {
                              return (
                                el.balanceAmount > 0 &&
                                el.packageId === packageId &&
                                el.token === tokenPackage
                              );
                            })"
                            :key="index"
                          >
                            <v-card
                              class="ma-2 p-1"
                              width="340"
                              height="100"
                              color="#FFFFFF"
                              elevation="6"
                              :style="
                                item.packageId === packageId &&
                                item.token === tokenPackage
                                  ? 'border: 1px solid green;'
                                  : 'border: 1px solid white;'
                              "
                            >
                              <v-row>
                                <v-col cols="4" class="pr-1">
                                  <v-img
                                    contain
                                    max-height="80"
                                    max-width="200"
                                    :src="item.packageImg"
                                  ></v-img>
                                </v-col>
                                <v-col cols="8" class="pb-6">
                                  <v-row class="font16 headline1">
                                    <v-col class="pl-0 pt-2 pb-0">{{
                                      item.packageName
                                    }}</v-col>
                                    <!-- <v-btn class="mr-4 mt-3" v-if="item.packageId !== packageId" color="green" outlined rounded x-small @click="UpdatePackage(item.packageId,'ตกลง',item.packageName, item)">ตกลง</v-btn>
                                      <v-btn class="mr-4 mt-3" v-if="item.packageId === packageId" color="red" outlined rounded x-small @click="UpdatePackage(item.packageId,'ยกเลิก',item.packageName, item)">ยกเลิก</v-btn> -->
                                  </v-row>
                                  <v-row class="font14 headline1">
                                    <v-col class="pl-0 pt-0 pb-0"
                                      >จำนวนการใช้ {{ item.balanceAmount }} /
                                      {{ item.amount }}
                                    </v-col>
                                  </v-row>
                                  <v-row class="font14 headline1">
                                    <v-col class="pl-0 pt-0 pb-0">
                                      <VueCustomTooltip
                                        label="สามารถใช้ได้"
                                        position="is-top"
                                        v-if="
                                          dateTimestamp <= item.expirePackage
                                        "
                                      >
                                        <v-icon large color="teal darken-2">
                                          mdi-clock-check
                                        </v-icon>
                                      </VueCustomTooltip>
                                      <VueCustomTooltip
                                        label="หมดอายุแล้ว"
                                        position="is-top"
                                        v-if="
                                          dateTimestamp > item.expirePackage
                                        "
                                      >
                                        <v-icon large color="red darken-2">
                                          mdi-clock-alert
                                        </v-icon>
                                      </VueCustomTooltip>
                                      >> วันหมดอายุ
                                      {{
                                        new Date(item.expirePackage * 1000)
                                          .toLocaleString()
                                          .substr(0, 9)
                                      }}
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-slide-item>
                        </v-slide-group>
                      </v-card>
                      <br />
                    </v-col>
                    <v-form
                      ref="form_bookingAgain"
                      v-model="validBookingAgain"
                      lazy-validation
                    >
                      <v-col cols="12" v-if="dataEditReady">
                        <v-autocomplete
                          v-model="formEdit.flowId"
                          :items="dataFlowSelectEdit"
                          label="ประเภทบริการ"
                          outlined
                          dense
                          required
                          @change="
                            SetallowedDatesEdit(),
                              checkTimeEdit(),
                              (dateEdit = '')
                          "
                          :rules="[rules.required]"
                        ></v-autocomplete>
                        <v-autocomplete
                          v-model="formEdit.masBranchID"
                          :items="branch"
                          label="สาขา"
                          outlined
                          dense
                          required
                          :rules="[rules.required]"
                        ></v-autocomplete>
                        <template v-if="BookingDataItemEdit">
                          <div
                            v-for="(item, index) in BookingDataItemEdit"
                            :key="index"
                          >
                            <template
                              v-if="
                                item.conditionField === '' ||
                                  item.conditionField === null
                              "
                            >
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'text'"
                              >
                                <v-text-field
                                  v-if="item.fieldName === 'เบอร์โทร'"
                                  v-mask="'###-###-####'"
                                  v-model="item.fieldValue"
                                  :label="item.fieldName"
                                  outlined
                                  dense
                                  required
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                ></v-text-field>
                                <v-text-field
                                  v-else
                                  v-model="item.fieldValue"
                                  :label="item.fieldName"
                                  outlined
                                  dense
                                  required
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'number'"
                              >
                                <v-text-field
                                  v-if="item.fieldName === 'เบอร์โทร'"
                                  v-mask="'###-###-####'"
                                  v-model="item.fieldValue"
                                  :label="item.fieldName"
                                  outlined
                                  dense
                                  required
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                ></v-text-field>
                                <v-text-field
                                  v-else
                                  v-model="item.fieldValue"
                                  :label="item.fieldName"
                                  outlined
                                  dense
                                  required
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'dateTime'"
                              >
                                <v-menu
                                  v-model="menuEdit1[item.fieldId]"
                                  :close-on-content-click="false"
                                  :return-value.sync="date"
                                  :rules="[rules.required]"
                                  transition="scale-transition"
                                  offset-y
                                  required
                                  min-width="auto"
                                  :ref="menuEdit1[item.fieldId]"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="item.fieldValue"
                                      readonly
                                      :label="item.fieldName"
                                      outlined
                                      dense
                                      v-bind="attrs"
                                      v-on="on"
                                      required
                                      prepend-inner-icon="mdi-calendar"
                                      :rules="
                                        item.requiredField === 'True'
                                          ? [rules.required]
                                          : [true]
                                      "
                                    >
                                    </v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="item.fieldValue"
                                    no-title
                                    scrollable
                                    @input="
                                      (menuEdit1[item.fieldId] = false),
                                        $refs.menuEdit1[item.fieldId].save(item.fieldValue)
                                    "
                                  >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'Autocompletes'"
                              >
                                <v-autocomplete
                                  v-model="item.fieldValue"
                                  :items="JSON.parse(item.optionField)"
                                  outlined
                                  :label="item.fieldName"
                                  required
                                  dense
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'Selects'"
                              >
                                <v-select
                                  class="mb-6"
                                  v-model="item.fieldValue"
                                  :items="JSON.parse(item.optionField)"
                                  menu-props="auto"
                                  :label="item.fieldName"
                                  required
                                  :rules="
                                    item.requiredField === 'True'
                                      ? [rules.required]
                                      : [true]
                                  "
                                  dense
                                  clearable
                                  outlined
                                ></v-select>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'Radio'"
                                style="padding:0px;"
                              >
                                <v-container fluid style="padding:0px;">
                                  <v-radio-group
                                    column
                                    dense
                                    v-model="item.fieldValue"
                                    style="margin:0px;"
                                  >
                                    <template v-slot:label> </template>
                                    <div
                                      v-for="radios in JSON.parse(
                                        item.optionField
                                      )"
                                      :key="radios.toISOString"
                                    >
                                      <v-radio
                                        :label="radios.text"
                                        dense
                                        :value="radios.value"
                                      ></v-radio>
                                    </div>
                                  </v-radio-group>
                                </v-container>
                              </v-col>
                              <v-col
                                cols="12"
                                class="InputData"
                                v-if="item.fieldType == 'Checkbox'"
                                style="padding: 0;"
                              >
                                <div>
                                  <p
                                    style="
                                      text-align: left;
                                      display: block;
                                      font-size: 16px;
                                      margin-bottom: 10px;
                                    "
                                  >
                                    {{ item.fieldName }}
                                  </p>
                                  <div
                                    v-for="(checkbox, index) in JSON.parse(item.optionField)"
                                    :key="checkbox.text"
                                  >
                                    <v-container
                                      fluid
                                      class="pa-0 pt-0"
                                      :class="{
                                        'mb-1': index !== JSON.parse(item.optionField).length - 1, // ระยะปกติ
                                        'mb-5': index === JSON.parse(item.optionField).length - 1, // ตัวสุดท้าย
                                      }"
                                    >
                                      <span style="display: none;">{{ item.fieldValue }}</span>
                                      <v-checkbox
                                        v-model="selected[item.fieldId]"
                                        :label="languageSelect === 0 ? checkbox.text : checkbox.textEng"
                                        :value="checkbox.value"
                                        :rules="item.requiredField === 'True' ? [rules.checkBox] : [true]"
                                        @click="item.fieldValue = JSON.stringify(selected[item.fieldId] || [])"
                                        class="pt-1 mt-2 ps-3"
                                      >
                                      </v-checkbox>
                                    </v-container>
                                  </div>
                                </div>
                              </v-col>
                            </template>
                            <template
                              v-if="
                                item.conditionField !== '' &&
                                  BookingDataItemEdit.filter(row => {
                                    return (
                                      row.fieldId ===
                                      parseInt(item.conditionField)
                                    );
                                  }).length > 0
                              "
                            >
                              <template
                                v-if="
                                  item.conditionValue ===
                                    BookingDataItemEdit.filter(row => {
                                      return (
                                        row.fieldId ===
                                        parseInt(item.conditionField)
                                      );
                                    })[0].fieldValue
                                "
                              >
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'text'"
                                >
                                  <v-text-field
                                    v-if="item.fieldName === 'เบอร์โทร'"
                                    v-model="item.fieldValue"
                                    :label="item.fieldName"
                                    v-mask="'###-###-####'"
                                    outlined
                                    dense
                                    required
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                  ></v-text-field>
                                  <v-text-field
                                    v-else
                                    v-model="item.fieldValue"
                                    :label="item.fieldName"
                                    outlined
                                    required
                                    dense
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'number'"
                                >
                                  <v-text-field
                                    v-if="item.fieldName === 'เบอร์โทร'"
                                    v-mask="'###-###-####'"
                                    v-model="item.fieldValue"
                                    :label="item.fieldName"
                                    outlined
                                    required
                                    dense
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                  ></v-text-field>
                                  <v-text-field
                                    v-else
                                    v-model="item.fieldValue"
                                    :label="item.fieldName"
                                    outlined
                                    required
                                    dense
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'dateTime'"
                                >
                                  <v-menu
                                    v-model="menuEdit2[item.fieldId]"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    :rules="[rules.required]"
                                    transition="scale-transition"
                                    offset-y
                                    required
                                    min-width="auto"
                                    :ref="menuEdit2[item.fieldId]"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="item.fieldValue"
                                        readonly
                                        :label="item.fieldName"
                                        outlined
                                        dense
                                        prepend-inner-icon="mdi-calendar"
                                        v-bind="attrs"
                                        v-on="on"
                                        required
                                        :rules="
                                          item.requiredField === 'True'
                                            ? [rules.required]
                                            : [true]
                                        "
                                      >
                                      </v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="item.fieldValue"
                                      no-title
                                      scrollable
                                      @input="
                                        (menuEdit2[item.fieldId] = false),
                                          $refs.menuEdit2[item.fieldId].save(item.fieldValue)
                                      "
                                    >
                                    </v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'Autocompletes'"
                                >
                                  <v-autocomplete
                                    v-model="item.fieldValue"
                                    :items="JSON.parse(item.optionField)"
                                    outlined
                                    :label="item.fieldName"
                                    required
                                    dense
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                  ></v-autocomplete>
                                </v-col>
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'Selects'"
                                >
                                  <v-select
                                    class="mb-6"
                                    v-model="item.fieldValue"
                                    :items="JSON.parse(item.optionField)"
                                    menu-props="auto"
                                    :label="item.fieldName"
                                    required
                                    dense
                                    clearable
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                    outlined
                                  ></v-select>
                                </v-col>
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'Radio'"
                                  style="padding:0px;"
                                >
                                  <v-container fluid style="padding:0px;">
                                    <v-radio-group
                                      row
                                      dense
                                      v-model="item.fieldValue"
                                      :rules="
                                        item.requiredField === 'True'
                                          ? [rules.required]
                                          : [true]
                                      "
                                      style="margin:0px;"
                                    >
                                      <template v-slot:label> </template>
                                      <div
                                        v-for="radios in JSON.parse(
                                          item.optionField
                                        )"
                                        :key="radios.toISOString"
                                      >
                                        <v-radio
                                          :label="radios.text"
                                          :value="radios.value"
                                          dense
                                        ></v-radio>
                                      </div>
                                    </v-radio-group>
                                  </v-container>
                                </v-col>
                              </template>
                            </template>
                            <template v-if="item.conditionField === 'flow'">
                              <template
                                v-if="
                                  parseInt(item.conditionValue) ===
                                    parseInt(formEdit.flowId)
                                "
                              >
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'text'"
                                >
                                  <v-text-field
                                    v-if="item.fieldName === 'เบอร์โทร'"
                                    v-mask="'###-###-####'"
                                    v-model="item.fieldValue"
                                    :label="item.fieldName"
                                    dense
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                    outlined
                                  ></v-text-field>
                                  <v-text-field
                                    v-else
                                    v-model="item.fieldValue"
                                    :label="item.fieldName"
                                    dense
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                    outlined
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'number'"
                                >
                                  <v-text-field
                                    v-if="item.fieldName === 'เบอร์โทร'"
                                    v-mask="'###-###-####'"
                                    v-model="item.fieldValue"
                                    :label="item.fieldName"
                                    dense
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                    outlined
                                  ></v-text-field>
                                  <v-text-field
                                    v-else
                                    v-model="item.fieldValue"
                                    :label="item.fieldName"
                                    dense
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                    outlined
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'dateTime'"
                                >
                                  <v-menu
                                    v-model="menuEdit3[item.fieldId]"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    :rules="[rules.required]"
                                    transition="scale-transition"
                                    offset-y
                                    required
                                    min-width="auto"
                                    :ref="menuEdit3[item.fieldId]"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="item.fieldValue"
                                        readonly
                                        :label="item.fieldName"
                                        outlined
                                        dense
                                        prepend-inner-icon="mdi-calendar"
                                        v-bind="attrs"
                                        v-on="on"
                                        required
                                        :rules="
                                          item.requiredField === 'True'
                                            ? [rules.required]
                                            : [true]
                                        "
                                      >
                                      </v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="item.fieldValue"
                                      no-title
                                      scrollable
                                      @input="
                                        (menuEdit3[item.fieldId] = false),
                                          $refs.menuEdit3[item.fieldId].save(item.fieldValue)
                                      "
                                    >
                                    </v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'Autocompletes'"
                                >
                                  <v-autocomplete
                                    v-model="item.fieldValue"
                                    :items="JSON.parse(item.optionField)"
                                    dense
                                    filled
                                    :label="item.fieldName"
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                  ></v-autocomplete>
                                </v-col>
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType == 'Selects'"
                                >
                                  <v-select
                                    class="mb-6"
                                    v-model="item.fieldValue"
                                    :items="JSON.parse(item.optionField)"
                                    menu-props="auto"
                                    :label="item.fieldName"
                                    dense
                                    clearable
                                    :rules="
                                      item.requiredField === 'True'
                                        ? [rules.required]
                                        : [true]
                                    "
                                    hide-details
                                    outlined
                                  ></v-select>
                                </v-col>
                                <v-col
                                  cols="12"
                                  class="InputData"
                                  v-if="item.fieldType === 'Radio'"
                                  style="padding:0px;"
                                >
                                  <v-container fluid style="padding:0px;">
                                    <v-radio-group
                                      row
                                      v-model="item.fieldValue"
                                      style="margin:0px;"
                                      :rules="
                                        item.requiredField === 'True'
                                          ? [rules.required]
                                          : [true]
                                      "
                                    >
                                      <template v-slot:label> </template>
                                      <div
                                        v-for="radios in JSON.parse(
                                          item.optionField
                                        )"
                                        :key="radios.toISOString"
                                        class="text-center"
                                      >
                                        <v-radio
                                          :label="radios.text"
                                          dense
                                          :value="radios.value"
                                        ></v-radio>
                                      </div>
                                    </v-radio-group>
                                  </v-container>
                                </v-col>
                              </template>
                            </template>
                          </div>
                        </template>
                        <v-row>
                          <v-col class="pb-0">
                            <v-menu
                              v-model="menuDateEdit"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="dateEdit"
                                  label="วันที่นัดหมาย"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  dense
                                  outlined
                                  v-on="on"
                                  required
                                  :rules="[rules.required]"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="dateEdit"
                                :allowed-dates="allowedDatesEdit"
                                @input="
                                  (menuDateEdit = false),
                                    setLimitBookingAgain(dateEdit)
                                "
                                :min="
                                  new Date(
                                    Date.now() -
                                      new Date().getTimezoneOffset() * 60000
                                  )
                                    .toISOString()
                                    .substr(0, 10)
                                "
                              ></v-date-picker>
                              <!-- <v-date-picker
                                v-model="dateEdit"
                                @input="menuDate = false"
                              ></v-date-picker> -->
                            </v-menu>
                          </v-col>
                          <v-col class="pb-0">
                            <v-autocomplete
                              v-if="dateEdit !== ''"
                              v-model="timeEdit"
                              :items="timeavailable"
                              label="เวลา"
                              item-text="text"
                              item-value="text"
                              persistent-hint
                              return-object
                              outlined
                              dense
                              required
                              :rules="[rules.required]"
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row v-if="showMenu === 'True'">
                          <sideMenu
                            :drawerParent="drawerAdd"
                            :toggleParent="toggleAdd"
                            :languageSelectParent="languageSelect"
                            :dataMenuParent="dataMenuEdit"
                            :priceMenuParent="priceMenuAdd"
                            @updatePriceMenuParent="updatePriceMenuAdd"
                          ></sideMenu>
                          <v-col cols="12" class="pt-0 pb-4">
                            <v-btn block dark @click="toggleAdd">เมนู</v-btn>
                          </v-col>
                          <v-col cols="12" class="pt-0 pb-6">
                            <v-expansion-panels
                              multiple
                              v-model="expansionMenuAdd"
                            >
                              <v-expansion-panel>
                                <v-expansion-panel-header
                                  >รายการและราคา</v-expansion-panel-header
                                >
                                <v-expansion-panel-content>
                                  <div style="align-items: center;width:100%;">
                                    <v-row>
                                      <v-col
                                        cols="12"
                                        v-for="(item, id) in dataMenuEdit.filter(
                                          el => {
                                            return parseInt(el.qty) > 0;
                                          }
                                        )"
                                        :key="id"
                                        style="display: flex;"
                                      >
                                        <v-card class="cardMenu">
                                          <v-img
                                            class="pictureMenu"
                                            :src="item.picture"
                                          ></v-img>
                                          <v-row>
                                            <v-col
                                              cols="8"
                                              class="pt-0 pb-0 textTitelMenu"
                                              >{{ item.name }}</v-col
                                            >
                                            <v-col
                                              cols="8"
                                              style="display: flex;justify-content: flex-start;"
                                              class="pt-0 pb-0 textTitelMenuSub"
                                              >{{ item.qty }} x
                                              {{
                                                formatNumber(item.price)
                                              }}</v-col
                                            >
                                            <v-col
                                              cols="6"
                                              class="pt-0 pb-0 textTitelMenuRemark"
                                              >{{ item.remark }}</v-col
                                            >
                                          </v-row>
                                        </v-card>
                                      </v-col>
                                      <v-col cols="12">
                                        <v-row>
                                          <v-col cols="6"
                                            ><p class="ma-0 textTitelPriceMenu">
                                              รวมราคา
                                            </p></v-col
                                          >
                                          <v-col
                                            cols="6"
                                            style="display: flex;justify-content: flex-end;"
                                            class="textTitelPriceMenu"
                                            >{{
                                              formatNumber(priceMenuAdd)
                                            }}</v-col
                                          >
                                        </v-row>
                                      </v-col>
                                    </v-row>
                                  </div>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </v-col>
                        </v-row>
                        <v-row
                          v-if="
                            $session.getAll().data.shopId !==
                              'U9f316c85400fd716ea8c80d7cd5b61f8'
                          "
                        >
                          <v-col class="pt-0 pb-0">
                            <v-radio-group
                              v-model="formEdit.radiosRemark"
                              row
                              required
                              :rules="[rules.required]"
                            >
                              <v-radio value="ซ่อมปกติ">
                                <template v-slot:label>
                                  <div class="mt-3">
                                    <strong class="primary--text">{{
                                      dataTypeJob1
                                    }}</strong>
                                  </div>
                                </template>
                              </v-radio>
                              <v-radio value="ExtraJob">
                                <template v-slot:label>
                                  <div class="mt-3">
                                    <strong class="error--text">{{
                                      dataTypeJob2
                                    }}</strong>
                                  </div>
                                </template>
                              </v-radio>
                              <v-radio value="FastTrack">
                                <template v-slot:label>
                                  <div class="mt-3">
                                    <strong class="orange--text">{{
                                      dataTypeJob3
                                    }}</strong>
                                  </div>
                                </template>
                              </v-radio>
                            </v-radio-group>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="pt-0">
                            <v-autocomplete
                              v-model="empSelectEdit"
                              :items="empSelectStepAdd"
                              label="พนักงานที่รับนัดหมาย"
                              outlined
                              dense
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="pt-0">
                            <v-textarea
                              v-model="remark"
                              outlined
                              rows="1"
                              label="หมายเหตุเพิ่มเติม"
                              auto-grow
                              required
                              :rules="[rules.required]"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                        <v-row v-if="statusShowMap === 'True'">
                          <v-col class="pb-0 pt-0" cols="12">
                            <v-text-field
                              v-model="address"
                              label="ชื่อของที่อยู่"
                              outlined
                              required
                              dense
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-card class="p-3">
                              <v-card-text>
                                <v-row>
                                  <v-col class="pb-0" cols="12">
                                    <h6>ค้นหาที่อยู่ลูกค้า :</h6>
                                  </v-col>
                                  <v-col class="pb-0 pt-0" id="divTest3" cols="12">
                                    <gmap-autocomplete
                                      class="introInput"
                                      placeholder="ค้นหาสถานที่"
                                      @place_changed="updatePlace"
                                      @keydown="testStyleInputGoogleMap('divTest3')"
                                      style="width: 100%; height: 45px; border: 1px solid;padding-left: 8px; border-radius: 4px;">
                                    </gmap-autocomplete>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                              <hr />
                              <!-- <gmap-autocomplete @place_changed="updatePlace"/> -->
                              <v-card-text>
                                <GmapMap
                                  v-if="center !== null"
                                  :center="center"
                                  :zoom="15"
                                  style="width: 100%; height: 200px"
                                  :options="{
                                    disableDefaultUI: true,
                                    fullscreenControl: true,
                                    zoomControl: true,
                                    gestureHandling: 'greedy',
                                  }"
                                >
                                  <GmapMarker
                                    :position="center"
                                    :draggable="true"
                                    @drag="updateCoordinates"
                                  />
                                </GmapMap>
                              </v-card-text>
                            </v-card>
                            <br />
                          </v-col>
                        </v-row>
                        <div class="text-center">
                          <v-btn
                            elevation="2"
                            large
                            color="#173053"
                            block
                            class="text-white"
                            :loading="loadingEdit"
                            :disabled="loadingEdit"
                            @click="addBookingAgain()"
                          >
                            <template v-slot:loader>
                              <span class="custom-loader">
                                <v-icon light>mdi-cached</v-icon>
                              </span>
                            </template>
                            <v-icon left>mdi-checkbox-marked-circle</v-icon>
                            นัดหมายอีกครั้ง
                          </v-btn>
                          <!-- <v-btn
                            elevation="2"
                            large
                            color="red"
                            dark
                            @click="dialogEditData = false"
                          >
                            <v-icon left>mdi-close</v-icon>
                            ปิด
                          </v-btn> -->
                        </div>
                      </v-col>
                    </v-form>
                    <div class="text-center" v-if="!dataEditReady">
                      <waitingAlert></waitingAlert>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogShowFileUpload" persistent max-width="80%">
          <v-card>
            <v-card-title>
              File Upload
            </v-card-title>
            <v-card-text v-if="typeof srcUpload === 'string'">
              <v-row>
                <v-col cols="12">
                  รายการที่ : 1
                </v-col>
                <v-col
                  cols="12"
                  v-if="
                    srcUpload.endsWith('.pdf') ||
                      srcUpload.endsWith('.xlsx') ||
                      srcUpload.endsWith('.xls')
                  "
                >
                  <v-btn
                    color="blue-grey"
                    class="ma-2 white--text"
                    @click="gotoPicture(srcUpload)"
                  >
                    แสดงรายการ
                    <v-icon right dark>
                      mdi-eye
                    </v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12" v-else>
                  <v-img
                    height="300"
                    contain
                    :src="srcUpload"
                    @click="gotoPicture(srcUpload)"
                  ></v-img>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text v-else>
              <v-row v-for="(item, index) in srcUpload" :key="index">
                <v-col cols="12"> รายการที่ : {{ index + 1 }} </v-col>
                <v-col
                  cols="12"
                  v-if="
                    item.endsWith('.pdf') ||
                      item.endsWith('.xlsx') ||
                      item.endsWith('.xls')
                  "
                >
                  <v-btn
                    color="blue-grey"
                    class="ma-2 white--text"
                    @click="gotoPicture(item)"
                  >
                    แสดงรายการ
                    <v-icon right dark>
                      mdi-eye
                    </v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12" v-else>
                  <v-img
                    height="300"
                    contain
                    :src="item"
                    @click="gotoPicture(item)"
                  ></v-img>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                color="red darken-1"
                text
                @click="dialogShowFileUpload = false"
              >
                <v-icon left> mdi-cancel</v-icon>
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogOnsite" persistent max-width="70%">
          <v-card class="text-center">
            <v-card-text>
              <v-row>
                <v-col cols="6" class="text-left pt-10">
                  <h3><strong>มอบหมายงานให้พนักงาน Onsite</strong></h3>
                </v-col>
                <v-col cols="6" class="pt-10">
                  <div style="text-align: end;">
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      dark
                      color="white"
                      :style="styleCloseBt"
                      @click="dialogOnsite = false"
                    >
                      X
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-row>
              <v-col
                class="pb-0 pt-0"
                cols="12"
                v-if="
                  dataPackage.filter(el => {
                    return el.balanceAmount > 0;
                  }).length > 0 && dataPackageDefault === false
                "
              >
                <v-card class="pl-1">
                  <v-subheader
                    >ลูกค้ามี
                    {{
                      dataPackage.filter(el => {
                        return el.balanceAmount > 0;
                      }).length
                    }}
                    แพ็คเกจ</v-subheader
                  >
                  <v-subheader v-show="StatusPackage.packageName"
                    >ลูกค้าได้ทำการเลือกแพ็คเกจ
                    {{ StatusPackage.packageName }}</v-subheader
                  >
                  <v-slide-group
                    v-model="modelPackageIndexConfirmJob"
                    center-active
                    show-arrows
                  >
                    <v-slide-item
                      v-for="(item, index) in dataPackage.filter(el => {
                        return el.balanceAmount > 0;
                      })"
                      :key="index"
                    >
                      <v-card
                        class="ma-2 p-1"
                        width="340"
                        height="100"
                        color="#FFFFFF"
                        elevation="6"
                        :style="
                          item.packageId === packageId &&
                          item.token === tokenPackage
                            ? 'border: 1px solid green;'
                            : 'border: 1px solid white;'
                        "
                      >
                        <v-row>
                          <v-col cols="4" class="pr-1">
                            <v-img
                              contain
                              max-height="80"
                              max-width="200"
                              :src="item.packageImg"
                            ></v-img>
                          </v-col>
                          <v-col cols="8" class="pb-6">
                            <v-row class="font16 headline1">
                              <v-col class="pl-0 pt-2 pb-0">{{
                                item.packageName
                              }}</v-col>
                              <v-btn
                                class="mr-4 mt-3"
                                v-if="
                                  item.packageId !== packageId &&
                                    item.token !== tokenPackage
                                "
                                color="green"
                                outlined
                                rounded
                                x-small
                                @click="
                                  UpdatePackage(
                                    item.packageId,
                                    'ตกลง',
                                    item.packageName,
                                    item,
                                    item.token
                                  ),
                                    (jobCheckPackage = true)
                                "
                                >ตกลง</v-btn
                              >
                              <v-btn
                                class="mr-4 mt-3"
                                v-if="
                                  item.packageId === packageId &&
                                    item.token !== tokenPackage
                                "
                                color="green"
                                outlined
                                rounded
                                x-small
                                @click="
                                  UpdatePackage(
                                    item.packageId,
                                    'ตกลง',
                                    item.packageName,
                                    item,
                                    item.token
                                  ),
                                    (jobCheckPackage = true)
                                "
                                >ตกลง</v-btn
                              >
                              <v-btn
                                class="mr-4 mt-3"
                                v-if="
                                  item.packageId === packageId &&
                                    item.token === tokenPackage
                                "
                                color="red"
                                outlined
                                rounded
                                x-small
                                @click="
                                  UpdatePackage(
                                    item.packageId,
                                    'ยกเลิก',
                                    item.packageName,
                                    item,
                                    item.token
                                  ),
                                    (jobCheckPackage = false)
                                "
                                >ยกเลิก</v-btn
                              >
                            </v-row>
                            <v-row class="font14 headline1">
                              <v-col class="pl-0 pt-0 pb-0"
                                >จำนวนการใช้ {{ item.balanceAmount }} /
                                {{ item.amount }}
                              </v-col>
                            </v-row>
                            <v-row class="font14 headline1">
                              <v-col class="pl-0 pt-0 pb-0">
                                <VueCustomTooltip
                                  label="สามารถใช้ได้"
                                  position="is-top"
                                  v-if="dateTimestamp <= item.expirePackage"
                                >
                                  <v-icon large color="teal darken-2">
                                    mdi-clock-check
                                  </v-icon>
                                </VueCustomTooltip>
                                <VueCustomTooltip
                                  label="หมดอายุแล้ว"
                                  position="is-top"
                                  v-if="dateTimestamp > item.expirePackage"
                                >
                                  <v-icon large color="red darken-2">
                                    mdi-clock-alert
                                  </v-icon>
                                </VueCustomTooltip>
                                >> วันหมดอายุ
                                {{
                                  new Date(item.expirePackage * 1000)
                                    .toLocaleString()
                                    .substr(0, 9)
                                }}
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-slide-item>
                  </v-slide-group>
                </v-card>
                <br />
              </v-col>
              <v-col
                class="pb-0 pt-0"
                cols="12"
                v-if="
                  dataPackage.filter(el => {
                    return el.balanceAmount > 0;
                  }).length > 0 && dataPackageDefault === true
                "
              >
                <v-card class="pl-1">
                  <v-subheader
                    >ลูกค้ามี
                    {{
                      dataPackage.filter(el => {
                        return el.balanceAmount > 0;
                      }).length
                    }}
                    แพ็คเกจ</v-subheader
                  >
                  <v-subheader v-show="StatusPackage.packageName"
                    >ลูกค้าได้ทำการเลือกแพ็คเกจ
                    {{ StatusPackage.packageName }}</v-subheader
                  >
                  <v-slide-group
                    v-model="modelPackageIndexConfirmJob"
                    center-active
                    show-arrows
                  >
                    <v-slide-item
                      v-for="(item, index) in dataPackage.filter(el => {
                        return el.balanceAmount > 0;
                      })"
                      :key="index"
                    >
                      <v-card
                        class="ma-2 p-1"
                        width="340"
                        height="100"
                        color="#FFFFFF"
                        elevation="6"
                        :style="
                          item.packageId === packageId &&
                          item.token === tokenPackage
                            ? 'border: 1px solid green;'
                            : 'border: 1px solid white;'
                        "
                      >
                        <v-row>
                          <v-col cols="4" class="pr-1">
                            <v-img
                              contain
                              max-height="80"
                              max-width="200"
                              :src="item.packageImg"
                            ></v-img>
                          </v-col>
                          <v-col cols="8" class="pb-6">
                            <v-row class="font16 headline1">
                              <v-col class="pl-0 pt-2 pb-0">{{
                                item.packageName
                              }}</v-col>
                              <!-- <v-btn class="mr-4 mt-3" v-if="item.packageId !== packageId" color="green" outlined rounded x-small @click="UpdatePackage(item.packageId,'ตกลง',item.packageName, item)">ตกลง</v-btn>
                                  <v-btn class="mr-4 mt-3" v-if="item.packageId === packageId" color="red" outlined rounded x-small @click="UpdatePackage(item.packageId,'ยกเลิก',item.packageName, item)">ยกเลิก</v-btn> -->
                            </v-row>
                            <v-row class="font14 headline1">
                              <v-col class="pl-0 pt-0 pb-0"
                                >จำนวนการใช้ {{ item.balanceAmount }} /
                                {{ item.amount }}
                              </v-col>
                            </v-row>
                            <v-row class="font14 headline1">
                              <v-col class="pl-0 pt-0 pb-0">
                                <VueCustomTooltip
                                  label="สามารถใช้ได้"
                                  position="is-top"
                                  v-if="dateTimestamp <= item.expirePackage"
                                >
                                  <v-icon large color="teal darken-2">
                                    mdi-clock-check
                                  </v-icon>
                                </VueCustomTooltip>
                                <VueCustomTooltip
                                  label="หมดอายุแล้ว"
                                  position="is-top"
                                  v-if="dateTimestamp > item.expirePackage"
                                >
                                  <v-icon large color="red darken-2">
                                    mdi-clock-alert
                                  </v-icon>
                                </VueCustomTooltip>
                                >> วันหมดอายุ
                                {{
                                  new Date(item.expirePackage * 1000)
                                    .toLocaleString()
                                    .substr(0, 9)
                                }}
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-slide-item>
                  </v-slide-group>
                </v-card>
                <br />
              </v-col>
            </v-row>
            <!-- <v-card-title>มอบหมายงานให้พนักงาน Onsite</v-card-title> -->
            <v-card-text v-if="dataEditJobReady">
              <!-- {{BookingDataItem}} -->
              <v-container>
                <v-col
                  v-for="(item, indexitem) in BookingDataItem"
                  :key="indexitem"
                  cols="12"
                  class="pa-0"
                >
                  <v-text-field
                    :label="item.fieldName"
                    :value="item.fieldValue"
                    class="pa-0"
                    outlined
                    dense
                    readonly
                  ></v-text-field>
                  <!-- {{item.fieldName}} : {{item.fieldValue}} -->
                </v-col>
                <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                  <div v-for="(p, index) in flowfieldNameitem" :key="index">
                    <div class="pa-0" v-if="p.conditionField === ''">
                      <div>
                        <div v-if="p.fieldType == 'text'">
                          <br />
                          <v-text-field
                            v-model="p.fieldValue"
                            :label="p.fieldName"
                            dense
                            :rules="
                              p.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            outlined
                          ></v-text-field>
                        </div>
                        <div v-if="p.fieldType == 'number'">
                          <br />
                          <!-- <p>{{p.fieldName}}</p> -->
                          <v-text-field
                            v-model="p.fieldValue"
                            :label="p.fieldName"
                            dense
                            :rules="
                              p.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            outlined
                          ></v-text-field>
                        </div>
                        <v-row>
                          <v-col
                            cols="12"
                            v-if="p.fieldType == 'Autocompletes'"
                            style="padding-top: 0px;padding-bottom: 0px;"
                          >
                            <br />
                            <v-autocomplete
                              v-model="p.fieldValue"
                              :items="JSON.parse(p.optionField)"
                              dense
                              filled
                              :label="p.fieldName"
                              :rules="
                                p.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                            ></v-autocomplete>
                          </v-col>
                          <v-col
                            cols="12"
                            v-if="p.fieldType == 'Selects'"
                            style="padding-top: 0px;padding-bottom: 0px;"
                          >
                            <br />
                            <div>
                              <v-select
                                v-model="p.fieldValue"
                                :items="JSON.parse(p.optionField)"
                                menu-props="auto"
                                :label="p.fieldName"
                                hide-details
                                outlined
                                dense
                                :rules="
                                  p.requiredField === 'True'
                                    ? [rules.required]
                                    : [true]
                                "
                              ></v-select>
                            </div>
                          </v-col>
                        </v-row>
                        <div v-if="p.fieldType == 'Radio'" style="padding:0px;">
                          <br />
                          <v-container fluid style="padding:0px;">
                            <v-radio-group
                              row
                              v-model="p.fieldValue"
                              style="margin:0px;"
                              :rules="
                                p.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                            >
                              <template v-slot:label> </template>
                              <div
                                v-for="radios in JSON.parse(p.optionField)"
                                :key="radios.toISOString"
                                class="text-center"
                              >
                                <v-radio
                                  :label="radios.text"
                                  dense
                                  :value="radios.value"
                                ></v-radio>
                              </div>
                            </v-radio-group>
                          </v-container>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="
                        p.conditionField !== '' &&
                          flowfieldNameitem.filter(row => {
                            return row.fieldId === parseInt(p.conditionField);
                          }).length > 0
                      "
                    >
                      <div
                        v-if="
                          p.conditionValue ===
                            flowfieldNameitem.filter(row => {
                              return row.fieldId === parseInt(p.conditionField);
                            })[0].fieldValue
                        "
                      >
                        <div cols="12" v-if="p.fieldType == 'Autocompletes'">
                          <v-autocomplete
                            v-model="p.fieldValue"
                            :items="JSON.parse(p.optionField)"
                            dense
                            filled
                            :label="p.fieldName"
                            :rules="
                              p.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                          ></v-autocomplete>
                        </div>
                        <div v-if="p.fieldType == 'Selects'">
                          <v-select
                            v-model="p.fieldValue"
                            :items="JSON.parse(p.optionField)"
                            menu-props="auto"
                            :label="p.fieldName"
                            dense
                            hide-details
                            outlined
                            :rules="
                              p.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                          ></v-select>
                        </div>
                        <div
                          v-if="p.fieldType === 'Radio'"
                          style="padding:0px;"
                        >
                          <br />
                          <v-container fluid style="padding:0px;">
                            <v-radio-group
                              row
                              v-model="p.fieldValue"
                              style="margin:0px;"
                              :rules="
                                p.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                            >
                              <template v-slot:label> </template>
                              <div
                                v-for="radios in JSON.parse(p.optionField)"
                                :key="radios.toISOString"
                                class="text-center"
                              >
                                <v-radio
                                  :label="radios.text"
                                  dense
                                  :value="radios.value"
                                ></v-radio>
                              </div>
                            </v-radio-group>
                          </v-container>
                        </div>
                      </div>
                    </div>
                    <div v-if="p.conditionField === 'flow'">
                      <div
                        v-if="
                          parseInt(p.conditionValue) ===
                            parseInt(formAdd.flowId)
                        "
                      >
                        <div v-if="p.fieldType == 'text'">
                          <br />
                          <v-text-field
                            v-model="p.fieldValue"
                            :label="p.fieldName"
                            dense
                            :rules="
                              p.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            outlined
                          ></v-text-field>
                        </div>
                        <div v-if="p.fieldType == 'number'">
                          <br />
                          <v-text-field
                            v-model="p.fieldValue"
                            :label="p.fieldName"
                            dense
                            :rules="
                              p.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            outlined
                          ></v-text-field>
                        </div>
                        <div cols="12" v-if="p.fieldType == 'Autocompletes'">
                          <v-autocomplete
                            v-model="p.fieldValue"
                            :items="JSON.parse(p.optionField)"
                            dense
                            filled
                            :label="p.fieldName"
                            :rules="
                              p.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                          ></v-autocomplete>
                        </div>
                        <div v-if="p.fieldType == 'Selects'">
                          <v-select
                            v-model="p.fieldValue"
                            :items="JSON.parse(p.optionField)"
                            menu-props="auto"
                            :label="p.fieldName"
                            dense
                            :rules="
                              p.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            hide-details
                            outlined
                          ></v-select>
                        </div>
                        <div
                          v-if="p.fieldType === 'Radio'"
                          style="padding:0px;"
                        >
                          <br />
                          <v-container fluid style="padding:0px;">
                            <v-radio-group
                              row
                              v-model="p.fieldValue"
                              style="margin:0px;"
                              :rules="
                                p.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                            >
                              <template v-slot:label> </template>
                              <div
                                v-for="radios in JSON.parse(p.optionField)"
                                :key="radios.toISOString"
                                class="text-center"
                              >
                                <v-radio
                                  :label="radios.text"
                                  dense
                                  :value="radios.value"
                                ></v-radio>
                              </div>
                            </v-radio-group>
                          </v-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <v-row>
                    <v-col cols="12" sm="6" md="6" lg="6" class="pb-0">
                      <v-text-field
                        readonly
                        v-model="dueDateText"
                        outlined
                        dense
                        label="วันที่นัดหมายลูกค้า"
                        prepend-inner-icon="mdi-calendar-multiple-check"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="6">
                      <v-autocomplete
                        v-model="empSelectJob"
                        :items="empSelectStepAdd"
                        label="พนักงาน Onsite"
                        menu-props="auto"
                        outlined
                        required
                        :rules="[rules.required]"
                        dense
                        @change="checkEmpJob()"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row v-if="empSelectJob !== ''">
                    <v-col cols="12" class="pb-0 pt-0">
                      <v-sheet height="64">
                        <v-toolbar dense>
                          <v-btn
                            fab
                            text
                            small
                            color="grey darken-2"
                            @click="prev()"
                          >
                            <v-icon small>
                              mdi-chevron-left
                            </v-icon>
                          </v-btn>
                          <v-btn
                            fab
                            text
                            small
                            color="grey darken-2"
                            @click="next()"
                          >
                            <v-icon small>
                              mdi-chevron-right
                            </v-icon>
                          </v-btn>
                          <!-- <v-toolbar-title v-if="$refs.calendaronsite">{{
                          $refs.calendaronsite.title
                        }}</v-toolbar-title> -->
                          <v-toolbar-title>{{
                            monthNamesThai[parseInt(today.split("-")[1])] +
                              " " +
                              today.split("-")[0]
                          }}</v-toolbar-title>
                        </v-toolbar>
                      </v-sheet>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="empSelectJob !== '' && checkEventInfo.length > 0"
                  >
                    <v-col cols="12" class="pb-0 pt-0">
                      <v-sheet>
                        <v-calendar
                          ref="calendaronsite"
                          :now="today"
                          v-model="today"
                          locale="th-TH"
                          color="primary"
                          type="month"
                        >
                          <!-- <template v-slot:day-label="{ day }">
                          <span style="font-size:26px !important;">{{day}}</span>
                        </template> -->
                          <template v-slot:day="{ date }">
                            <div v-if="eventInfo[date]">
                              <v-row>
                                <v-col class="text-center mb-1 mt-0">
                                  <v-badge
                                    avatar
                                    bordered
                                    overlap
                                    color="orange darken-1"
                                    v-if="eventInfo[date].sortNo1 > 0"
                                    class="mr-1"
                                    style="cursor: pointer"
                                    @click.native="
                                      openCalendaList(date, 'sortNo1')
                                    "
                                  >
                                    <template v-slot:badge>
                                      <v-avatar
                                        class="mb-1"
                                        color="orange darken-1"
                                      >
                                        {{ eventInfo[date].sortNo1 }}
                                      </v-avatar>
                                    </template>

                                    <v-avatar size="40" color="orange darken-3">
                                      <v-icon dark>
                                        mdi-water-plus
                                      </v-icon>
                                    </v-avatar>
                                  </v-badge>
                                  <v-badge
                                    avatar
                                    bordered
                                    overlap
                                    color="blue darken-1"
                                    v-if="eventInfo[date].sortNo2 > 0"
                                    class="mr-1"
                                    style="cursor: pointer"
                                    @click.native="
                                      openCalendaList(date, 'sortNo2')
                                    "
                                  >
                                    <template v-slot:badge>
                                      <v-avatar
                                        class="mb-1"
                                        color="blue darken-1"
                                      >
                                        {{ eventInfo[date].sortNo2 }}
                                      </v-avatar>
                                    </template>

                                    <v-avatar size="40" color="blue darken-3">
                                      <v-icon dark>
                                        mdi-water-check
                                      </v-icon>
                                    </v-avatar>
                                  </v-badge>
                                </v-col>
                              </v-row>
                            </div>
                          </template>
                        </v-calendar>
                      </v-sheet>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="empSelectJob !== '' && checkEventInfo.length === 0"
                  >
                    <v-col cols="12" class="pb-0 pt-0">
                      <v-sheet>
                        <v-calendar
                          ref="calendaronsite"
                          :now="today"
                          v-model="today"
                          locale="th-TH"
                          color="primary"
                          type="month"
                        ></v-calendar>
                      </v-sheet>
                    </v-col>
                    <v-col cols="12">
                      <v-alert text type="success">
                        เดือน
                        <strong>{{
                          monthNamesThai[parseInt(today.split("-")[1])]
                        }}</strong>
                        พนักงานท่านนี้ <strong>ว่างงาน</strong>
                      </v-alert>
                    </v-col>
                  </v-row>
                </v-form>
                <br />
                <template v-if="BookingDataItem.length > 0">
                  <div
                    class="text-center"
                    v-if="BookingDataItem[0].addressLatLong === null"
                  >
                    <v-alert dense outlined type="error">
                      <v-row align="center">
                        <v-col class="grow">
                          เนื่องจาก นัดหมายนี้ยังไม่มี แผนที่ กรุณานำ QR code
                          หรือ ส่งลิงค์ ให้ลูกค้ากรอกด้วย !!
                        </v-col>
                        <v-col class="shrink">
                          <v-btn
                            tile
                            color="success"
                            @click="getQrCOde(BookingDataItem[0])"
                          >
                            <v-icon left>
                              mdi-qrcode-scan
                            </v-icon>
                            เปิด QR Code
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-alert>
                  </div>
                  <div class="text-center">
                    <v-btn
                      elevation="10"
                      color="green darken-1"
                      dark
                      large
                      block
                      @click="addEmpJob()"
                      >ยืนยันนัดหมาย</v-btn
                    >
                  </div>
                  <!-- <div class="text-center">
                    <v-btn
                      elevation="2"
                      v-if="BookingDataItem[0].addressLatLong !== null"
                      small
                      dark
                      color="#173053"
                      @click="addEmpJob()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      มอบหมายงาน
                    </v-btn>
                    <v-btn small color="red" dark @click="dialogOnsite = false, getDataDefault(), searchOther = '', showColorSearch = false, statusSearch = 'no', empSelectJob = ''">
                      <v-icon color="#173053">mdi-close</v-icon> ยกเลิก
                    </v-btn>
                  </div> -->
                </template>
              </v-container>
            </v-card-text>
            <v-card-text v-if="!dataEditJobReady">
              <v-container>
                <div class="text-center">
                  <waitingAlert></waitingAlert>
                </div>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogQrCode" persistent :max-width="dialogwidth">
          <v-card
            style="background: linear-gradient(180deg, #FFFFFF 0%, #E1F3FF 100%);"
          >
            <v-container>
              <v-row>
                <v-col cols="12">
                  <div class=" text-center">
                    <br />
                    <br />
                    <h2 style="font-weight: 900; color:#FFA000">
                      QR Code และ Link สำหรับ รับที่อยู่ลูกค้า !
                    </h2>
                    <qrcode-vue
                      :value="value"
                      :size="size"
                      level="H"
                      :foreground="foreground"
                    />
                    <v-row align-content="center">
                      <v-col cols="12" class="pb-0">
                        <v-text-field
                          v-model="Redirect"
                          style="background-color:#050C42;"
                          solo
                          disabled
                          id="myInput"
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row justify="center" no-gutters>
                      <v-col cols="6" class="text-center">
                        <v-btn
                          color="#1B437C"
                          small
                          fab
                          dark
                          @click="FunCopy()"
                        >
                          <v-icon>mdi-content-copy</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-container>
            <v-row>
              <v-col cols="12">
                <v-container class="text-center">
                  <v-btn
                    small
                    class="ma-2"
                    color="error"
                    @click="dialogQrCode = false"
                    dark
                  >
                    ปิดหน้านี้
                    <v-icon dark right>
                      mdi-minus-circle
                    </v-icon>
                  </v-btn>
                </v-container>
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialogChangeOnsite"
          persistent
          :max-width="dialogwidth"
        >
          <v-card
            style="background: linear-gradient(180deg, #FFFFFF 0%, #E1F3FF 100%);"
          >
            <v-container>
              <v-row>
                <v-col cols="12" v-if="sortNo === 1">
                  <div class=" text-center">
                    <br />
                    <br />
                    <h2 style="font-weight: 900; color:#FFA000">
                      เปลี่ยนพนักงาน Onsite!
                    </h2>
                    <v-row>
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="empSelectJob"
                          :items="empSelectStepAdd"
                          label="พนักงาน Onsite"
                          menu-props="auto"
                          outlined
                          required
                          :rules="[rules.required]"
                          dense
                          @change="checkEmpJob()"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row v-if="empSelectJob !== ''">
                      <v-col cols="12" class="pb-0 pt-0">
                        <v-sheet height="64">
                          <v-toolbar dense>
                            <v-btn
                              fab
                              text
                              small
                              color="grey darken-2"
                              @click="prev()"
                            >
                              <v-icon small>
                                mdi-chevron-left
                              </v-icon>
                            </v-btn>
                            <v-btn
                              fab
                              text
                              small
                              color="grey darken-2"
                              @click="next()"
                            >
                              <v-icon small>
                                mdi-chevron-right
                              </v-icon>
                            </v-btn>
                            <!-- <v-toolbar-title v-if="$refs.calendaronsite">{{
                                $refs.calendaronsite.title
                              }}</v-toolbar-title> -->
                            <v-toolbar-title>{{
                              monthNamesThai[parseInt(today.split("-")[1])] +
                                " " +
                                today.split("-")[0]
                            }}</v-toolbar-title>
                          </v-toolbar>
                        </v-sheet>
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="empSelectJob !== '' && checkEventInfo.length > 0"
                    >
                      <v-col cols="12" class="pb-0 pt-0">
                        <v-sheet>
                          <v-calendar
                            ref="calendaronsite"
                            :now="today"
                            v-model="today"
                            locale="th-TH"
                            color="primary"
                            type="month"
                          >
                            <!-- <template v-slot:day-label="{ day }">
                                <span style="font-size:26px !important;">{{day}}</span>
                              </template> -->
                            <template v-slot:day="{ date }">
                              <div v-if="eventInfo[date]">
                                <v-row>
                                  <v-col class="text-center mb-1 mt-0">
                                    <v-badge
                                      avatar
                                      bordered
                                      overlap
                                      color="orange darken-1"
                                      v-if="eventInfo[date].sortNo1 > 0"
                                      class="mr-1"
                                      style="cursor: pointer"
                                      @click.native="
                                        openCalendaList(date, 'sortNo1')
                                      "
                                    >
                                      <template v-slot:badge>
                                        <v-avatar
                                          class="mb-1"
                                          color="orange darken-1"
                                        >
                                          {{ eventInfo[date].sortNo1 }}
                                        </v-avatar>
                                      </template>

                                      <v-avatar
                                        size="40"
                                        color="orange darken-3"
                                      >
                                        <v-icon dark>
                                          mdi-water-plus
                                        </v-icon>
                                      </v-avatar>
                                    </v-badge>
                                    <v-badge
                                      avatar
                                      bordered
                                      overlap
                                      color="blue darken-1"
                                      v-if="eventInfo[date].sortNo2 > 0"
                                      class="mr-1"
                                      style="cursor: pointer"
                                      @click.native="
                                        openCalendaList(date, 'sortNo2')
                                      "
                                    >
                                      <template v-slot:badge>
                                        <v-avatar
                                          class="mb-1"
                                          color="blue darken-1"
                                        >
                                          {{ eventInfo[date].sortNo2 }}
                                        </v-avatar>
                                      </template>

                                      <v-avatar size="40" color="blue darken-3">
                                        <v-icon dark>
                                          mdi-water-check
                                        </v-icon>
                                      </v-avatar>
                                    </v-badge>
                                  </v-col>
                                </v-row>
                              </div>
                            </template>
                          </v-calendar>
                        </v-sheet>
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="empSelectJob !== '' && checkEventInfo.length === 0"
                    >
                      <v-col cols="12" class="pb-0 pt-0">
                        <v-sheet>
                          <v-calendar
                            ref="calendaronsite"
                            :now="today"
                            v-model="today"
                            locale="th-TH"
                            color="primary"
                            type="month"
                          ></v-calendar>
                        </v-sheet>
                      </v-col>
                      <v-col cols="12">
                        <v-alert text type="success">
                          เดือน
                          <strong>{{
                            monthNamesThai[parseInt(today.split("-")[1])]
                          }}</strong>
                          พนักงานท่านนี้ <strong>ว่างงาน</strong>
                        </v-alert>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <v-col cols="12" v-if="sortNo !== 1">
                  <div class=" text-center">
                    <v-alert outlined type="error">
                      รายการนี้ได้เริ่มงานไปแล้ว !!
                    </v-alert>
                  </div>
                </v-col>
              </v-row>
            </v-container>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-btn
                  small
                  class="ma-2"
                  v-if="sortNo === 1"
                  color="primary"
                  @click="jobChangeOnsite()"
                  dark
                >
                  เปลี่ยนพนักงาน
                  <v-icon dark right>
                    mdi-checkbox-marked-circle
                  </v-icon>
                </v-btn>
                <v-btn
                  small
                  class="ma-2"
                  color="error"
                  @click="
                    (dialogChangeOnsite = false),
                      getDataDefault(),
                      (searchOther = ''),
                      (showColorSearch = false),
                      (statusSearch = 'no'),
                      (empSelectJob = '')
                  "
                  dark
                >
                  ปิด
                  <v-icon dark right>
                    mdi-minus-circle
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogCalenda" width="600">
          <v-card>
            <v-card-title class="text-h6 grey lighten-2">
              รายชื่อลูกค้านัดหมาย
            </v-card-title>
            <br />
            <template v-for="(sumItems, index1) in dataSummary">
              <!-- {{sumItems}} -->
              <v-row v-bind:key="'sum' + index1" no-gutters>
                <template v-for="(items, index2) in sumItems">
                  <v-col cols="auto" v-bind:key="'sum' + index1 + index2">
                    <v-chip
                      class="ma-2"
                      :color="index1 + ' darken-2'"
                      text-color="white"
                    >
                      <v-avatar left :class="index1 + ' darken-4'">
                        {{ items.length }}
                      </v-avatar>
                      {{ index2 }}
                    </v-chip>
                  </v-col>
                </template>
              </v-row>
            </template>
            <v-card-text v-for="(items, index) in dataCalendar" :key="index">
              <v-card elevation="2">
                <v-list-item
                  :style="
                    items.bgcolor
                      ? 'background-color:' + items.bgcolor + ' !important'
                      : ''
                  "
                >
                  <v-list-item-content>
                    <v-row style="color:#fff;">
                      <v-col cols="3">
                        <!-- <h3>{{items.timeDue}}</h3><br> -->
                        <h3>{{ items.timeDue }}</h3>
                        <br />
                        <v-icon dark class="mr-1" v-if="items.sortNo === 1">
                          mdi-water-plus
                        </v-icon>
                        <v-icon
                          dark
                          class="mr-1"
                          v-else-if="items.sortNo === 2"
                        >
                          mdi-water-check
                        </v-icon>
                        <v-icon dark class="mr-1" v-else>
                          mdi-clock-outline
                        </v-icon>
                      </v-col>
                      <v-col cols="9">
                        <v-row>
                          <v-col cols="8"
                            ><h4>คุณ {{ items.name }}</h4></v-col
                          >
                          <v-col cols="4" class="text-right">{{
                            items.licenseNo
                          }}</v-col>
                        </v-row>
                        โทร {{ items.tel }}
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialogCalenda = false">
                ยืนยัน
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogMenu" persistent :max-width="dialogwidth">
          <v-card>
            <v-card-text>
              <v-row>
                <v-col cols="6" class="text-left pt-10">
                  <h3><strong>รายการเมนู</strong></h3>
                </v-col>
                <v-col cols="6" class="pt-10">
                  <div style="text-align: end;">
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      dark
                      color="white"
                      :style="styleCloseBt"
                      @click="dialogMenu = false"
                    >
                      X
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="12" v-if="dataMenu.length > 0">
                  <div
                    style="width:100% !important;background: linear-gradient(90deg, #FCFCFC 0%, #F7F7F7 10.04%, #F7F7F7 51.56%, #F7F7F7 89.58%, #FCFCFC 100%);box-shadow: 0px 4px 20px rgba(114, 114, 114, 0.1);"
                  >
                    <div
                      style="align-items: center;width:100%;height:600px;overflow-y: scroll;"
                    >
                      <v-row>
                        <v-col
                          cols="12"
                          v-for="(item, id) in dataMenu"
                          :key="id"
                          style="display: flex;"
                        >
                          <v-card class="cardMenuEdit">
                            <v-img
                              class="pictureMenuEdit"
                              :src="item.picture"
                            ></v-img>
                            <div class="cardTextMenu">
                              <div>
                                <p class="ma-0 textTitelMenu">
                                  {{ item.name }}
                                </p>
                                <p
                                  class="ma-0 textSubTitelMenu"
                                  v-if="item.nameSub.length < 20"
                                >
                                  {{ item.nameSub }}
                                </p>
                                <p class="ma-0 textSubTitelMenu" v-else>
                                  {{ item.nameSub.substring(0, 20) + ".." }}
                                </p>
                                <br />
                                <p class="ma-0 textPriceMenu">
                                  {{ formatNumber(item.price) + " บาท" }}
                                </p>
                                <!-- <p>{{item.nameSub}}</p> -->
                                <v-text-field
                                  v-if="parseInt(item.qty) > 0"
                                  v-model="item.remark"
                                  label="หมายเหตุ"
                                  single-line
                                  hide-details
                                  dense
                                  class="pl-0"
                                ></v-text-field>
                              </div>
                            </div>
                            <div class="buttomMenu">
                              <v-btn
                                icon
                                x-small
                                color="#FF7B2C"
                                class="buttomMenuplusmins"
                                @click="changeCounter('-1', item)"
                              >
                                <v-icon dark>
                                  mdi-minus
                                </v-icon>
                              </v-btn>
                              {{ item.qty }}
                              <v-btn
                                icon
                                x-small
                                color="#FF7B2C"
                                class="buttomMenuplusmins "
                                @click="changeCounter('1', item)"
                              >
                                <v-icon dark>
                                  mdi-plus
                                </v-icon>
                              </v-btn>
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </div>
                    <div class="sendOrder">
                      <v-card
                        width="100%"
                        height="58px"
                        class="display: flex;align-items: center;"
                        style="border-radius: 16px;"
                      >
                        <v-container>
                          <v-row>
                            <v-col cols="6">รวมราคา</v-col>
                            <v-col cols="6" class="text-right">{{
                              formatNumber(priceMenu)
                            }}</v-col>
                          </v-row>
                        </v-container>
                      </v-card>
                    </div>
                    <hr />
                    <v-row>
                      <v-col cols="12">
                        <v-btn
                          color="#1B437C"
                          large
                          block
                          dark
                          @click="updateMenu()"
                        >
                          อัพเดทรายการเมนู
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <v-col cols="12" v-else>
                  <v-card
                    elevation="2"
                    class="pa-3 py-10 d-flex justify-center"
                  >
                <v-card-title><h3><strong>ไม่มีข้อมูล เมนู</strong></h3></v-card-title>
                </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogMenuConclusion" persistent :max-width="dialogwidth">
          <v-card>
            <v-card-text>
              <v-row>
                <v-col cols="6" class="text-left pt-10">
                  <h3><strong>สรุปรายการ</strong></h3>
                </v-col>
                <v-col cols="6" class="pt-10">
                  <div style="text-align: end;">
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      dark
                      color="white"
                      :style="styleCloseBt"
                      @click="dialogMenuConclusion = false"
                    >
                      X
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="12" v-if="dataMenu.length > 0">
                  <div
                    style="width:100% !important;background: linear-gradient(90deg, #FCFCFC 0%, #F7F7F7 10.04%, #F7F7F7 51.56%, #F7F7F7 89.58%, #FCFCFC 100%);box-shadow: 0px 4px 20px rgba(114, 114, 114, 0.1);"
                  >
                    <div
                      style="align-items: center;width:100%;"
                    >
                      <v-row>
                        <v-col
                          cols="12"
                          v-for="(item, id) in dataMenu"
                          :key="id"
                          v-if="parseInt(item.qty) !== 0"
                          style="display: flex;"
                        >
                          <v-card class="cardMenuEdit">
                            <v-img
                              class="pictureMenuEdit"
                              :src="item.picture"
                            ></v-img>
                            <div class="cardTextMenu">
                              <div>
                                <p class="ma-0 textTitelMenu">
                                  {{ item.name }}
                                </p>
                                <p
                                  class="ma-0 textSubTitelMenu"
                                  v-if="item.nameSub.length < 20"
                                >
                                  {{ item.nameSub }}
                                </p>
                                <p class="ma-0 textSubTitelMenu" v-else>
                                  {{ item.nameSub.substring(0, 20) + ".." }}
                                </p>
                                <br />
                                <p class="ma-0 textPriceMenu">
                                  {{item.qty + " X "+ formatNumber(item.price) + " บาท" }}
                                </p>
                                <!-- <p>{{item.nameSub}}</p> -->
                                <!-- <v-text-field
                                  v-if="parseInt(item.qty) > 0"
                                  v-model="item.remark"
                                  label="หมายเหตุ"
                                  single-line
                                  hide-details
                                  dense
                                  class="pl-0"
                                ></v-text-field> -->
                              </div>
                            </div>
                            <!-- <div class="buttomMenu">
                              <v-btn
                                icon
                                x-small
                                color="#FF7B2C"
                                class="buttomMenuplusmins"
                              >
                              </v-btn>
                              {{ item.qty }}
                              <v-btn
                                icon
                                x-small
                                color="#FF7B2C"
                                class="buttomMenuplusmins "
                              >
                              </v-btn>
                            </div> -->
                          </v-card>
                        </v-col>
                      </v-row>
                    </div>
                    <div class="sendOrder">
                      <v-card
                        width="100%"
                        height="58px"
                        class="display: flex;align-items: center;"
                        style="border-radius: 16px;"
                      >
                        <v-container>
                          <v-row>
                            <v-col cols="6">รวมราคา</v-col>
                            <v-col cols="6" class="text-right">{{
                              formatNumber(priceMenu)
                            }}</v-col>
                          </v-row>
                        </v-container>
                      </v-card>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" v-else>
                  <v-card
                    elevation="2"
                    class="pa-3 py-10 d-flex justify-center"
                  >
                <v-card-title><h3><strong>ไม่มีข้อมูล เมนู</strong></h3></v-card-title>
                </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialogShowDeposit"
          persistent
          :max-width="dialogwidth"
        >
          <v-card>
            <v-card-text>
              <v-row>
                <v-col cols="6" class="text-left pt-10">
                  <h3><strong>เรียกเก็บค่าบริการเพื่อจอง</strong></h3>
                </v-col>
                <v-col cols="6" class="pt-10">
                  <div style="text-align: end;">
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      dark
                      color="white"
                      :style="styleCloseBt"
                      @click="dialogShowDeposit = false, copyFallbackClose()"
                    >
                      X
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <v-row align-content="center">
                <v-col cols="12" class="pb-0">
                  <v-textarea
                    v-model="datailLinkDeposit"
                    outlined
                    label="ข้อความ"
                    rows="4"
                    row-height="6"
                    dense
                  ></v-textarea>
                  <v-text-field
                    v-show="dialogShowDeposit === false"
                    v-model="depositLink"
                    label="ลิงค์ มัดจำ"
                    solo
                    disabled
                    id="myInputDeposit"
                    dense
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pb-0" v-if="statusdepositPrice">
                  <VuetifyMoney
                    v-model="depositPrice"
                    placeholder="ค่าใช้จ่าย"
                    dense
                    label="ค่าใช้จ่าย"
                    outlined
                    v-bind:options="options2"
                  />
                </v-col>
              </v-row>
              <v-row v-if="copyTextStatus === false" cols="12" align-content="center">
                <v-col cols="12" md="12" sm="12">
                  <v-btn
                    color="#1B437C"
                    large
                    block
                    dark
                    v-clipboard:copy="copyTextBtTH"
                    @click="FunCopyDeposit()"
                  >
                    <v-icon left dark>
                      mdi-update
                    </v-icon>
                    บันทึก
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-else cols="12">
                <v-col cols="12" lg="5" md="12" sm="12" xs="12">
                  <v-btn
                    style="width: 100%;"
                    color="teal"
                    large
                    dark
                    v-clipboard:copy="copyTextBtTH"
                    @click="copyFallbackTH()"
                  >
                    <v-icon left dark>
                      mdi-content-copy
                    </v-icon>
                    คัดลอกข้อความ TH
                  </v-btn>
                </v-col>
                <v-col cols="12" lg="5" md="12" sm="12" xs="12">
                  <v-btn
                    style="width: 100%;"
                    color="teal"
                    large
                    dark
                    v-clipboard:copy="copyTextBtEN"
                    @click="copyFallbackEN()"
                  >
                    <v-icon left dark>
                      mdi-content-copy
                    </v-icon>
                    คัดลอกข้อความ EN
                  </v-btn>
                </v-col>
                <v-col cols="12" lg="2" md="12" sm="12" xs="12">
                  <v-btn
                    style="width: 100%;"
                    large
                    dark
                    @click="copyFallbackClose()"
                  >
                    Close
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogShowMenuReport" persistent max-width="80%">
          <v-card>
            <v-card-text>
              <v-row>
                <v-col cols="6" class="text-left pt-10">
                  <h3><strong>รายการนัดหมาย</strong></h3>
                </v-col>
                <v-col cols="6" class="pt-10">
                  <div style="text-align: end;">
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      dark
                      color="white"
                      :style="styleCloseBt"
                      @click="dialogShowMenuReport = false"
                    >
                      X
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-menu
                    ref="menu"
                    v-model="menuShowMenuReport"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        hide-details
                        background-color="white"
                        v-model="dateStartShowMenuReport"
                        style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;margin-bottom: 10px;"
                        label="วัน/เดือน/ปี นัดหมาย"
                        readonly
                        outlined
                        dense
                        v-bind="attrs"
                        v-on="on"
                      >
                        <template #prepend-inner>
                          <v-icon
                            color="#69D1FD"
                            style="background-color: #E0F4FF;padding: 4px;border-radius: 50px;margin-top: -1px;margin-right: 3px;margin-bottom: 3px;"
                          >
                            mdi-calendar
                          </v-icon>
                        </template></v-text-field
                      >
                    </template>
                    <v-date-picker
                      @input="
                        (menuShowMenuReport = false), getBookingShowMenuList()
                      "
                      v-model="dateStartShowMenuReport"
                      no-title
                      scrollable
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    style="box-shadow: 0px 38px 72px 30px rgb(10 4 60 / 6%);border-radius: 40px !important;margin-bottom: 10px;"
                    v-model="flowSelectMenu"
                    hide-details
                    background-color="white"
                    :items="DataFlowNameMenu"
                    label="ประเภทบริการ"
                    outlined
                    dense
                    @change="getBookingShowMenuList()"
                  >
                    <template #prepend-inner>
                      <v-icon
                        color="#69D1FD"
                        style="background-color: #E0F4FF;padding: 4px;border-radius: 50px;margin-top: -1px;margin-right: 3px;margin-bottom: 3px;"
                      >
                        mdi-note-text-outline
                      </v-icon>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6" v-if="dataShowMenuReport.length > 0">
                  <v-btn
                    color="teal"
                    dark
                    style="border-radius: 20px !important;margin-right: 0px;box-shadow: 0px 1px 2px rgba(255, 255, 255, 0.4), 0px 5px 15px rgba(162, 171, 198, 0.6);"
                    @click="exportShowMenuReport()"
                  >
                    <v-icon color="white" left>mdi-microsoft-excel</v-icon>
                    ส่งออกเป็น Excel
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :search="searchShowMenuReport"
                    :headers="headersShowMenuReport"
                    :items="dataShowMenuReport"
                    item-key="bookNo"
                    :items-per-page="-1"
                    sort-by="dueDate"
                    group-by="cusNameTel"
                    class="elevation-1"
                    show-group-by
                    hide-default-footer
                  >
                  <template v-slot:group="{ items }">
                      <tr
                        @click="toggleShowMenuList(items[0].cusNameTel)"
                        style="background-color:#CFD8DC;"
                      >
                        <td class="text-xs-right">
                          <strong>{{ items[0].cusNameTel }}</strong>
                        </td>
                        <td class="text-xs-right"></td>
                        <td class="text-xs-right"></td>
                        <td class="text-xs-right"></td>
                      </tr>
                      <tr
                        v-for="item in items"
                        :key="item.bookNo"
                        v-show="!item.hide"
                      >
                        <td
                          v-for="(header, index) in headersShowMenuReport"
                          :key="index"
                        >
                          <p v-if="header.value !== 'statusBt'">
                            {{
                              header.value === "menuPrice"
                                ? formatNumber(item[header.value])
                                : item[header.value]
                            }}
                          </p>
                          <template v-else>
                            <v-chip
                              filter
                              dark
                              v-if="item['statusBt'] === 'confirm'"
                              color="#97DDBB"
                            >
                              {{ dataTypeProcess2 }}
                            </v-chip>
                            <v-chip
                              filter
                              dark
                              v-if="item['statusBt'] === 'confirmJob'"
                              color="#E5B5D8"
                            >
                              {{ dataTypeProcess4 }}
                            </v-chip>
                            <v-chip
                              filter
                              dark
                              v-if="item['statusBt'] === 'wait'"
                              color="#FEAE34"
                            >
                              {{ dataTypeProcess1 }}
                            </v-chip>
                          </template>
                        </td>
                      </tr>
                      <tr
                        v-for="item in items"
                        :key="item.bookingId"
                        v-show="!item.hide"
                      >
                        <td class="text-xs-right" colspan="4">
                          <div style="align-items: center;width:100%;">
                            <v-row>
                              <v-col
                                cols="4"
                                v-for="(itemss, id) in item.menuItem.filter(
                                  el => {
                                    return parseInt(el.qty) > 0;
                                  }
                                )"
                                :key="id"
                                style="display: flex;"
                              >
                                <v-card class="cardMenu">
                                  <v-img
                                    class="pictureMenu"
                                    :src="itemss.picture"
                                  ></v-img>
                                  <v-row>
                                    <v-col
                                      cols="12"
                                      class="textTitelMenu pb-0 pt-0"
                                      >{{ itemss.name }}</v-col
                                    >
                                    <v-col
                                      cols="12"
                                      style="display: flex;justify-content: flex-end;"
                                      class="textTitelMenu pb-0 pt-0"
                                      >{{ itemss.qty }} x
                                      {{ formatNumber(itemss.price) }}</v-col
                                    >
                                    <v-col
                                      cols="12"
                                      class="textTitelMenu pb-0 pt-0"
                                      >{{ itemss.remark }}</v-col
                                    >
                                  </v-row>
                                </v-card>
                              </v-col>
                              <v-col cols="12">
                                <v-row>
                                  <v-col cols="6"
                                    ><p class="ma-0 textTitelPriceMenu">
                                      รวมราคา
                                    </p></v-col
                                  >
                                  <v-col
                                    cols="6"
                                    style="display: flex;justify-content: flex-end;"
                                    class="textTitelPriceMenu"
                                    >{{ formatNumber(item.menuPrice) }}</v-col
                                  >
                                </v-row>
                              </v-col>
                            </v-row>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length">
                        <div style="align-items: center;width:100%;">
                          <v-row>
                            <v-col
                              cols="12"
                              v-for="(items, id) in item.menuItem.filter(el => {
                                return parseInt(el.qty) > 0;
                              })"
                              :key="id"
                              style="display: flex;"
                            >
                              <v-card class="cardMenu">
                                <v-img
                                  class="pictureMenu"
                                  :src="items.picture"
                                ></v-img>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    class="textTitelMenu pb-0 pt-0"
                                    >{{ items.name }}</v-col
                                  >
                                  <v-col
                                    cols="12"
                                    style="display: flex;justify-content: flex-end;"
                                    class="textTitelMenu pb-0 pt-0"
                                    >{{ items.qty }} x
                                    {{ formatNumber(items.price) }}</v-col
                                  >
                                  <v-col
                                    cols="12"
                                    class="textTitelMenu pb-0 pt-0"
                                    >{{ items.remark }}</v-col
                                  >
                                </v-row>
                              </v-card>
                            </v-col>
                            <v-col cols="12">
                              <v-row>
                                <v-col cols="6"
                                  ><p class="ma-0 textTitelPriceMenu">
                                    "รวมราคา"
                                  </p></v-col
                                >
                                <v-col
                                  cols="6"
                                  style="display: flex;justify-content: flex-end;"
                                  class="textTitelPriceMenu"
                                  >{{ formatNumber(item.menuPrice) }}</v-col
                                >
                              </v-row>
                            </v-col>
                          </v-row>
                        </div>
                      </td>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <RetureDeposit ref="RetureDeposit"></RetureDeposit>
        <CallLog ref="CallLog"></CallLog>
        <NotificationService ref="NotificationService"></NotificationService>
        <PrintQrCodeConfirmJobLINE
          ref="PrintQrCodeConfirmJobLINE"
        ></PrintQrCodeConfirmJobLINE>
        <GoogleCalendarCmp ref="GoogleCalendarRef" />
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import draggable from 'vuedraggable'
import adminLeftMenu from '../Sidebar.vue' // เมนู
import VuetifyMoney from '../VuetifyMoney.vue'
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import DateRangePicker from 'vue2-daterange-picker'
// you need to import the CSS manually
import QrcodeVue from 'qrcode.vue'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
// import { PivotTable } from '@click2buy/vue-pivot-table'
import moment from 'moment-timezone'
import BookingQueue from './BookingQueue.vue'
// import CalendarBooking from './CalendarBookingList.vue'
import CalendarBooking from './CalendarBookingList.vue' // test
import waitingAlert from '../waitingAlert.vue'
import RetureDeposit from '../BookingListComponents/RetureDeposit.vue'
import CallLog from '../BookingListComponents/CallLog.vue'
import NotificationService from '../BookingListComponents/NotificationService.vue'
import PrintQrCodeConfirmJobLINE from '../BookingListComponents/PrintQrCodeConfirmJobLINE.vue'
import sideMenu from '../Menu/sideMenu.vue'
import GoogleCalendarCmp from '../Core/GoogleCalendarCmp.vue'
// import copy from 'copy-to-clipboard'

export default {
  name: 'BookingListBeauty',
  components: {
    sideMenu,
    draggable,
    'left-menu-admin': adminLeftMenu,
    DateRangePicker,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    VuetifyMoney,
    QrcodeVue,
    // PivotTable,
    BookingQueue,
    CalendarBooking,
    waitingAlert,
    RetureDeposit,
    CallLog,
    NotificationService,
    PrintQrCodeConfirmJobLINE,
    GoogleCalendarCmp
  },
  computed: {
    filteredSelect () {
      console.log('time data 1 ', new Date())
      // console.log('tset')
      const xxx = this.dataItemSelect.filter(d => {
        return (
          this.filters.length < 1 ||
          d['dueDate']
            .toString()
            .toLowerCase()
            .includes(this.filters.toLowerCase())
        )
        // return Object.keys(this.filters).every(f => {
        // f is search column
        // this.filters[f] is the current search string entered by user
        // d[f] is the entry being tested against the search string
        //   return this.filters[f].length < 1 || d[f].toString().toLowerCase().includes(this.filters[f].toLowerCase())
        // })
      })
      console.log('time data 2 ', new Date())

      return xxx
    },
    ColsDialogAdd () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 'False'
        case 'sm':
          return 'False'
        case 'md':
          return 'False'
        case 'lg':
          return 'True'
        case 'xl':
          return 'True'
      }
    },
    dialogwidth () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '70%'
        case 'sm':
          return '60%'
        case 'md':
          return '50%'
        case 'lg':
          return '50%'
        case 'xl':
          return '50%'
      }
    },
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 'xs'
        case 'sm':
          return 'sm'
        case 'md':
          return 'md'
        case 'lg':
          return 'lg'
        case 'xl':
          return 'xl'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    }
  },
  watch: {
    '$route.query.bookNoNoti' (newVal, oldVal) {
      if (newVal !== '') {
        if (
          this.$route.query.customerName &&
          this.$route.query.dueDate &&
          this.$route.query.masBranchID
        ) {
          this.searchAll2 = this.$route.query.customerName
          this.dateStart = this.$route.query.dueDate
          this.masBranchID = parseInt(this.$route.query.masBranchID)
          this.checkShowDataOnsite()
        }
      }
    },
    pickerDate (newval, oldval) {
      this.getMonth(newval)
      // this.allowedDates()
      // here you can check if month changed using newval and oldval
    },
    pickerDateChang (newval, oldval) {
      // console.log('newval', newval)
      this.getMonthChang(newval)
      // this.allowedDates()
      // here you can check if month changed using newval and oldval
    }
  },
  data () {
    let startDate = null
    let endDate = null
    return {
      shopLat: '',
      shopLong: '',
      unsubscribe: null,
      // menu
      bookNoNoti: '',
      showMenu: 'False',
      dataMenuAdd: [],
      dataMenuEdit: [],
      expansionMenuAdd: [0],
      drawerAdd: false,
      priceMenuAdd: 0,
      languageSelect: 0,
      // ******
      dialogShowMenuReport: false,
      menuShowMenuReport: false,
      dataShowMenuReport: [],
      dateStartShowMenuReport: moment().format('YYYY-MM-DD'),
      searchShowMenuReport: null,
      dataMenuShowMenuReport: [],
      BookingDataListShowMenuReport: [],
      DataFlowNameMenu: [],
      flowSelectMenu: 'AllFlow',
      sortSelect: null,
      expandedMenu: [],
      headersShowMenuReport: [
        {
          text: 'สถานะ',
          groupable: false,
          value: 'statusBt'
        },
        // { text: 'ชื่อลูกค้า', value: 'cusName', sortable: false, groupable: false }
        {
          text: 'วันที่/เวลา',
          value: 'dueDate',
          sortable: false,
          groupable: false
        },
        {
          text: 'บริการ',
          value: 'flowName',
          sortable: false,
          groupable: false,
          width: '400px'
        },
        { text: 'ราคา', value: 'menuPrice', sortable: false, groupable: false }
        // { text: 'เบอร์โทร', value: 'tel', sortable: false, groupable: false }
      ],

      customerNameJob: '',
      dialogHistoryJob: false,
      timelineitem: [],
      codeColor: [
        'rgb(142, 202, 230)',
        'rgb(33, 158, 188)',
        'rgb(2, 48, 71)',
        'rgb(241, 91, 76)',
        'rgb(255, 183, 3)',
        'rgb(251, 133, 0)',
        'rgb(61,90,128)',
        'rgb(152,193,217)',
        'rgb(224,251,252)',
        'rgb(255,212,91)',
        'rgb(238,108,77)',
        'rgb(41,50,65)'
      ],
      showOnsite: 'ไม่แสดง',
      selectOnsite: '',
      menuAdd1: [],
      menuAdd2: [],
      menuAdd3: [],
      menuEdit1: [],
      menuEdit2: [],
      menuEdit3: [],

      items: [
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me 2' }
      ],

      monthNamesThai: [
        '',
        'มกราคม',
        'กุมภาพันธ์',
        'มีนาคม',
        'เมษายน',
        'พฤษภาคม',
        'มิถุนายน',
        'กรกฎาคม',
        'สิงหาคม',
        'กันยายน',
        'ตุลาคม',
        'พฤศจิกายน',
        'ธันวาคม'
      ],
      dialogOnsite: false,
      dialogChangeOnsite: false,
      eventInfo: [],
      checkEventInfo: [],
      dialogQrCode: false,
      dueDateText: '',
      sortNo: '',
      dataCalendar: [],
      dataSummary: [],
      today: moment().format('YYYY-MM-DD'),
      events: [],
      dialogCalenda: false,

      srcUpload: '',
      dialogShowFileUpload: false,
      pickerDate: null,
      pickerDateChang: null,
      currentDate: moment().format('YYYY-MM-DD'),
      currentMonth: moment().format('YYYY-MM'),
      headersLimitBookingDate: [
        {
          text: 'เวลา',
          align: 'center',
          sortable: true,
          value: 'bookingTime'
        },
        {
          text: 'จำนวน Limit ปัจจุบัน / จำนวน Limit ที่ตั้งไว้',
          value: 'countBookingLimit',
          align: 'center'
        }
      ],
      dataLimitBookingDate: [],
      options2: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 9,
        precision: 2
      },
      options1: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 1,
        precision: 0
      },
      recordStatusJob: '',
      checkPayment: 'True',
      formCloseJob: {
        jobId: '',
        jobNo: '',
        totalPrice: 0
      },
      dialogCloseJob: false,
      loadingCloseJob: false,
      modelPackageIndexConfirm: null,
      modelPackageIndexConfirmJob: null,
      dataPackageDefault: false,
      jobCheckPackage: false,
      dateTimestamp: '',
      packageId: '',
      tokenPackage: '',
      dataPackage: [],
      StatusPackage: {
        status: 'ตกลง',
        color: 'green',
        packageName: '',
        token: ''
      },
      dataFlowSelectAdd: [],
      dataFlowSelectEdit: [],
      checkSelectText: '',
      pictureUrHistory: '',
      tagName: '',
      dialogHistory: false,
      dialogAddTag: false,
      tagItem: [],
      tagData: [],
      DataFlowNameA: [],
      panelDeposit: [],
      dataDepositAdd: 'ไม่มี',
      pictureUrlPreviewDeposit: null,
      pictureUrlDeposit: null,
      filesDeposit: null,
      filesDepositAdd: null,
      valid_deposit: true,
      statusDeposit: false,
      flowSelect: '',
      dueDate: '',
      statusConfirmJob: false,
      filters: '',
      loadingTag: false,
      loadingDeposit: false,
      loadingEdit: false,
      loadingAdd: false,
      loadingRefresh: false,
      menuDateSearch: false,
      timeTable: '',
      drawer: false,
      value: '',
      size: 200,
      foreground: '#173053',
      userId: '',
      skip: {
        userId: 'user-skip'
      },
      pathToweb: '',
      changeBackgroundColor: true,
      countWaiting: 0,
      countConfirm: 0,
      countCancel: 0,
      countJob: 0,
      countAll: 0,
      export_fields: {
        'Booking Id': 'bookNo',
        สาขา: 'masBranchName',
        ชื่อลูกค้า: 'cusName',
        ทะเบียนรถ: 'cusReg',
        วันและเวลานัดหมาย: 'dueDate',
        ชื่อบริการ: 'flowName',
        'สถานะ ติดต่อ': 'statusBt',
        'วันที่ ติดต่อ': 'contactDateBt',
        // 'วันที่ แจ้งเปลี่ยน': 'changDateBt',
        สถานะนำเข้ากระดาน: 'statusUseBt',
        'วันที่ สร้าง': 'CREATE_DATE',
        'วันที่ แก้ไขล่าสุด': 'LAST_DATE'
      },
      exportType: 'xls',
      exportFileName:
        'BookingList' +
        new Date()
          .toISOString()
          .substr(0, 10)
          .replace('/-/g', '') +
        '.xls',
      exportWorksheet: 'WorkSheet',
      export_data: [],
      dateRange: { startDate, endDate },
      localeData: {
        // direction: 'ltr',
        format: 'yyyy-mm-dd',
        // separator: ' - ',
        applyLabel: 'ยืนยัน',
        cancelLabel: 'ยกเลิก',
        // weekLabel: 'W',
        // customRangeLabel: 'Custom Range',
        // daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        daysOfWeek: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
        monthNames: [
          'ม.ค',
          'ก.พ',
          'มี.ค',
          'เม.ย',
          'พ.ค',
          'มิ.ย',
          'ก.ค',
          'ส.ค',
          'ก.ย',
          'ต.ค',
          'พ.ย',
          'ธ.ค'
        ],
        // monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        firstDay: 1
      },
      masterTime: [
        '06:00',
        '07:00',
        '08:00',
        '09:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
        '18:00',
        '19:00',
        '20:00',
        '21:00',
        '22:00'
      ],
      masBranchID: '',
      masBranchIDExport: '',
      bookNo: '',
      BookingDataItem: [],
      Layout: [],
      dataItemTime: [],
      dataItemTimesChange: [],
      appendBody: true,
      dataEditReady: true,
      dataConfirmReady: true,
      dataCancelReady: true,
      dialogTag: false,
      dialogExport: false,
      dialogRemove: false,
      dialogError: false,
      dialogDeposit: false,
      dataReady: false,
      menuDate: false,
      menuDateEdit: false,
      menuDateChange: false,
      menuDataBokkAgain: false,
      date: '',
      time: '',
      empSelectAdd: '',
      dateEdit: '',
      timeEdit: '',
      empSelectEdit: '',
      session: this.$session.getAll(),
      fieldNameItem: [],
      flowfieldNameitem: [],
      sort: null,
      DataflowId: '',
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'รายชื่อลูกค้านัดหมาย',
          disabled: false,
          href: '/Master/BookingListBeauty'
        }
      ],
      branch: [],
      DataFlowName: [],
      // Data Table Config
      searchAll2: '',
      columns: [
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' },
        // { text: 'Booking Id', value: 'bookNo' },
        { text: 'วันและเวลานัดหมาย', value: 'dueDate' },
        { text: 'ชื่อบริการ', value: 'flowName' },
        { text: 'ชื่อลูกค้า', value: 'cusName' },
        { text: 'เบอร์โทร', value: 'tel' },
        { text: 'ทะเบียนรถ', value: 'cusReg' },
        { text: 'สถานะนัดหมาย', value: 'statusBtText' },
        {
          text: 'คุณสมบัติเพิ่มเติม',
          value: 'action3',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Confirm นัดล่วงหน้า',
          value: 'action2',
          sortable: false,
          align: 'center'
        }
        // { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
      ],
      columnsSelected: [],
      dataItem: [],
      dataItemCheck: [],
      dataexport: [],
      dataItemSelect: [],
      editedItemSeleteField: [],
      jobitem: [],
      itemsSort: [
        'เรียงตามวันที่นัดหมาย',
        'เรียงตามวันที่เปลี่ยนสถานะ',
        'เรียงตามวันที่สร้าง'
      ],
      itemsSortWaiting: ['เรียงตามวันที่นัดหมาย', 'เรียงตามวันที่สร้าง'],
      // End Data Table Config
      formAdd: {
        bookingId: null,
        fieldId: '',
        fieldValue: '',
        flowId: null,
        masBranchID: null,
        dueDate: '',
        shopId: this.$session.getAll().data.shopId,
        bookingFieldId: '',
        radiosRemark: '',
        depositStatus: '',
        depositImge: '',
        pictureUrlPreviewDeposit: '',
        depositPrice: 0
      },
      formEdit: {
        bookingId: null,
        fieldId: '',
        fieldValue: '',
        bookingLanguage: 0,
        flowId: null,
        masBranchID: null,
        dueDate: '',
        shopId: this.$session.getAll().data.shopId,
        bookingFieldId: '',
        radiosRemark: ''
      },
      formUpdate: {
        masBranchCode: '',
        masBranchName: '',
        tel: '',
        map: '',
        shopId: '',
        bookNo: ''
      },
      formChange: {
        date: '',
        time: ''
      },
      dataChange: {},
      validUpdate: true,
      validAdd: true,
      validEdit: true,
      validRemove: true,
      validChange: true,
      validExport: true,
      validBookingAgain: true,
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogEditData: false,
      dialogDelete: false,
      dialogChange: false,
      dialogRemark: false,
      dialogRemarkReturn: false,
      dialogJob: false,
      dialogAddCon: false,
      menuReturn: false,
      menu: false,
      menu1: false,
      menuStart: false,
      dateStart: new Date().toISOString().substr(0, 7),
      endDate: '',
      endTime: '',
      memberPicture: '',
      memberName: '',
      dataInfo: null,
      dialogInfo: false,
      detailInfo: null,
      rules: {
        checkBox: value => {
          // value อาจเป็น undefined / '' ถ้ายังไม่เคยติ๊ก จึงต้องกันไว้ก่อน
          if (!Array.isArray(value) || value.length < 1) {
            return 'กรุณากรอกข้อมูลอย่างน้อย 1 รายการ'
          }
          return true
        },
        phoneRules: value => {
          const cleanedValue = value.replace(/-/g, '') // ลบเครื่องหมายขีดกลางก่อนเอาไปเช็คต่อ
          return /^0[0-9]{8,9}$/.test(cleanedValue) || 'เบอร์โทรศัพท์ต้องเริ่มต้นด้วยเลข 0 และมี 9-10 หลัก'
        },
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        resizeImag: value =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        integer: value => /^\d+$/.test(value) || 'กรุณากรอกตัวเลขจำนวนเต็ม',
        positive: value => (parseInt(value) > 0) || 'กรุณากรอกตัวเลขที่มากกว่า 0',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      getSelectText: '',
      getSelectCount: 0,
      selectedStatus: false,
      swalConfig: {
        title: null,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      },
      BookingDataList: [],
      BookingDataListTimechange: [],
      remarkRemove: '',
      bookNoRemove: '',
      timeavailable: [],
      dialogConfirm: false,
      dialogAssignEmp: false,
      dialogMap: false,
      empSelectStep: [],
      empSelectStepAdd: [],
      selected: {},
      dataConfirm: [],
      empSelect: '',
      dataRemoveExport: [],
      dataexportRemove: [],
      BookingDataItemEdit: [],
      dataQrcode: [],
      bookNoRemark: '',
      remark: '',
      remarkReturn: '',
      dateReturn: '',
      showMap: '',
      setTimer: null,
      setTimerCalendar: null,
      searchOther: '',
      showColorSearch: false,
      dataEditJobReady: true,
      dataChangeReady: true,
      statusSearch: 'no',
      // window_open: true,
      center: null,
      address: '',
      empSelectJob: '',
      textError: '',
      dataReadyAdd: true,
      checkShowSelectUser: false,
      tabSelectUser: null,
      dataSelectUser: {},
      dataTypeJob1: '',
      dataTypeJob2: '',
      dataTypeJob3: '',
      dataTypeProcess1: '',
      dataTypeProcess2: '',
      dataTypeProcess3: '',
      dataTypeProcess4: '',
      checkDepositAdd: '',
      defaultData: [],
      phonenumItem: [],
      HistoryData: [],
      phonenum: [],
      lineUserId: '',
      booking: [],
      bookingData: [],
      dialogBookingAgain: false,
      loadingBookingAgain: false,
      limitBookingCheck: 'False',
      limitBookingSelect: 'False',
      limitCountBranch: 0,
      limitCountBranchOld: 0,
      countBookingLimit: 0,
      selectCountBookingLimit: 1,
      dueDateOld: '',
      dueDateTimeOld: '',
      masBranchIDLimit: '',
      flowIDLimit: '',
      dateDayoff: [],
      dateDayCustom: [],
      dateDaylimit: null,
      flowItemLimit: [],
      checkLimitBooking: {
        ID: '',
        countBooking: null,
        limitCheck: null,
        limitBooking: 0
      },
      dataEdit: '',
      statusShowDateConfiremjob: true,
      memberId: '',
      flowIdOldEdit: '',
      masBranchIDOldEdit: '',
      Redirect: '',
      dialogShowDeposit: false,
      depositLink: '',
      datailLinkDeposit: '',
      depositPrice: 0,
      statusdepositPrice: false,
      statusBranchReadonly: false,
      dataEmpOnsite: [],
      statusShowMap: '',
      listFilterCloseJob: ['ทั้งหมด', 'ยังไม่ปิดงาน', 'ปิดงาน'],
      filterCloseJobValue: 'ทั้งหมด',
      dataGetJob: [],
      dataCoin: [],
      productExchangeRateId: '',
      memberTel: '',
      dataLineConfig: {},
      priceMenu: null,
      dataMenu: [],
      expansionMenu: [0],
      dialogMenu: false,
      dialogMenuConclusion: false,
      depositTextTH: '',
      statusVIP: 'False',
      statusVIPEdit: 'False',
      statusVIPChang: 'False',
      statusVIPRemove: 'False',
      masBranchIDAddJob: '',
      statusPushEndStep: 'False',
      statusPushEndConfirm: 'False',
      endStepItem: [],
      ItemendStepStanby: [],
      DataFlowNameDefault: [],
      statusGoogleCalendar: '',
      statusGoogleCalendarEmp: '',
      copyTextBtTH: '',
      copyTextBtEN: '',
      copyTextStatus: false,
      dialogShowImg: false,
      showImgItem: [],
      dialogImg: false,
      dialogImg2: false,
      showImg: '',
      dataCloseJob: [],
      dataCloseJobData: [],
      sendRemarkRemove: false,
      checkSwal: 0,
      loadingConfirm: false,
      queueJobFixShop: null
    }
  },
  beforeCreate () {
    // if (localStorage.userName) {
    //   console.log(localStorage.userName)
    // } else {
    //   console.log('not user')
    // }
    if (!this.$session.exists()) {
      if (this.$route.query.bookNo) {
        this.$router.push(
          '/Core/Login?bookNo=' +
            this.$route.query.bookNo +
            '&shopId=' +
            this.$route.query.shopId +
            '&type=' +
            this.$route.query.type
        )
      } else {
        this.$router.push('/Core/Login')
      }
      // this.$router.push('/Core/Login?bookNo=' + this.$route.query.bookNo + '&shopId=' + this.$route.query.shopId)
    }
  },
  async mounted () {
    await this.getShop()
    this.dataLineConfig = await this.getDataLineConfig(
      this.$session.getAll().data.shopId
    )
    this.Redirect =
      'https://liff.line.me/' +
      this.dataLineConfig.liffMainID +
      '/BookingAddress?shopId=' +
      this.$session.getAll().data.shopId
    this.pathToweb =
      'https://liff.line.me/' +
      this.dataLineConfig.liffMainID +
      '/JobConfirm?jobId='
    if (
      this.$route.query.customerName &&
      this.$route.query.dueDate &&
      this.$route.query.masBranchID
    ) {
      this.searchAll2 = this.$route.query.customerName
      this.dateStart = this.$route.query.dueDate
      this.masBranchID = parseInt(this.$route.query.masBranchID)
      this.checkShowDataOnsite()
    } else {
      await this.checkShowDataOnsite('ไม่แสดง')
    }
    this.$root.$on('dataReturn', item => {
      this.dataReturn(item)
    })
    this.$root.$on('closeSetTimeGetCalenda', () => {
      // your code goes here
      this.closeSetTimeGetCalenda()
    })
    if (this.$route.query.type === 'babegonLineNotify') {
      await this.toggle()
    }
    // await this.beforeCreate()
  },
  created () {
    // this.getFirestore()
  },
  beforeDestroy () {
    this.$root.$off('dataReturn')
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  },
  methods: {
    calculateTimelineStats () {
      if (this.timelineitem.length === 0) {
        this.timelinestartTime = null
        this.timelineendTime = null
        this.timelinetotalTime = null
        return
      }

      // เวลาเริ่มต้น (อันแรก) และเวลาสิ้นสุด (อันสุดท้าย)
      this.timelinestartTime = this.timelineitem[0].DTCREATE_DATE
      this.timelineendTime = this.timelineitem[this.timelineitem.length - 1].DTLAST_DATE

      // แปลง string เป็น Date object เพื่อคำนวณ
      const startTime = new Date(this.timelinestartTime)
      const endTime = new Date(this.timelineendTime)

      // ตรวจสอบว่าค่า Date ถูกต้องหรือไม่
      if (isNaN(startTime) || isNaN(endTime)) {
        console.error('Invalid date format')
        this.timelinetotalTime = 'ไม่สามารถคำนวณเวลาได้'
        return
      }

      // คำนวณความต่างของเวลาในหน่วยนาที
      const durationInMilliseconds = endTime - startTime
      const totalMinutes = Math.floor(durationInMilliseconds / (1000 * 60))

      // กำหนดผลลัพธ์
      this.timelinetotalTime = `${totalMinutes} นาที`
    },
    builValue (item) {
      console.log('item======', item)
      let data = this.BookingDataItemEdit.filter((i) => parseInt(i.conditionField) === item.fieldId)

      if (data.length > 0) {
        for (let i = 0; i < this.BookingDataItemEdit.length; i++) {
          let fieldItem = this.BookingDataItemEdit[i]
          if (parseInt(fieldItem.conditionField) === item.fieldId && fieldItem.conditionValue !== item.fieldValue) {
            console.log('if1', fieldItem.conditionValue, '-', item.fieldValue)
            fieldItem.fieldValue = ''
          }
        }
        this.clearConditionStepByStep(data, new Set())
      }
    },
    clearConditionStepByStep (items, checkedItems) {
      console.log('checkedItems', checkedItems)
      items.forEach((item) => {
        if (checkedItems.has(item.fieldId)) {
          return // หากมีการตรวจสอบฟิลด์นี้แล้ว ให้ข้ามไป
        }
        checkedItems.add(item.fieldId) // บันทึกว่าได้ตรวจสอบฟิลด์นี้แล้ว

        for (let i = 0; i < this.BookingDataItemEdit.length; i++) {
          let fieldItem = this.BookingDataItemEdit[i]
          if (parseInt(fieldItem.conditionField) === item.fieldId && fieldItem.conditionValue !== item.fieldValue) {
            console.log('if3', fieldItem.conditionValue, '-', item.fieldValue)
            fieldItem.fieldValue = ''
          }
        }

        let checkData = this.BookingDataItemEdit.filter((i) => parseInt(i.conditionField) === item.fieldId)
        if (checkData.length > 0) {
          this.clearConditionStepByStep(checkData, checkedItems)
        }
      })
    },

    // ------ รับค่า flowId, masBranchId ที่เลือกจาก component CalendarBookingList -----
    SelectedFlowId (item) {
      this.calendarFlowId = item
      console.log('this.calendarFlowId', this.calendarFlowId)
    },
    SelectedmasBranchName (item) {
      this.calendarMasBranchId = item
      console.log('this.calendarMasBranchId', this.calendarMasBranchId)
    },
    // -----------------------------------------------------
    async pushMsgLineNotifyGroup (bookNo) {
      await axios
        .post(this.$DNS_IP + '/Booking/pushMsgLineNotifyGroup/' + bookNo)
        .then(response => {
          this.clearData()
        })
        .catch(error => {
          console.log('error function pushMsgQueue : ', error)
        })
    },
    getRowClass (item) {
      if (this.$route.query.bookNoNoti) {
        return item.bookNo === this.$route.query.bookNoNoti
          ? 'orange lighten-5'
          : ''
      } else {
        return ''
      }
    },
    async connectGoogleCalendar (status, bookNo) {
      const payload = {
        bookNo: bookNo,
        status: status
      }
      await axios
        .post(this.$DNS_IP + '/GoogleCalendarApi/event/byBookNo', payload)
        .then(response => {
          console.log('response connectGoogleCalendar : ', response)
        })
        .catch((error) => {
          console.log('error connectGoogleCalendar : ', error)
        })
      // this.$refs.GoogleCalendarRef.checkTypeEven(status, bookNo)
    },
    momentThaiTextClose (item) {
      let dt =
        'วัน' +
        moment(item)
          .locale('th')
          .format('dddd') +
        'ที่ ' +
        moment(item)
          .locale('th')
          .format('LL')
      return dt
    },
    openImageInNewTab () {
      window.open(this.showImg, '_blank')
      // this.dialogImg = false
    },
    SelectImg (Imgitem) {
      this.showImg = Imgitem
      if (this.checkShopSigneture[this.session.data.shopId]) {
        this.dialogImg2 = true
      } else {
        this.dialogImg = true
      }
    },
    async SaveImg () {
      console.log(this.showImgItem)
      if (this.checkShopSigneture[this.session.data.shopId]) {
        console.log('true', this.showImgItem)
        for (let i = 0; i < this.showImgItem.length; i++) {
          let d = this.showImgItem[i]
          if (d.beforeafter !== null && d.typeUpload === 'afterImage') {
            try {
              await axios
                .post(this.$DNS_IP + '/job/image-to-base64', {
                  imageUrl: d.beforeafter
                })
                .then(async response => {
                  console.log('response', response)
                  const base64Image = response.data.base64Image
                  const imgName = 'after' + '.jpg'
                  await this.downloadBase64Image(base64Image, imgName)
                })
                .catch(error => {
                  console.log(
                    'เกิดข้อผิดพลาดในการร้องขอข้อมูล Base64 ของรูปภาพ:',
                    error
                  )
                })
            } catch (error) {
              console.log('เกิดข้อผิดพลาดในการดาวน์โหลดรูปภาพ:', error)
            }
          }
          if (d.beforeafter !== null && d.typeUpload === 'beforeImage') {
            try {
              await axios
                .post(this.$DNS_IP + '/job/image-to-base64', {
                  imageUrl: d.beforeafter
                })
                .then(async response => {
                  console.log('response', response)
                  const base64Image = response.data.base64Image
                  const imgName = 'before' + '.jpg'
                  await this.downloadBase64Image(base64Image, imgName)
                })
                .catch(error => {
                  console.log(
                    'เกิดข้อผิดพลาดในการร้องขอข้อมูล Base64 ของรูปภาพ:',
                    error
                  )
                })
            } catch (error) {
              console.log('เกิดข้อผิดพลาดในการดาวน์โหลดรูปภาพ:', error)
            }
          }
        }
      } else {
        for (let i = 0; i < this.showImgItem.length; i++) {
          let d = this.showImgItem[i]
          if (d.afterImage !== null) {
            try {
              await axios
                .post(this.$DNS_IP + '/job/image-to-base64', {
                  imageUrl: d.afterImage
                })
                .then(async response => {
                  console.log('response', response)
                  const base64Image = response.data.base64Image
                  const imgName = 'after' + (i + 1) + '.jpg'
                  await this.downloadBase64Image(base64Image, imgName)
                })
                .catch(error => {
                  console.log(
                    'เกิดข้อผิดพลาดในการร้องขอข้อมูล Base64 ของรูปภาพ:',
                    error
                  )
                })
            } catch (error) {
              console.log('เกิดข้อผิดพลาดในการดาวน์โหลดรูปภาพ:', error)
            }
          }
          if (d.beforeImage !== null) {
            try {
              await axios
                .post(this.$DNS_IP + '/job/image-to-base64', {
                  imageUrl: d.beforeImage
                })
                .then(async response => {
                  console.log('response', response)
                  const base64Image = response.data.base64Image
                  const imgName = 'before' + (i + 1) + '.jpg'
                  await this.downloadBase64Image(base64Image, imgName)
                })
                .catch(error => {
                  console.log(
                    'เกิดข้อผิดพลาดในการร้องขอข้อมูล Base64 ของรูปภาพ:',
                    error
                  )
                })
            } catch (error) {
              console.log('เกิดข้อผิดพลาดในการดาวน์โหลดรูปภาพ:', error)
            }
          }
        }
      }
    },
    async downloadBase64Image (base64Data, fileName) {
      // สร้าง Blob จากข้อมูล base64
      const blob = await this.base64ToBlob(base64Data)
      // สร้างลิงก์ดาวน์โหลด
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      // คลิกลิงก์เพื่อดาวน์โหลด
      link.click()
    },
    base64ToBlob (base64Data) {
      const byteCharacters = atob(base64Data)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      return new Blob([byteArray], { type: 'image/jpeg' })
    },
    async ShowImg (item) {
      console.log(';sfsdfsdf', item)
      await this.getJob(item.jobNo)
      await this.getJobData(item.jobNo)
      await this.getBeforAfter(item.jobNo)
      this.dialogShowImg = true
    },
    async getBeforAfter (jobNo) {
      this.showImgItem = []
      await axios
        .get(this.$DNS_IP + '/jobBeforeAfter/get?jobNo=' + jobNo)
        .then(response => {
          let rs = response.data
          if (rs.length > 0) {
            // this.showImgItem = rs
            if ((this.checkShopSigneture[this.session.data.shopId])) {
              console.log('aaaaaa')
              for (let i = 0; i < rs.length; i++) {
                let d = rs[i]
                if (d.afterImage !== null || d.beforeImage !== null || d.beforeafter !== null) {
                  this.showImgItem.push(d)
                }
              }
            } else {
              for (let i = 0; i < rs.length; i++) {
                let d = rs[i]
                if (d.afterImage !== null || d.beforeImage !== null) {
                  this.showImgItem.push(d)
                }
              }
            }
          }
          console.log('rs', rs)
          console.log('this.showImgItem', this.showImgItem)
          console.log('this.session.data.shopId', this.session.data.shopId)
        })
    },
    async getJob (jobNo) {
      this.dataCloseJob = []
      await axios
        .get(this.$DNS_IP + '/job/getCloseJobBKlist?jobNo=' + jobNo)
        .then(async response => {
          let rs = response.data
          console.log('this.dataCloseJob', rs)
          if (rs.status === false) {
            this.dataCloseJob = []
          } else {
            this.dataCloseJob = rs
          }
        })
    },
    async getJobData (jobNo) {
      this.dataCloseJobData = []
      await axios
        .get(this.$DNS_IP + '/job/getCloseJobData?jobNo=' + jobNo)
        .then(async response => {
          let rs = response.data
          console.log('this.dataCloseJobData', rs)
          if (rs.status === false) {
            this.dataCloseJobData = []
          } else {
            this.dataCloseJobData = rs
            // console.log('this.dataCloseJobData', this.dataCloseJobData)
          }
        })
    },
    async getShop () {
      await axios
        .get(this.$DNS_IP + '/sys_shop/get?shopId=' + this.session.data.shopId)
        .then(response => {
          let rs = response.data
          console.log('rssssssssssss', rs)
          if (rs.length > 0) {
            this.shop = rs
            this.statusGoogleCalendar = rs[0].statusGoogleCalendar
            this.statusGoogleCalendarEmp = rs[0].statusGoogleCalendarEmp
          }
        })
    },
    async setCloseJob (item) {
      console.log('item', item)
      // await this.getCoin(item)
      await this.setCloseJobItem(item[0].jobNo)
      console.log('this.ItemendStepStanby', this.ItemendStepStanby)
      await this.getStepFlowCloseJob(
        this.ItemendStepStanby.flowId,
        this.ItemendStepStanby.shopId
      )
    },
    async setCloseJobItem (jobNo) {
      await axios
        .get(this.$DNS_IP + '/job/getJobNo?jobNo=' + jobNo)
        .then(response => {
          let rs = response.data
          if (rs.length > 0) {
            this.ItemendStepStanby = rs[0]
          }
        })
    },
    async getStepFlowCloseJob (flowId, shopId) {
      await axios
        .get(
          this.$DNS_IP + '/flowStep/get?flowId=' + flowId + '&shopId=' + shopId
        )
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            this.endStepItem = rs.filter(
              endItem => endItem.sortNo === rs.length
            )
            console.log('this.endStepItem', this.endStepItem)
          }
        })
    },
    async updateStepEnd () {
      console.log('endStepItem', this.endStepItem)
      console.log('ItemendStepStanby', this.ItemendStepStanby)
      if (this.statusPushEndStep === 'True') {
        let itemUpdate = {}
        itemUpdate.stepId = this.endStepItem[0].stepId
        itemUpdate.flowId = this.ItemendStepStanby.flowId
        itemUpdate.shopId = this.ItemendStepStanby.shopId
        itemUpdate.LAST_USER = this.session.data.userName
        itemUpdate.jobId = this.ItemendStepStanby.jobId
        await axios
          .post(
            // eslint-disable-next-line quotes
            this.$DNS_IP + "/job/edit/" + itemUpdate.jobId,
            itemUpdate
          )
          .then(async response => {
            console.log('editDataGlobal DNS_IP + PATH + "edit"', response)
            await this.pushmessage(itemUpdate.jobId)
          })
          // eslint-disable-next-line handle-callback-err
          .catch(error => {
            console.log('error function editDataGlobal : ', error)
          })
      }
    },
    async pushmessage (jobId) {
      let updateStatusSend = { updateStatusSend: 'false' }
      await axios
        .post(this.$DNS_IP + '/job/pushMsg/' + jobId, updateStatusSend)
        .then(console.log(jobId))
    },
    toggleAdd () {
      this.drawerAdd = !this.drawerAdd
    },
    updatePriceMenuAdd (price, dataMenu) {
      console.log('updatePriceMenu', price)
      this.priceMenuAdd = price
      this.dataMenuAdd = dataMenu
    },
    checkTypeSort () {
      if (this.sortSelect && this.sort) {
        if (this.sortSelect === 'เรียงตามวันที่นัดหมาย') {
          console.log('เรียงตามวันที่นัดหมาย')
          if (this.sort === 'มากไปน้อย') {
            this.dataItemSelect.sort(function (a, b) {
              return new Date(b.dueDate) - new Date(a.dueDate)
            })
          } else {
            this.dataItemSelect.sort(function (a, b) {
              return new Date(a.dueDate) - new Date(b.dueDate)
            })
          }
        } else if (this.sortSelect === 'เรียงตามวันที่เปลี่ยนสถานะ') {
          console.log('เรียงตามวันที่เปลี่ยนสถานะ')
          if (this.sort === 'มากไปน้อย') {
            this.dataItemSelect.sort(function (a, b) {
              return (
                new Date(b.CREATE_DATE_Status) - new Date(a.CREATE_DATE_Status)
              )
            })
          } else {
            this.dataItemSelect.sort(function (a, b) {
              return (
                new Date(a.CREATE_DATE_Status) - new Date(b.CREATE_DATE_Status)
              )
            })
          }
        } else if (this.sortSelect === 'เรียงตามวันที่สร้าง') {
          if (this.sort === 'มากไปน้อย') {
            this.dataItemSelect.sort(function (a, b) {
              return new Date(b.CREATE_DATE) - new Date(a.CREATE_DATE)
            })
          } else {
            this.dataItemSelect.sort(function (a, b) {
              return new Date(a.CREATE_DATE) - new Date(b.CREATE_DATE)
            })
          }
        }
      }
      // console.log('this.dataItemSelect', this.dataItemSelect)
    },
    async updateMenu () {
      let dt = {
        menuItem: JSON.stringify(
          this.dataMenu.filter(i => parseInt(i.qty) > 0)
        ),
        menuPrice: this.priceMenu || '',
        LAST_USER: this.$session.getAll().data.userName
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.$DNS_IP + "/Booking/edit/" + this.bookNo,
          dt
        )
        .then(async response => {
          this.$swal('สำเร็จ', 'แก้ไขรายการเมนูเรียบร้อย', 'success')
          if (this.statusSearch === 'no') {
            this.getBookingList()
          } else {
            this.searchAny()
          }
          if (this.getSelectText) {
            this.getSelect(
              this.getSelectText,
              this.getSelectCount,
              this.filterCloseJobValue
            )
          }
          this.getDataCalendaBooking()
          this.dialogMenu = false
          this.dialogMenuConclusion = false
        })
    },
    getDataMenu (item) {
      this.dataMenu = []
      this.priceMenu = null
      this.bookNo = item.bookNo
      var dataCheckmenu = this.DataFlowNameMenu.filter(el => {
        return el.value === item.flowId
      })
      console.log('dataCheckmenu', dataCheckmenu)
      if (dataCheckmenu.length > 0) {
        let setMenu = JSON.parse(dataCheckmenu[0].allData.menuItem) || []
        console.log('setMenu', setMenu)
        if (
          item.menuItem && item.menuItem.length > 1
        ) {
          let dataMenu = JSON.parse(item.menuItem)
          for (let i = 0; i < dataMenu.length; i++) {
            let d = dataMenu[i]
            if (
              setMenu.filter(el => {
                return el.name === d.name
              }).length > 0
            ) {
              let index = setMenu.findIndex(it => {
                return it.name === d.name
              })
              console.log(index)
              setMenu[index].price = d.price
              setMenu[index].qty = d.qty
              setMenu[index].remark = d.remark
            }
          }
          if (setMenu.length > 0) {
            this.dataMenu = setMenu
          } else {
            if (
              item.menuItem &&
              item.menuItem.length > 1
            ) {
              this.dataMenu = JSON.parse(item.menuItem)
            }
          }
          this.priceMenu = parseInt(item.menuPrice)
        }
      } else {
        if (
          item.menuItem && item.menuItem.length > 1
        ) {
          this.dataMenu = JSON.parse(item.menuItem)
          this.priceMenu = parseInt(item.menuPrice)
        }
      }
      this.dialogMenu = true
    },
    getDataMenuConclusion (item) {
      this.dataMenu = []
      this.priceMenu = null
      this.bookNo = item.bookNo
      var dataCheckmenu = this.DataFlowNameMenu.filter(el => {
        return el.value === item.flowId
      })
      console.log('dataCheckmenu', dataCheckmenu)
      if (dataCheckmenu.length > 0) {
        let setMenu = JSON.parse(dataCheckmenu[0].allData.menuItem) || []
        console.log('setMenu', setMenu)
        if (
          item.menuItem && item.menuItem.length > 1
        ) {
          let dataMenu = JSON.parse(item.menuItem)
          for (let i = 0; i < dataMenu.length; i++) {
            let d = dataMenu[i]
            if (
              setMenu.filter(el => {
                return el.name === d.name
              }).length > 0
            ) {
              let index = setMenu.findIndex(it => {
                return it.name === d.name
              })
              console.log(index)
              setMenu[index].price = d.price
              setMenu[index].qty = d.qty
              setMenu[index].remark = d.remark
            }
          }
          if (setMenu.length > 0) {
            this.dataMenu = setMenu
          } else {
            if (
              item.menuItem && item.menuItem.length > 1
            ) {
              this.dataMenu = JSON.parse(item.menuItem)
            }
          }
          this.priceMenu = parseInt(item.menuPrice)
        }
      } else {
        if (
          item.menuItem && item.menuItem.length > 1
        ) {
          this.dataMenu = JSON.parse(item.menuItem)
          this.priceMenu = parseInt(item.menuPrice)
        }
      }
      this.dialogMenuConclusion = true
    },
    changeCounter (num, item) {
      item.qty += +num
      if (num === '1') {
        this.priceMenu = this.priceMenu + parseInt(item.price)
      } else {
        if (item.qty >= 0) {
          this.priceMenu = this.priceMenu - parseInt(item.price)
        }
      }
      // eslint-disable-next-line no-unused-expressions
      !isNaN(item.qty) && item.qty > 0 ? item.qty : (item.qty = 0)
      if (item.qty === 0) {
        item.remark = ''
      }
    },
    exportShowMenuReport () {
      let dataexport = []
      for (let i = 0; i < this.dataShowMenuReport.length; i++) {
        let a = this.dataShowMenuReport[i]
        if (a.statusBt === 'wait') {
          a.statusBtShow = this.dataTypeProcess1
        } else if (a.statusBt === 'confirm') {
          a.statusBtShow = this.dataTypeProcess2
        } else if (a.statusBt === 'confirmJob') {
          a.statusBtShow = this.dataTypeProcess4
        }
        let data1 = {}
        if (a.shopId === 'Uec804350aa290d70772883350c7c60c4') {
          data1 = {
            สถานะ: a.statusBtShow,
            บริการ: a.flowName,
            ชื่อลูกค้า: a.cusName,
            เบอร์โทร: a.tel,
            วันที่: a.dueDate,
            การจัดส่ง: a.deliveryOptions,
            ที่อยู่: a.address
          }
        } else {
          data1 = {
            สถานะ: a.statusBtShow,
            บริการ: a.flowName,
            ชื่อลูกค้า: a.cusName,
            เบอร์โทร: a.tel,
            วันที่: a.dueDate
          }
        }
        console.log('this.DataFlowNameMenu', this.DataFlowNameMenu)
        let checkFlow = this.DataFlowNameMenu.filter(el => {
          return el.value === this.flowSelectMenu
        })
        console.log('------!_!_!_!_!_!_!_!_!_!_!_-------', checkFlow)
        if (checkFlow[0].value === 'AllFlow') {
          for (let i = 0; i < this.DataFlowNameMenu.length; i++) {
            let t = this.DataFlowNameMenu[i]
            if (t.value !== 'AllFlow') {
              let menuItem = JSON.parse(t.allData.menuItem) || []
              if (menuItem.length > 0) {
                for (let y = 0; y < menuItem.length; y++) {
                  let x = menuItem[y]
                  // console.log(menuItem)
                  let checkmenu = a.menuItem.filter(el => {
                    return el.name === x.name
                  })
                  if (checkmenu.length > 0) {
                    // เพิ่ม column เฉพาะเมื่อ qty ไม่เป็น 0
                    if (checkmenu[0].qty !== 0 && checkmenu[0].qty !== '0') {
                      data1[x.name] = checkmenu[0].qty
                      data1['หมายเหตุ' + x.name] = checkmenu[0].remark || ''
                    }
                  }
                  // ถ้าไม่มี checkmenu หรือ qty เป็น 0 ก็ไม่เพิ่ม column
                }
              }
            }
          }
        } else {
          let menuItem = JSON.parse(checkFlow[0].allData.menuItem) || []
          console.log('------!_!_!_!_!_!EROROR_!_!_!_!_!_-------')
          console.log(menuItem)
          if (menuItem.length > 0) {
            for (let y = 0; y < menuItem.length; y++) {
              let x = menuItem[y]
              // console.log(menuItem)
              let checkmenu = a.menuItem.filter(el => {
                return el.name === x.name
              })
              if (checkmenu.length > 0) {
                // เพิ่ม column เฉพาะเมื่อ qty ไม่เป็น 0
                if (checkmenu[0].qty !== 0 && checkmenu[0].qty !== '0') {
                  data1[x.name] = checkmenu[0].qty
                  data1['หมายเหตุ' + x.name] = checkmenu[0].remark || ''
                }
              }
              // ถ้าไม่มี checkmenu หรือ qty เป็น 0 ก็ไม่เพิ่ม column
            }
          }
        }
        dataexport.push(data1)
      }

      // const wb = XLSX.utils.book_new()
      let datause2 = dataexport.sort((a, b) => {
        if (a.วันที่ < b.วันที่) return -1
        return a.วันที่ > b.วันที่ ? 1 : 0
      })
      console.log('datause2', datause2)
      const dataWS = XLSX.utils.json_to_sheet(datause2)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(
        wb,
        'export_' +
          this.format_dateNotime(this.dateStartShowMenuReport) +
          '.xlsx'
      )
      // console.log(datause2)
      // console.log(this.dataShowMenuReport)
      // for (let i = 0; i < this.dataMenuShowMenuReport.length; i++) {
      //   let d = this.dataMenuShowMenuReport[i]
      //   if (datause2.filter(el => { return el.ชื่อพนักงาน === d.value }).length > 0) {
      //     console.log(datause2.filter(el => { return el.ชื่อพนักงาน === d.value }))
      //     let sheetNm = ''
      //     if (d.value.length > 30) {
      //       sheetNm = d.value.substring(0, 29)
      //     } else {
      //       sheetNm = d.value
      //     }
      //     XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(datause2.filter(el => { return el.ชื่อพนักงาน === d.value })), sheetNm)
      //   }
      // }
      // console.log('dataexport', dataexport)
      // XLSX.writeFile(wb, 'export_' + this.format_dateNotime(this.dateStartShowMenuReport) + '.xlsx')
    },
    toggleShowMenuList (cusNameTel) {
      this.dataShowMenuReport.forEach(dessert => {
        if (dessert.cusNameTel === cusNameTel) {
          dessert.hide = !dessert.hide
        }
      })
    },
    async getBookingShowMenuList () {
      this.dataShowMenuReport = []
      this.dataMenuShowMenuReport = []
      this.BookingDataListShowMenuReport = []
      console.log('this.dateStartShowMenuReport na', this.dateStartShowMenuReport)
      if (this.dateStartShowMenuReport && this.flowSelectMenu) {
        await this.getBookingDataListShowMenuReport(
          this.dateStartShowMenuReport
        )
        let urlApi = ''
        if (this.flowSelectMenu === 'AllFlow') {
          urlApi =
          this.$DNS_IP +
          '/booking_view/get?shopId=' +
          this.session.data.shopId +
          '&dueDate=' +
          this.dateStartShowMenuReport
        } else {
          urlApi =
          this.$DNS_IP +
          '/booking_view/get?shopId=' +
          this.session.data.shopId +
          '&dueDate=' +
          this.dateStartShowMenuReport +
          '&flowId=' +
          this.flowSelectMenu
        }
        console.log('url', urlApi)
        await axios.get(urlApi).then(async response => {
          console.log('getData', response.data.length)
          if (response.data.length > 0) {
            console.log('getData check1', response.data)
            for (let i = 0; i < response.data.length; i++) {
              let d = response.data[i]
              d.statusBt = d.statusBt || 'wait'
              if (d.statusBt !== 'cancel') {
                // if (this.dataMenuShowMenuReport.filter(el => { return el.value === d.bookingEmpFlowName }).length === 0) {
                //   let s = {}
                //   s.text = d.bookingEmpFlowName
                //   s.value = d.bookingEmpFlowName
                //   this.dataMenuShowMenuReport.push(s)
                // }
                d.hide = false
                if (d.menuItem === null || d.menuItem === '') {
                  d.menuItem = []
                } else {
                  d.menuItem = JSON.parse(d.menuItem || [])
                }
                d.cusName = this.getDataFromFieldName(
                  this.BookingDataListShowMenuReport[d.bookNo],
                  'ชื่อ'
                )
                d.cusReg = this.getDataFromFieldName(
                  this.BookingDataListShowMenuReport[d.bookNo],
                  'เลขทะเบียน'
                )
                d.tel = this.getDataFromFieldName(
                  this.BookingDataListShowMenuReport[d.bookNo],
                  'เบอร์โทร'
                )
                // ร้านข้าวมันไก่ (Uec804350aa290d70772883350c7c60c4)
                if (d.shopId === 'Uec804350aa290d70772883350c7c60c4') {
                  d.deliveryOptions = this.getDataFromFieldName(
                    this.BookingDataListShowMenuReport[d.bookNo],
                    'การจัดส่ง'
                  )
                  d.address = this.getDataFromFieldName(
                    this.BookingDataListShowMenuReport[d.bookNo],
                    'ที่อยู่'
                  )
                  d.deliveryOptions =
                    d.deliveryOptions.length > 0
                      ? d.deliveryOptions[0].fieldValue
                      : ''
                  d.address =
                    d.address.length > 0 ? d.address[0].fieldValue : ''
                }
                //
                d.cusName = d.cusName.length > 0 ? d.cusName[0].fieldValue : ''
                d.cusReg = d.cusReg.length > 0 ? d.cusReg[0].fieldValue : ''
                d.tel = d.tel.length > 0 ? d.tel[0].fieldValue : ''
                d.cusNameTel = d.cusName + ' : ' + d.tel
                this.dataShowMenuReport.push(d)
              }
            }
            console.log('this.dataShowMenuReport', this.dataShowMenuReport)
          } else {
            this.dataShowMenuReport = []
            this.dataMenuShowMenuReport = []
          }
        })
      }
    },
    async getBookingDataListShowMenuReport (dateStart) {
      console.log('dateStart', dateStart)
      this.BookingDataListShowMenuReport = []
      let url = ''
      url = `${this.$DNS_IP}/BookingData/getView?shopId=${this.session.data.shopId}&dueDate=${dateStart}`
      await axios
        .get(url)
        .then(async response => {
          if (response.data.status !== false) {
            response.data.forEach(row => {
              if (
                typeof this.BookingDataListShowMenuReport[row.bookNo] ===
                'undefined'
              ) {
                this.BookingDataListShowMenuReport[row.bookNo] = []
              }
              this.BookingDataListShowMenuReport[row.bookNo].push(row)
            })
          }
        })
        .catch(error => {
          // this.dataEditReady = true
          setTimeout(
            () => this.getBookingDataListShowMenuReport(dateStart),
            3000
          )
          console.log('catch getBookingDataListShowMenuReport : ', error)
        })
      console.log(
        'this.BookingDataListShowMenuReport',
        this.BookingDataListShowMenuReport
      )
    },
    gotoLineOa () {
      window.open('https://chat.line.biz/', '_blank')
    },
    async coppyLink (item) {
      console.log('item', item)
      // this.$swal.fire('Any fool can use a computer')
      // this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
      this.$swal({
        title: 'Copy successfully',
        text: 'คัดลอกลายชื่อเรียบร้อย',
        type: 'success',
        timer: 2000,
        showConfirmButton: false
      })
      await navigator.clipboard.writeText(item)
    },
    FunCopyQrcode (text) {
      // var copyText = document.getElementById('myInput')
      // copyText.select()
      // copyText.setSelectionRange(0, 99999)
      navigator.clipboard.writeText(text)
      this.$swal({
        title: 'Copy successfully',
        text: 'คัดลอกลิงก์สำเร็จ',
        type: 'success',
        timer: 2000,
        showConfirmButton: false
      })
    },
    // getColor (item) {
    //   if (item.RECORD_STATUS_Job === 'D') {
    //     return 'red darken-2 white--text'
    //   }
    // },
    async getJobitem (item) {
      console.log('getJobitem', item)
      this.customerNameJob = item.cusName
      this.timelineitem = []
      await axios
        .get(this.$DNS_IP + '/job_logCloseJob/' + item.jobNo)
        .then(response => {
          let rs = response.data
          console.log('rs', rs)
          if (rs.length > 0) {
            for (let i = 0; i < rs.length; i++) {
              let d = rs[i]
              let s = {}
              s.empStep = d.empStep
              s.endDate = d.endDate
              s.totalPrice = s.totalPrice
              s.DTCREATE_DATE = d.CREATE_DATE
              s.DTLAST_DATE = d.LAST_DATE
              s.stepTitle = d.totalPrice === null ? d.stepTitle : 'ปิดจ๊อบ'
              s.timediff = d.timediff
              s.LAST_USER_Name = d.LAST_USER_Name || d.LAST_USER
              s.Counttime = this.convertHMS(
                this.jsTimeDiff(d.CREATE_DATE, d.LAST_DATE)
              )
              s.totalPrice = d.totalPrice
              this.timelineitem.push(s)
            }
          }
          if (this.$session.getAll().data.shopId === this.shopNameData.udon1 || this.$session.getAll().data.shopId === this.shopNameData.udon2) {
            this.calculateTimelineStats()
          }
          this.dialogHistoryJob = true
        })
        .catch(error => {
          console.log('error function addData : ', error)
          this.dialogHistoryJob = true
        })
    },
    convertHMS (value) {
      const sec = parseInt(value, 10) // convert value to number if it's string
      let hours = Math.floor(sec / 3600) // get hours
      let minutes = Math.floor((sec - hours * 3600) / 60) // get minutes
      let seconds = sec - hours * 3600 - minutes * 60 // get seconds
      // add 0 if value < 10; Example: 2 => 02
      if (hours < 10) {
        hours = '0' + hours
      }
      if (minutes < 10) {
        minutes = '0' + minutes
      }
      if (seconds < 10) {
        seconds = '0' + seconds
      }
      return hours + ':' + minutes + ':' + seconds // Return is HH : MM : SS
    },
    jsTimeDiff (Time1, Time2) {
      var oneday = 1000 * 60
      var defDate =
        (new Date(Time2).getTime() - new Date(Time1).getTime()) / oneday
      // console.log('def', Time1, Time2)
      return defDate
    },
    async getjobChangeOnsite (item) {
      this.dataEmpOnsite = item
      await this.getEmpSelectAddJob()
      this.jobitem = []
      console.log(item)
      console.log(this.empSelectStepAdd)
      if (item.jobNo !== '') {
        await axios
          .get(this.$DNS_IP + '/job/getJobNo?jobNo=' + item.jobNo)
          .then(response => {
            let rs = response.data
            console.log('getJobNo', rs)
            if (rs.status === false) {
            } else {
              this.jobitem = rs
              this.sortNo = rs[0].sortNo
              this.empSelectJob = parseInt(rs[0].empStepId)
              this.flowId = rs[0].flowId
              console.log('this.flowId', this.flowId)
              if (this.sortNo === 1) {
                this.checkEmpJob()
              }
            }
          })
      }
    },
    updatePlace (place) {
      // console.log(place)
      this.shopLat = place.geometry.location.lat()
      this.shopLong = place.geometry.location.lng()
      this.center = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      }
    },
    updateCoordinates (location) {
      console.log('location.latLng.lat()', location.latLng.lat())
      console.log('location.latLng.lng()', location.latLng.lng())
      this.shopLat = location.latLng.lat()
      this.shopLong = location.latLng.lng()
      this.center = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng()
      }
    },
    async setDataServiceList (item) {
      this.$refs.NotificationService.setData(item)
    },
    async printQrcodeComfirmJob (value, jobitem) {
      let valueStep =
        'https://betask-linked-admin.web.app/AdminStampStep?jobNo=' +
        this.dataGetJob.jobNo +
        '&shopId=' +
        this.$session.getAll().data.shopId
      this.$refs.PrintQrCodeConfirmJobLINE.printQrcode(
        value,
        jobitem,
        this.dataGetJob,
        valueStep
      )
    },
    async setDataCallLog (item) {
      this.$refs.CallLog.setData(item)
    },
    async setDataReture (item) {
      this.$refs.RetureDeposit.setData(item)
    },
    setDataCopyLink (item) {
      console.log('filteredSelect', this.filteredSelect)
      this.statusdepositPrice = true
      this.depositPrice = item.depositPrice || 0
      this.depositTextTH = item.depositTextTH || 'ชำระเงินมัดจำ'
      this.bookNo = item.bookNo
      this.datailLinkDeposit = item.remarkDepositLinked
      this.depositLink =
        'https://betask-linked.web.app/Thank?shopId=' +
        item.shopId +
        '&redirectBy=BookingAdmin&flowId=' +
        item.flowId +
        '&bookNo=' +
        item.bookNo
      this.dialogShowDeposit = true
    },
    async dataReturn (item) {
      console.log('dataReturn', item)
      if (this.statusSearch === 'no') {
        await this.getBookingList()
      } else {
        await this.searchAny()
      }
      // this.getTimesChange('update')
      if (this.getSelectText) {
        this.getSelect(
          this.getSelectText,
          this.getSelectCount,
          this.filterCloseJobValue
        )
      }
    },
    async FunCopyDeposit () {
      let textBookNo = ''
      let textBookNoEn = ''
      let depositPrice = ''
      let textLink = ''
      let textDepositPrice = ''
      this.copyTextBtTH = ''
      this.copyTextBtEN = ''
      let dt = {}
      if (this.statusdepositPrice === true) {
        dt = {
          remarkDepositLinked: (this.datailLinkDeposit || '')
            .replace(/%/g, '%%')
            .replace(/'/g, "\\'")
            .replace(/`/g, '\\`'),
          depositPrice: this.depositPrice || '',
          LAST_USER: this.$session.getAll().data.userName
        }
      } else {
        dt = {
          remarkDepositLinked: (this.datailLinkDeposit || '')
            .replace(/%/g, '%%')
            .replace(/'/g, "\\'")
            .replace(/`/g, '\\`'),
          LAST_USER: this.$session.getAll().data.userName
        }
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.$DNS_IP + "/Booking/edit/" + this.bookNo,
          dt
        )
        .then(async response => {})
      await axios
        // .post(this.$DNS_IP + '/Booking/setDetailsCopyLinkAddData/' + 'BK025446181660716002544')
        .post(this.$DNS_IP + '/Booking/setDetailsCopyLinkAddData/' + this.bookNo)
        .then(response => {
          console.log('response.data', response.data)
          if (response.data.status) {
            textBookNo = response.data.message
            depositPrice = response.data.depositPrice || 0
            if (depositPrice === '0') {
              textLink = 'กรุณากดเพื่อผูกบัญชี : ' + this.depositLink
            } else {
              textLink =
                'กรุณากดเพื่อโอน' +
                this.depositTextTH +
                ' : ' +
                this.depositLink
              textDepositPrice =
                `\nจำนวนเงิน : ` +
                depositPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            // console.log('textBookNo', textBookNo + `\n` + this.datailLinkDeposit + textDepositPrice + `\n------------------------\n` + textLink)
            let copyText =
              textBookNo +
              `\n` +
              this.datailLinkDeposit +
              textDepositPrice +
              `\n------------------------\n` +
              textLink

            textBookNoEn = response.data.messageEn
            depositPrice = response.data.depositPrice || 0
            if (depositPrice === '0') {
              textLink =
                'Please click on the link to confirm your booking : ' +
                this.depositLink +
                '&languageSelect=1'
            } else {
              textLink =
                'Please click on the link to proceed with payment. To complete your booking : ' +
                this.depositLink +
                '&languageSelect=1'
              textDepositPrice =
                `\nTotal Amount : ` +
                depositPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            // console.log('textBookNo', textBookNo + `\n` + this.datailLinkDeposit + textDepositPrice + `\n------------------------\n` + textLink)
            let copyTextEn =
              textBookNoEn +
              `\n` +
              this.datailLinkDeposit +
              textDepositPrice +
              `\n------------------------\n` +
              textLink

            console.log('copyText', copyText)
            this.copyTextBtTH = copyText
            this.copyTextBtEN = copyTextEn
            this.copyTextStatus = true
            this.updateBookingListByDeposit()
          } else {
            this.$swal('ผิดพลาด', 'กรุณาทำรายการใหม่', 'error')
          }
        })
    },
    async copyFallbackTH () {
      await this.updateBookingLanguage('0')
      this.$swal('สำเร็จ', 'คัดลอกลิงก์สำเร็จ', 'success')
    },
    async copyFallbackEN () {
      await this.updateBookingLanguage('1')
      this.$swal('สำเร็จ', 'คัดลอกลิงก์สำเร็จ', 'success')
    },
    copyFallbackClose () {
      this.dialogShowDeposit = false
      this.copyTextStatus = false
    },
    async updateBookingLanguage (bookingLanguage) {
      try {
        let dt = {
          bookingLanguage: bookingLanguage,
          LAST_USER: this.$session.getAll().data.userName
        }
        await axios.post(this.$DNS_IP + '/Booking/edit/' + this.bookNo, dt)
      } catch (e) {
        console.log(e)
      }
    },
    async updateBookingListByDeposit () {
      let urlApi =
        this.$DNS_IP +
        '/booking_view/get?shopId=' +
        this.session.data.shopId +
        '&bookNo=' +
        this.bookNo
      await axios.get(urlApi).then(async response => {
        console.log('updateBookingListByDeposit', response.data.length)
        if (response.data.length > 0) {
          let objIndex = this.dataItem.findIndex(
            obj => obj.bookNo === this.bookNo
          )
          this.dataItem[objIndex].remarkDepositLinked =
            response.data[0].remarkDepositLinked || ''
          this.dataItem[objIndex].depositPrice =
            response.data[0].depositPrice || 0
        }
      })
    },
    clearOnsiteChange () {
      this.getDataDefault()
      this.searchOther = ''
      this.showColorSearch = false
      this.statusSearch = 'no'
      this.empSelectJob = ''
    },
    async openCalendaList (date, text) {
      this.dataSummary = []
      this.dataCalendar = []
      let dataJobData = []
      if (text === 'sortNo1') {
        // let jobNo = this.checkEventInfo.filter(el => { return el.start === date && el.sortNo === 2 })[0].jobNo
        await axios
          .get(
            // eslint-disable-next-line quotes
            this.$DNS_IP +
              '/job/get?shopId=' +
              this.session.data.shopId +
              '&empStepId=' +
              this.empSelectJob +
              '&dueDate=' +
              date +
              '&sortNo=1' +
              '&checkOnsite=True'
          )
          .then(async response => {
            if (response.data.status === false) {
              dataJobData = []
            } else {
              // dataJobData = response.data
              response.data.forEach(row => {
                if (typeof dataJobData[row.jobNo] === 'undefined') {
                  dataJobData[row.jobNo] = []
                }
                dataJobData[row.jobNo].push(row)
              })
              console.log('dataJobData', dataJobData)
              console.log(
                'checkEventInfo',
                this.checkEventInfo.filter(el => {
                  return el.start === date && el.sortNo === 1
                })
              )
              for (
                let i = 0;
                i <
                this.checkEventInfo.filter(el => {
                  return el.start === date && el.sortNo === 1
                }).length;
                i++
              ) {
                var d = this.checkEventInfo.filter(el => {
                  return el.start === date && el.sortNo === 1
                })[i]
                d.name = dataJobData[d.jobNo].filter(row => {
                  return row.fieldName === 'ชื่อ'
                })
                d.licenseNo = dataJobData[d.jobNo].filter(row => {
                  return row.fieldName === 'เลขทะเบียน'
                })
                d.tel = dataJobData[d.jobNo].filter(row => {
                  return row.fieldName === 'เบอร์โทร'
                })
                d.carModel = dataJobData[d.jobNo].filter(row => {
                  return row.fieldName === 'รุ่นรถ'
                })
                d.name = d.name.length > 0 ? d.name[0].fieldValue : ''
                d.licenseNo =
                  d.licenseNo.length > 0 ? d.licenseNo[0].fieldValue : ''
                d.tel = d.tel.length > 0 ? d.tel[0].fieldValue : ''
                d.carModel =
                  d.carModel.length > 0 ? d.carModel[0].fieldValue : ''
                d.timeDue = dataJobData[d.jobNo][0].timeDue
                d.dueDate = dataJobData[d.jobNo][0].dueDate
                d.bgcolor = 'orange'
                this.dataCalendar.push(d)
              }

              this.dataCalendar.sort((a, b) => {
                let keyA = new Date(a.dueDate)
                let keyB = new Date(b.dueDate)
                if (keyA < keyB) return -1
                if (keyA > keyB) return 1
                return 0
              })
              console.log('this.dataCalendar', this.dataCalendar)
              this.dataSummary = this.dataCalendar.reduce((r, a) => {
                r[a.bgcolor] = r[a.bgcolor] || {}
                r[a.bgcolor][a.timeDue] = r[a.bgcolor][a.timeDue] || []
                r[a.bgcolor][a.timeDue].push(a)
                return r
              }, Object.create(null))
              console.log('this.dataSummary', this.dataSummary)
            }
          })
        this.dialogCalenda = true
      } else {
        await axios
          .get(
            // eslint-disable-next-line quotes
            this.$DNS_IP +
              '/job/get?shopId=' +
              this.session.data.shopId +
              '&empStepId=' +
              this.empSelectJob +
              '&dueDate=' +
              date +
              '&sortNo=2' +
              '&checkOnsite=True'
          )
          .then(async response => {
            if (response.data.status === false) {
              dataJobData = []
            } else {
              // dataJobData = response.data
              response.data.forEach(row => {
                if (typeof dataJobData[row.jobNo] === 'undefined') {
                  dataJobData[row.jobNo] = []
                }
                dataJobData[row.jobNo].push(row)
              })
              console.log('dataJobData', dataJobData)
              console.log(
                'checkEventInfo',
                this.checkEventInfo.filter(el => {
                  return el.start === date && el.sortNo === 2
                })
              )
              for (
                let i = 0;
                i <
                this.checkEventInfo.filter(el => {
                  return el.start === date && el.sortNo === 2
                }).length;
                i++
              ) {
                var d = this.checkEventInfo.filter(el => {
                  return el.start === date && el.sortNo === 2
                })[i]
                d.name = dataJobData[d.jobNo].filter(row => {
                  return row.fieldName === 'ชื่อ'
                })[0].fieldValue
                d.licenseNo = dataJobData[d.jobNo].filter(row => {
                  return row.fieldName === 'เลขทะเบียน'
                })[0].fieldValue
                d.tel = dataJobData[d.jobNo].filter(row => {
                  return row.fieldName === 'เบอร์โทร'
                })[0].fieldValue
                d.timeDue = dataJobData[d.jobNo][0].timeDue
                d.dueDate = dataJobData[d.jobNo][0].dueDate
                d.bgcolor = 'blue'
                this.dataCalendar.push(d)
              }

              this.dataCalendar.sort((a, b) => {
                let keyA = new Date(a.dueDate)
                let keyB = new Date(b.dueDate)
                if (keyA < keyB) return -1
                if (keyA > keyB) return 1
                return 0
              })
              console.log('this.dataCalendar', this.dataCalendar)
              this.dataSummary = this.dataCalendar.reduce((r, a) => {
                r[a.bgcolor] = r[a.bgcolor] || {}
                r[a.bgcolor][a.timeDue] = r[a.bgcolor][a.timeDue] || []
                r[a.bgcolor][a.timeDue].push(a)
                return r
              }, Object.create(null))
              console.log('this.dataSummary', this.dataSummary)
            }
          })
        this.dialogCalenda = true
      }
    },
    FunCopy (text) {
      var copyText = document.getElementById('myInput')
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      navigator.clipboard.writeText(copyText.value + '&bookNo=' + this.bookNo)
    },
    getQrCOde (item) {
      this.bookNo = item.bookNo
      this.value = this.Redirect + '&bookNo=' + this.bookNo
      this.dialogQrCode = true
    },
    async prev () {
      this.$refs.calendaronsite.prev()
      // this.getBookingList()
      await this.checkEmpJobCalenda()
    },
    async next () {
      this.$refs.calendaronsite.next()
      // this.getBookingList()
      await this.checkEmpJobCalenda()
    },
    async checkEmpJob () {
      this.today = moment().format('YYYY-MM-DD')
      // console.log('this.dateStart => ', this.dateStart)
      // console.log('this.today => ', this.today)
      const dateSplit = this.today.split('-')
      const year = String(dateSplit[0])
      const month = String(dateSplit[1])
      var flowId = this.dataEmpOnsite.flowId
      // if (this.flowId !== '') {
      //   flowId = this.flowId
      // } else {
      //   flowId = this.dataEmpOnsite.flowId
      // }
      this.eventInfo = []
      await axios
        .get(
          this.$DNS_IP +
            '/booking_view/getCountNotimeJob?shopId=' +
            this.session.data.shopId +
            '&empStep=' +
            this.empSelectJob +
            '&flowId=' +
            flowId +
            '&dueDate=' +
            year +
            '-' +
            month +
            '&checkOnsite=True'
        )
        .then(async responses => {
          console.log('this.responses', responses.data)
          if (responses.data.status === false) {
            this.eventInfo = []
            this.checkEventInfo = []
          } else {
            for (var x = 0; x < responses.data.length; x++) {
              var d = responses.data[x]
              // var s = {}
              let dueDate = d.start
              // s.start = d.start
              // s.name = d.name.toString()
              // s.color = 'blue'
              // this.events.push(s)
              if (typeof this.eventInfo[dueDate] === 'undefined') {
                this.eventInfo[dueDate] = {
                  sortNo1: 0,
                  sortNo2: 0,
                  sortNo3: 0
                }
              }
              if (d.sortNo === 1) {
                this.eventInfo[dueDate].sortNo1++
              } else if (d.sortNo === 2) {
                this.eventInfo[dueDate].sortNo2++
              } else if (d.sortNo === 3) {
                this.eventInfo[dueDate].sortNo3++
              }
            }
            this.checkEventInfo = responses.data
            console.log('this.eventInfo', this.eventInfo)
            console.log('this.checkEventInfo', this.checkEventInfo)
          }
        })
      // this.$refs.calendaronsite.checkChange()
      //   }
      // })
    },
    async checkEmpJobCalenda () {
      console.log('this.today', this.today)
      // this.dataEmpOnsite = []
      // this.today = moment(moment(new Date()), 'YYYY-MM-DD').format('YYYY-MM-DD')
      const dateSplit = this.today.split('-')
      const year = String(dateSplit[0])
      const month = String(dateSplit[1])
      var flowId = this.dataEmpOnsite.flowId
      // if (this.flowId !== '') {
      //   flowId = this.flowId
      // } else {
      //   flowId = this.dataEmpOnsite.flowId
      // }
      this.eventInfo = []
      await axios
        .get(
          this.$DNS_IP +
            '/booking_view/getCountNotimeJob?shopId=' +
            this.session.data.shopId +
            '&empStep=' +
            this.empSelectJob +
            '&flowId=' +
            flowId +
            '&dueDate=' +
            year +
            '-' +
            month +
            '&checkOnsite=True'
        )
        .then(async responses => {
          if (responses.data.status === false) {
            this.eventInfo = []
            this.checkEventInfo = []
          } else {
            for (var x = 0; x < responses.data.length; x++) {
              var d = responses.data[x]
              // var s = {}
              let dueDate = d.start
              // s.start = d.start
              // s.name = d.name.toString()
              // s.color = 'blue'
              // this.events.push(s)
              if (typeof this.eventInfo[dueDate] === 'undefined') {
                this.eventInfo[dueDate] = {
                  sortNo1: 0,
                  sortNo2: 0,
                  sortNo3: 0
                }
              }
              if (d.sortNo === 1) {
                this.eventInfo[dueDate].sortNo1++
              } else if (d.sortNo === 2) {
                this.eventInfo[dueDate].sortNo2++
              } else if (d.sortNo === 3) {
                this.eventInfo[dueDate].sortNo3++
              }
            }
            this.checkEventInfo = responses.data
            console.log('this.eventInfo', this.eventInfo)
            console.log('this.checkEventInfo', this.checkEventInfo)
          }
        })
      // this.$refs.calendaronsite.checkChange()
    },
    addEmpJob () {
      this.validate('UPDATE')
      setTimeout(() => this.addEmpJobSubmit(), 500)
    },
    async addEmpJobSubmit () {
      console.log('this.BookingDataItem[0]', this.BookingDataItem[0])
      if (this.$session.id() !== undefined) {
        if (this.validUpdate === true) {
          this.dataEditJobReady = false
          let checkJobno = ''
          await axios
            .get(
              this.$DNS_IP +
                '/booking_view/get?bookNo=' +
                this.BookingDataItem[0].bookNo
            )
            .then(async response => {
              let rs = response.data
              console.log('checkJobNoInBooking', rs)
              if (rs.status === false) {
                checkJobno = 'ไม่มีข้อมูล'
              } else {
                checkJobno = rs[0].jobNo || ''
              }
            })
          if (checkJobno === '') {
            let Add = []
            let fielditem = this.flowfieldNameitem
            console.log('fielditem', fielditem)
            for (var i = 0; i < this.BookingDataItem.length; i++) {
              var d = this.BookingDataItem[i]
              let update = {}
              let addData = false
              var dataField = this.editedItemSeleteField.filter(el => {
                return parseInt(el.fieldId) === parseInt(d.fieldId)
              })
              if (
                dataField[0].conditionField === '' ||
                dataField[0].conditionField === null
              ) {
                addData = true
              } else {
                if (
                  fielditem.filter(row => {
                    return row.fieldId === parseInt(d.conditionField)
                  }).length > 0
                ) {
                  console.log('this', fielditem)
                  if (
                    d.conditionValue ===
                    fielditem.filter(row => {
                      return row.fieldId === parseInt(d.conditionField)
                    })[0].fieldValue
                  ) {
                    addData = true
                  } else if (d.conditionField === 'flow') {
                    addData = true
                  }
                } else if (d.conditionField === 'flow') {
                  addData = true
                }
              }
              if (addData) {
                if (d.fieldValue !== '') {
                  update.masBranchID =
                    this.BookingDataItem[0].masBranchID || ''
                  update.CREATE_USER = d.userName
                  update.LAST_USER = d.userName
                  update.packageId = d.packageId
                  update.checkCar = ''
                  // update.userId = d.userId
                  update.endDate = this.endDate
                  update.endTime = this.endTime.value
                  update.fieldId = d.fieldId
                  update.fieldName = d.fieldName
                  update.fieldType = dataField[0].fieldType || ''
                  update.fieldValue = (d.fieldValue || '').replace(/\\/g, '\\\\').replace(/'/g, "\\'")
                  update.flowId = d.flowId
                  update.empSelect = this.empSelectJob
                  update.empStep = this.empSelectJob
                  update.conditionField = dataField[0].conditionField || ''
                  update.conditionValue = dataField[0].conditionValue || ''
                  update.optionField = dataField[0].optionField || ''
                  update.shopId = dataField[0].shopId || ''
                  update.showCard = dataField[0].showCard || ''
                  update.bookNo = this.BookingDataItem[0].bookNo || ''
                  update.tokenPackage = this.tokenPackage || ''
                  Add.push(update)
                }
              }
            }
            for (var x = 0; x < fielditem.length; x++) {
              var t = fielditem[x]
              if (
                Add.filter(row => {
                  return row.fieldId === t.fieldId
                }).length === 0
              ) {
                let update = {}
                let dataField = this.editedItemSeleteField.filter(el => {
                  return parseInt(el.fieldId) === parseInt(t.fieldId)
                })
                update.masBranchID = this.BookingDataItem[0].masBranchID || ''
                update.CREATE_USER = Add[0].CREATE_USER
                update.LAST_USER = Add[0].CREATE_USER
                update.packageId = Add[0].packageId
                update.checkCar = ''
                // update.userId = Add[0].userId
                update.endDate = this.endDate
                update.endTime = this.endTime.value
                update.fieldId = t.fieldId
                update.fieldName = t.fieldName
                update.fieldType = dataField[0].fieldType || ''
                update.fieldValue = (t.fieldValue || '').replace(/\\/g, '\\\\').replace(/'/g, "\\'")
                update.flowId = d.flowId
                update.empSelect = this.empSelectJob
                update.empStep = this.empSelectJob
                update.conditionField = dataField[0].conditionField || ''
                update.conditionValue = dataField[0].conditionValue || ''
                update.optionField = dataField[0].optionField || ''
                update.shopId = dataField[0].shopId || ''
                update.showCard = dataField[0].showCard || ''
                update.bookNo = this.BookingDataItem[0].bookNo || ''
                update.tokenPackage = this.tokenPackage || ''
                Add.push(update)
              }
            }
            this.swalConfig.title = 'ต้องการนำรายการนี้ เข้าตารางใช่หรือไม่?'
            this.$swal(this.swalConfig)
              .then(async (result) => {
                this.dataEditJobReady = false
                await axios
                  .post(this.$DNS_IP + '/job/addOneStep', Add)
                  .then(async response => {
                    this.endDate = ''
                    this.endTime = ''
                    this.empSelectJob = ''
                    this.statusShowDateConfiremjob = true
                    if (response.data.status) {
                      // var dt = {
                      //   bookNo: this.BookingDataItem[0].bookNo,
                      //   statusJob: 'job',
                      //   jobNo: response.data.jobNo
                      // }
                      // await axios
                      //   .post(this.$DNS_IP + '/Booking/editStatus/' + this.BookingDataItem[0].bookNo, dt)
                      //   .then(async response1 => {
                      //     var dtt = {
                      //       bookNo: this.BookingDataItem[0].bookNo,
                      //       contactDate: moment().format('YYYY-MM-DD HH:mm:ss'),
                      //       status: 'confirmJob',
                      //       statusUse: 'use',
                      //       shopId: this.$session.getAll().data.shopId,
                      //       CREATE_USER: this.session.data.userName,
                      //       LAST_USER: this.session.data.userName,
                      //       packageId: this.packageId,
                      //       tokenPackage: this.tokenPackage
                      //     }
                      //     axios
                      //       .post(this.$DNS_IP + '/booking_transaction/add', dtt)
                      //       .then(async response => {
                      this.lineNotifyGroupOnsite(
                        this.BookingDataItem[0].bookNo
                      )
                      if (this.jobCheckPackage) {
                        await this.usePackage(
                          this.BookingDataItem[0].bookNo,
                          this.BookingDataItem[0].masBranchID
                        )
                      }
                      this.$swal('เรียบร้อย', 'นำเข้าสำเร็จ', 'success')
                      if (this.statusSearch === 'no') {
                        await this.getBookingList()
                      } else {
                        await this.searchAny()
                      }
                      this.dialogOnsite = false
                      this.dataEditJobReady = true
                      var dataJob = this.dataItem.filter(el => {
                        return el.bookNo === this.dataQrcode.bookNo
                      })
                      this.getjob(dataJob[0])
                      this.dialogJob = true
                      //     })
                      // })
                    } else {
                      this.$swal('ผิดพลาด', 'กรุณาทำรายการใหม่', 'error')
                      this.dialogOnsite = false
                      this.clearOnsiteChange()
                      if (this.statusSearch === 'no') {
                        await this.getBookingList()
                      } else {
                        await this.searchAny()
                      }
                      // this.getTimesChange('update')
                      if (this.getSelectText) {
                        this.getSelect(
                          this.getSelectText,
                          this.getSelectCount,
                          this.filterCloseJobValue
                        )
                      }
                    }
                  })
                this.insertFormPDF()
              })
              .catch(error => {
                console.log('>>>>>>>>> swal catch <<<<<<<< : ', error)
                if (error === 'cancel') {
                  this.dataEditJobReady = true
                } else {
                  this.checkSwal++
                  if (this.checkSwal <= 3) {
                    setTimeout(() => this.addEmpJobSubmit(), 3000)
                    console.log('error function updateJobNo : ', error)
                  } else {
                    this.dataEditJobReady = true
                    return false
                  }
                }
              })
          } else {
            this.$swal(
              'ผิดพลาด',
              'รายการนี้ได้นำเข้ากระดานการทำงานแล้ว',
              'error'
            )
              .then(async response => {
                this.dialogOnsite = false
                this.clearOnsiteChange()
                if (this.statusSearch === 'no') {
                  await this.getBookingList()
                } else {
                  await this.searchAny()
                }
                if (this.getSelectText) {
                  this.getSelect(
                    this.getSelectText,
                    this.getSelectCount,
                    this.filterCloseJobValue
                  )
                }
              })
              .catch(error => {
                console.log('error function addData : ', error)
                this.dialogOnsite = false
                this.clearOnsiteChange()
                if (this.statusSearch === 'no') {
                  this.getBookingList()
                } else {
                  this.searchAny()
                }
                if (this.getSelectText) {
                  this.getSelect(
                    this.getSelectText,
                    this.getSelectCount,
                    this.filterCloseJobValue
                  )
                }
              })
          }
        }
      } else {
        this.$swal('ผิดพลาด', 'กรุณาลองอีกครั้ง', 'error')
        clearInterval(this.setTimerCalendar)
        this.setTimerCalendar = null
        this.$router.push('/Core/Login')
      }
    },
    async insertFormPDF (bookNo) {
      if (this.checkShopSigneture[this.session.data.shopId]) {
        console.log('bookNo insertFormPDF', bookNo)
        let body = [{
          shopId: this.$session.getAll().data.shopId,
          bookNo: bookNo,
          jobNo: '',
          beforeAir: '',
          checkBox1: '',
          checkBox2: '',
          remarkCheckbox1: '',
          remarkCheckbox2: '',
          remarkDetail: '',
          redio1: '',
          afterAir: '',
          remark: '',
          CREATE_USER: this.$session.getAll().data.userName,
          LAST_USER: this.$session.getAll().data.userName,
          processNow: ''
        }]
        console.log('body shopId insertFormPDF', body)
        await axios.post(this.$DNS_IP + '/formpdf/insert', body)
      }
    },
    async lineNotifyGroupOnsite (bookNo) {
      console.log('>>>>>>>>>>>>>>>>>>>>>>>>PTNP<<<<<<<<<<<<<<<<<<<<<<<<')
      if (this.lineUserId !== '') {
        var dt = {
          updateStatusSend: 'false'
        }
        await axios
          .post(
            this.$DNS_IP + '/BookingOnsite/pushEmpCustomer/' + bookNo,
            dt
          )
          .then(async response1 => {})
      }
      await axios
        .post(this.$DNS_IP + '/Booking/LineNotifyGroupOnsite/' + bookNo)
        .then(async response => {
        })
    },
    async updateBookingEmpSelect (bookNo, empSelect) {
      try {
        let dt = {
          empSelect: empSelect,
          LAST_USER: this.$session.getAll().data.userName
        }
        await axios.post(this.$DNS_IP + '/Booking/edit/' + bookNo, dt)
      } catch (e) {
        console.log(e)
      }
    },
    async ChangeOnsiteCalendarGridTime (bookNo, empId) {
      let obj = {
        bookNo: bookNo,
        empId: empId
      }
      await axios
        .post(this.$DNS_IP + '/CalendarGridTime/ChangEmp', obj)
        .then(async response => {
          console.log(response)
        })
        .catch(error => {
          console.log('error function addData : ', error)
        })
    },
    async jobChangeOnsite () {
      console.log('>>>>>>>>>>>>>>>>>>>>>>>>PTNP<<<<<<<<<<<<<<<<<<<<<<<<')

      console.log('this.jobitem', this.jobitem)
      this.swalConfig.title = 'ต้องการ เปลี่ยนพนักงาน ใช่หรือไม่?'
      this.$swal(this.swalConfig).then(async () => {
        if (this.$session.id() !== undefined) {
          await this.updateBookingEmpSelect(
            this.jobitem[0].bookNo,
            this.empSelectJob
          )
          var updateJob = {
            empStep: this.empSelectJob,
            empSelect: this.empSelectJob,
            LAST_USER: this.$session.getAll().data.userName
          }
          await axios
            .post(
              this.$DNS_IP + '/job/updateJobNo/' + this.jobitem[0].jobNo,
              updateJob
            )
            .then(async response => {
              this.ChangeOnsiteCalendarGridTime(
                this.jobitem[0].bookNo,
                this.empSelectJob
              )
              this.$swal('เรียบร้อย', 'เปลี่ยนพนักงาน เรียบร้อย', 'success')
              if (parseInt(this.jobitem[0].empStepId) !== this.empSelectJob) {
                if (this.jobitem[0].lineUserId !== '') {
                  var dt = {
                    updateStatusSend: 'false',
                    oldEmpName: this.jobitem[0].empStep
                  }
                  axios
                    .post(
                      this.$DNS_IP +
                        '/BookingOnsite/pushEmpCustomer/' +
                        this.jobitem[0].bookNo,
                      dt
                    )
                    .then(async response1 => {})
                }
                var dtNoti = {
                  oldEmpName: this.jobitem[0].empStep
                }
                axios
                  .post(
                    this.$DNS_IP +
                      '/Booking/LineNotifyGroupOnsite/' +
                      this.jobitem[0].bookNo,
                    dtNoti
                  )
                  .then(async response1 => {})
              }
              if (this.statusSearch === 'no') {
                await this.getBookingList()
              } else {
                await this.searchAny()
              }
              this.dialogChangeOnsite = false
              // this.getTimesChange('update')
              if (this.getSelectText) {
                this.getSelect(
                  this.getSelectText,
                  this.getSelectCount,
                  this.filterCloseJobValue
                )
              }
            })
        } else {
          this.$swal('ผิดพลาด', 'กรุณาลองอีกครั้ง', 'error')
          clearInterval(this.setTimerCalendar)
          this.setTimerCalendar = null
          this.$router.push('/Core/Login')
        }
      })
    },
    async getShowOnsite () {
      // let LimitBooking = this.$session.getAll().data.showOnsite
      let LimitBooking = axios
        .get(
          this.$DNS_IP +
            '/system_user/auth?userName=' +
            this.$session.getAll().data.userName +
            '&userPassword=' +
            this.$session.getAll().data.userPassword
        )
        .then(async response => {
          let rs = response.data[0].showOnsite
          return rs
        })
        .catch(error => {
          console.log('error function addData : ', error)
          return 'ไม่แสดง'
        })
      return LimitBooking || 'ไม่แสดง'
      // return this.$session.getAll().data.showOnsite || 'ไม่แสดง'
    },
    async updateShowOnsite (text) {
      await axios
        .post(
          this.$DNS_IP +
            '/system_user/edit/' +
            this.$session.getAll().data.userId,
          { showOnsite: text }
        )
        .then(async response => {})
    },
    async checkShowDataOnsiteSet (text) {
      if (text === 'ไม่แสดง') {
        // this.showOnsite = 'แสดง'
        // this.selectOnsite = '&checkOnsite=is null'
        await this.updateShowOnsite('ไม่แสดง')
        this.checkShowDataOnsite()
      } else {
        // this.showOnsite = 'ไม่แสดง'
        // this.selectOnsite = '&checkOnsite=True'
        await this.updateShowOnsite('แสดง')
        this.checkShowDataOnsite()
      }
    },
    async checkShowDataOnsite () {
      this.dataReady = false
      let text = await this.getShowOnsite()
      if (text === 'ไม่แสดง') {
        this.showOnsite = 'แสดง'
        this.selectOnsite = '&checkOnsite=is null'
        // this.updateShowOnsite('ไม่แสดง')
      } else {
        this.showOnsite = 'ไม่แสดง'
        this.selectOnsite = '&checkOnsite=True'
        // this.updateShowOnsite('แสดง')
      }
      if (this.$route.query.bookNo) {
        // this.beforeCreateScan()
        await this.getDataBranch()
        await this.getEmpSelectAdd()
        await this.getBookingFieldText()
        this.getCustomFieldStart()
        await this.getDataFlow()
        await this.scanQrcode()
        // this.getBookingList()
      } else {
        await this.getDataBranch()
        await this.getEmpSelectAdd()
        await this.getBookingFieldText()
        this.getCustomFieldStart()
        await this.getDataFlow()
        this.getBookingList()
      }
    },
    pushMsgConfirm (bookNo) {
      axios
        .post(this.$DNS_IP + '/Booking/pushMsgConfirm/' + bookNo)
        .catch(error => {
          console.log('error function addData : ', error)
        })
    },
    pushMsgConfirmChangeTime (bookNo) {
      let dt = {
        dueDateOld: this.dueDateOld + ' ' + this.dueDateTimeOld
      }
      axios
        .post(this.$DNS_IP + '/Booking/pushMsgConfirmChamgeTime/' + bookNo, dt)
        .catch(error => {
          console.log('error function addData : ', error)
        })
    },
    pushMsgConfirmEditDataTime (bookNo) {
      let dt = {
        dueDateOld: this.dueDateOld + ' ' + this.dueDateTimeOld,
        flowId: this.flowIdOldEdit
      }
      axios
        .post(this.$DNS_IP + '/Booking/pushMsgConfirmChamgeTime/' + bookNo, dt)
        .catch(error => {
          console.log('error function addData : ', error)
        })
    },
    gotoPicture (Linkitem) {
      window.open(Linkitem, '_blank')
    },
    SetallowedDatesChange (flowId) {
      let dataFlow = this.dataFlowSelectAdd.filter(el => {
        return el.value === flowId
      })
      if (dataFlow.length > 0) {
        dataFlow.forEach((v, k) => {
          console.log('v', v)
          if (v.allData.flowId === flowId) {
            // console.log('Value', v.dateDayoffValue)
            v.allData.dateDayCustom = v.allData.dateDayCustom || ''
            v.allData.dateDayoffValue = v.allData.dateDayoffValue || ''
            if (v.allData.dateDayoffValue !== '') {
              console.log('if')
              this.dateDayoff = JSON.parse(v.allData.dateDayoffValue)
            } else {
              console.log('else')
              this.dateDayoff = []
            }
            if (v.dateDayCustom !== '') {
              this.dateDayCustom = JSON.parse(v.allData.dateDayCustom)
            } else {
              this.dateDayCustom = []
            }
          }
        })
      } else {
        this.dateDayoff = []
        this.dateDayCustom = []
      }
    },
    allowedDatesChange (val) {
      // if (this.dateDaylimit) {
      if (
        this.dataFlowSelectAdd.filter(el => el.value === this.flowIDLimit)
          .length > 0
      ) {
        if (
          this.dataFlowSelectAdd.filter(el => el.value === this.flowIDLimit)[0]
            .allData.typeDayCustom === 'on'
        ) {
          return val === this.dateDayCustom.filter(el => el === val)[0]
        } else {
          if (
            this.dateDayoff.filter(el => {
              return el === new Date(val).getDay()
            }).length === 0 &&
            this.dateDayCustom.filter(el => {
              return el === val
            }).length === 0 &&
            this.dateDaylimit.filter(el => {
              return el === val
            }).length === 0
          ) {
            return val
          }
        }
      } else {
        return val
      }
      // if (this.dateDaylimit) {
      //   if (this.dataFlowSelectAdd.filter(el => el.value === this.formAdd.flowId).length > 0) {
      //     if (this.dataFlowSelectAdd.filter(el => el.value === this.formAdd.flowId)[0].allData.typeDayCustom === 'on') {
      //       return val === this.dateDayCustom.filter(el => el === val)[0]
      //     } else {
      //       if (this.dateDayoff.filter(el => { return el === new Date(val).getDay() }).length === 0
      //       && this.dateDayCustom.filter(el => { return el === val }).length === 0
      //       && this.dateDaylimit.filter(el => {
      //         return el === val
      //       }).length === 0
      //       ) {
      //         return val
      //       }
      //     }
      //   } else {
      //     return val
      //   }
      // } else {
      //   return val
      // }
      // }
    },
    SetallowedDatesEdit () {
      console.log('this.dataFlowSelectEdit', this.dataFlowSelectEdit)
      let dataFlow = this.dataFlowSelectEdit.filter(el => {
        return el.value === this.formEdit.flowId
      })
      if (dataFlow.length > 0) {
        dataFlow.forEach((v, k) => {
          v.allData.dateDayCustom = v.allData.dateDayCustom || ''
          v.allData.dateDayoffValue = v.allData.dateDayoffValue || ''
          if (v.allData.dateDayoffValue !== '') {
            console.log('if')
            this.dateDayoff = JSON.parse(v.allData.dateDayoffValue)
          } else {
            console.log('else')
            this.dateDayoff = []
          }
          if (v.dateDayCustom !== '') {
            this.dateDayCustom = JSON.parse(v.allData.dateDayCustom)
          } else {
            this.dateDayCustom = []
          }
        })
      } else {
        this.dateDayoff = []
        this.dateDayCustom = []
      }
    },
    allowedDatesEdit (val) {
      // if (this.dateDaylimit) {
      if (
        this.dataFlowSelectEdit.filter(el => el.value === this.formEdit.flowId)
          .length > 0
      ) {
        if (
          this.dataFlowSelectEdit.filter(
            el => el.value === this.formEdit.flowId
          )[0].allData.typeDayCustom === 'on'
        ) {
          return val === this.dateDayCustom.filter(el => el === val)[0]
        } else {
          if (
            this.dateDayoff.filter(el => {
              return el === new Date(val).getDay()
            }).length === 0 &&
            this.dateDayCustom.filter(el => {
              return el === val
            }).length === 0
          ) {
            return val
          }
        }
      } else {
        return val
      }
      // }
    },
    showFileUpload (item, text) {
      if (text === '1') {
        if (item.fileUpload1.includes('[')) {
          this.srcUpload = JSON.parse(item.fileUpload1)
        } else {
          this.srcUpload = item.fileUpload1
        }
      } else {
        if (item.fileUpload2.includes('[')) {
          this.srcUpload = JSON.parse(item.fileUpload2)
        } else {
          this.srcUpload = item.fileUpload2
        }
      }
      this.dialogShowFileUpload = true
    },
    async checkLimit () {
      this.checkLimitBooking.ID = 'NO'
      this.checkLimitBooking.countBooking = 1
      let LimitBooking = await this.getLimitBooking()
      if (this.statusVIP === 'False') {
        if (LimitBooking.status === false) {
          this.checkLimitBooking.ID = 'NO'
          this.checkLimitBooking.countBooking = 1
          console.log('1257')
        } else {
          console.log('1259', LimitBooking)
          LimitBooking.forEach(item => {
            let setTime = []
            // เช็คว่า เวลาในแต่ละวันเหมือนกันรึป่าว
            if (
              this.DataFlowNameDefault.filter(item => {
                return item.value === this.formAdd.flowId
              })[0].allData.setTimebyday === 'True'
            ) {
              let timeJson = JSON.parse(
                this.DataFlowNameDefault.filter(item => {
                  return item.value === this.formAdd.flowId
                })[0].allData.setTime
              ).filter(items => items.value === new Date(this.date).getDay())
              setTime = timeJson[0].setTime || []
              console.log('IF')
            } else {
              console.log('ELSE')
              setTime =
                JSON.parse(
                  this.DataFlowNameDefault.filter(item => {
                    return item.value === this.formAdd.flowId
                  })[0].allData.setTime
                ) || []
            }
            let dt = setTime
            // let dt = JSON.parse(this.branchData.filter(item => { return item.masBranchID === this.formAdd.masBranchID })[0].setTime) || []
            let dtint = '0'
            if (dt.filter(item => item.value === this.time.value).length > 0) {
              dtint = parseInt(
                dt.filter(item => item.value === this.time.value)[0]
                  .limitBooking || '0'
              )
            } else {
              dtint = '0'
            }
            console.log('test', dtint)
            if (
              item.flowId === this.formAdd.flowId &&
              item.bookingDate === this.date &&
              item.bookingTime === this.time.value
            ) {
              this.checkLimitBooking.ID = item.id
              console.log('1266')
              this.checkLimitBooking.countBooking =
                parseInt(item.countBooking) + 1
              this.checkLimitBooking.limitCheck =
                parseInt(item.countBooking) >= dtint ? 'false' : 'true'
              this.checkLimitBooking.limitBooking = dtint
              // console.log('item.masBranchID', item)
            }
          })
        }
      }
    },
    // เช็ค limit สำหรับ "นัดหมายอีกครั้ง" (สร้างการจองใหม่) โดยอ่านค่าจากฟอร์ม edit
    async checkLimitBookingAgain () {
      this.checkLimitBooking.ID = 'NO'
      this.checkLimitBooking.countBooking = 1
      this.checkLimitBooking.limitCheck = ''
      let LimitBooking = await this.getLimitBookingEdit()
      if (this.statusVIP === 'False') {
        if (LimitBooking.status === false) {
          this.checkLimitBooking.ID = 'NO'
          this.checkLimitBooking.countBooking = 1
        } else {
          LimitBooking.forEach(item => {
            let setTime = []
            // เช็คว่า เวลาในแต่ละวันเหมือนกันรึป่าว
            if (
              this.DataFlowNameDefault.filter(item => {
                return item.value === this.formEdit.flowId
              })[0].allData.setTimebyday === 'True'
            ) {
              let timeJson = JSON.parse(
                this.DataFlowNameDefault.filter(item => {
                  return item.value === this.formEdit.flowId
                })[0].allData.setTime
              ).filter(items => items.value === new Date(this.dateEdit).getDay())
              setTime = timeJson[0].setTime || []
            } else {
              setTime =
                JSON.parse(
                  this.DataFlowNameDefault.filter(item => {
                    return item.value === this.formEdit.flowId
                  })[0].allData.setTime
                ) || []
            }
            let dt = setTime
            let dtint = '0'
            if (
              dt.filter(item => item.value === this.timeEdit.value).length > 0
            ) {
              dtint = parseInt(
                dt.filter(item => item.value === this.timeEdit.value)[0]
                  .limitBooking || '0'
              )
            } else {
              dtint = '0'
            }
            if (
              item.flowId === this.formEdit.flowId &&
              item.bookingDate === this.dateEdit &&
              item.bookingTime === this.timeEdit.value
            ) {
              this.checkLimitBooking.ID = item.id
              this.checkLimitBooking.countBooking =
                parseInt(item.countBooking) + 1
              this.checkLimitBooking.limitCheck =
                parseInt(item.countBooking) >= dtint ? 'false' : 'true'
              this.checkLimitBooking.limitBooking = dtint
            }
          })
        }
      }
    },
    async getMonth (month) {
      console.log('month!!!!!!!', month)
      // console.log('!!!!!!!!!', this.DataFlowNameDefault.filter(el => { return el.value === parseInt(this.formAdd.flowId) })[0].allData.setTimebyday)
      // const result = await axios.get(this.$DNS_IP + '/LimitBookingDate/get_LimitDate?shopId=' + this.$session.getAll().data.shopId + '&masBranchID=' + this.formAdd.masBranchID + '&bookingDate=' + month)
      const result = await axios.get(
        this.$DNS_IP +
          '/LimitBookingDate/get_LimitDate?shopId=' +
          this.$session.getAll().data.shopId +
          '&flowId=' +
          this.formAdd.flowId +
          '&bookingDate=' +
          month
      )
      if (result.data.length > 0) {
        let setTimebyday = this.DataFlowNameDefault.filter(el => {
          return el.value === parseInt(this.formAdd.flowId)
        })[0].allData.setTimebyday
        console.log('getMonth IF', result.data)
        this.dateDaylimit = []
        // let dt = result.data
        const objectDT = result.data.reduce((acc, curr) => {
          const bookingDate = curr.bookingDate
          if (!acc[bookingDate]) {
            acc[bookingDate] = []
          }
          acc[bookingDate].push(curr)
          return acc
        }, {})

        console.log(objectDT)
        for (const dt in objectDT) {
          let statusOffDate1 = false
          if (objectDT[dt][0].limitBookingCheck === 'True') {
            objectDT[dt].forEach((v, k) => {
              if (JSON.parse(v.setTime)) {
                if (setTimebyday === 'True') {
                  JSON.parse(v.setTime)
                    .filter(
                      items => items.value === new Date(v.bookingDate).getDay()
                    )[0]
                    .setTime.forEach((v2, k2) => {
                      if (
                        parseInt(v2.limitBooking) > 0 &&
                        v.bookingTime === v2.value
                      ) {
                        if (v.bookingTime === v2.value) {
                          if (v.countBooking < parseInt(v2.limitBooking)) {
                            statusOffDate1 = true
                          }
                        }
                      } else if (parseInt(v2.limitBooking) > 0) {
                        if (
                          objectDT[dt].filter(aa => aa.bookingTime === v2.value)
                            .length === 0
                        ) {
                          console.log(v.bookingDate, '+++++', v2.value)
                          statusOffDate1 = true
                        }
                      }
                    })
                } else {
                  JSON.parse(v.setTime).forEach((v2, k2) => {
                    if (
                      parseInt(v2.limitBooking) > 0 &&
                      v.bookingTime === v2.value
                    ) {
                      if (v.bookingTime === v2.value) {
                        if (v.countBooking < parseInt(v2.limitBooking)) {
                          statusOffDate1 = true
                          // console.log(v.bookingDate, '----', 'v', v.bookingTime, ' ', v.countBooking, '    ', 'v2', v2.value, ' ', v2.limitBooking)
                        }
                      }
                    } else if (parseInt(v2.limitBooking) > 0) {
                      if (
                        objectDT[dt].filter(aa => aa.bookingTime === v2.value)
                          .length === 0
                      ) {
                        console.log(v.bookingDate, '+++++', v2.value)
                        statusOffDate1 = true
                      }
                    }
                  })
                }
              }
            })
            if (statusOffDate1 === false) {
              if (this.statusVIP === 'False') {
                this.dateDaylimit.push(
                  moment(objectDT[dt][0].bookingDate).format('YYYY-MM-DD')
                )
              }
            }
          } else {
            this.dateDaylimit = []
          }
        }
      } else {
        this.dateDaylimit = []
      }
    },
    async getMonthChang (month) {
      console.log('month11111', month)
      // console.log('!!!!!!!!!', this.DataFlowNameDefault.filter(el => { return el.value === parseInt(this.formAdd.flowId) })[0].allData.setTimebyday)
      // const result = await axios.get(this.$DNS_IP + '/LimitBookingDate/get_LimitDate?shopId=' + this.$session.getAll().data.shopId + '&masBranchID=' + this.formAdd.masBranchID + '&bookingDate=' + month)
      const result = await axios.get(
        this.$DNS_IP +
          '/LimitBookingDate/get_LimitDate?shopId=' +
          this.$session.getAll().data.shopId +
          '&flowId=' +
          this.flowIDLimit +
          '&bookingDate=' +
          month
      )
      if (result.data.length > 0) {
        let setTimebyday = this.DataFlowNameDefault.filter(el => {
          return el.value === parseInt(this.flowIDLimit)
        })[0].allData.setTimebyday
        this.dateDaylimit = []
        // let dt = result.data
        const objectDT = result.data.reduce((acc, curr) => {
          const bookingDate = curr.bookingDate
          if (!acc[bookingDate]) {
            acc[bookingDate] = []
          }
          acc[bookingDate].push(curr)
          return acc
        }, {})

        console.log(objectDT)
        for (const dt in objectDT) {
          let statusOffDate1 = false
          // console.log(dt, objectDT[dt])
          if (objectDT[dt][0].limitBookingCheck === 'True') {
            // console.log('limitBookingCheck === True')
            objectDT[dt].forEach((v, k) => {
              // let statusOffDate2 = false
              // let statusOffDate3 = false
              if (JSON.parse(v.setTime)) {
                if (setTimebyday === 'True') {
                  // console.log('sdfsdfsdfds', JSON.parse(v.setTime).filter((items) => items.value === new Date(v.bookingDate).getDay())[0].setTime)
                  JSON.parse(v.setTime)
                    .filter(
                      items => items.value === new Date(v.bookingDate).getDay()
                    )[0]
                    .setTime.forEach((v2, k2) => {
                      // console.log(v.bookingDate, '----', 'v', v.bookingTime, ' ', v.countBooking, '    ', 'v2', v2.value, ' ', v2.limitBooking)
                      if (
                        parseInt(v2.limitBooking) > 0 &&
                        v.bookingTime === v2.value
                      ) {
                        if (v.bookingTime === v2.value) {
                          if (v.countBooking < parseInt(v2.limitBooking)) {
                            statusOffDate1 = true
                            // console.log(v.bookingDate, '----', 'v', v.bookingTime, ' ', v.countBooking, '    ', 'v2', v2.value, ' ', v2.limitBooking)
                          }
                        }
                      } else if (parseInt(v2.limitBooking) > 0) {
                        if (
                          objectDT[dt].filter(aa => aa.bookingTime === v2.value)
                            .length === 0
                        ) {
                          statusOffDate1 = true
                        }
                      }
                    })
                } else {
                  JSON.parse(v.setTime).forEach((v2, k2) => {
                    if (
                      parseInt(v2.limitBooking) > 0 &&
                      v.bookingTime === v2.value
                    ) {
                      if (v.bookingTime === v2.value) {
                        if (v.countBooking < parseInt(v2.limitBooking)) {
                          statusOffDate1 = true
                        }
                      }
                    } else if (parseInt(v2.limitBooking) > 0) {
                      if (
                        objectDT[dt].filter(aa => aa.bookingTime === v2.value)
                          .length === 0
                      ) {
                        console.log(v.bookingDate, '+++++', v2.value)
                        statusOffDate1 = true
                      }
                    }
                  })
                }
              }
            })
            if (statusOffDate1 === false) {
              if (this.statusVIPChang === 'False') {
                this.dateDaylimit.push(
                  moment(objectDT[dt][0].bookingDate).format('YYYY-MM-DD')
                )
              }
            }
          } else {
            // console.log('limitBookingCheck === False')
            this.dateDaylimit = []
          }
        }
      } else {
        this.dateDaylimit = []
      }
    },
    allowedDates (val) {
      if (this.dateDaylimit) {
        if (
          this.dataFlowSelectAdd.filter(el => el.value === this.formAdd.flowId)
            .length > 0
        ) {
          if (
            this.dataFlowSelectAdd.filter(
              el => el.value === this.formAdd.flowId
            )[0].allData.typeDayCustom === 'on'
          ) {
            return val === this.dateDayCustom.filter(el => el === val)[0]
          } else {
            if (
              this.dateDayoff.filter(el => {
                return el === new Date(val).getDay()
              }).length === 0 &&
              this.dateDayCustom.filter(el => {
                return el === val
              }).length === 0 &&
              this.dateDaylimit.filter(el => {
                return el === val
              }).length === 0
            ) {
              return val
            }
          }
        } else {
          return val
        }
      } else {
        return val
      }
    },
    async setLimitBookingChange (dateitem) {
      this.time = ''
      this.timeavailable = []
      this.limitBookingCheck = 'False'
      let setTime = []
      console.log('!!!_____', this.formChange)
      // เช็คว่า เวลาในแต่ละวันเหมือนกันรึป่าว
      if (
        this.DataFlowNameDefault.filter(el => {
          return el.value === parseInt(this.flowIDLimit)
        })[0].allData.setTimebyday === 'True'
      ) {
        let timeJson = JSON.parse(
          this.DataFlowNameDefault.filter(el => {
            return el.value === parseInt(this.flowIDLimit)
          })[0].allData.setTime
        ).filter(items => items.value === new Date(dateitem).getDay())
        setTime = timeJson[0].setTime || []
        console.log('IF')
      } else {
        console.log('ELSE')
        setTime =
          JSON.parse(
            this.DataFlowNameDefault.filter(el => {
              return el.value === parseInt(this.flowIDLimit)
            })[0].allData.setTime
          ) || []
      }
      if (
        this.DataFlowNameDefault.filter(el => {
          return el.value === parseInt(this.flowIDLimit)
        }).length > 0
      ) {
        this.limitBookingCheck =
          this.DataFlowNameDefault.filter(el => {
            return el.value === parseInt(this.flowIDLimit)
          })[0].allData.limitBookingCheck || 'False'
      } else {
        this.limitBookingCheck = 'False'
      }
      if (this.limitBookingCheck === 'True') {
        let TimeData = []
        let currentDate = setTime
        TimeData = currentDate
        if (this.statusVIPChang === 'False') {
          this.timeavailable = TimeData.filter(
            item => parseInt(item.limitBooking) > 0
          )
          console.log('TimeData', TimeData)
          if (this.timeavailable.length > 0) {
            let LimitBooking = await this.getLimitBookingChang()
            console.log('LimitBooking!!!!!!!', LimitBooking)
            if (LimitBooking.status !== false) {
              if (LimitBooking.length > 0) {
                LimitBooking.forEach((i, n) => {
                  this.timeavailable.forEach((v, k) => {
                    if (i.bookingTime === v.value) {
                      if (i.countBooking >= parseInt(v.limitBooking)) {
                        this.timeavailable.splice(k, 1)
                      }
                    }
                  })
                })
                if (this.timeavailable.length === 0) {
                  this.$swal(
                    'คิวเต็มแล้ว',
                    'กรุณาเลือกวันที่ใหม่อีกครั้ง',
                    'error'
                  )
                  this.date = ''
                }
              }
              console.log('this.timeavailable IF', this.timeavailable)
            } else {
              this.timeavailable = TimeData.filter(
                item => parseInt(item.limitBooking) > 0
              )
              console.log('this.timeavailable ELSE', this.timeavailable)
            }
          } else {
            this.$swal('คิวเต็มแล้ว', 'กรุณาเลือกวันที่ใหม่อีกครั้ง', 'error')
            this.date = ''
          }
        } else {
          this.timeavailable = TimeData
        }
      } else {
        console.log('this.timeavailable ELSEEEEE', this.timeavailable)
        // LimitBookingBy Flow
        // this.timeavailable = JSON.parse(this.flowItemLimit.filter(item => { return item.flowId === this.flowIDLimit })[0].setTime) || []

        // LimitBookingBy masBranch
        if (
          this.DataFlowNameDefault.filter(el => {
            return el.value === parseInt(this.flowIDLimit)
          }).length > 0
        ) {
          this.timeavailable = setTime
        } else {
          this.timeavailable = []
        }
      }
    },
    async setLimitBookingEdit (dateitem) {
      this.time = ''
      this.timeavailable = []
      this.limitBookingCheck = 'False'
      let setTime = []
      // เช็คว่า เวลาในแต่ละวันเหมือนกันรึป่าว
      if (
        this.DataFlowNameDefault.filter(el => {
          return el.value === parseInt(this.formEdit.flowId)
        })[0].allData.setTimebyday === 'True'
      ) {
        let timeJson = JSON.parse(
          this.DataFlowNameDefault.filter(el => {
            return el.value === parseInt(this.formEdit.flowId)
          })[0].allData.setTime
        ).filter(items => items.value === new Date(dateitem).getDay())
        setTime = timeJson[0].setTime || []
        console.log('IF')
      } else {
        console.log(
          'ELSE###',
          JSON.parse(
            this.DataFlowNameDefault.filter(el => {
              return el.value === parseInt(this.formEdit.flowId)
            })[0].allData.setTime
          )
        )
        setTime =
          JSON.parse(
            this.DataFlowNameDefault.filter(el => {
              return el.value === parseInt(this.formEdit.flowId)
            })[0].allData.setTime
          ) || []
      }
      if (
        this.DataFlowNameDefault.filter(el => {
          return el.value === parseInt(this.formEdit.flowId)
        }).length > 0
      ) {
        this.limitBookingCheck =
          this.DataFlowNameDefault.filter(el => {
            return el.value === parseInt(this.formEdit.flowId)
          })[0].allData.limitBookingCheck || 'False'
      } else {
        this.limitBookingCheck = 'False'
      }
      if (this.limitBookingCheck === 'True') {
        let TimeData = []
        let currentDate = setTime
        TimeData = currentDate
        if (this.statusEdit === 'False') {
          this.timeavailable = TimeData.filter(
            item => parseInt(item.limitBooking) > 0
          )
          console.log('TimeData', TimeData)
          if (this.timeavailable.length > 0) {
            let LimitBooking = await this.getLimitBookingEdit()
            console.log('LimitBooking', LimitBooking)
            if (LimitBooking.status !== false) {
              if (LimitBooking.length > 0) {
                LimitBooking.forEach((i, n) => {
                  this.timeavailable.forEach((v, k) => {
                    if (i.bookingTime === v.value) {
                      if (i.countBooking >= parseInt(v.limitBooking)) {
                        this.timeavailable.splice(k, 1)
                      }
                    }
                  })
                })
                if (this.timeavailable.length === 0) {
                  this.$swal(
                    'คิวเต็มแล้ว',
                    'กรุณาเลือกวันที่ใหม่อีกครั้ง',
                    'error'
                  )
                  this.date = ''
                }
              }
              console.log('this.timeavailable IF', this.timeavailable)
            } else {
              this.timeavailable = TimeData.filter(
                item => parseInt(item.limitBooking) > 0
              )
              console.log('this.timeavailable ELSE', this.timeavailable)
            }
          } else {
            this.$swal('คิวเต็มแล้ว', 'กรุณาเลือกวันที่ใหม่อีกครั้ง', 'error')
            this.date = ''
          }
        } else {
          this.timeavailable = TimeData
        }
      } else {
        console.log('this.timeavailable ELSEEEEE@@@@@', this.timeavailable)
        console.log(
          '----',
          this.DataFlowNameDefault.filter(el => {
            return el.value === parseInt(this.formEdit.flowId)
          })
        )
        // LimitBookingBy Flow
        // this.timeavailable = JSON.parse(this.flowItemLimit.filter(item => { return item.flowId === this.formEdit.flowId })[0].setTime) || []
        // LimitBookingBy masBranch
        if (
          this.DataFlowNameDefault.filter(el => {
            return el.value === parseInt(this.formEdit.flowId)
          }).length > 0
        ) {
          this.timeavailable = setTime
        } else {
          this.timeavailable = []
        }
      }
    },
    async setLimitBooking (dateitem) {
      this.time = ''
      this.timeavailable = []
      this.limitBookingCheck = 'False'
      let setTime = []
      // เช็คว่า เวลาในแต่ละวันเหมือนกันรึป่าว
      if (
        this.DataFlowNameDefault.filter(el => {
          return el.value === parseInt(this.formAdd.flowId)
        })[0].allData.setTimebyday === 'True'
      ) {
        let timeJson = JSON.parse(
          this.DataFlowNameDefault.filter(el => {
            return el.value === parseInt(this.formAdd.flowId)
          })[0].allData.setTime
        ).filter(items => items.value === new Date(dateitem).getDay())
        setTime = timeJson[0].setTime || []
        console.log('IF11123123123123123123123123123123123123121231233')
      } else {
        console.log('ELSE12312312312312312312312312312312312312123123313')
        setTime =
          JSON.parse(
            this.DataFlowNameDefault.filter(el => {
              return el.value === parseInt(this.formAdd.flowId)
            })[0].allData.setTime
          ) || []
      }
      if (
        this.DataFlowNameDefault.filter(el => {
          return el.value === parseInt(this.formAdd.flowId)
        }).length > 0
      ) {
        this.limitBookingCheck =
          this.DataFlowNameDefault.filter(el => {
            return el.value === parseInt(this.formAdd.flowId)
          })[0].allData.limitBookingCheck || 'False'
      } else {
        this.limitBookingCheck = 'False'
      }
      if (this.limitBookingCheck === 'True') {
        let TimeData = []
        let currentDate = setTime
        TimeData = currentDate
        if (this.statusVIP === 'False') {
          this.timeavailable = TimeData.filter(
            item => parseInt(item.limitBooking) > 0
          )
          console.log('TimeData', TimeData)
          if (this.timeavailable.length > 0) {
            let LimitBooking = await this.getLimitBooking()
            console.log('LimitBooking', LimitBooking)
            if (LimitBooking.status !== false) {
              if (LimitBooking.length > 0) {
                LimitBooking.forEach((i, n) => {
                  this.timeavailable.forEach((v, k) => {
                    if (i.bookingTime === v.value) {
                      if (i.countBooking >= parseInt(v.limitBooking)) {
                        this.timeavailable.splice(k, 1)
                      }
                    }
                  })
                })
                if (this.timeavailable.length === 0) {
                  this.$swal(
                    'คิวเต็มแล้ว',
                    'กรุณาเลือกวันที่ใหม่อีกครั้ง',
                    'error'
                  )
                  this.date = ''
                }
              }
              console.log('this.timeavailable IF', this.timeavailable)
            } else {
              this.timeavailable = TimeData.filter(
                item => parseInt(item.limitBooking) > 0
              )
              console.log('this.timeavailable ELSE', this.timeavailable)
            }
          } else {
            this.$swal('คิวเต็มแล้ว', 'กรุณาเลือกวันที่ใหม่อีกครั้ง', 'error')
            this.date = ''
          }
        } else {
          this.timeavailable = TimeData
        }
      } else {
        console.log('this.timeavailable ELSEEEEE', this.timeavailable)
        // LimitBookingBy Flow
        // this.timeavailable = JSON.parse(this.flowItemLimit.filter(item => { return item.flowId === this.formAdd.flowId })[0].setTime) || []

        // LimitBookingBy masBranch
        if (
          this.DataFlowNameDefault.filter(el => {
            return el.value === parseInt(this.formAdd.flowId)
          }).length > 0
        ) {
          this.timeavailable = setTime
        } else {
          this.timeavailable = []
        }
      }
    },
    // ตัดช่วงเวลาที่คิวเต็มออกจากดรอปดาวน์ ตอนเลือกวันที่ในหน้า "นัดหมายอีกครั้ง"
    // (เป็นการจองใหม่ จึงกรองเหมือนหน้าสร้างนัดหมาย ต่างจาก setLimitBookingEdit ที่ใช้กับหน้าแก้ไข)
    async setLimitBookingAgain (dateitem) {
      this.timeEdit = ''
      this.timeavailable = []
      this.limitBookingCheck = 'False'
      let setTime = []
      // ดึงข้อมูล flow ที่เลือกครั้งเดียว แล้วใช้ซ้ำ
      let flowData = this.DataFlowNameDefault.filter(el => {
        return el.value === parseInt(this.formEdit.flowId)
      })
      let flowAllData = flowData.length > 0 ? flowData[0].allData : null
      if (flowAllData) {
        // เช็คว่า เวลาในแต่ละวันเหมือนกันรึป่าว
        if (flowAllData.setTimebyday === 'True') {
          let timeJson = JSON.parse(flowAllData.setTime).filter(
            items => items.value === new Date(dateitem).getDay()
          )
          setTime = timeJson[0].setTime || []
        } else {
          setTime = JSON.parse(flowAllData.setTime) || []
        }
        this.limitBookingCheck = flowAllData.limitBookingCheck || 'False'
      } else {
        this.limitBookingCheck = 'False'
      }
      if (this.limitBookingCheck === 'True') {
        let TimeData = setTime
        if (this.statusVIP === 'False') {
          this.timeavailable = TimeData.filter(
            item => parseInt(item.limitBooking) > 0
          )
          if (this.timeavailable.length > 0) {
            let LimitBooking = await this.getLimitBookingEdit()
            if (LimitBooking.status !== false) {
              if (LimitBooking.length > 0) {
                LimitBooking.forEach((i, n) => {
                  this.timeavailable.forEach((v, k) => {
                    if (i.bookingTime === v.value) {
                      if (i.countBooking >= parseInt(v.limitBooking)) {
                        this.timeavailable.splice(k, 1)
                      }
                    }
                  })
                })
                if (this.timeavailable.length === 0) {
                  this.$swal(
                    'คิวเต็มแล้ว',
                    'กรุณาเลือกวันที่ใหม่อีกครั้ง',
                    'error'
                  )
                  this.dateEdit = ''
                }
              }
            } else {
              this.timeavailable = TimeData.filter(
                item => parseInt(item.limitBooking) > 0
              )
            }
          } else {
            this.$swal('คิวเต็มแล้ว', 'กรุณาเลือกวันที่ใหม่อีกครั้ง', 'error')
            this.dateEdit = ''
          }
        } else {
          this.timeavailable = TimeData
        }
      } else {
        this.timeavailable = flowAllData ? setTime : []
      }
    },
    async getLimitBookingChang () {
      let LimitBooking = axios
        .get(
          this.$DNS_IP +
            '/LimitBookingDate/get?shopId=' +
            this.$session.getAll().data.shopId +
            '&flowId=' +
            this.flowIDLimit +
            '&bookingDate=' +
            this.formChange.date
        )
        .then(async response => {
          let rs = response.data
          console.log('rs', rs)
          return rs
        })
      return LimitBooking
    },
    async getLimitBookingEdit () {
      let LimitBooking = axios
        .get(
          this.$DNS_IP +
            '/LimitBookingDate/get?shopId=' +
            this.$session.getAll().data.shopId +
            '&flowId=' +
            this.formEdit.flowId +
            '&bookingDate=' +
            this.dateEdit
        )
        .then(async response => {
          let rs = response.data
          return rs
        })
      return LimitBooking
    },
    async getLimitBooking () {
      let LimitBooking = axios
        .get(
          this.$DNS_IP +
            '/LimitBookingDate/get?shopId=' +
            this.$session.getAll().data.shopId +
            '&flowId=' +
            this.formAdd.flowId +
            '&bookingDate=' +
            this.date
        )
        .then(async response => {
          let rs = response.data
          return rs
        })
      return LimitBooking
    },
    SetallowedDates () {
      let dataFlow = this.dataFlowSelectAdd.filter(el => {
        return el.value === this.formAdd.flowId
      })
      if (dataFlow.length > 0) {
        dataFlow.forEach((v, k) => {
          console.log('v', v)
          if (v.allData.flowId === this.formAdd.flowId) {
            // console.log('Value', v.dateDayoffValue)
            v.allData.dateDayCustom = v.allData.dateDayCustom || ''
            v.allData.dateDayoffValue = v.allData.dateDayoffValue || ''
            if (v.allData.dateDayoffValue !== '') {
              // console.log('if')
              this.dateDayoff = JSON.parse(v.allData.dateDayoffValue)
            } else {
              // console.log('else')
              this.dateDayoff = []
            }
            if (v.dateDayCustom !== '') {
              this.dateDayCustom = JSON.parse(v.allData.dateDayCustom)
            } else {
              this.dateDayCustom = []
            }
          }
        })
      } else {
        this.dateDayoff = []
        this.dateDayCustom = []
      }
    },
    onCopySuccess () {
      this.$swal('เรียบร้อย', 'คัดลอกสำเร็จ', 'success')
    },
    async closeJob () {
      this.loadingCloseJob = true
      if (this.checkPayment === 'True') {
        if (this.formCloseJob.totalPrice !== '') {
          // await this.updateStepEnd()
          this.closeJobSubmit(this.formCloseJob.totalPrice)
        } else {
          this.loadingCloseJob = false
          this.$swal('ผิดพลาด', 'กรุณาใส่จำนวนเงิน', 'error')
        }
      } else {
        // await this.updateStepEnd()
        this.closeJobSubmit('0')
      }
    },
    closeJobSubmit (totalPrice) {
      console.log('form:', this.formCloseJob)
      this.$swal({
        title: 'ให้บริการ เสร็จเรียบร้อยแล้ว ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async response => {
          var ID = this.formCloseJob.jobId
          let ds = {
            jobNo: this.formCloseJob.jobNo,
            shopId: this.$session.getAll().data.shopId,
            totalPrice: totalPrice,
            LAST_USER: this.session.data.userName,
            statusDelete: 'true'
          }
          await this.updateStepEnd()
          console.log('ds', ds)
          let checkJob = ''
          await axios
            .get(this.$DNS_IP + '/job/getJobNo?jobNo=' + this.formCloseJob.jobNo)
            .then(response => {
              let rs = response.data
              console.log('getJobNo', rs)
              if (rs.length > 0) {
                checkJob = rs[0].RECORD_STATUS
              }
            })
          if (checkJob === 'N') {
            await axios
              .post(this.$DNS_IP + '/job/editPrice/' + ID, ds)
              .then(async response => {
                if (
                  this.productExchangeRateId !== '' &&
                  parseInt(totalPrice) > 0 &&
                  this.lineUserId !== ''
                ) {
                  await this.useCoin(totalPrice)
                }
                await this.pushmessagePrice(this.formCloseJob.jobNo)
                this.$swal(
                  'เรียบร้อย',
                  'ให้บริการ เสร็จเรียบร้อยแล้ว',
                  'success'
                )
                if (this.statusSearch === 'no') {
                  await this.getBookingList()
                } else {
                  await this.searchAny()
                }
                // this.getTimesChange('update')
                if (this.getSelectText) {
                  this.getSelect(
                    this.getSelectText,
                    this.getSelectCount,
                    this.filterCloseJobValue
                  )
                }
                this.dialogCloseJob = false
                this.dialogJob = false
                this.loadingCloseJob = false
                this.formCloseJob.totalPrice = 0
              })
          } else {
            this.$swal('ผิดพลาด', 'รายการนี้ปิดงานไปแล้ว', 'error')
            this.dialogCloseJob = false
            this.dialogJob = false
            this.loadingCloseJob = false
            this.formCloseJob.totalPrice = 0
          }
        })
        .catch(error => {
          this.loadingCloseJob = false
          console.log('Close Job Error', error)
        })
    },
    async useCoin (totalPrice) {
      let ds = {
        exchangRateId: this.productExchangeRateId.value,
        Amount: totalPrice.toString(),
        shopId: this.$session.getAll().data.shopId,
        tel: this.memberTel,
        liffUserId: this.lineUserId,
        refId: ''
      }
      console.log('ds', ds)
      await axios
        .post(this.$DNS_IP_Loyalty + '/POSapi', ds)
        .then(async response => {})
    },
    async pushmessagePrice (jobNo) {
      let updateStatusSend = {
        updateStatusSend: 'false',
        checkPayment: this.checkPayment
      }
      await axios
        .post(this.$DNS_IP + '/job/pushClosejob/' + jobNo, updateStatusSend)
        .then(console.log(jobNo))
    },
    pushmessagePriceConfirm (bookNo) {
      axios
        .post(this.$DNS_IP + '/Booking/pushConfirmBooking/' + bookNo)
        .catch(error => {
          console.log('error function addData : ', error)
        })
    },
    // async pushmessagePriceConfirm (jobNo) {
    //   let updateStatusSend = {
    //     updateStatusSend: 'false',
    //     checkPayment: this.checkPayment
    //   }
    //   await axios
    //     .post(this.$DNS_IP + '/job/pushConfirmBooking/' + jobNo, updateStatusSend)
    //     .then(console.log(jobNo))
    // },
    async getPackage (dt) {
      this.dataPackage = []
      await axios
        .get(
          this.$DNS_IP_Loyalty +
            '/PackageLog/get?shopId=' +
            dt.shopId +
            '&userId=' +
            dt.lineUserId +
            '&flowId=' +
            dt.flowId
        )
        .then(response => {
          console.log('PackageLog', response.data)
          let rs = response.data
          if (rs.status !== false) {
            for (var i = 0; i < rs.length; i++) {
              let d = rs[i]
              d.text = d.packageName
              d.value = d.packageId
              this.dataPackage.push(d)
            }
          } else {
            this.dataPackage = []
          }
        })
        .catch(error => {
          this.dataPackage = []
          console.log(error)
        })
    },
    async UpdatePackage (
      packageId,
      StatusPackage,
      packageName,
      data,
      tokenPackage
    ) {
      if (StatusPackage === 'ตกลง') {
        this.packageId = packageId
        this.tokenPackage = tokenPackage
        // this.StatusPackage.status = 'ยกเลิก'
        // this.StatusPackage.color = 'red'
        this.StatusPackage.packageName = packageName
        this.StatusPackage.token = data.token
        // console.log(this.dataPackage.findIndex(x => x.token === tokenPackage && x.packageId === packageId))
        this.modelPackageIndexConfirm =
          this.dataPackage.findIndex(
            x => x.token === tokenPackage && x.packageId === packageId
          ) - 1
        this.modelPackageIndexConfirmJob =
          this.dataPackage.findIndex(
            x => x.token === tokenPackage && x.packageId === packageId
          ) - 1
      } else {
        this.packageId = ''
        this.tokenPackage = ''
        // this.StatusPackage.status = 'ตกลง'
        // this.StatusPackage.color = 'green'
        this.StatusPackage.packageName = ''
        this.StatusPackage.token = ''
        this.modelPackageIndexConfirm = null
        this.modelPackageIndexConfirmJob = null
      }
    },
    updateStatusBookingTransaction (item) {
      this.$swal({
        title: 'ต้องการ ย้ายนัดหมายนี้กลับไปสถานะก่อนหน้า ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async () => {
        var dt = {
          bookNo: item.bookNo,
          contactDate: moment().format('YYYY-MM-DD HH:mm:ss'),
          status: 'wait',
          statusUse: 'use',
          shopId: this.$session.getAll().data.shopId,
          CREATE_USER: this.session.data.userName,
          LAST_USER: this.session.data.userName
        }
        await axios
          .post(this.$DNS_IP + '/booking_transaction/add', dt)
          .then(async response => {
            // this.getDataCalendaBooking()
            await this.onUpdateRemark(
              'เนื่องจากลูกค้าไม่สะดวก รอโทรยืนยันอีกครั้ง',
              item.bookNo
            )
            this.connectGoogleCalendar('Delete', item.bookNo)
            this.$swal(
              'เรียบร้อย',
              'ย้ายนัดหมายนี้กลับไปสถานะก่อนหน้า เรียบร้อย',
              'success'
            )
            // await this.getBookingList()
            // this.getTimesChange('update')
          })
          .catch(error => {
            console.log('error function addData : ', error)
            setTimeout(() => this.confirmChkAdd(), 3000)
          })
      })
    },
    async onUpdateRemark (text, bookNo) {
      var dt = {
        LAST_USER: this.session.data.userName,
        remark: text
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.$DNS_IP + "/Booking/edit/" + bookNo,
          dt
        )
        .then(async response => {
          if (this.statusSearch === 'no') {
            await this.getBookingList()
          } else {
            await this.searchAny()
          }
          // this.getTimesChange('update')
          if (this.getSelectText) {
            this.getSelect(
              this.getSelectText,
              this.getSelectCount,
              this.filterCloseJobValue
            )
          }
          clearInterval(this.setTimerCalendar)
          this.setTimerCalendar = null
        })
    },
    async SelectDataHistory () {
      this.HistoryData = []
      this.HistoryData.push(this.defaultData[this.phonenum])
      console.log('this.HistoryData', this.HistoryData)
    },
    async openHistory (item) {
      console.log('item', item)
      this.pictureUrHistory = item.memberPicture
      this.memberName = item.memberName
      let url = ''
      if (item.userId === null || item.userId === 'No Line') {
        url = this.$DNS_IP + '/BookingData/get_history?shopId=' + this.$session.getAll().data.shopId + '&bookNo=' + item.bookNo
      } else {
        url = this.$DNS_IP + '/BookingData/get_history?shopId=' + this.$session.getAll().data.shopId + '&userId=' + item.userId
      }
      const BookingData = await axios
        .get(url)
        .then(async response => {
          return response.data
        })
        .catch(error => {
          console.log('error function addData : ', error)
          return null
        })
      await this.ConvertHistoryData(BookingData)
    },
    async ConvertHistoryData (BookingData) {
      this.HistoryData = []
      this.phonenumItem = []
      // console.log('BookingData', BookingData)
      if (BookingData !== null) {
        if (BookingData.length > 0) {
          this.defaultData = BookingData.reduce((r, a) => {
            let bookNo = a.bookNo
            let filter = a.fieldName === 'เบอร์โทร' ? a.fieldValue : null
            if (filter !== null) {
              r[filter] = r[filter] || {}
              r[filter][bookNo] = r[filter][bookNo] || []
              r[filter][bookNo].push(
                BookingData.filter(item => item.bookNo === a.bookNo)
              )
              this.phonenumItem.push(filter)
            }
            return r
          }, Object.create(null))

          console.log(this.defaultData)
          this.phonenum = ''
          this.dialogHistory = true
        } else if (BookingData.status === false) {
          this.$swal(
            'ไม่พบประวัติการเข้ารับบริการ',
            'กรูณาตรวจสอบข้อมูล',
            'info'
          )
          this.dialogHistory = false
        }
      } else {
        this.$swal(
          'พบความผิดพลาดระหว่างดำเนินการ',
          'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่',
          'info'
        )
          .then(result => {
            this.dialogHistory = false
          })
          .catch(error => {
            console.log('error function addData : ', error)
            this.dialogHistory = false
          })
      }

      // console.log('this.HistoryData', this.HistoryData)
    },
    async AddDataTag () {
      await axios
        .get(
          this.$DNS_IP +
            '/Mas_Tag/get?shopId=' +
            this.session.data.shopId +
            '&tagName=' +
            this.tagName
        )
        .then(response => {
          let rs = response.data
          console.log('rs', rs)
          if (rs.status === false) {
            this.$swal({
              title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
              type: 'question',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#b3b1ab',
              confirmButtonText: 'ใช่',
              cancelButtonText: 'ไม่'
            }).then(async () => {
              let dt = {
                tagName: this.tagName,
                CREATE_USER: this.$session.getAll().data.USER_ROLE,
                LAST_USER: this.$session.getAll().data.USER_ROLE,
                shopId: this.$session.getAll().data.shopId
              }
              await axios
                .post(this.$DNS_IP + '/Mas_Tag/add', dt)
                .then(async response => {
                  this.$swal('บันทึกข้อมูลเรียบร้อย', ' ', 'success')
                  this.dialogAddTag = false
                  this.getTagData()
                })
                // eslint-disable-next-line handle-callback-err
                .catch(error => {
                  console.log('error function addData : ', error)
                })
            })
          } else {
            this.$swal('มีข้อมูลอยู่แล้ว', ' ', 'error')
          }
        })
        .catch(error => {
          console.log('error function addData : ', error)
        })
    },
    async getTagData () {
      this.tagItem = await this.getDataFromAPI(
        '/Mas_Tag/get',
        'tagId',
        'tagName',
        ''
      )
    },
    async editTagData () {
      console.log('tagData', this.tagData)
      let dt = {
        tagData: JSON.stringify(this.tagData),
        LAST_USER: this.session.data.userName
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.$DNS_IP + "/member/edit/" + this.memberId,
          dt
        )
        .then(async response => {
          this.$swal('เรียบร้อย', 'อัพเดท Tag เรียบร้อย', 'success')
          this.dialogTag = false
          if (this.statusSearch === 'no') {
            await this.getBookingList()
          } else {
            await this.searchAny()
          }
          // this.getTimesChange('update')
          if (this.getSelectText) {
            this.getSelect(
              this.getSelectText,
              this.getSelectCount,
              this.filterCloseJobValue
            )
          }
        })
    },
    async editStatusDeposit () {
      this.loadingDeposit = true
      console.log('bookNo', this.bookNo)
      if (this.filesDeposit) {
        const _this = this
        let configDepositUpload = {
          headers: {
            bookNo: this.bookNo
          }
        }
        let params = new FormData()
        params.append('file', this.filesDeposit)
        await axios
          .post(
            this.$DNS_IP + `/file/upload/deposit`,
            params,
            configDepositUpload
          )
          .then(function (response) {
            _this.pictureUrlDeposit = response.data
            console.log('url Pic', response.data)
          })
      } else {
        this.pictureUrlDeposit = this.pictureUrlPreviewDeposit
      }
      let dt = {
        depositStatus: 'True',
        depositImge: this.pictureUrlDeposit,
        LAST_USER: this.session.data.userName
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.$DNS_IP + "/Booking/edit/" + this.bookNo,
          dt
        )
        .then(async response => {
          this.$swal('เรียบร้อย', 'อัพเดทหลักฐานเงินมัดจำเรียบร้อย', 'success')
          this.dialogDeposit = false
          this.pictureUrlDeposit = null
          this.filesDeposit = null
          this.loadingDeposit = false
          this.pictureUrlPreviewDeposit = null
          if (this.statusSearch === 'no') {
            await this.getBookingList()
          } else {
            await this.searchAny()
          }
          // this.getTimesChange('update')
          if (this.getSelectText) {
            this.getSelect(
              this.getSelectText,
              this.getSelectCount,
              this.filterCloseJobValue
            )
          }
        })
    },
    async cancelStatusDeposit () {
      this.loadingDeposit = true
      console.log('bookNo', this.bookNo)
      let dt = {
        depositStatus: 'False',
        LAST_USER: this.session.data.userName
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.$DNS_IP + "/Booking/edit/" + this.bookNo,
          dt
        )
        .then(async response => {
          this.$swal('เรียบร้อย', 'อัพเดทหลักฐานเงินมัดจำเรียบร้อย', 'success')
          this.pictureUrlDeposit = null
          this.filesDeposit = null
          this.loadingDeposit = false
          this.dialogDeposit = false
          this.statusDeposit = false
          this.pictureUrlPreviewDeposit = null
          if (this.statusSearch === 'no') {
            await this.getBookingList()
          } else {
            await this.searchAny()
          }
          // this.getTimesChange('update')
          if (this.getSelectText) {
            this.getSelect(
              this.getSelectText,
              this.getSelectCount,
              this.filterCloseJobValue
            )
          }
        })
    },
    selectImgDeposit () {
      if (this.filesDeposit) {
        this.pictureUrlPreviewDeposit = URL.createObjectURL(this.filesDeposit)
      } else {
        this.pictureUrlPreviewDeposit = ''
      }
      // console.log(event)
    },
    selectImgAdd () {
      if (this.filesDepositAdd) {
        this.formAdd.pictureUrlPreviewDeposit = URL.createObjectURL(
          this.filesDepositAdd
        )
      } else {
        this.formAdd.pictureUrlPreviewDeposit = ''
      }
      // console.log(event)
    },
    setFlowAdd () {
      if (
        this.dataFlowSelectAdd.filter(el => {
          return el.value === this.formAdd.flowId
        }).length > 0
      ) {
        this.checkDepositAdd =
          this.dataFlowSelectAdd.filter(el => {
            return el.value === this.formAdd.flowId
          })[0].allData.checkDeposit || 'False'
        this.statusShowMap =
          this.dataFlowSelectAdd.filter(el => {
            return el.value === this.formAdd.flowId
          })[0].allData.checkOnsite || 'False'
      } else {
        this.checkDepositAdd = 'False'
        this.statusShowMap = 'False'
      }
    },
    async getBookingFieldText () {
      if (JSON.parse(localStorage.getItem('typeData')) === null) {
        await axios
          .get(
            this.$DNS_IP + '/BookingField/get?shopId=' + this.session.data.shopId
          )
          .then(async response => {
            let rs = response.data
            console.log('rs', rs)
            if (rs.status === false) {
              this.$swal(
                'ผิดพลาด',
                'เนื่องจากไม่สามารถเรียกชื่อกระบวนการ และประเภทงานได้',
                'success'
              )
            } else {
              localStorage.setItem('typeData', JSON.stringify(rs[0]))
              this.dataTypeJob1 =
                JSON.parse(localStorage.getItem('typeData')).typeJob1 || ''
              this.dataTypeJob2 =
                JSON.parse(localStorage.getItem('typeData')).typeJob2 || ''
              this.dataTypeJob3 =
                JSON.parse(localStorage.getItem('typeData')).typeJob3 || ''
              this.dataTypeProcess1 =
                JSON.parse(localStorage.getItem('typeData')).typeProcess1 || ''
              this.dataTypeProcess2 =
                JSON.parse(localStorage.getItem('typeData')).typeProcess2 || ''
              this.dataTypeProcess3 =
                JSON.parse(localStorage.getItem('typeData')).typeProcess3 || ''
              this.dataTypeProcess4 =
                JSON.parse(localStorage.getItem('typeData')).typeProcess4 || ''
            }
          })
      } else {
        this.dataTypeJob1 =
          JSON.parse(localStorage.getItem('typeData')).typeJob1 || ''
        this.dataTypeJob2 =
          JSON.parse(localStorage.getItem('typeData')).typeJob2 || ''
        this.dataTypeJob3 =
          JSON.parse(localStorage.getItem('typeData')).typeJob3 || ''
        this.dataTypeProcess1 =
          JSON.parse(localStorage.getItem('typeData')).typeProcess1 || ''
        this.dataTypeProcess2 =
          JSON.parse(localStorage.getItem('typeData')).typeProcess2 || ''
        this.dataTypeProcess3 =
          JSON.parse(localStorage.getItem('typeData')).typeProcess3 || ''
        this.dataTypeProcess4 =
          JSON.parse(localStorage.getItem('typeData')).typeProcess4 || ''
      }
    },
    closeSetTimeGetCalenda () {
      clearInterval(this.setTimerCalendar)
      this.setTimerCalendar = null
    },
    gotoMap () {
      window.open(
        'https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=' +
          this.center.lat +
          ',' +
          this.center.lng,
        '_blank'
      )
      // window.location.href = 'https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=' + this.center.lat + ',' + this.center.lng
    },
    setShowMap (dt) {
      this.center = null
      if (dt.addressLatLong === null && dt.addressLatLong === '') {
        this.center = null
      } else {
        this.center = JSON.parse(dt.addressLatLong)
        this.address = dt.address
        this.dialogMap = true
      }
    },
    async searchAny () {
      if (this.searchOther.trim().length > 1) {
        // this.dataReady = false
        this.selectedStatus = true
        // this.getSelectText = ''
        this.dataItem = []
        this.countWaiting = 0
        this.countConfirm = 0
        this.countCancel = 0
        this.countJob = 0
        this.countAll = 0
        // Clear ช่องค้นหา
        this.searchAll2 = ''
        // this.dataItemSelect = []
        var dataItemTimes = []
        var dataItems = []
        let categoryUser = ''
        if (
          this.$session.getAll().data.category === 'ธุรกิจรถยนต์' ||
          this.$session.getAll().data.category === '7'
        ) {
          categoryUser = 'ธุรกิจรถยนต์'
        } else {
          categoryUser = this.$session.getAll().data.category
        }
        // await this.getBookingDataList('no', this.searchOther)
        await axios
          .get(
            // eslint-disable-next-line quotes
            this.$DNS_IP +
              '/booking_view/getSearchName?shopId=' +
              this.session.data.shopId +
              '&category=' +
              categoryUser +
              '&masBranchID=' +
              this.masBranchID +
              '&fieldValue=' +
              this.searchOther +
              this.selectOnsite
          )
          .then(async response => {
            if (response.data.length > 0) {
              for (let i = 0; i < response.data.length; i++) {
                let d = response.data[i]
                let s = {}
                if (
                  dataItems.filter(el => {
                    return el.bookNo === d.bookNo
                  }).length === 0
                ) {
                  s.bookNo = d.bookNo
                  s.flowId = d.flowId
                  let checkDeposit = this.DataFlowNameDefault.filter(el => {
                    return el.value === parseInt(d.flowId)
                  })
                  if (checkDeposit.length > 0) {
                    s.depositCheckStatus =
                      checkDeposit[0].allData.checkDeposit || 'False'
                  } else {
                    s.depositCheckStatus = 'False'
                  }
                  s.flowName = d.flowName
                  s.dueDate = d.dueDate || ''
                  if (d.timeText === null || d.timeText === '') {
                    d.timeText = d.timeDue
                  }
                  if (s.dueDate === '') {
                    s.dueDateText = 'ไม่มีเวลานัดหมาย'
                  } else {
                    s.dueDateText = d.dueDateTextDay + ' ' + d.timeText
                  }
                  s.shopId = d.shopId
                  s.dueDateDay = d.dueDateDay
                  s.statusVIP = d.statusVIP
                  s.checkDateConfirmJob = d.checkDateConfirmJob
                  s.bookingLanguage = d.bookingLanguage
                  s.zone = d.bookingDataCustomerZone
                  s.packageName = d.packageName
                  s.packageDetails = d.packageDetails
                  s.packageImage = d.packageImage
                  s.packagePrice = d.packagePrice
                  s.packageBalanceAmount = d.packageBalanceAmount
                  s.packageAmount = d.packageAmount
                  s.packagePoint = d.packagePoint
                  s.packageExpire = d.packageExpire
                  s.depositTextTH = d.depositTextTH
                  s.CREATE_DATE_Status = d.CREATE_DATE_Status
                  s.CREATE_DATE = d.CREATE_DATE
                  s.menuShowStatus = d.menuShowStatus
                  s.dueDateTextDay = d.dueDateTextDay
                  s.remark = d.remark || ''
                  s.masBranchID = d.masBranchID
                  s.limitBookingCheck = d.limitBookingCheck
                  s.memberId = d.memberId || ''
                  s.countHourLimit = d.countHourLimit
                  s.empSelect = d.empSelect
                  s.empFull_NameTH = d.empFull_NameTH || ''
                  s.empFull_NameTH = s.empFull_NameTH.replace('นางสาว', '')
                  s.empFull_NameTH = s.empFull_NameTH.replace('นาย', '')
                  s.empFull_NameTH = s.empFull_NameTH.replace('นาง', '')
                  s.userId = d.userId
                  s.chkConfirm = false
                  s.chkCancel = false
                  s.address = d.address
                  s.addressLatLong = d.addressLatLong
                  s.jobNo = d.jobNo
                  s.timeText = d.timeText
                  s.remarkRemove = d.remarkRemove || ''
                  s.cancelBy = d.cancelBy || '-'
                  switch (d.cancelBy) {
                    case 'system':
                      s.cancelBy = 'ยกเลิกโดยระบบ'
                      break
                    case 'user':
                      s.cancelBy = 'ยกเลิกโดยประชาชน'
                      break
                    case 'admin':
                      s.cancelBy = 'ยกเลิกโดยเจ้าหน้าที่'
                      break
                  }
                  s.remarkConfirm1 =
                    d.remarkConfirm1 === 'true' || d.remarkConfirm1 === 'True'
                  s.remarkConfirm2 =
                    d.remarkConfirm2 === 'true' || d.remarkConfirm2 === 'True'
                  s.extraJob = d.extraJob === 'true' || d.extraJob === 'True'
                  s.fastTrack =
                    d.fastTrack === 'true' || d.fastTrack === 'True'
                  s.depositStatus = d.depositStatus || 'False'
                  s.paymentType = d.paymentType || ''
                  s.depositImge = d.depositImge || ''
                  s.depositReturnImge = d.depositReturnImge || ''
                  s.depositPrice = d.depositPrice || ''
                  s.remarkDepositLinked = d.remarkDepositLinked || ''
                  s.lineUserId = d.lineUserId
                  s.memberPicture = d.memberPicture
                  s.memberName = d.memberName
                  s.timeDueHtext = d.timeDueH + ':00'
                  s.timeDuetext = d.timeDue
                  s.countChangeTime = d.countChangeTime || 0
                  s.remarkReturn = d.remarkReturn || ''
                  s.dateReturn = d.dateReturn || ''
                  s.packageId = d.packageId || ''
                  s.tokenPackage = d.tokenPackage || ''
                  s.RECORD_STATUS_Job = d.RECORD_STATUS_Job || ''
                  s.menuItem = d.menuItem || []
                  s.menuPrice = d.menuPrice || ''
                  this.countAll = this.countAll + 1
                  if (d.statusUseBt === 'use' && d.statusBt === 'confirm') {
                    s.chkConfirm = true
                    s.chkCancel = false
                  }
                  if (d.statusUseBt === 'use' && d.statusBt === 'cancel') {
                    s.chkConfirm = false
                    s.chkCancel = true
                  }
                  s.statusBt = d.statusBt || 'wait'
                  switch (d.statusBt) {
                    case 'confirm':
                      s.statusBtText = 'ยืนยันแล้ว'
                      this.countConfirm = this.countConfirm + 1
                      break
                    case 'cancel':
                      s.statusBtText = 'ยกเลิก'
                      this.countCancel = this.countCancel + 1
                      break
                    case 'confirmJob':
                      s.statusBtText = 'รับรถแล้ว'
                      this.countJob = this.countJob + 1
                      break
                    // default:
                    //   s.statusBtText = 'รายการนัดหมายใหม่'
                    //   this.countWaiting = this.countWaiting + 1
                    //   break
                  }
                  var chkTime = this.dataItemTime.filter(el => {
                    return el.timeDueHtext === s.timeDueHtext
                  })
                  if (chkTime.length === 0) {
                    dataItemTimes.push(s)
                  }
                  try {
                    s.memberDataTagName = []
                    s.memberDataTag = JSON.parse(d.memberDataTag) || []
                    if (s.memberDataTag.length > 0) {
                      s.tagDataShow = []
                      let memberDataTag = s.memberDataTag
                      for (let i = 0; i < memberDataTag.length; i++) {
                        let d = memberDataTag[i]
                        let x = {}
                        let checkTagItem = this.tagItem.filter(el => {
                          return el.value === d
                        })
                        if (checkTagItem.length > 0) {
                          x.text = checkTagItem[0].text
                          x.value = checkTagItem[0].value
                          s.tagDataShow.push(x)
                        }
                      }
                    }
                    // s.memberDataTagName = s.memberDataTagName.join(', ')
                  } catch (error) {
                    console.log(error)
                  }

                  // s.cusName = this.getDataFromFieldName(this.BookingDataList[d.bookNo], 'ชื่อ')
                  // s.cusReg = this.getDataFromFieldName(this.BookingDataList[d.bookNo], 'เลขทะเบียน')
                  // s.tel = this.getDataFromFieldName(this.BookingDataList[d.bookNo], 'เบอร์โทร')
                  // s.cusName = (s.cusName.length > 0) ? s.cusName[0].fieldValue : ''
                  // s.cusReg = (s.cusReg.length > 0) ? s.cusReg[0].fieldValue : ''
                  // s.tel = (s.tel.length > 0) ? s.tel[0].fieldValue : ''
                  s.cusName = d.bookingDataCustomerName || ''
                  s.cusReg = d.bookingDataCustomerRegisNumber || ''
                  s.tel = d.bookingDataCustomerTel || ''
                  s.displayFlowName = d.displayFlowName || ''
                  s.remarkQueue = d.remarkQueue
                  dataItems.push(s)
                }
              }
            }
            if (dataItems.length === 0 || dataItems.status === false) {
              this.dataItem = []
              this.dataItemTime = []
              // await this.getTimesChange('update')
              if (this.getSelectText) {
                this.getSelect(this.getSelectText, 0, this.filterCloseJobValue)
              } else {
                this.getSelect(
                  'wait',
                  this.countWaiting,
                  this.filterCloseJobValue
                )
              }
              this.dataReady = true
              // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
            } else {
              this.dataItem = dataItems
              var datause = dataItemTimes.sort((a, b) => {
                if (a.timeDueHtext < b.timeDueHtext) return -1
                return a.timeDueHtext > b.timeDueHtext ? 1 : 0
              })
              console.log('datause', datause)
              for (var k = 0; k < datause.length; k++) {
                var t = datause[k]
                var h = {}
                h.timeDueHtext = t.timeDueHtext
                let chkTimes = this.dataItemTime.filter(el => {
                  return el.timeDueHtext === t.timeDueHtext
                })
                // console.log('chkTimes', chkTimes)
                if (chkTimes.length === 0) {
                  this.dataItemTime.push(h)
                }
              }
              // await this.getTimesChange('update')
              if (this.getSelectText) {
                this.getSelect(this.getSelectText, 0, this.filterCloseJobValue)
              } else {
                this.getSelect(
                  'wait',
                  this.countWaiting,
                  this.filterCloseJobValue
                )
              }
              // this.dataItemTime = dataItemTimes.sort((a, b) => {
              //   if (a.timeDueHtext < b.timeDueHtext) return -1
              //   return a.timeDueHtext > b.timeDueHtext ? 1 : 0
              // })
              console.log('this.BookingDataList', this.BookingDataList)
              this.dataReady = true
            }
          })
          // eslint-disable-next-line handle-callback-err
          .catch(error => {
            console.log(error)
            this.dataReady = true
            setTimeout(() => this.searchAny(), 3000)
            //   this.$router.push('/system/Errorpage?returnLink=' + returnLink)
          })
      } else {
        this.$swal('ผิดพลาด', 'กรุณาใส่คำค้นหาให้มากว่า 1 ตัวอักษร', 'error')
      }
    },
    openRemark (item) {
      this.bookNoRemark = item.bookNo
      this.remark = item.remark
      this.dialogRemark = true
    },
    async openRemarkReturn (item) {
      console.log('openRemarkReturn', item)
      await axios
        .get(this.$DNS_IP + '/job/getJobNo?jobNo=' + item.jobNo)
        .then(response => {
          let rs = response.data
          console.log('getJobNo', rs)
          if (rs.length > 0) {
            this.lineUserId = rs[0].lineUserId || ''
          } else {
            this.lineUserId = ''
          }
        })
      this.dateReturn = item.dateReturn
      this.bookNoRemark = item.bookNo
      // this.lineUserId = item.lineUserId
      this.remarkReturn = item.remarkReturn
      this.dialogRemarkReturn = true
    },
    async onSaveRemark () {
      var dt = {
        LAST_USER: this.session.data.userName,
        remark: (this.remark || '').replace(/%/g, '%%')
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.$DNS_IP + "/Booking/edit/" + this.bookNoRemark,
          dt
        )
        .then(async response => {
          this.$swal(
            'เรียบร้อย',
            'เปลี่ยนแปลงหมายเหตุเพิ่มเติมเรียบร้อย',
            'success'
          )
          this.dialogRemark = false
          if (this.statusSearch === 'no') {
            await this.getBookingList()
          } else {
            await this.searchAny()
          }
          // this.getTimesChange('update')
          if (this.getSelectText) {
            this.getSelect(
              this.getSelectText,
              this.getSelectCount,
              this.filterCloseJobValue
            )
          }
        })
    },
    async onSaveRemarkReturn () {
      if (this.remarkReturn !== '' && this.dateReturn !== '') {
        var dt = {
          bookNo: this.bookNoRemark,
          remarkReturn: (this.remarkReturn || '').replace(/%/g, '%%'),
          dateReturn: this.dateReturn,
          lineUserId: this.lineUserId,
          shopId: this.session.data.shopId,
          CREATE_USER: this.session.data.userName,
          LAST_USER: this.session.data.userName
        }
        await axios
          .post(
            // eslint-disable-next-line quotes
            this.$DNS_IP + "/bookingRemarkReturnLog/addRecordD",
            dt
          )
          .then(async response => {
            this.$swal('เรียบร้อย', 'เปลี่ยนแปลงหมายเหตุเรียบร้อย', 'success')
            this.dialogRemarkReturn = false
            if (this.lineUserId !== '') {
              let pushText = {
                to: this.lineUserId,
                messages: [
                  {
                    type: 'text',
                    text: ` 📣 คุณลูกค้ามีนัด\n 🛎 ${this.remarkReturn}
                          \nวันที่กลับมาใช้บริการ ${this.format_dateNotime(
    this.dateReturn
  )}`
                  }
                ]
              }
              axios
                .post(
                  this.$DNS_IP +
                    '/line/pushmessage?shopId=' +
                    this.$session.getAll().data.shopId,
                  pushText
                )
                .catch(error => {
                  console.log('error function addData : ', error)
                })
            }
            if (this.statusSearch === 'no') {
              await this.getBookingList()
            } else {
              await this.searchAny()
            }
            // this.getTimesChange('update')
            if (this.getSelectText) {
              this.getSelect(
                this.getSelectText,
                this.getSelectCount,
                this.filterCloseJobValue
              )
            }
          })
      } else {
        this.$swal(
          'ผิดพลาด',
          'กรุณากรอก หมายเหตุ และวันที่เรียกลูกค้ากลับ',
          'error'
        )
      }
    },
    async setDataEdit (dt) {
      this.checkSelectText = dt.statusBt
      // this.dialogEditData = true
      await this.getBookingField()
      console.log('setDataEdit', dt)
      this.statusVIPEdit = dt.statusVIP
      this.dataEdit = dt
      this.userId = dt.userId
      this.BookingDataItemEdit = []
      this.formEdit.masBranchID = dt.masBranchID
      await this.setFlowByBranchEdit()
      this.masBranchIDOldEdit = dt.masBranchID
      this.formEdit.flowId = dt.flowId
      this.flowIdOldEdit = dt.flowId
      if (dt.empSelect) {
        this.empSelectEdit = parseInt(dt.empSelect)
      } else {
        this.empSelectEdit = ''
      }
      this.dueDateOld = dt.dueDateDay
      this.dueDateTimeOld = dt.timeDuetext

      this.address = dt.address
      this.center = JSON.parse(dt.addressLatLong) || null

      // this.SetallowedDatesEdit()
      this.dateEdit = dt.dueDateDay
      this.timeavailable = []
      // let dtTime = await this.branch.filter(item => { return item.value === this.formEdit.masBranchID })
      let dtTime =
        this.dataFlowSelectEdit.filter(item => {
          return item.value === this.formEdit.flowId
        }) || []
      await this.setLimitBookingEdit(dt.dueDateDay)
      let setTime = []
      if (
        this.DataFlowNameDefault.filter(el => {
          return el.value === parseInt(this.formEdit.flowId)
        })[0].allData.setTimebyday === 'True'
      ) {
        let timeJson = JSON.parse(
          this.DataFlowNameDefault.filter(el => {
            return el.value === parseInt(this.formEdit.flowId)
          })[0].allData.setTime
        ).filter(items => items.value === new Date(dt.dueDateDay).getDay())
        setTime = timeJson[0].setTime || []
      } else {
        setTime =
          JSON.parse(
            this.DataFlowNameDefault.filter(el => {
              return el.value === parseInt(this.formEdit.flowId)
            })[0].allData.setTime
          ) || []
      }
      if (dtTime.length > 0) {
        this.statusShowMap = dtTime[0].allData.checkOnsite || 'False'
        if (
          dtTime.map(item => item.allData.setTime)[0] === null ||
          dtTime.map(item => item.allData.setTime)[0] === ''
        ) {
          this.timeavailable = []
          this.timeEdit = ''
        } else {
          this.timeavailable = setTime
          if (
            this.timeavailable.filter(el => {
              return el.text === dt.timeText
            }).length > 0
          ) {
            if (dt.timeText) {
              this.timeEdit = {
                text: dt.timeText,
                value: dt.dueDate.slice(-5)
              }
            } else {
              this.timeEdit = {
                text: dt.dueDate.slice(-5),
                value: dt.dueDate.slice(-5)
              }
            }
          } else {
            this.timeEdit = {
              text: dt.dueDate.slice(-5),
              value: dt.dueDate.slice(-5)
            }
          }
        }
      } else {
        this.statusShowMap = 'False'
      }
      console.log('setDataEdit', dt)
      await this.getPackage(dt)
      if (this.dataPackage.length > 0) {
        console.log(
          'dataPackage',
          this.dataPackage.filter(el => {
            return el.packageId === dt.packageId
          })
        )
        if (
          this.dataPackage.filter(el => {
            return el.packageId === dt.packageId
          }).length > 0
        ) {
          var dataPack = this.dataPackage.filter(el => {
            return el.packageId === dt.packageId
          })
          this.dataPackageDefault = true
          // this.packageId = dataPack[0].value
          this.UpdatePackage(
            dataPack[0].value,
            'ตกลง',
            dataPack[0].text,
            dataPack[0],
            dt.tokenPackage
          )
        } else {
          this.UpdatePackage('', 'ยกเลิก', '', '', '')
          this.dataPackageDefault = false
        }
      }
      console.log('setDataEdit', dt)
      var extraJob = ''
      var fastTrack = ''
      if (dt.extraJob === null) {
        extraJob = false
      } else {
        extraJob = dt.extraJob
      }
      if (dt.fastTrack === null) {
        fastTrack = false
      } else {
        fastTrack = dt.fastTrack
      }

      if (!extraJob && !fastTrack) {
        this.formEdit.radiosRemark = 'ซ่อมปกติ'
      } else if (extraJob && !fastTrack) {
        this.formEdit.radiosRemark = 'ExtraJob'
      } else if (!extraJob && fastTrack) {
        this.formEdit.radiosRemark = 'FastTrack'
      }

      let itemIncustomField = []
      await axios
        .get(
          this.$DNS_IP + '/BookingField/get?shopId=' + this.session.data.shopId
        )
        .then(async response1 => {
          let rs2 = response1.data
          console.log('BookingField', rs2)
          if (rs2.length > 0) {
            let bookingData = []
            bookingData = JSON.parse(rs2[0].flowfieldName)
            for (let i = 0; i < bookingData.length; i++) {
              let d = bookingData[i]
              itemIncustomField.push(d.fieldId)
            }
            await axios
              .get(
                this.$DNS_IP +
                  '/customField/fieldId?fieldId=' +
                  itemIncustomField
              )
              .then(async responses => {
                let rs1 = responses.data
                console.log('customField', rs1)
                await axios
                  .get(
                    this.$DNS_IP + '/BookingDataSelect/get?bookNo=' + dt.bookNo
                  )
                  .then(async response => {
                    let rs = response.data
                    console.log('BookingDataSelect1', rs)
                    if (rs.length > 0) {
                      let sortrs = rs1.sort(
                        (a, b) => a.sortNoField - b.sortNoField
                      )
                      for (var i = 0; i < sortrs.length; i++) {
                        var d = sortrs[i]
                        var s = {}
                        var dataBD = rs.filter(el => {
                          return parseInt(el.fieldId) === parseInt(d.fieldId)
                        })
                        // console.log('dataBD', dataBD)
                        if (dataBD.length > 0) {
                          s.bookNo = dataBD[0].bookNo
                          s.bookingFieldId = rs2[0].bookingFieldId
                          s.bookingDataId = dataBD[0].bookingDataId
                          s.conditionField = d.conditionField
                          s.fieldId = d.fieldId
                          s.fieldType = d.fieldType
                          if (d.fieldType === 'Checkbox') {
                            console.log('checkbox')
                            this.selected[d.fieldId] = this.parseCheckboxValue(dataBD[0].fieldValue)
                          }
                          s.fieldValue = dataBD[0].fieldValue
                          s.fieldName = d.fieldName
                          s.conditionField = d.conditionField
                          s.conditionValue = d.conditionValue
                          s.requiredField = d.requiredField
                          s.optionField = d.optionField
                          this.BookingDataItemEdit.push(s)
                        } else {
                          s.bookNo = rs[0].bookNo
                          s.bookingFieldId = rs2[0].bookingFieldId
                          s.bookingDataId = 'newDataBooking'
                          s.conditionField = d.conditionField
                          s.fieldId = d.fieldId
                          s.fieldType = d.fieldType
                          s.fieldValue = s.fieldType === 'Checkbox' ? '[]' : ''
                          s.fieldName = d.fieldName
                          s.conditionField = d.conditionField
                          s.conditionValue = d.conditionValue
                          s.requiredField = d.requiredField
                          s.optionField = d.optionField
                          this.BookingDataItemEdit.push(s)
                        }
                      }
                    } else {
                      this.$swal(
                        'พบความผิดพลาดระหว่างดำเนินการ',
                        'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่',
                        'info'
                      )
                        .then(result => {
                          this.dialogEditData = false
                        })
                        .catch(error => {
                          console.log('error function setDataEdit : ', error)
                          this.dialogEditData = false
                        })
                    }
                  })
                  .catch(error => {
                    this.$swal(
                      'พบความผิดพลาดระหว่างดำเนินการ',
                      'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่',
                      'info'
                    )
                      .then(result => {
                        this.dialogEditData = false
                      })
                      .catch(error => {
                        console.log('error function setDataEdit : ', error)
                        this.dialogEditData = false
                      })
                    console.log('error function setDataEdit : ', error)
                  })
              })
          } else {
            this.$swal(
              'พบความผิดพลาดระหว่างดำเนินการ',
              'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่',
              'info'
            )
              .then(result => {
                this.dialogEditData = false
              })
              .catch(error => {
                console.log('error function setDataEdit : ', error)
                this.dialogEditData = false
              })
          }
        })
        .catch(error => {
          this.$swal(
            'พบความผิดพลาดระหว่างดำเนินการ',
            'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่',
            'info'
          )
            .then(result => {
              this.dialogEditData = false
            })
            .catch(error => {
              console.log('error function setDataEdit : ', error)
              this.dialogEditData = false
            })
          console.log('error function setDataEdit : ', error)
        })
      console.log('this.BookingDataItemEdit', this.BookingDataItemEdit)
      this.dialogEditData = true
      this.SetallowedDatesEdit()
    },
    editDataSelect () {
      console.log('flowIdOldEdit', this.flowIdOldEdit, this.formEdit.flowId)
      console.log('formEdit', this.formEdit)
      this.validate('EDIT')
      setTimeout(() => this.checkDuplicate(), 500)
      // setTimeout(() => this.editDataSelectSubmit(), 500)
    },
    async checkDuplicate () {
      console.log('statusVIP', this.statusVIPEdit)
      if (this.validEdit !== false) {
        this.loadingEdit = true
        this.swalConfig.title = 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?'
        this.$swal(this.swalConfig)
          .then(async result => {
            if (this.getSelectText === 'cancel') {
              this.editDataSelectSubmit()
            } else {
              if (this.formEdit.radiosRemark === 'FastTrack') {
                let getcount = await this.getCountFastTrack(
                  this.dateEdit,
                  this.formEdit.flowId,
                  this.formEdit.masBranchID
                )
                let setCountFast = this.branch.filter(el => {
                  return el.value === this.formEdit.masBranchID
                })[0].allData.countFastTrack
                if (getcount < setCountFast) {
                  let chkStatLimit = this.dataFlowSelectEdit.filter(el => {
                    return el.value === this.formEdit.flowId
                  })
                  console.log('this.getSelectText', this.getSelectText)
                  if (chkStatLimit.length > 0) {
                    if (chkStatLimit[0].allData.limitBookingCheck === 'True') {
                      let dueOld = this.dueDateOld + this.dueDateTimeOld
                      let dueNew = this.dateEdit + this.timeEdit.value
                      let limitBookingCount = this.timeavailable.filter(el => {
                        return el.value === this.timeEdit.value
                      })
                      console.log('limitBookingCount', limitBookingCount)
                      let limitBookingCounts = 0
                      if (limitBookingCount.length > 0) {
                        limitBookingCounts = parseInt(
                          limitBookingCount[0].limitBooking
                        )
                      } else {
                        limitBookingCounts = 0
                      }
                      console.log('NEW', this.formEdit.masBranchID)
                      console.log('OLD', this.masBranchIDOldEdit)
                      if (this.statusVIPEdit === 'False') {
                        if (dueOld !== dueNew) {
                          let chkStatus = await this.updateLimitBookingEdit(
                            this.formEdit,
                            this.dueDateOld,
                            this.dueDateTimeOld,
                            this.dateEdit,
                            this.timeEdit.value,
                            limitBookingCounts
                          )
                          console.log('chkStatus', chkStatus)
                          if (chkStatus.status) {
                            this.editDataSelectSubmit()
                          } else {
                            this.$swal(
                              'ผิดพลาด',
                              'เวลาที่ท่านเลือกคิวเต็มแล้ว',
                              'error'
                            )
                            this.loadingEdit = false
                          }
                        } else if (
                          dueOld === dueNew &&
                          this.flowIdOldEdit !== this.formEdit.flowId
                        ) {
                          let chkStatus = await this.updateLimitBookingEdit(
                            this.formEdit,
                            this.dueDateOld,
                            this.dueDateTimeOld,
                            this.dateEdit,
                            this.timeEdit.value,
                            limitBookingCounts
                          )
                          console.log('chkStatus', chkStatus)
                          if (chkStatus.status) {
                            this.editDataSelectSubmit()
                          } else {
                            this.$swal(
                              'ผิดพลาด',
                              'เวลาที่ท่านเลือกคิวเต็มแล้ว',
                              'error'
                            )
                            this.loadingEdit = false
                          }
                        } else if (
                          dueOld === dueNew &&
                          this.masBranchIDOldEdit !== this.formEdit.masBranchID
                        ) {
                          let chkStatus = await this.updateLimitBookingEdit(
                            this.formEdit,
                            this.dueDateOld,
                            this.dueDateTimeOld,
                            this.dateEdit,
                            this.timeEdit.value,
                            limitBookingCounts
                          )
                          console.log('chkStatus', chkStatus)
                          if (chkStatus.status) {
                            this.editDataSelectSubmit()
                          } else {
                            this.$swal(
                              'ผิดพลาด',
                              'เวลาที่ท่านเลือกคิวเต็มแล้ว',
                              'error'
                            )
                            this.loadingEdit = false
                          }
                        } else if (
                          dueOld === dueNew &&
                          this.masBranchIDOldEdit !==
                            this.formEdit.masBranchID &&
                          this.flowIdOldEdit !== this.formEdit.flowId
                        ) {
                          let chkStatus = await this.updateLimitBookingEdit(
                            this.formEdit,
                            this.dueDateOld,
                            this.dueDateTimeOld,
                            this.dateEdit,
                            this.timeEdit.value,
                            limitBookingCounts
                          )
                          console.log('chkStatus', chkStatus)
                          if (chkStatus.status) {
                            this.editDataSelectSubmit()
                          } else {
                            this.$swal(
                              'ผิดพลาด',
                              'เวลาที่ท่านเลือกคิวเต็มแล้ว',
                              'error'
                            )
                            this.loadingEdit = false
                          }
                        } else {
                          this.editDataSelectSubmit()
                        }
                      } else {
                        this.editDataSelectSubmit()
                      }
                    } else {
                      this.editDataSelectSubmit()
                    }
                  } else {
                    this.editDataSelectSubmit()
                  }
                } else {
                  this.textError = 'จำนวนงานด่วนต่อวัน เกินกว่าที่ตั้งไว้'
                  this.dialogError = true
                  this.loadingEdit = false
                }
              } else {
                let chkStatLimit = this.dataFlowSelectEdit.filter(el => {
                  return el.value === this.formEdit.flowId
                })
                console.log('this.getSelectText', this.getSelectText)
                if (chkStatLimit.length > 0) {
                  if (chkStatLimit[0].allData.limitBookingCheck === 'True') {
                    let dueOld = this.dueDateOld + this.dueDateTimeOld
                    let dueNew = this.dateEdit + this.timeEdit.value
                    let limitBookingCount = this.timeavailable.filter(el => {
                      return el.value === this.timeEdit.value
                    })
                    console.log('limitBookingCount', limitBookingCount)
                    let limitBookingCounts = 0
                    if (limitBookingCount.length > 0) {
                      limitBookingCounts = parseInt(
                        limitBookingCount[0].limitBooking
                      )
                    } else {
                      limitBookingCounts = 0
                    }
                    if (this.statusVIPEdit === 'False') {
                      if (dueOld !== dueNew) {
                        let chkStatus = await this.updateLimitBookingEdit(
                          this.formEdit,
                          this.dueDateOld,
                          this.dueDateTimeOld,
                          this.dateEdit,
                          this.timeEdit.value,
                          limitBookingCounts
                        )
                        console.log('chkStatus', chkStatus)
                        if (chkStatus.status) {
                          this.editDataSelectSubmit()
                        } else {
                          this.$swal(
                            'ผิดพลาด',
                            'เวลาที่ท่านเลือกคิวเต็มแล้ว',
                            'error'
                          )
                          this.loadingEdit = false
                        }
                      } else if (
                        dueOld === dueNew &&
                        this.flowIdOldEdit !== this.formEdit.flowId
                      ) {
                        let chkStatus = await this.updateLimitBookingEdit(
                          this.formEdit,
                          this.dueDateOld,
                          this.dueDateTimeOld,
                          this.dateEdit,
                          this.timeEdit.value,
                          limitBookingCounts
                        )
                        console.log('chkStatus', chkStatus)
                        if (chkStatus.status) {
                          this.editDataSelectSubmit()
                        } else {
                          this.$swal(
                            'ผิดพลาด',
                            'เวลาที่ท่านเลือกคิวเต็มแล้ว',
                            'error'
                          )
                          this.loadingEdit = false
                        }
                      } else if (
                        dueOld === dueNew &&
                        this.masBranchIDOldEdit !== this.formEdit.masBranchID
                      ) {
                        let chkStatus = await this.updateLimitBookingEdit(
                          this.formEdit,
                          this.dueDateOld,
                          this.dueDateTimeOld,
                          this.dateEdit,
                          this.timeEdit.value,
                          limitBookingCounts
                        )
                        console.log('chkStatus', chkStatus)
                        if (chkStatus.status) {
                          this.editDataSelectSubmit()
                        } else {
                          this.$swal(
                            'ผิดพลาด',
                            'เวลาที่ท่านเลือกคิวเต็มแล้ว',
                            'error'
                          )
                          this.loadingEdit = false
                        }
                      } else if (
                        dueOld === dueNew &&
                        this.masBranchIDOldEdit !== this.formEdit.masBranchID &&
                        this.flowIdOldEdit !== this.formEdit.flowId
                      ) {
                        let chkStatus = await this.updateLimitBookingEdit(
                          this.formEdit,
                          this.dueDateOld,
                          this.dueDateTimeOld,
                          this.dateEdit,
                          this.timeEdit.value,
                          limitBookingCounts
                        )
                        console.log('chkStatus', chkStatus)
                        if (chkStatus.status) {
                          this.editDataSelectSubmit()
                        } else {
                          this.$swal(
                            'ผิดพลาด',
                            'เวลาที่ท่านเลือกคิวเต็มแล้ว',
                            'error'
                          )
                          this.loadingEdit = false
                        }
                      } else {
                        this.editDataSelectSubmit()
                      }
                    } else {
                      this.editDataSelectSubmit()
                    }
                  } else {
                    this.editDataSelectSubmit()
                  }
                } else {
                  this.editDataSelectSubmit()
                }
              }
            }
          })
          .catch(error => {
            this.loadingEdit = false
            console.log('editDataSelectSubmit error', error)
          })
      } else {
        this.loadingEdit = false
      }
    },
    async editDataSelectSubmit () {
      // if (this.validEdit !== false) {
      if (this.$session.id() !== undefined) {
        let bookNoEditData = ''
        this.dataEditReady = false
        let rs = this.BookingDataItemEdit
        let Add = []
        let fielditem = this.BookingDataItemEdit
        console.log('this.BookingDataItemEdit', this.BookingDataItemEdit)
        var fastTrack = 'False'
        var extraJob = 'False'
        switch (this.formEdit.radiosRemark) {
          case 'ซ่อมปกติ':
            fastTrack = 'False'
            extraJob = 'False'
            break
          case 'ExtraJob':
            fastTrack = 'False'
            extraJob = 'True'
            break
          case 'FastTrack':
            fastTrack = 'True'
            extraJob = 'False'
            break
        }
        let storeFront = this.DataFlowNameDefault.filter(item => {
          return item.value === this.formEdit.flowId
        })
        let storeFrontCheck = ''
        if (storeFront.length > 0) {
          storeFrontCheck = storeFront[0].allData.storeFrontCheck || 'False'
        } else {
          storeFrontCheck = 'False'
        }
        for (let i = 0; i < rs.length; i++) {
          let d = rs[i]
          console.log('ddddddd.field', d.fieldName, '-', d.fieldValue)
          let update = {}
          bookNoEditData = d.bookNo
          if (d.conditionField === '' || d.conditionField === null) {
            update.fieldId = d.fieldId
            update.bookingDataId = d.bookingDataId
            update.bookingFieldId = d.bookingFieldId
            update.bookNo = d.bookNo
            update.fieldValue = (d.fieldValue || '')
              .replace(/\\/g, '\\\\').replace(/%/g, '%%')
              .replace(/'/g, "\\'")
            update.dueDate = this.dateEdit + ' ' + this.timeEdit.value
            update.timeText = this.timeEdit.text
            update.flowId = this.formEdit.flowId
            update.masBranchID = this.formEdit.masBranchID
            update.fastTrack = fastTrack
            update.extraJob = extraJob
            update.LAST_USER = this.$session.getAll().data.userName
            update.empSelect = this.empSelectEdit
            update.shopId = this.session.data.shopId
            update.address = (this.address || '')
              .replace(/%/g, '%%')
              .replace(/'/g, "\\'")
            update.addressLatLong = JSON.stringify(this.center)
            update.storeFrontCheck = storeFrontCheck
            update.statusBookingForm = 'BookingForm'
            update.timeSelect = this.timeEdit.value
            Add.push(update)
          } else {
            if (
              fielditem.filter(row => {
                return row.fieldId === parseInt(d.conditionField)
              }).length > 0
            ) {
              if (
                d.conditionValue ===
                fielditem.filter(row => {
                  return row.fieldId === parseInt(d.conditionField)
                })[0].fieldValue
              ) {
                update.fieldId = d.fieldId
                update.bookingDataId = d.bookingDataId
                update.bookingFieldId = d.bookingFieldId
                update.bookNo = d.bookNo
                update.fieldValue = (d.fieldValue || '')
                  .replace(/\\/g, '\\\\').replace(/%/g, '%%')
                  .replace(/'/g, "\\'")
                update.dueDate = this.dateEdit + ' ' + this.timeEdit.value
                update.timeText = this.timeEdit.text
                update.flowId = this.formEdit.flowId
                update.masBranchID = this.formEdit.masBranchID
                update.fastTrack = fastTrack
                update.extraJob = extraJob
                update.LAST_USER = this.$session.getAll().data.userName
                update.empSelect = this.empSelectEdit
                update.shopId = this.session.data.shopId
                update.address = (this.address || '')
                  .replace(/%/g, '%%')
                  .replace(/'/g, "\\'")
                update.addressLatLong = JSON.stringify(this.center)
                update.storeFrontCheck = storeFrontCheck
                update.statusBookingForm = 'BookingForm'
                update.timeSelect = this.timeEdit.value
                Add.push(update)
              }
            } else if (d.conditionField === 'flow') {
              if (
                parseInt(d.conditionValue) === parseInt(this.formEdit.flowId)
              ) {
                update.fieldId = d.fieldId
                update.bookingDataId = d.bookingDataId
                update.bookingFieldId = d.bookingFieldId
                update.bookNo = d.bookNo
                update.fieldValue = (d.fieldValue || '')
                  .replace(/\\/g, '\\\\').replace(/%/g, '%%')
                  .replace(/'/g, "\\'")
                update.dueDate = this.dateEdit + ' ' + this.timeEdit.value
                update.timeText = this.timeEdit.text
                update.flowId = this.formEdit.flowId
                update.masBranchID = this.formEdit.masBranchID
                update.fastTrack = fastTrack
                update.extraJob = extraJob
                update.LAST_USER = this.$session.getAll().data.userName
                update.empSelect = this.empSelectEdit
                update.shopId = this.session.data.shopId
                update.address = (this.address || '')
                  .replace(/%/g, '%%')
                  .replace(/'/g, "\\'")
                update.addressLatLong = JSON.stringify(this.center)
                update.storeFrontCheck = storeFrontCheck
                update.statusBookingForm = 'BookingForm'
                update.timeSelect = this.timeEdit.value
                Add.push(update)
              }
            }
          }
        }
        console.log('Add', Add)
        // this.swalConfig.title = 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?'
        // this.$swal(this.swalConfig)
        //   .then(async result => {
        await axios
          .post(
            // eslint-disable-next-line quotes
            this.$DNS_IP + "/BookingData/editAdmin",
            Add
          )
          .then(async response => {
            if (this.statusSearch === 'no') {
              await this.getBookingList()
            } else {
              await this.searchAny()
            }
            console.log('statusGoogleCalendar', this.statusGoogleCalendar)
            if (this.statusGoogleCalendar === 'True') {
              this.connectGoogleCalendar('Edit', Add[0].bookNo)
            }
            // this.getTimesChange('update')
            this.formEdit.radiosRemark = ''
            if (this.getSelectText) {
              this.getSelect(
                this.getSelectText,
                this.getSelectCount,
                this.filterCloseJobValue
              )
            }
            if (this.getSelectText === 'confirm') {
              this.pushMsgConfirmEditDataTime(bookNoEditData)
            }
            // this.getDataCalendaBooking()
            this.dialogEditData = false
            this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
            this.dataEditReady = true
            this.loadingEdit = false
          })
          .catch(error => {
            // this.dataEditReady = true
            setTimeout(() => this.editDataSelectSubmit(), 3000)
            console.log('close alert : ', error)
          })
      } else {
        this.$swal('ผิดพลาด', 'กรุณาลองอีกครั้ง', 'error')
        clearInterval(this.setTimerCalendar)
        this.setTimerCalendar = null
        this.$router.push('/Core/Login')
      }
      // }
    },
    async getDataCalendaBooking () {
      console.log('this.$session.id()', this.$session.id())
      if (this.$session.id() !== undefined) {
        console.log('getDataCalendaBooking')
        try {
          // เอาค่าที่เลือกตอน onChange v-autocomplete ในส่วน component CalendarBooking ที่อยู่ในหน้า BookingListBeauty ส่งไปที่ component CalendarBooking function: getDataReturn
          await this.$refs.CalendarBooking.getDataReturn(
            this.selectOnsite,
            this.dateStart,
            this.masBranchID,
            this.flowSelect
          )
        } catch (e) {
          console.log(e)
        }
        // this.$refs.CalendarBooking.getDataBranch()
        // this.$refs.CalendarBooking.getBookingList()
      } else {
        this.$swal('ผิดพลาด', 'กรุณาลองอีกครั้ง', 'error')
        clearInterval(this.setTimerCalendar)
        this.setTimerCalendar = null
        this.$router.push('/Core/Login')
      }
    },
    async getDataCalendaBookingAdd () {
      console.log('this.$session.id()', this.$session.id())
      if (this.$session.id() !== undefined) {
        console.log('getDataCalendaBooking')
        let masBranchID = this.formAdd.masBranchID
        let flowSelect = this.formAdd.flowId
        console.log('masBranchID', masBranchID)
        console.log('flowSelect', flowSelect)
        try {
          // เอาค่าที่เลือกตอน onChange v-autocomplete (formAdd) หน้า BookingListBeauty (ตอนเพิ่มรายการนัดหมาย) ส่งไปที่ component CalendarBooking function: getDataReturn
          await this.$refs.CalendarBooking.getDataReturn(
            this.selectOnsite,
            this.dateStart,
            masBranchID,
            flowSelect
          )
        } catch (e) {
          console.log(e)
        }
        // this.$refs.CalendarBooking.getDataBranch()
        // this.$refs.CalendarBooking.getBookingList()
      } else {
        this.$swal('ผิดพลาด', 'กรุณาลองอีกครั้ง', 'error')
        clearInterval(this.setTimerCalendar)
        this.setTimerCalendar = null
        this.$router.push('/Core/Login')
      }
    },
    async addDataSet () {
      this.statusdepositPrice = false
      this.datailLinkDeposit = ''
      this.remark = ''
      let _this = this
      this.setTimerCalendar = setInterval(function () {
        _this.getDataCalendaBookingAdd()
      }, 20000)
      // var _this = this
      // this.setTimerCalendar = setInterval(function () { _this.getDataCalendaBooking() }, 30000)
      await this.resetFormAdd()
      this.dialogAdd = true
      setTimeout(() => this.getDataCalendaBookingAdd(), 1000)
      if (this.branch.length === 0) {
        this.getDataBranch()
      }
      this.getBookingField()
      this.checkTime()
      this.setFlowAdd()
      if (this.$session.getAll().data.shopId === this.shopNameData.yara && this.$session.getAll().data.USER_ROLE === 'user') {
        this.empSelectAdd = parseInt(this.$session.getAll().data.empId)
      }
      this.$refs.CalendarBooking.setdataReturnReady()
    },
    async resetFormAdd () {
      this.formAdd = {
        bookingId: null,
        fieldId: '',
        fieldValue: '',
        flowId: null,
        masBranchID: null,
        dueDate: '',
        shopId: this.$session.getAll().data.shopId,
        bookingFieldId: '',
        radiosRemark: '',
        depositStatus: '',
        depositImge: '',
        pictureUrlPreviewDeposit: '',
        depositPrice: 0
      }
    },
    async getDataDefault () {
      this.loadingRefresh = true
      this.$route.query.bookNoNoti = 'None'
      this.searchAll2 = ''
      await this.getDataBranch()
      await this.getEmpSelectAdd()
      this.getCustomFieldStart()
      await this.getDataFlow()
      await this.getBookingList()
      // await this.getTimesChange('update')
      this.getSelect(
        this.getSelectText,
        this.getSelectCount,
        this.filterCloseJobValue
      )
      // this.getDataCalendaBooking()
      this.loadingRefresh = false
    },
    async getDataSetTime () {
      if (this.statusSearch === 'no') {
        await this.getBookingList()
      } else {
        await this.searchAny()
      }
      // await this.getTimesChange('update')
      if (this.getSelectText) {
        this.getSelect(
          this.getSelectText,
          this.getSelectCount,
          this.filterCloseJobValue
        )
      }
    },
    checkTime () {
      this.timeavailable = []
      let dtTime = this.dataFlowSelectAdd.filter(item => {
        return item.value === this.formAdd.flowId
      })
      if (dtTime.length > 0) {
        if (dtTime[0].menuShowStatus === 'True') {
          this.showMenu = 'True'
          this.dataMenuAdd = JSON.parse(dtTime[0].allData.menuItem) || []
        } else {
          this.showMenu = 'False'
          this.dataMenuAdd = []
        }
        // let dtTime = this.branch.filter(item => { return item.value === this.formAdd.masBranchID })
        // console.log('test', dtTime)
        // this.timeavailable = JSON.parse(dtTime.map(item => item.allData.setTime))
        // console.log('timevailable', this.timeavailable)
        if (dtTime.map(item => item.allData.setTime) === null) {
          this.timeavailable = []
          // this.$swal('แจ้งเตือน', 'เนื่องจากยังไม่ได้ตั้งค่าเวลา', 'info')
        } else {
          this.timeavailable = JSON.parse(
            dtTime.map(item => item.allData.setTime)
          )
        }
      }
    },
    checkTimeEdit () {
      this.timeavailable = []
      let dtTime = this.dataFlowSelectEdit.filter(item => {
        return item.value === this.formEdit.flowId
      })
      if (dtTime.length > 0) {
        if (dtTime[0].menuShowStatus === 'True') {
          this.showMenu = 'True'
          this.dataMenuEdit = JSON.parse(dtTime[0].allData.menuItem) || []
        } else {
          this.showMenu = 'False'
          this.dataMenuEdit = []
        }
        // let dtTime = this.branch.filter(item => { return item.value === this.formEdit.masBranchID })
        // console.log('test', dtTime)
        // this.timeavailable = JSON.parse(dtTime.map(item => item.allData.setTime))
        // console.log('timevailable', this.timeavailable)
        if (dtTime.map(item => item.allData.setTime) === null) {
          this.timeavailable = []
          // this.$swal('แจ้งเตือน', 'เนื่องจากยังไม่ได้ตั้งค่าเวลา', 'info')
        } else {
          this.timeavailable = JSON.parse(
            dtTime.map(item => item.allData.setTime)
          )
        }
      }
    },
    checkTimeFlow (dt) {
      this.timeavailable = []
      // let dtTime = this.branch.filter(item => { return item.value === this.masBranchID })
      let dtTime = this.DataFlowNameDefault.filter(item => {
        return item.value === dt.flowId
      })
      // console.log('dtTime', dtTime)
      if (dtTime.length > 0) {
        console.log(
          'dtTime',
          dtTime.filter(item => item.allData.setTime)
        )
        if (dtTime.filter(item => item.allData.setTime).length > 0) {
          if (dtTime.filter(item => item.allData.setTime)[0] === null) {
            this.timeavailable = []
            // this.$swal('แจ้งเตือน', 'เนื่องจากยังไม่ได้ตั้งค่าเวลา', 'info')
          } else {
            this.timeavailable = JSON.parse(
              dtTime.map(item => item.allData.setTime)
            )
          }
        } else {
          this.timeavailable = []
        }
      } else {
        this.timeavailable = []
      }
    },
    async getCountFastTrack (dateS, flowId, branch) {
      let result = []
      let dateSelect = ''
      if (dateS) {
        dateSelect = this.momenDate_1(dateS)
      } else {
        dateSelect = moment().format('YYYY-MM-DD')
      }
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.$DNS_IP +
            '/booking_view/getCountFastTrack?shopId=' +
            this.session.data.shopId +
            '&masBranchID=' +
            branch +
            '&dueDate=' +
            dateSelect +
            '&flowId=' +
            flowId +
            '&fastTrack=True' +
            this.selectOnsite
        )
        .then(async response => {
          console.log(
            'response.data[0].countFastTrack',
            response.data[0].countFastTrack
          )
          if (response.data.status === false) {
            result = 'ไม่มีข้อมูล'
          } else {
            result = response.data[0].countFastTrack
          }
        })
      return result
    },
    async confirmRemark (item, text) {
      console.log('item', item)
      let dt = null
      let errorMessage = ''
      if (text === 'inAdvance') {
        dt = {
          remarkConfirm1: item.remarkConfirm1,
          LAST_USER: this.session.data.userName
        }
      } else if (text === 'inDay') {
        dt = {
          remarkConfirm2: item.remarkConfirm2,
          LAST_USER: this.session.data.userName
        }
      } else if (text === 'extraJob') {
        dt = {
          fastTrack: item.extraJob ? false : item.fastTrack,
          extraJob: item.extraJob,
          LAST_USER: this.session.data.userName
        }
      } else if (text === 'fastTrack') {
        if (item.fastTrack === true) {
          let getcount = await this.getCountFastTrack(
            item.dueDate,
            this.flowSelect,
            this.masBranchID
          )
          let setCountFast = this.branch.filter(el => {
            return el.value === this.masBranchID
          })[0].allData.countFastTrack
          console.log('getcount', getcount)
          console.log('setCountFast', setCountFast)
          if (getcount < setCountFast) {
            dt = {
              extraJob: item.fastTrack ? false : item.extraJob,
              fastTrack: item.fastTrack,
              LAST_USER: this.session.data.userName
            }
          } else {
            dt = null
            item.fastTrack = false
            errorMessage = 'จำนวนงานด่วนต่อวัน เกินกว่าที่ตั้งไว้'
          }
        } else {
          dt = {
            extraJob: item.fastTrack ? false : item.extraJob,
            fastTrack: item.fastTrack,
            LAST_USER: this.session.data.userName
          }
        }
      }
      if (dt) {
        await axios
          .post(this.$DNS_IP + '/Booking/edit/' + item.bookNo, dt)
          .then(async response => {
            if (this.statusSearch === 'no') {
              await this.getBookingList()
            } else {
              await this.searchAny()
            }
            // this.getTimesChange('update')
            if (this.getSelectText) {
              this.getSelect(
                this.getSelectText,
                this.getSelectCount,
                this.filterCloseJobValue
              )
            }
            console.log(
              'getSelectText',
              this.getSelectText,
              this.getSelectCount
            )
          })
          .catch(error => {
            console.log('error function addData : ', error)
          })
      } else {
        this.$swal('ผิดพลาด', errorMessage, 'error')
      }
    },
    exportExcelMazda () {
      const url = `${window.location.origin}/mazda/report?shopId=${this.session.data.shopId}&masBranchID=${this.masBranchID}&timeTable=${this.timeTable}${this.selectOnsite}`
      window.open(url, '_blank').focus()
    },
    async getCallLog (others) {
      let callLog = []
      let url = `${this.$DNS_IP}/callLog/get?shopId=${this.session.data.shopId}&masBranchID=${this.masBranchID}` + others
      await axios
        .get(url)
        .then(async response => {
          if (response.data.status !== false) {
            response.data.forEach(row => {
              if (!callLog[row.bookNo]) {
                callLog[row.bookNo] = Object.assign({}, row, { remarks_sum: row.callDateTime + ' : ' + row.remark })
              } else {
                callLog[row.bookNo].remarks_sum += ' | ' + row.callDateTime + ' : ' + row.remark
              }
            })
          }
        })
        .catch(error => {
          callLog = []
          console.log(error)
        })
      return callLog
    },
    exportExcel () {
      let dataExport = []
      this.dataexport = []
      let runNo = 0
      var datause = this.dataItemTime.sort((a, b) => {
        if (a.timeDuetext < b.timeDuetext) return -1
        return a.timeDuetext > b.timeDuetext ? 1 : 0
      })
      console.log('datause1', datause)
      for (let i = 0; i < datause.length; i++) {
        // var d = this.dataItemTimesChange.filter(el => { return el.timeDueHtext === item.timeDueHtext })[i]
        let d = datause[i]
        let dataSelect = this.dataItemTimesChange.filter(el => {
          return (
            el.timeDueHtext === d.timeDueHtext &&
            el.fastTrack &&
            (el.statusBtText === 'ยืนยันแล้ว' ||
              el.statusBtText === 'รับรถแล้ว')
          )
        })
        // console.log('s.dataSelect', dataSelect)
        if (dataSelect.length > 0) {
          var datauseSelect = dataSelect.sort((a, b) => {
            if (a.dueDateTimeStamp < b.dueDateTimeStamp) return -1
            return a.dueDateTimeStamp > b.dueDateTimeStamp ? 1 : 0
          })
          console.log('datauseSelect', datauseSelect)
          for (let x = 0; x < datauseSelect.length; x++) {
            runNo++
            let t = datauseSelect[x]
            let s = {}
            // console.log('fastTrack')
            // console.log('s.t', t)
            console.log('t', t)
            if (
              dataExport.filter(el => {
                return (
                  el.timeDueHtext ===
                  this.format_dateNotime(this.timeTable) +
                    ' ' +
                    d.timeDueHtext +
                    ' ( ' +
                    dataSelect.length.toString() +
                    ' )'
                )
              }).length === 0
            ) {
              s.timeDueHtext =
                this.format_dateNotime(this.timeTable) +
                ' ' +
                d.timeDueHtext +
                ' ( ' +
                dataSelect.length.toString() +
                ' )'
            } else {
              s.timeDueHtext = ''
            }
            let serviceDetail = ''
            let fieldflow = this.editedItemSeleteField.filter(row => {
              return (
                row.conditionField === 'flow' &&
                String(row.conditionValue) === String(t.flowId)
              )
            })
            fieldflow.forEach(row => {
              let tempField = this.BookingDataListTimechange[t.bookNo].filter(
                row2 => {
                  return String(row2.fieldId) === String(row.fieldId)
                }
              )
              // serviceDetail += (tempField.length > 0 ? tempField[0].fieldValue + ' ' : '')
              let convertTextField = ''
              if (tempField.length > 0) {
                // console.log('fieldType', row.fieldType)
                if (
                  row.fieldType === 'Selects' ||
                  row.fieldType === 'Autocompletes' ||
                  row.fieldType === 'Radio'
                ) {
                  // console.log('optionField', row.optionField)
                  // console.log('fieldValue', tempField[0].fieldValue)
                  if (tempField[0].fieldValue) {
                    convertTextField = JSON.parse(row.optionField).filter(
                      el => {
                        return el.value === tempField[0].fieldValue
                      }
                    )[0].text
                  } else {
                    convertTextField = tempField[0].fieldValue
                  }
                } else {
                  convertTextField = tempField[0].fieldValue
                }
              }
              // console.log('convertTextField', convertTextField)
              serviceDetail +=
                tempField.length > 0 ? convertTextField + ' ' : ''
            })
            serviceDetail = serviceDetail.trim() || t.flowName
            console.log('serviceDetail', serviceDetail)
            s.bookNo = t.bookNo
            s.type = this.dataTypeJob3
            s.runNo = runNo
            s.dateBooking = this.format_dateNotime(this.timeTable)
            s.licenseNo = t.cusReg
            s.title = t.timeDuetext
            s.status = t.statusBtText
            s.remark = t.remark
            s.cusName = t.cusName
            s.cusReg = t.cusReg
            // s.flowName = serviceDetail
            s.flowName = t.flowName
            s.empFull_NameTH = t.empFull_NameTH
            s.extraJob = t.extraJob ? this.dataTypeJob2 : ''
            s.carModel = this.getDataFromFieldName(
              this.BookingDataListTimechange[t.bookNo],
              'รุ่นรถ'
            )
            s.carModel = s.carModel.length > 0 ? s.carModel[0].fieldValue : ''
            s.tel = t.tel
            s.dataFiled = this.BookingDataListTimechange[t.bookNo] || []
            s.packageName = t.packageName || ''
            s.packageDetails = t.packageDetails || ''
            s.packageImage = t.packageImage || ''
            s.packagePrice = t.packagePrice || ''
            s.packageBalanceAmount = t.packageBalanceAmount || ''
            s.packageAmount = t.packageAmount || ''
            s.packagePoint = t.packagePoint || ''
            s.packageExpire = t.packageExpire || ''
            s.empFull_NameTH = t.empFull_NameTH || ''
            s.statusUpload1 = t.statusUpload1 || 'False'
            s.statusUpload2 = t.statusUpload2 || 'False'
            s.fileUpload1 = t.fileUpload1 || '[]'
            s.fileUpload2 = t.fileUpload2 || '[]'
            dataExport.push(s)
          }
        }
      }
      let s = {}
      s.bookNo = ''
      s.type = ''
      s.runNo = ''
      s.licenseNo = ''
      s.title = ''
      s.status = ''
      s.cusName = ''
      s.cusReg = ''
      s.flowName = ''
      s.remark = ''
      s.tel = ''
      s.empFull_NameTH = ''
      s.carModel = ''
      s.dataFiled = []
      s.packageName = ''
      s.packageDetails = ''
      s.packageImage = ''
      s.packagePrice = ''
      s.packageBalanceAmount = ''
      s.packageAmount = ''
      s.packagePoint = ''
      s.packageExpire = ''
      s.empFull_NameTH = ''
      s.statusUpload1 = 'False'
      s.statusUpload2 = 'False'
      s.fileUpload1 = '[]'
      s.fileUpload2 = '[]'
      dataExport.push(s)
      runNo = 0
      var datause2 = this.dataItemTime.sort((a, b) => {
        if (a.timeDuetext < b.timeDuetext) return -1
        return a.timeDuetext > b.timeDuetext ? 1 : 0
      })
      for (let i = 0; i < datause2.length; i++) {
        let d = datause2[i]
        let dataSelect = this.dataItemTimesChange.filter(el => {
          return (
            el.timeDueHtext === d.timeDueHtext &&
            !el.fastTrack &&
            (el.statusBtText === 'ยืนยันแล้ว' ||
              el.statusBtText === 'รับรถแล้ว')
          )
        })
        // console.log('s.dataSelect', dataSelect)
        // console.log('this.BookingDataList', this.BookingDataListTimechange)
        if (dataSelect.length > 0) {
          var datauseSelect2 = dataSelect.sort((a, b) => {
            if (a.dueDateTimeStamp < b.dueDateTimeStamp) return -1
            return a.dueDateTimeStamp > b.dueDateTimeStamp ? 1 : 0
          })

          for (let x = 0; x < datauseSelect2.length; x++) {
            runNo++
            let t = datauseSelect2[x]
            let s = {}
            let serviceDetail = ''
            let fieldflow = this.editedItemSeleteField.filter(row => {
              return (
                row.conditionField === 'flow' &&
                String(row.conditionValue) === String(t.flowId)
              )
            })
            fieldflow.forEach(row => {
              let tempField = this.BookingDataListTimechange[t.bookNo].filter(
                row2 => {
                  return String(row2.fieldId) === String(row.fieldId)
                }
              )
              // serviceDetail += (tempField.length > 0 ? tempField[0].fieldValue + ' ' : '')
              let convertTextField = ''
              if (tempField.length > 0) {
                // console.log('fieldType', row.fieldType)
                if (
                  row.fieldType === 'Selects' ||
                  row.fieldType === 'Autocompletes' ||
                  row.fieldType === 'Radio'
                ) {
                  // console.log('optionField', row.optionField)
                  // console.log('fieldValue', tempField[0].fieldValue)
                  if (tempField[0].fieldValue) {
                    convertTextField = JSON.parse(row.optionField).filter(
                      el => {
                        return el.value === tempField[0].fieldValue
                      }
                    )[0].text
                  } else {
                    convertTextField = tempField[0].fieldValue
                  }
                } else {
                  convertTextField = tempField[0].fieldValue
                }
              }
              // console.log('convertTextField', convertTextField)
              serviceDetail +=
                tempField.length > 0 ? convertTextField + ' ' : ''
            })
            if (
              dataExport.filter(el => {
                return (
                  el.timeDueHtext ===
                  this.format_dateNotime(this.timeTable) +
                    ' ' +
                    d.timeDueHtext +
                    ' ( ' +
                    dataSelect.length.toString() +
                    ' )'
                )
              }).length === 0
            ) {
              s.timeDueHtext =
                this.format_dateNotime(this.timeTable) +
                ' ' +
                d.timeDueHtext +
                ' ( ' +
                dataSelect.length.toString() +
                ' )'
            } else {
              s.timeDueHtext = ''
            }
            serviceDetail = serviceDetail.trim() || t.flowName
            s.bookNo = t.bookNo
            s.type = 'ปกติ'
            s.runNo = runNo
            s.dateBooking = this.format_dateNotime(this.timeTable)
            s.licenseNo = t.cusReg
            s.title = t.timeDuetext
            s.status = t.statusBtText
            s.cusName = t.cusName
            s.remark = t.remark
            s.cusReg = t.cusReg
            // s.flowName = serviceDetail
            s.flowName = t.flowName
            s.tel = t.tel
            s.empFull_NameTH = t.empFull_NameTH
            s.extraJob = t.extraJob ? 'Extra Job' : ''
            s.carModel = this.getDataFromFieldName(
              this.BookingDataListTimechange[t.bookNo],
              'รุ่นรถ'
            )
            s.carModel = s.carModel.length > 0 ? s.carModel[0].fieldValue : ''
            s.dataFiled = this.BookingDataListTimechange[t.bookNo] || []
            s.packageName = t.packageName || ''
            s.packageDetails = t.packageDetails || ''
            s.packageImage = t.packageImage || ''
            s.packagePrice = t.packagePrice || ''
            s.packageBalanceAmount = t.packageBalanceAmount || ''
            s.packageAmount = t.packageAmount || ''
            s.packagePoint = t.packagePoint || ''
            s.packageExpire = t.packageExpire || ''
            s.empFull_NameTH = t.empFull_NameTH || ''
            s.statusUpload1 = t.statusUpload1 || 'False'
            s.statusUpload2 = t.statusUpload2 || 'False'
            s.fileUpload1 = t.fileUpload1 || '[]'
            s.fileUpload2 = t.fileUpload2 || '[]'
            dataExport.push(s)
            // console.log('t', t)
          }
        }
      }
      this.dataexport = dataExport
      console.log('this.dataexport => ', this.dataexport)
      this.onExport()
      // console.log('dataEport', JSON.stringify(dataExport))
    },
    async onExport () {
      var dataexport = []
      let checkPackageShow = this.dataexport.filter(el => {
        return el.packageName !== ''
      }).length
      let dataCallLog = []
      if (this.session.data.shopId === 'Ucd377d0dd363c1360b3a4149fdb0c447') {
        dataCallLog = await this.getCallLog('&dueDate=' + this.dateStart)
      }
      for (var i = 0; i < this.dataexport.length; i++) {
        var a = this.dataexport[i]
        let data2 = {}
        let countKey = 1
        for (let g = 0; g < a.dataFiled.length; g++) {
          let t = a.dataFiled[g]
          let fieldNames = ''
          let fieldValues = ''
          fieldNames = t.fieldName
          fieldValues = t.fieldValue
          // data2[fieldNames] = fieldValues
          if (this.session.data.shopId === 'U753e6614793b89cffd5461cb76047d1c') {
            if (t.fieldName.trim() === 'กรุณากรอกเลข') {
              data2[fieldNames.trim() + countKey] = fieldValues
              countKey++
            } else {
              data2[fieldNames] = fieldValues
            }
          } else {
            data2[fieldNames] = fieldValues
          }
          // dataOb.push({fieldNames: fieldValues})
          // console.log('G', t)
        }
        console.log('a', a)
        let data1 = {
          ประเภท: a.type,
          ลำดับ: a.runNo,
          วันที่: a.dateBooking,
          เวลา: a.title,
          // 'ชื่อลูกค้า': a.cusName,
          รายการบริการ: a.flowName,
          หมายเหตุ: a.remark,
          // 'หมายเหตุยกเลิก': a.remarkRemove,
          // 'เวลาติดตาม': '',
          // 'เหตุผล': '',
          // 'ตรง': '',
          // 'ไม่ตรง': '',
          // 'เปิดJob': '',
          พนักงานรับนัดหมาย: a.empFull_NameTH
          // 'หมายเหตุเพิ่มเติม': a.remark
        }
        let data4 = {}
        let fileUpload = []
        if (a.statusUpload1 === 'True') {
          let jsDT1 = JSON.parse(a.fileUpload1)
          // console.log('jsDT1', jsDT1, jsDT1.length)
          if (jsDT1.length > 0) {
            for (let element = 0; element < jsDT1.length; element++) {
              let dt = jsDT1[element]
              // console.log('dt1', dt)
              fileUpload.push(dt)
              // data1[`fileUpdate${element + 1}`] = dt
            }
          }
        }
        if (a.statusUpload2 === 'True') {
          let jsDT2 = JSON.parse(a.fileUpload2)
          console.log('jsDT2', jsDT2)
          if (jsDT2.length > 0) {
            for (let element = 0; element < jsDT2.length; element++) {
              let dt = jsDT2[element]
              // console.log('dt2', dt)
              // data1[`fileUpdate${element + 1}`] = dt
              fileUpload.push(dt)
            }
          }
        }
        if (fileUpload.length > 0) {
          for (let element = 0; element < fileUpload.length; element++) {
            let dt = fileUpload[element]
            data4[`fileUpload${element + 1}`] = dt
          }
        }
        let data5 = {}
        if (this.session.data.shopId === 'Ucd377d0dd363c1360b3a4149fdb0c447') {
          if (dataCallLog[a.bookNo]) {
            data5 = {
              'บันทึกการโทร': dataCallLog[a.bookNo].remarks_sum
            }
          }
        }
        if (checkPackageShow > 0) {
          let data3 = {
            แพ็คเกจที่ใช้: a.packageName,
            จำนวนการใช้ที่เหลือ: a.packageBalanceAmount,
            จำนวนการใช้ทั้งหมด: a.packageAmount,
            พนักงานที่รับนัดหมาย: a.empFull_NameTH
          }
          let dataSum = null
          if (fileUpload.length > 0) {
            dataSum = Object.assign({}, data1, data2, data4, data3, data5)
          } else {
            dataSum = Object.assign({}, data1, data2, data3, data5)
          }
          dataexport.push(dataSum)
        } else {
          let dataSum = null
          if (fileUpload.length > 0) {
            dataSum = Object.assign({}, data1, data2, data4, data5)
          } else {
            dataSum = Object.assign({}, data1, data2, data5)
          }
          dataexport.push(dataSum)
        }
      }
      console.log('dataexport', dataexport)
      const dataWS = XLSX.utils.json_to_sheet(dataexport)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(
        wb,
        'export_' + this.format_dateNotime(this.timeTable) + '.xlsx'
      )
    },
    async exportConfirmJob () {
      let dataExport = []
      let bookingDataView = []
      this.dataexport = []
      let runNo = 0
      var datause = this.filteredSelect.sort((a, b) => {
        if (a.timeDuetext < b.timeDuetext) return -1
        return a.timeDuetext > b.timeDuetext ? 1 : 0
      })
      let url = `${this.$DNS_IP}/BookingData/getView?shopId=${this.session.data.shopId}&masBranchID=${this.masBranchID}&statusBt=confirmJob&dueDate=${this.dateStart}`
      await axios
        .get(url)
        .then(async response => {
          if (response.data.status !== false) {
            response.data.forEach(row => {
              if (typeof bookingDataView[row.bookNo] === 'undefined') {
                bookingDataView[row.bookNo] = []
              }
              bookingDataView[row.bookNo].push(row)
            })
          }
        })
        .catch(error => {
          bookingDataView = []
          console.log(error)
        })
      console.log('datause', datause)
      for (let i = 0; i < datause.length; i++) {
        runNo++
        let t = datause[i]
        let s = {}
        if (t.fastTrack) {
          s.type = this.dataTypeJob3
          s.runNo = runNo
          s.dateBooking = t.dueDateDay
          s.licenseNo = t.cusReg
          s.title = t.timeDuetext + (t.dueDateEnd || '')
          s.status = t.statusBtText
          s.remark = t.remark
          s.cusName = t.cusName
          s.cusReg = t.cusReg
          s.flowName = t.displayFlowName
            ? t.flowName + ' : ' + t.displayFlowName
            : t.flowName
          // s.flowName = t.flowName
          s.empFull_NameTH = t.empFull_NameTH
          s.extraJob = t.extraJob ? this.dataTypeJob2 : ''
          // s.carModel = this.getDataFromFieldName(this.BookingDataListTimechange[t.bookNo], 'รุ่นรถ')
          // s.carModel = (s.carModel.length > 0) ? s.carModel[0].fieldValue : ''
          s.carModel = t.bookingDataCustomerCarModel || ''
          s.tel = t.tel
          s.dataFiled = bookingDataView[t.bookNo] || []
          s.packageName = t.packageName || ''
          s.packageDetails = t.packageDetails || ''
          s.packageImage = t.packageImage || ''
          s.packagePrice = t.packagePrice || ''
          s.packageBalanceAmount = t.packageBalanceAmount || ''
          s.packageAmount = t.packageAmount || ''
          s.packagePoint = t.packagePoint || ''
          s.packageExpire = t.packageExpire || ''
          s.memberName = t.memberName || ''
          s.statusUpload1 = t.statusUpload1 || 'False'
          s.statusUpload2 = t.statusUpload2 || 'False'
          s.fileUpload1 = t.fileUpload1 || '[]'
          s.fileUpload2 = t.fileUpload2 || '[]'
          if (this.$session.getAll().data.shopId === this.shopNameData.yara) {
            s.remarkQueue = t.remarkQueue
          }
          dataExport.push(s)
        }
      }
      console.log('dataExport', dataExport)
      let s = {}
      s.memberName = ''
      s.type = ''
      s.runNo = ''
      s.licenseNo = ''
      s.title = ''
      s.status = ''
      s.cusName = ''
      s.bookingEmpFlowName = ''
      s.cusReg = ''
      s.flowName = ''
      s.remark = ''
      s.tel = ''
      s.empFull_NameTH = ''
      s.carModel = ''
      s.dataFiled = []
      s.packageName = ''
      s.packageDetails = ''
      s.packageImage = ''
      s.packagePrice = ''
      s.packageBalanceAmount = ''
      s.packageAmount = ''
      s.packagePoint = ''
      s.packageExpire = ''
      s.empFull_NameTH = ''
      s.statusUpload1 = 'False'
      s.statusUpload2 = 'False'
      s.fileUpload1 = '[]'
      s.fileUpload2 = '[]'
      dataExport.push(s)
      runNo = 0
      var datause2 = this.filteredSelect.sort((a, b) => {
        if (a.timeDuetext < b.timeDuetext) return -1
        return a.timeDuetext > b.timeDuetext ? 1 : 0
      })
      for (let i = 0; i < datause2.length; i++) {
        runNo++
        let t = datause2[i]
        let s = {}
        if (!t.fastTrack) {
          s.type = 'ปกติ'
          s.runNo = runNo
          s.dateBooking = t.dueDateDay
          s.licenseNo = t.cusReg
          s.title = t.timeDuetext + (t.dueDateEnd || '')
          s.status = t.statusBtText
          s.cusName = t.cusName
          s.bookingEmpFlowName = t.bookingEmpFlowName
          s.remark = t.remark
          s.cusReg = t.cusReg
          s.flowName = t.displayFlowName
            ? t.flowName + ' : ' + t.displayFlowName
            : t.flowName
          // s.flowName = t.flowName
          s.tel = t.tel
          s.empFull_NameTH = t.empFull_NameTH
          s.extraJob = t.extraJob ? 'Extra Job' : ''
          s.carModel = t.bookingDataCustomerCarModel || ''
          s.dataFiled = bookingDataView[t.bookNo] || []
          s.packageName = t.packageName || ''
          s.packageDetails = t.packageDetails || ''
          s.packageImage = t.packageImage || ''
          s.packagePrice = t.packagePrice || ''
          s.packageBalanceAmount = t.packageBalanceAmount || ''
          s.packageAmount = t.packageAmount || ''
          s.packagePoint = t.packagePoint || ''
          s.packageExpire = t.packageExpire || ''
          s.memberName = t.memberName || ''
          s.statusUpload1 = t.statusUpload1 || 'False'
          s.statusUpload2 = t.statusUpload2 || 'False'
          s.fileUpload1 = t.fileUpload1 || '[]'
          s.fileUpload2 = t.fileUpload2 || '[]'
          if (this.$session.getAll().data.shopId === this.shopNameData.yara) {
            s.remarkQueue = t.remarkQueue
          }
          dataExport.push(s)
        }
      }
      this.dataexport = dataExport
      this.onExportConfirmJob()
    },
    async exportExcelWait () {
      let dataExport = []
      let bookingDataView = []
      this.dataexport = []
      let runNo = 0
      var datause = this.filteredSelect.sort((a, b) => {
        if (a.timeDuetext < b.timeDuetext) return -1
        return a.timeDuetext > b.timeDuetext ? 1 : 0
      })
      console.log('dataUse', datause)
      let url = `${this.$DNS_IP}/BookingData/getView?shopId=${this.session.data.shopId}&masBranchID=${this.masBranchID}&statusBt=is null`
      await axios
        .get(url)
        .then(async response => {
          if (response.data.status !== false) {
            response.data.forEach(row => {
              if (typeof bookingDataView[row.bookNo] === 'undefined') {
                bookingDataView[row.bookNo] = []
              }
              bookingDataView[row.bookNo].push(row)
            })
          }
        })
        .catch(error => {
          bookingDataView = []
          console.log(error)
        })
      for (let i = 0; i < datause.length; i++) {
        runNo++
        let t = datause[i]
        let s = {}
        if (t.fastTrack) {
          s.type = this.dataTypeJob3
          s.runNo = runNo
          s.dateBooking = t.dueDateDay
          s.licenseNo = t.cusReg
          s.title = t.timeDuetext
          s.status = t.statusBtText
          s.remark = t.remark
          s.cusName = t.cusName
          s.cusReg = t.cusReg
          s.flowName = t.displayFlowName
            ? t.flowName + ' : ' + t.displayFlowName
            : t.flowName
          // s.flowName = t.flowName
          s.empFull_NameTH = t.empFull_NameTH
          s.extraJob = t.extraJob ? this.dataTypeJob2 : ''
          s.carModel = t.bookingDataCustomerCarModel || ''
          s.tel = t.tel
          s.dataFiled = bookingDataView[t.bookNo] || []
          s.packageName = t.packageName || ''
          s.packageDetails = t.packageDetails || ''
          s.packageImage = t.packageImage || ''
          s.packagePrice = t.packagePrice || ''
          s.packageBalanceAmount = t.packageBalanceAmount || ''
          s.packageAmount = t.packageAmount || ''
          s.packagePoint = t.packagePoint || ''
          s.packageExpire = t.packageExpire || ''
          s.memberName = t.memberName || ''
          s.statusUpload1 = t.statusUpload1 || 'False'
          s.statusUpload2 = t.statusUpload2 || 'False'
          s.fileUpload1 = t.fileUpload1 || '[]'
          s.fileUpload2 = t.fileUpload2 || '[]'
          dataExport.push(s)
        }
      }
      let s = {}
      s.memberName = ''
      s.type = ''
      s.runNo = ''
      s.licenseNo = ''
      s.title = ''
      s.status = ''
      s.cusName = ''
      s.cusReg = ''
      s.flowName = ''
      s.remark = ''
      s.tel = ''
      s.empFull_NameTH = ''
      s.carModel = ''
      s.dataFiled = []
      s.packageName = ''
      s.packageDetails = ''
      s.packageImage = ''
      s.packagePrice = ''
      s.packageBalanceAmount = ''
      s.packageAmount = ''
      s.packagePoint = ''
      s.packageExpire = ''
      s.empFull_NameTH = ''
      s.statusUpload1 = 'False'
      s.statusUpload2 = 'False'
      s.fileUpload1 = '[]'
      s.fileUpload2 = '[]'
      dataExport.push(s)
      runNo = 0
      var datause2 = this.filteredSelect.sort((a, b) => {
        if (a.timeDuetext < b.timeDuetext) return -1
        return a.timeDuetext > b.timeDuetext ? 1 : 0
      })
      for (let i = 0; i < datause2.length; i++) {
        runNo++
        let t = datause2[i]
        let s = {}
        if (!t.fastTrack) {
          s.type = 'ปกติ'
          s.runNo = runNo
          s.dateBooking = t.dueDateDay
          s.licenseNo = t.cusReg
          s.title = t.timeDuetext
          s.status = t.statusBtText
          s.cusName = t.cusName
          s.remark = t.remark
          s.cusReg = t.cusReg
          s.flowName = t.displayFlowName
            ? t.flowName + ' : ' + t.displayFlowName
            : t.flowName
          // s.flowName = t.flowName
          s.tel = t.tel
          s.empFull_NameTH = t.empFull_NameTH
          s.extraJob = t.extraJob ? 'Extra Job' : ''
          s.carModel = t.bookingDataCustomerCarModel || ''
          s.dataFiled = bookingDataView[t.bookNo] || []
          s.packageName = t.packageName || ''
          s.packageDetails = t.packageDetails || ''
          s.packageImage = t.packageImage || ''
          s.packagePrice = t.packagePrice || ''
          s.packageBalanceAmount = t.packageBalanceAmount || ''
          s.packageAmount = t.packageAmount || ''
          s.packagePoint = t.packagePoint || ''
          s.packageExpire = t.packageExpire || ''
          s.memberName = t.memberName || ''
          s.statusUpload1 = t.statusUpload1 || 'False'
          s.statusUpload2 = t.statusUpload2 || 'False'
          s.fileUpload1 = t.fileUpload1 || '[]'
          s.fileUpload2 = t.fileUpload2 || '[]'
          dataExport.push(s)
        }
      }
      console.log('!@#!@#!@#!@#!@#', dataExport)
      this.dataexport = dataExport
      this.onExportWait()
      // console.log('dataEport', JSON.stringify(dataExport))
    },
    onExportWait () {
      var dataexport = []
      console.log(
        '!!!!',
        this.dataexport.filter(el => {
          return el.packageName !== ''
        })
      )
      let checkPackageShow = this.dataexport.filter(el => {
        return el.packageName !== ''
      }).length
      console.log('checkPackageShow', checkPackageShow)
      for (var i = 0; i < this.dataexport.length; i++) {
        var a = this.dataexport[i]
        let data2 = {}
        let countKey = 1
        for (let g = 0; g < a.dataFiled.length; g++) {
          let t = a.dataFiled[g]
          let fieldNames = ''
          let fieldValues = ''
          fieldNames = t.fieldName
          if (t.fieldType === 'Checkbox') {
            try {
            // ตรวจสอบว่า t.fieldValue เป็นสตริงและแปลงเป็นอาร์เรย์หากจำเป็น
              const arrayValue = typeof t.fieldValue === 'string' ? JSON.parse(t.fieldValue) : t.fieldValue

              // ถ้าเป็นอาร์เรย์ ให้แปลงเป็นสตริงที่คั่นด้วยจุลภาค
              if (Array.isArray(arrayValue)) {
                t.fieldValue = arrayValue.join(',') // แปลงเป็นสตริงคั่นด้วยจุลภาค
              } else {
                console.warn('t.fieldValue is not an array:', t.fieldValue)
              }
            } catch (error) {
              console.error('Error parsing t.fieldValue:', error)
            }

            // console.log('ttttttttttt', t.fieldValue)
          }
          fieldValues = t.fieldValue
          // data2[fieldNames] = fieldValues
          if (this.session.data.shopId === 'U753e6614793b89cffd5461cb76047d1c') {
            if (t.fieldName.trim() === 'กรุณากรอกเลข') {
              data2[fieldNames.trim() + countKey] = fieldValues
              countKey++
            } else {
              data2[fieldNames] = fieldValues
            }
          } else {
            data2[fieldNames] = fieldValues
          }
          // dataOb.push({fieldNames: fieldValues})
        }
        let data1 = {
          ประเภท: a.type,
          ลำดับ: a.runNo,
          วันที่: a.dateBooking,
          เวลา: a.title,
          // 'ชื่อลูกค้า': a.cusName,
          รายการบริการ: a.flowName,
          // 'หมายเหตุ': a.extraJob,
          // 'หมายเหตุยกเลิก': a.remarkRemove,
          // 'เวลาติดตาม': '',
          // 'เหตุผล': '',
          // 'ตรง': '',
          // 'ไม่ตรง': '',
          // 'เปิดJob': '',
          พนักงานรับนัดหมาย: a.empFull_NameTH,
          'ชื่อ LINE': a.memberName
          // 'หมายเหตุเพิ่มเติม': a.remark
        }
        let data4 = {}
        let fileUpload = []
        if (a.statusUpload1 === 'True') {
          let jsDT1 = JSON.parse(a.fileUpload1)
          // console.log('jsDT1', jsDT1, jsDT1.length)
          if (jsDT1.length > 0) {
            for (let element = 0; element < jsDT1.length; element++) {
              let dt = jsDT1[element]
              // console.log('dt1', dt)
              fileUpload.push(dt)
              // data1[`fileUpdate${element + 1}`] = dt
            }
          }
        }
        if (a.statusUpload2 === 'True') {
          let jsDT2 = JSON.parse(a.fileUpload2)
          console.log('jsDT2', jsDT2)
          if (jsDT2.length > 0) {
            for (let element = 0; element < jsDT2.length; element++) {
              let dt = jsDT2[element]
              // console.log('dt2', dt)
              // data1[`fileUpdate${element + 1}`] = dt
              fileUpload.push(dt)
            }
          }
        }
        if (fileUpload.length > 0) {
          for (let element = 0; element < fileUpload.length; element++) {
            let dt = fileUpload[element]
            data4[`fileUpload${element + 1}`] = dt
          }
        }
        if (checkPackageShow > 0) {
          let data3 = {
            แพ็คเกจที่ใช้: a.packageName,
            จำนวนการใช้ที่เหลือ: a.packageBalanceAmount,
            จำนวนการใช้ทั้งหมด: a.packageAmount,
            พนักงานที่รับนัดหมาย: a.empFull_NameTH
          }
          let dataSum = null
          if (fileUpload.length > 0) {
            dataSum = Object.assign({}, data1, data2, data4, data3)
          } else {
            dataSum = Object.assign({}, data1, data2, data3)
          }
          dataexport.push(dataSum)
        } else {
          let dataSum = null
          if (fileUpload.length > 0) {
            dataSum = Object.assign({}, data1, data2, data4)
          } else {
            dataSum = Object.assign({}, data1, data2)
          }
          dataexport.push(dataSum)
        }
      }
      console.log('dataexport', dataexport)
      const dataWS = XLSX.utils.json_to_sheet(dataexport)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'รายชื่อลูกค้านัดหมาย_รอยืนยัน_' + this.dateStart + '.xlsx')
    },
    onExportConfirmJob () {
      var dataexport = []
      let checkPackageShow = this.dataexport.filter(el => {
        return el.packageName !== ''
      }).length
      console.log('checkPackageShow', checkPackageShow)
      for (var i = 0; i < this.dataexport.length; i++) {
        var a = this.dataexport[i]
        let data2 = {}
        let countKey = 1
        for (let g = 0; g < a.dataFiled.length; g++) {
          let t = a.dataFiled[g]
          let fieldNames = ''
          let fieldValues = ''
          fieldNames = t.fieldName
          if (t.fieldType === 'Checkbox') {
            try {
            // ตรวจสอบว่า t.fieldValue เป็นสตริงและแปลงเป็นอาร์เรย์หากจำเป็น
              const arrayValue = typeof t.fieldValue === 'string' ? JSON.parse(t.fieldValue) : t.fieldValue

              // ถ้าเป็นอาร์เรย์ ให้แปลงเป็นสตริงที่คั่นด้วยจุลภาค
              if (Array.isArray(arrayValue)) {
                t.fieldValue = arrayValue.join(',') // แปลงเป็นสตริงคั่นด้วยจุลภาค
              } else {
                console.warn('t.fieldValue is not an array:', t.fieldValue)
              }
            } catch (error) {
              console.error('Error parsing t.fieldValue:', error)
            }

            // console.log('ttttttttttt', t.fieldValue)
          }
          fieldValues = t.fieldValue
          // data2[fieldNames] = fieldValues
          if (this.session.data.shopId === 'U753e6614793b89cffd5461cb76047d1c') {
            if (t.fieldName.trim() === 'กรุณากรอกเลข') {
              data2[fieldNames.trim() + countKey] = fieldValues
              countKey++
            } else {
              data2[fieldNames] = fieldValues
            }
          } else {
            data2[fieldNames] = fieldValues
          }
          // dataOb.push({fieldNames: fieldValues})
        }
        let data1 = {
          ประเภท: a.type,
          ลำดับ: a.runNo,
          วันที่: a.dateBooking,
          เวลา: a.title,
          // 'ชื่อลูกค้า': a.cusName,
          รายการบริการ: a.flowName,
          // 'หมายเหตุ': a.extraJob,
          // 'หมายเหตุยกเลิก': a.remarkRemove,
          // 'เวลาติดตาม': '',
          // 'เหตุผล': '',
          // 'ตรง': '',
          // 'ไม่ตรง': '',
          // 'เปิดJob': '',
          พนักงานรับนัดหมาย: a.empFull_NameTH,
          'ชื่อ LINE': a.memberName
          // 'หมายเหตุเพิ่มเติม': a.remark
        }
        if (this.$session.getAll().data.shopId === this.shopNameData.yara) {
          data1 = {
            ประเภท: a.type,
            ลำดับ: a.runNo,
            วันที่: a.dateBooking,
            เวลา: a.title,
            // 'ชื่อลูกค้า': a.cusName,
            รายการบริการ: a.flowName,
            // 'หมายเหตุ': a.extraJob,
            // 'หมายเหตุยกเลิก': a.remarkRemove,
            // 'เวลาติดตาม': '',
            // 'เหตุผล': '',
            // 'ตรง': '',
            // 'ไม่ตรง': '',
            // 'เปิดJob': '',
            พนักงานรับนัดหมาย: a.empFull_NameTH,
            'ชื่อ LINE': a.memberName,
            'หมายเลขคิว': a.remarkQueue,
            'หมายเหตุเพิ่มเติม': a.remark
          }
        }
        let data4 = {}
        let fileUpload = []
        if (a.statusUpload1 === 'True') {
          let jsDT1 = JSON.parse(a.fileUpload1)
          // console.log('jsDT1', jsDT1, jsDT1.length)
          if (jsDT1.length > 0) {
            for (let element = 0; element < jsDT1.length; element++) {
              let dt = jsDT1[element]
              // console.log('dt1', dt)
              fileUpload.push(dt)
              // data1[`fileUpdate${element + 1}`] = dt
            }
          }
        }
        if (a.statusUpload2 === 'True') {
          let jsDT2 = JSON.parse(a.fileUpload2)
          console.log('jsDT2', jsDT2)
          if (jsDT2.length > 0) {
            for (let element = 0; element < jsDT2.length; element++) {
              let dt = jsDT2[element]
              // console.log('dt2', dt)
              // data1[`fileUpdate${element + 1}`] = dt
              fileUpload.push(dt)
            }
          }
        }
        if (fileUpload.length > 0) {
          for (let element = 0; element < fileUpload.length; element++) {
            let dt = fileUpload[element]
            data4[`fileUpload${element + 1}`] = dt
          }
        }
        if (checkPackageShow > 0) {
          let data3 = {
            แพ็คเกจที่ใช้: a.packageName,
            จำนวนการใช้ที่เหลือ: a.packageBalanceAmount,
            จำนวนการใช้ทั้งหมด: a.packageAmount,
            พนักงานที่รับนัดหมาย: a.empFull_NameTH
          }
          let dataSum = null
          if (fileUpload.length > 0) {
            dataSum = Object.assign({}, data1, data2, data4, data3)
          } else {
            dataSum = Object.assign({}, data1, data2, data3)
          }
          dataexport.push(dataSum)
        } else {
          let dataSum = null
          if (fileUpload.length > 0) {
            dataSum = Object.assign({}, data1, data2, data4)
          } else {
            dataSum = Object.assign({}, data1, data2)
          }
          dataexport.push(dataSum)
        }
      }
      console.log('dataexport', dataexport)
      const dataWS = XLSX.utils.json_to_sheet(dataexport)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'รายชื่อลูกค้านัดหมาย_รับเข้าบริการ_' + this.dateStart + '.xlsx')
    },
    exportExcelRemove () {
      let dataExport = []
      this.dataexportRemove = []
      let runNo = 0
      var datause = this.dataItemTime.sort((a, b) => {
        if (a.timeDuetext < b.timeDuetext) return -1
        return a.timeDuetext > b.timeDuetext ? 1 : 0
      })
      for (let i = 0; i < datause.length; i++) {
        // var d = this.dataItemTimesChange.filter(el => { return el.timeDueHtext === item.timeDueHtext })[i]
        let d = datause[i]
        let dataSelect = this.dataItemTimesChange.filter(el => {
          return (
            el.timeDueHtext === d.timeDueHtext &&
            el.fastTrack &&
            el.statusBtText === 'ยกเลิก'
          )
        })
        // console.log('s.dataSelect', dataSelect)
        if (dataSelect.length > 0) {
          var datauseSelect = dataSelect.sort((a, b) => {
            if (a.dueDateTimeStamp < b.dueDateTimeStamp) return -1
            return a.dueDateTimeStamp > b.dueDateTimeStamp ? 1 : 0
          })
          for (let x = 0; x < datauseSelect.length; x++) {
            runNo++
            let t = datauseSelect[x]
            let s = {}
            console.log('fastTrack')
            console.log('s.t', t)
            if (
              dataExport.filter(el => {
                return (
                  el.timeDueHtext ===
                  this.format_dateNotime(this.timeTable) +
                    ' ' +
                    d.timeDueHtext +
                    ' ( ' +
                    dataSelect.length.toString() +
                    ' )'
                )
              }).length === 0
            ) {
              s.timeDueHtext =
                this.format_dateNotime(this.timeTable) +
                ' ' +
                d.timeDueHtext +
                ' ( ' +
                dataSelect.length.toString() +
                ' )'
            } else {
              s.timeDueHtext = ''
            }
            let serviceDetail = ''
            let fieldflow = this.editedItemSeleteField.filter(row => {
              return (
                row.conditionField === 'flow' &&
                String(row.conditionValue) === String(t.flowId)
              )
            })
            fieldflow.forEach(row => {
              let tempField = this.BookingDataListTimechange[t.bookNo].filter(
                row2 => {
                  return String(row2.fieldId) === String(row.fieldId)
                }
              )
              // serviceDetail += (tempField.length > 0 ? tempField[0].fieldValue + ' ' : '')
              let convertTextField = ''
              if (tempField.length > 0) {
                console.log('fieldType', row.fieldType)
                if (
                  row.fieldType === 'Selects' ||
                  row.fieldType === 'Autocompletes' ||
                  row.fieldType === 'Radio'
                ) {
                  console.log('optionField', row.optionField)
                  console.log('fieldValue', tempField[0].fieldValue)
                  if (tempField[0].fieldValue) {
                    convertTextField = JSON.parse(row.optionField).filter(
                      el => {
                        return el.value === tempField[0].fieldValue
                      }
                    )[0].text
                  } else {
                    convertTextField = tempField[0].fieldValue
                  }
                } else {
                  convertTextField = tempField[0].fieldValue
                }
              }
              console.log('convertTextField', convertTextField)
              serviceDetail +=
                tempField.length > 0 ? convertTextField + ' ' : ''
            })
            serviceDetail = serviceDetail.trim() || t.flowName
            s.bookNo = t.bookNo
            s.type = this.dataTypeJob3
            s.runNo = runNo
            s.dateBooking = this.format_dateNotime(this.timeTable)
            s.licenseNo = t.cusReg
            s.remarkRemove = t.remarkRemove
            s.title = t.timeDuetext
            s.status = t.statusBtText
            s.remark = t.remark
            s.cusName = t.cusName
            s.cusReg = t.cusReg
            // s.flowName = serviceDetail
            s.flowName = t.flowName
            s.empFull_NameTH = t.empFull_NameTH
            s.extraJob = t.extraJob ? this.dataTypeJob2 : ''
            s.tel = t.tel
            s.carModel = this.getDataFromFieldName(
              this.BookingDataListTimechange[t.bookNo],
              'รุ่นรถ'
            )
            s.carModel = s.carModel.length > 0 ? s.carModel[0].fieldValue : ''
            s.dataFiled = this.BookingDataListTimechange[t.bookNo] || []
            dataExport.push(s)
          }
        }
      }
      let s = {}
      s.bookNo = ''
      s.type = ''
      s.runNo = ''
      s.licenseNo = ''
      s.title = ''
      s.status = ''
      s.cusName = ''
      s.cusReg = ''
      s.remarkRemove = ''
      s.tel = ''
      s.remark = ''
      s.empFull_NameTH = ''
      s.carModel = ''
      s.dataFiled = []
      dataExport.push(s)
      runNo = 0
      var datause2 = this.dataItemTime.sort((a, b) => {
        if (a.timeDuetext < b.timeDuetext) return -1
        return a.timeDuetext > b.timeDuetext ? 1 : 0
      })
      for (let i = 0; i < datause2.length; i++) {
        let d = datause2[i]
        let dataSelect = this.dataItemTimesChange.filter(el => {
          return (
            el.timeDueHtext === d.timeDueHtext &&
            !el.fastTrack &&
            el.statusBtText === 'ยกเลิก'
          )
        })
        // console.log('s.dataSelect', dataSelect)
        if (dataSelect.length > 0) {
          var datauseSelect2 = dataSelect.sort((a, b) => {
            if (a.dueDateTimeStamp < b.dueDateTimeStamp) return -1
            return a.dueDateTimeStamp > b.dueDateTimeStamp ? 1 : 0
          })
          for (let x = 0; x < datauseSelect2.length; x++) {
            runNo++
            let t = datauseSelect2[x]
            let s = {}
            console.log('normal')
            console.log('s.t', t)
            if (
              dataExport.filter(el => {
                return (
                  el.timeDueHtext ===
                  this.format_dateNotime(this.timeTable) +
                    ' ' +
                    d.timeDueHtext +
                    ' ( ' +
                    dataSelect.length.toString() +
                    ' )'
                )
              }).length === 0
            ) {
              s.timeDueHtext =
                this.format_dateNotime(this.timeTable) +
                ' ' +
                d.timeDueHtext +
                ' ( ' +
                dataSelect.length.toString() +
                ' )'
            } else {
              s.timeDueHtext = ''
            }
            let serviceDetail = ''
            let fieldflow = this.editedItemSeleteField.filter(row => {
              return (
                row.conditionField === 'flow' &&
                String(row.conditionValue) === String(t.flowId)
              )
            })
            fieldflow.forEach(row => {
              let tempField = this.BookingDataListTimechange[t.bookNo].filter(
                row2 => {
                  return String(row2.fieldId) === String(row.fieldId)
                }
              )
              // serviceDetail += (tempField.length > 0 ? tempField[0].fieldValue + ' ' : '')
              let convertTextField = ''
              if (tempField.length > 0) {
                console.log('fieldType', row.fieldType)
                if (
                  row.fieldType === 'Selects' ||
                  row.fieldType === 'Autocompletes' ||
                  row.fieldType === 'Radio'
                ) {
                  console.log('optionField', row.optionField)
                  console.log('fieldValue', tempField[0].fieldValue)
                  if (tempField[0].fieldValue) {
                    convertTextField = JSON.parse(row.optionField).filter(
                      el => {
                        return el.value === tempField[0].fieldValue
                      }
                    )[0].text
                  } else {
                    convertTextField = tempField[0].fieldValue
                  }
                } else {
                  convertTextField = tempField[0].fieldValue
                }
              }
              console.log('convertTextField', convertTextField)
              serviceDetail +=
                tempField.length > 0 ? convertTextField + ' ' : ''
            })
            serviceDetail = serviceDetail.trim() || t.flowName
            s.bookNo = t.bookNo
            s.type = 'ปกติ'
            s.runNo = runNo
            s.dateBooking = this.format_dateNotime(this.timeTable)
            s.licenseNo = t.cusReg
            s.remarkRemove = t.remarkRemove
            s.title = t.timeDuetext
            s.status = t.statusBtText
            s.remark = t.remark
            s.cusName = t.cusName
            s.cusReg = t.cusReg
            // s.flowName = serviceDetail
            s.flowName = t.flowName
            s.tel = t.tel
            s.empFull_NameTH = t.empFull_NameTH
            s.extraJob = t.extraJob ? 'Extra Job' : ''
            s.carModel = this.getDataFromFieldName(
              this.BookingDataListTimechange[t.bookNo],
              'รุ่นรถ'
            )
            s.carModel = s.carModel.length > 0 ? s.carModel[0].fieldValue : ''
            s.dataFiled = this.BookingDataListTimechange[t.bookNo] || []
            dataExport.push(s)
          }
        }
      }
      this.dataexportRemove = dataExport
      this.onExportRemove()
      console.log('dataEportCancel', JSON.stringify(dataExport))
    },
    async onExportRemove () {
      var dataexport = []
      let dataCallLog = []
      if (this.session.data.shopId === 'Ucd377d0dd363c1360b3a4149fdb0c447') {
        dataCallLog = await this.getCallLog('&dueDate=' + this.bookingDataDate)
      }
      for (var i = 0; i < this.dataexportRemove.length; i++) {
        var a = this.dataexportRemove[i]
        // dataexport.push({
        //   'ประเภท': a.type,
        //   'ลำดับ': a.runNo,
        //   'วันที่': a.dateBooking,
        //   'เวลา': a.title,
        //   'ชื่อลูกค้า': a.cusName,
        //   // 'รุ่นรถ': a.carModel,
        //   // 'ทะเบียน': a.cusReg,
        //   'รายการบริการ': a.flowName,
        //   'เบอร์โทร': a.tel,
        //   'หมายเหตุ': a.extraJob,
        //   'หมายเหตุยกเลิก': a.remarkRemove,
        //   'เวลาติดตาม': '',
        //   'เหตุผล': '',
        //   'ตรง': '',
        //   'ไม่ตรง': '',
        //   'เปิดJob': '',
        //   'พนักงานรับนัดหมาย': a.empFull_NameTH,
        //   'หมายเหตุเพิ่มเติม': a.remark
        // })
        let data2 = {}
        let countKey = 1
        for (let g = 0; g < a.dataFiled.length; g++) {
          let t = a.dataFiled[g]
          let fieldNames = ''
          let fieldValues = ''
          fieldNames = t.fieldName
          fieldValues = t.fieldValue
          // data2[fieldNames] = fieldValues
          if (this.session.data.shopId === 'U753e6614793b89cffd5461cb76047d1c') {
            if (t.fieldName.trim() === 'กรุณากรอกเลข') {
              data2[fieldNames.trim() + countKey] = fieldValues
              countKey++
            } else {
              data2[fieldNames] = fieldValues
            }
          } else {
            data2[fieldNames] = fieldValues
          }
          // dataOb.push({fieldNames: fieldValues})
        }
        let data1 = {
          ประเภท: a.type,
          ลำดับ: a.runNo,
          วันที่: a.dateBooking,
          เวลา: a.title,
          // 'ชื่อลูกค้า': a.cusName,
          รายการบริการ: a.flowName
          // 'หมายเหตุ': a.extraJob,
          // 'หมายเหตุยกเลิก': a.remarkRemove,
          // 'เวลาติดตาม': '',
          // 'เหตุผล': '',
          // 'ตรง': '',
          // 'ไม่ตรง': '',
          // 'เปิดJob': '',
          // 'พนักงานรับนัดหมาย': a.empFull_NameTH,
          // 'หมายเหตุเพิ่มเติม': a.remark
        }
        let data5 = {}
        if (this.session.data.shopId === 'Ucd377d0dd363c1360b3a4149fdb0c447') {
          if (dataCallLog[a.bookNo]) {
            data5 = {
              'บันทึกการโทร': dataCallLog[a.bookNo].remarks_sum
            }
          }
        }
        let dataSum = Object.assign({}, data1, data2, data5)
        dataexport.push(dataSum)
      }
      const dataWS = XLSX.utils.json_to_sheet(dataexport)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(
        wb,
        'export_cancel_' + this.format_dateNotime(this.timeTable) + '.xlsx'
      )
    },
    toggle () {
      this.timeTable = moment(moment(new Date(), 'YYYY-MM-DD').toDate()).format(
        'YYYY-MM-DD'
      )
      this.getTimesChange('update')
      this.drawer = !this.drawer
    },
    async getCustomFieldStart () {
      this.editedItemSeleteField = []
      axios
        .get(
          this.$DNS_IP +
            '/customField/get?shopId=' +
            this.$session.getAll().data.shopId
        )
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            let sortrs = rs.sort((a, b) => a.sortNoField - b.sortNoField)
            for (let i = 0; i < sortrs.length; i++) {
              let d = sortrs[i]
              let s = {}
              s.fieldId = d.fieldId
              if (d.fieldType === 'Checkbox') {
                this.selected[s.fieldId] = []
              }
              s.fieldName = d.fieldName
              s.fieldType = d.fieldType
              s.optionField = d.optionField
              s.conditionField = d.conditionField
              s.conditionValue = d.conditionValue
              s.shopId = d.shopId
              s.showCard = d.showCard
              s.fieldValue = s.fieldType === 'Checkbox' ? '[]' : ''
              this.editedItemSeleteField.push(s)
            }
            // console.log('this.editedItemSeleteField', this.editedItemSeleteField)
          }
        })
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break
        case 'EDIT':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_edit.validate()
          })
          break
        case 'REMOVE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_remove.validate()
          })
          break
        case 'CHANGE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_change.validate()
          })
          break
        case 'EXPORT':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_export.validate()
          })
          break
        case 'DEPOSIT':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_deposit.validate()
          })
          break
        case 'BOOKAGAIN':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_bookingAgain.validate()
          })
          break

        default:
          break
      }
    },
    async scanQrcode () {
      if (this.$route.query.shopId === this.session.data.shopId) {
        let dt = {
          bookNo: this.$route.query.bookNo
        }
        await axios
          .get(this.$DNS_IP + '/booking_view/getJob?bookNo=' + dt.bookNo)
          .then(async response => {
            let rs = response.data
            console.log('rsJob', rs)
            if (rs.length > 0) {
              await this.getBookingListJob(rs[0])
              this.dialogEdit = true
            } else {
              this.$swal(
                'ผิดพลาด',
                'นัดหมายนี้ไม่ได้อยู่ในร้านของคุณ หรือ อยู่ในกระดานการทำงานแล้ว',
                'error'
              )
              this.$router.push('/Master/BookingListBeauty')
            }
          })
      } else {
        this.$swal('ผิดพลาด', 'นัดหมายนี้ไม่ได้อยู่ในร้านของคุณ', 'error')
        this.$router.push('/Core/Login')
      }
    },
    async getBookingListJob (item) {
      let dateCurrent = moment().format('YYYY-MM-DD')
      let dueDate = item.dueDateDay
      if (dateCurrent >= dueDate) {
        this.statusConfirmJob = true
      } else {
        this.dueDate = item.dueDate
        this.statusConfirmJob = false
      }
      if (this.statusConfirmJob) {
        let checkStep = await axios.get(
          this.$DNS_IP + '/flowStep/get?flowId=' + item.flowId
        )
        console.log('checkStep', checkStep)
        if (checkStep.data.status === false) {
          this.endDate = moment().format('YYYY-MM-DD')
          this.endTime = moment().format('HH:mm')
          this.statusShowDateConfiremjob = false
        } else {
          this.statusShowDateConfiremjob = true
        }
        this.dataQrcode = item
        this.dataReady = false
        this.selectedStatus = true
        // this.getSelectText = ''
        this.dataItem = []
        this.countWaiting = 0
        this.countConfirm = 0
        this.countCancel = 0
        this.countJob = 0
        this.countAll = 0
        // Clear ช่องค้นหา
        this.searchAll2 = ''
        // this.dataItemSelect = []
        var dataItemTimes = []
        var dataItems = []
        this.BookingDataList = []
        if (this.branch.length === 0) {
          await this.getDataBranch()
        }
        await axios
          .get(
            // eslint-disable-next-line quotes
            this.$DNS_IP +
              '/booking_view/getJob?shopId=' +
              this.session.data.shopId +
              '&bookNo=' +
              item.bookNo
          )
          .then(async response => {
            // console.log('getData', response.data)
            if (response.data.length > 0) {
              for (let i = 0; i < response.data.length; i++) {
                let d = response.data[i]
                let s = {}
                if (
                  dataItems.filter(el => {
                    return el.bookNo === d.bookNo
                  }).length === 0
                ) {
                  s.bookNo = d.bookNo
                  s.flowId = d.flowId
                  s.flowName = d.flowName
                  s.dueDate = d.dueDate
                  s.shopId = d.shopId
                  s.dueDateDay = d.dueDateDay
                  s.statusVIP = d.statusVIP
                  s.checkDateConfirmJob = d.checkDateConfirmJob
                  s.bookingLanguage = d.bookingLanguage
                  s.zone = d.bookingDataCustomerZone
                  s.packageName = d.packageName
                  s.packageDetails = d.packageDetails
                  s.packageImage = d.packageImage
                  s.packagePrice = d.packagePrice
                  s.packageBalanceAmount = d.packageBalanceAmount
                  s.packageAmount = d.packageAmount
                  s.packagePoint = d.packagePoint
                  s.packageExpire = d.packageExpire
                  s.depositTextTH = d.depositTextTH
                  s.CREATE_DATE_Status = d.CREATE_DATE_Status
                  s.CREATE_DATE = d.CREATE_DATE
                  s.menuShowStatus = d.menuShowStatus
                  s.dueDateTextDay = d.dueDateTextDay
                  s.remark = d.remark || ''
                  s.masBranchID = d.masBranchID
                  s.empSelect = d.empSelect
                  s.empFull_NameTH = d.empFull_NameTH || ''
                  s.empFull_NameTH = s.empFull_NameTH.replace('นางสาว', '')
                  s.empFull_NameTH = s.empFull_NameTH.replace('นาย', '')
                  s.empFull_NameTH = s.empFull_NameTH.replace('นาง', '')
                  s.userId = d.userId
                  s.chkConfirm = false
                  s.chkCancel = false
                  s.jobNo = d.jobNo
                  s.remarkRemove = d.remarkRemove || ''
                  s.cancelBy = d.cancelBy || '-'
                  switch (d.cancelBy) {
                    case 'system':
                      s.cancelBy = 'ยกเลิกโดยระบบ'
                      break
                    case 'user':
                      s.cancelBy = 'ยกเลิกโดยประชาชน'
                      break
                    case 'admin':
                      s.cancelBy = 'ยกเลิกโดยเจ้าหน้าที่'
                      break
                  }
                  s.remarkConfirm1 =
                    d.remarkConfirm1 === 'true' || d.remarkConfirm1 === 'True'
                  s.remarkConfirm2 =
                    d.remarkConfirm2 === 'true' || d.remarkConfirm2 === 'True'
                  s.extraJob = d.extraJob === 'true' || d.extraJob === 'True'
                  s.fastTrack =
                    d.fastTrack === 'true' || d.fastTrack === 'True'
                  s.lineUserId = d.lineUserId
                  s.memberPicture = d.memberPicture
                  s.timeDueHtext = d.timeDueH + ':00'
                  s.timeDuetext = d.timeDue

                  if (d.statusUseBt === 'use' && d.statusBt === 'confirm') {
                    s.chkConfirm = true
                    s.chkCancel = false
                  }
                  if (d.statusUseBt === 'use' && d.statusBt === 'cancel') {
                    s.chkConfirm = false
                    s.chkCancel = true
                  }
                  s.statusBt = d.statusBt || 'wait'
                  switch (d.statusBt) {
                    case 'confirm':
                      s.statusBtText = 'ยืนยันแล้ว'
                      this.countConfirm = this.countConfirm + 1
                      break
                    case 'cancel':
                      s.statusBtText = 'ยกเลิก'
                      this.countCancel = this.countCancel + 1
                      break
                    case 'confirmJob':
                      s.statusBtText = 'รับรถแล้ว'
                      this.countJob = this.countJob + 1
                      break
                    default:
                      s.statusBtText = 'รายการนัดหมายใหม่'
                      this.countWaiting = this.countWaiting + 1
                      break
                  }
                  var chkTime = this.dataItemTime.filter(el => {
                    return el.timeDueHtext === s.timeDueHtext
                  })
                  if (chkTime.length === 0) {
                    dataItemTimes.push(s)
                  }
                  // let dataBookingData = []
                  // await axios
                  //   .get(
                  //     // eslint-disable-next-line quotes
                  //     this.$DNS_IP + "/BookingData/getView?bookNo=" + d.bookNo
                  //   )
                  //   .then(async responses => {
                  //     console.log('getDataData', responses.data)
                  //     dataBookingData = responses.data
                  //     if (responses.data.status !== false) {
                  //       responses.data.forEach((row) => {
                  //         if (typeof (this.BookingDataList[row.bookNo]) === 'undefined') {
                  //           this.BookingDataList[row.bookNo] = []
                  //         }
                  //         this.BookingDataList[row.bookNo].push(row)
                  //       })
                  //     }
                  //   })
                  // s.cusName = dataBookingData.filter(function (el) {
                  //   return el.fieldName === 'ชื่อ'
                  // })
                  // s.cusReg = dataBookingData.filter(function (el) {
                  //   return el.fieldName === 'เลขทะเบียน'
                  // })
                  // s.tel = dataBookingData.filter(function (el) {
                  //   return el.fieldName === 'เบอร์โทร'
                  // })
                  // s.cusName = (s.cusName.length > 0) ? s.cusName[0].fieldValue : ''
                  // s.cusReg = (s.cusReg.length > 0) ? s.cusReg[0].fieldValue : ''
                  // s.tel = (s.tel.length > 0) ? s.tel[0].fieldValue : ''
                  s.cusName = d.bookingDataCustomerName || ''
                  s.cusReg = d.bookingDataCustomerRegisNumber || ''
                  s.tel = d.bookingDataCustomerTel || ''
                  s.displayFlowName = d.displayFlowName || ''
                  s.remarkQueue = d.remarkQueue || ''
                  dataItems.push(s)
                }
              }
            }
            if (dataItems.length === 0 || dataItems.status === false) {
              this.dataItem = []
              this.dataItemTime = []
              this.dataReady = true
              // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
            } else {
              this.dataItem = dataItems
              var datause = dataItemTimes.sort((a, b) => {
                if (a.timeDueHtext < b.timeDueHtext) return -1
                return a.timeDueHtext > b.timeDueHtext ? 1 : 0
              })
              for (var k = 0; k < datause.length; k++) {
                var t = datause[k]
                var h = {}
                h.timeDueHtext = t.timeDueHtext
                let chkTimes = this.dataItemTime.filter(el => {
                  return el.timeDueHtext === t.timeDueHtext
                })
                // console.log('chkTimes', chkTimes)
                if (chkTimes.length === 0) {
                  // console.log('datause(H)', h)
                  this.dataItemTime.push(h)
                }
              }
              this.masBranchID = this.dataItem[0].masBranchID
              console.log('dtTime', this.dataItem[0].masBranchID)
              await this.getBookingData(this.dataItem[0])
              this.checkTimeFlow(item)
              // this.timeavailable = []
              // console.log('dtTime', this.dataItem[0].masBranchID)
              // let dtTime = this.branch.filter(item => { return item.value === this.dataItem[0].masBranchID })
              // console.log('dtTime', this.dataItem[0].masBranchID)
              // this.timeavailable = JSON.parse(dtTime.map(item => item.allData.setTime))
              this.dialogEdit = true
            }
          })
          // eslint-disable-next-line handle-callback-err
          .catch(error => {
            console.log(error)
            this.dataReady = true
            //   this.$router.push('/system/Errorpage?returnLink=' + returnLink)
          })
      }
    },
    async getDataFromAPI (url, fieldId, fieldName, param) {
      let result = []
      await axios
        .get(this.$DNS_IP + `${url}?shopId=${this.session.data.shopId}${param}`)
        .then(response => {
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              let d = rs[i]
              let s = {}
              s.text = d[fieldName]
              s.value = d[fieldId]
              s.allData = d
              result.push(s)
              // console.log('this.DataFlowName', this.DataFlowName)
            }
          } else {
            result = []
          }
        })
      return result
    },
    async getDataFlow () {
      let result = []
      let resultOption = []
      await axios
        .get(
          this.$DNS_IP +
            `/flow/get?shopId=${this.session.data.shopId}${this.selectOnsite}&isShow=all`
        )
        .then(response => {
          let rs = response.data
          console.log('rs => ', rs)
          if (rs.length > 0) {
            result.push({ text: 'ทั้งหมด', value: 'AllFlow' })
            for (var i = 0; i < rs.length; i++) {
              let d = rs[i]
              let s = {}
              s.text = d.flowName
              s.value = d.flowId
              s.menuShowStatus = d.menuShowStatus
              s.masBranchID = d.masBranchID
              s.checkDeposit = d.checkDeposit
              s.allData = d
              result.push(s)
              resultOption.push(s)
              // console.log('this.DataFlowName', this.DataFlowName)
            }
          } else {
            result = []
            resultOption = []
          }
        })
      this.DataFlowNameDefault = result
      this.DataFlowNameA = result
      // this.DataFlowName = result
      console.log('getDataFlow', result)
      // console.log('masBranchID', this.masBranchID)
      // if (this.masBranchID !== '') {
      //   this.DataFlowName = result.filter(el => { return el.masBranchID === this.masBranchID })
      // } else {
      //   this.DataFlowName = result
      // }
      this.DataFlowNameMenu = result.filter(el => {
        return el.menuShowStatus === 'True'
      })
      if (this.DataFlowNameMenu.length > 0) {
        this.DataFlowNameMenu.unshift({ text: 'ทั้งหมด', value: 'AllFlow' })
      }
      this.dataFlowSelectAdd = resultOption
      this.dataFlowSelectEdit = resultOption
    },
    setFlowByBranchEdit (item) {
      this.formEdit.flowId = ''
      this.dateEdit = ''
      this.timeEdit = ''
      let DD = this.DataFlowNameDefault
      let dataFilter = []
      DD.forEach(item => {
        if (item.text !== 'ทั้งหมด') {
          let checkBranchByFlow = item.allData.masBranchID || 'All'
          if (
            checkBranchByFlow === this.formEdit.masBranchID.toString() ||
            checkBranchByFlow === 'All'
          ) {
            // console.log('eeeeeee', item.allData.flowName)
            dataFilter.push(item)
          }
        }
      })
      this.dataFlowSelectEdit = dataFilter
    },
    setFlowByBranchAdd () {
      this.formAdd.flowId = ''
      let DD = this.DataFlowNameDefault
      let dataFilter = []
      DD.forEach(item => {
        if (item.text !== 'ทั้งหมด') {
          let checkBranchByFlow = item.allData.masBranchID || 'All'
          if (
            checkBranchByFlow === this.formAdd.masBranchID.toString() ||
            checkBranchByFlow === 'All'
          ) {
            console.log('eeeeeee', item.allData.flowName)
            dataFilter.push(item)
          }
        }
      })
      this.dataFlowSelectAdd = dataFilter
    },
    async getDataBranch () {
      // if (localStorage.getItem('BRANCH') === null) {
      //   let temp = await this.getDataFromAPI('/master_branch/get', 'masBranchID', 'masBranchName')
      //   console.log(typeof temp)
      //   localStorage.setItem('BRANCH', JSON.stringify(temp))
      // }
      // this.branch = JSON.parse(localStorage.getItem('BRANCH'))
      let branchData = await this.getDataFromAPI(
        '/master_branch/get',
        'masBranchID',
        'masBranchName',
        ''
      )
      if (
        this.session.data.masBranchID === '' ||
        this.session.data.masBranchID === null
      ) {
        this.branch = branchData
      } else {
        let checkData = branchData.filter(el => {
          return el.value === this.session.data.masBranchID
        })
        if (checkData.length > 0) {
          this.branch = checkData
        } else {
          await this.getDataBranch()
          if (checkData.length > 0) {
            this.branch = checkData
          } else {
            this.branch = []
            this.$swal(
              'ผิดพลาด',
              'กรุณาตรวจสอบสาขาของท่าน เนื่องจากระบบตรวจหาสาขาไม่พบ',
              'error'
            )
          }
        }
      }
      console.log('TEST', this.branch)
    },
    getDataFromFieldName (data, key) {
      if (data !== undefined) {
        return data.filter(function (el) {
          return el.fieldName === key
        })
      } else {
        return []
      }
    },
    async updateValuesExport () {
      this.export_data = []
      console.log(
        'dateRange',
        new Date(this.dateRange.endDate).toISOString().substr(0, 10)
      )
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.$DNS_IP +
            '/booking_view/get?shopId=' +
            this.session.data.shopId +
            '&masBranchID=' +
            this.masBranchIDExport +
            '&dateRange=' +
            new Date(this.dateRange.startDate).toISOString().substr(0, 10) +
            '/' +
            new Date(this.dateRange.endDate).toISOString().substr(0, 10) +
            this.selectOnsite
        )
        .then(async response => {
          console.log('getData', response.data)
          this.dataReady = true
          var exportdatas = []
          for (let i = 0; i < response.data.length; i++) {
            let d = response.data[i]
            let s = {}
            s.bookNo = d.bookNo
            s.masBranchName = d.masBranchName
            s.statusUseBt = d.statusUseBt || 'booking'
            s.CREATE_DATE = d.CREATE_DATE
            s.LAST_DATE = d.LAST_DATE
            s.flowName = d.flowName
            s.dueDate = d.dueDate
            s.packageName = d.packageName
            s.packageDetails = d.packageDetails
            s.packageImage = d.packageImage
            s.packagePrice = d.packagePrice
            s.packageBalanceAmount = d.packageBalanceAmount
            s.packageAmount = d.packageAmount
            s.packagePoint = d.packagePoint
            s.packageExpire = d.packageExpire
            s.chkConfirm = false
            s.chkCancel = false
            if (d.statusUseBt === 'use' && d.statusBt === 'confirm') {
              s.chkConfirm = true
              s.chkCancel = false
            } else if (d.statusUseBt === 'use' && d.statusBt === 'cancel') {
              s.chkConfirm = false
              s.chkCancel = true
            }
            s.statusBt = d.statusBt || 'wait'
            switch (d.statusBt) {
              case 'confirm':
                s.statusBtText = 'ยืนยันแล้ว'
                break
              case 'cancel':
                s.statusBtText = 'ยกเลิก'
                break
              case 'confirmJob':
                s.statusBtText = 'รับรถแล้ว'
                break
              default:
                s.statusBtText = 'รอโทรยืนยัน'
                break
            }
            let dataBookingData = []
            await axios
              .get(this.$DNS_IP + `/BookingData/getView?bookNo=${d.bookNo}`)
              .then(async responses => {
                dataBookingData = responses.data
              })
            s.cusName = this.getDataFromFieldName(dataBookingData, 'ชื่อ')
            s.cusReg = this.getDataFromFieldName(dataBookingData, 'เลขทะเบียน')
            s.cusName = s.cusName.length > 0 ? s.cusName[0].fieldValue : ''
            s.cusReg = s.cusReg.length > 0 ? s.cusReg[0].fieldValue : ''
            exportdatas.push(s)
          }
          this.export_data = exportdatas
          // if (exportdatas.length === 0 || exportdatas.status === false) {
          //   this.export_data = []
          //   // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          // } else {
          //   // this.dataReady = true
          //   this.export_data = exportdatas
          // }
        })
        .catch(error => {
          console.log(error)
          this.dataReady = true
          //   this.$router.push('/system/Errorpage?returnLink=' + returnLink)
        })
    },
    getSelect (text, count, filterCloseJobValue) {
      this.selectedStatus = true
      this.getSelectText = text
      this.getSelectCount = count || 0
      this.dataItemSelect = []
      // this.dataItemTimesChange = []
      this.columnsSelected = []
      console.log('text', text)
      // if (count > 0) {
      if (text === 'all') {
        // this.dataItemSelect = this.dataItem
        if (this.dataItem.length > 0) {
          this.checkSelectText = this.dataItem[0].statusBt
          for (let x = 0; x < this.dataItem.length; x++) {
            let t = this.dataItem[x]
            // let serviceDetail = ''
            // let fieldflow = this.editedItemSeleteField.filter((row) => { return row.conditionField === 'flow' && String(row.conditionValue) === String(t.flowId) })
            // fieldflow.forEach((row) => {
            //   let tempField = this.BookingDataList[t.bookNo].filter((row2) => { return String(row2.fieldId) === String(row.fieldId) })
            //   let convertTextField = ''
            //   if (tempField.length > 0) {
            //     if (row.fieldType === 'Selects' || row.fieldType === 'Autocompletes' || row.fieldType === 'Radio') {
            //       if (tempField[0].fieldValue) {
            //         if (JSON.parse(row.optionField).filter(el => { return el.value === tempField[0].fieldValue }).length === 0) {
            //           convertTextField = tempField[0].fieldValue || ''
            //         } else {
            //           convertTextField = JSON.parse(row.optionField).filter(el => { return el.value === tempField[0].fieldValue })[0].text
            //         }
            //       } else {
            //         convertTextField = tempField[0].fieldValue
            //       }
            //     } else {
            //       convertTextField = tempField[0].fieldValue
            //     }
            //   }
            //   serviceDetail += (tempField.length > 0 ? convertTextField + ' ' : '')
            // })
            // serviceDetail = serviceDetail.trim() ? t.flowName + ' : ' + serviceDetail.trim() : t.flowName
            // t.flowNameShow = serviceDetail
            // t.flowNameShow = t.displayFlowName || t.flowName
            t.flowNameShow = t.displayFlowName
              ? t.flowName + ' : ' + t.displayFlowName
              : t.flowName
            this.dataItemSelect.push(t)
          }
        } else {
          this.dataItemSelect = []
        }
        console.log('dataItemSelect', this.dataItemSelect)
        this.columnsSelected = [
          // { text: 'Booking Id', value: 'bookNo' },
          { text: 'ชื่อลูกค้า', value: 'cusName', sortable: false },
          { text: 'วันที่/เวลา', value: 'dueDate', sortable: false },
          // { text: 'วันและเวลานัดหมาย', value: 'dueDate' },
          { text: 'บริการ', value: 'flowNameShow', sortable: false },
          { text: 'เบอร์โทร', value: 'tel', sortable: false },
          {
            text: 'เงินมัดจำ',
            value: 'action40',
            sortable: false,
            align: 'center'
          },
          // { text: 'คุณสมบัติเพิ่มเติม', value: 'action3', sortable: false, align: 'center' },
          // { text: 'Confirm นัดล่วงหน้า', value: 'action2', sortable: false, align: 'center' },
          {
            text: 'หมายเหตุที่ยกเลิก',
            value: 'remarkRemove',
            sortable: false,
            align: 'center'
          },
          {
            text: 'ชื่อพนักงาน',
            value: 'empFull_NameTH',
            align: 'center',
            sortable: false
          },
          {
            text: 'หมายเหตุ',
            value: 'remark',
            align: 'center',
            sortable: false
          },
          // { text: 'หมายเหตุเรียกกลับ', value: 'remarkReturn', align: 'center' },
          { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
        ]
      } else {
        var dataSelect = []
        if (text === 'confirmSum') {
          console.log('Time 1', new Date())
          dataSelect = this.dataItem.filter(el => {
            return el.statusBt === 'confirm' || el.statusBt === 'confirmJob'
          })
          console.log('Time 2', new Date())
          this.countJob = this.dataItem.filter(el => {
            return el.statusBt === 'confirmJob'
          }).length
          console.log('Time 3', new Date())
          this.filterCloseJobValue = 'ทั้งหมด'
        } else {
          if (text === 'confirmJob') {
            if (filterCloseJobValue) {
              if (filterCloseJobValue === 'ยังไม่ปิดงาน') {
                dataSelect = this.dataItem.filter(el => {
                  return el.statusBt === text && el.RECORD_STATUS_Job === 'N'
                })
                this.countJob = dataSelect.length
              } else if (filterCloseJobValue === 'ปิดงาน') {
                dataSelect = this.dataItem.filter(el => {
                  return el.statusBt === text && el.RECORD_STATUS_Job === 'D'
                })
                this.countJob = dataSelect.length
              } else {
                dataSelect = this.dataItem.filter(el => {
                  return el.statusBt === text
                })
                this.countJob = dataSelect.length
              }
            } else {
              dataSelect = this.dataItem.filter(el => {
                return el.statusBt === text
              })
              this.countJob = dataSelect.length
            }
          } else {
            // this.filterCloseJobValue = filterCloseJobValue
            dataSelect = this.dataItem.filter(el => {
              return el.statusBt === text
            })
          }
        }
        console.log('Time 4', new Date())
        // console.log('fieldflow', dataSelect)
        if (dataSelect.length > 0) {
          this.checkSelectText = dataSelect[0].statusBt
          for (let x = 0; x < dataSelect.length; x++) {
            let t = dataSelect[x]
            // let serviceDetail = ''
            // let fieldflow = this.editedItemSeleteField.filter((row) => { return row.conditionField === 'flow' && String(row.conditionValue) === String(t.flowId) })
            // if (fieldflow.length > 0) {
            //   fieldflow.forEach((row) => {
            //     let tempField = []
            //     if (this.BookingDataList[t.bookNo] !== undefined) {
            //       tempField = this.BookingDataList[t.bookNo].filter((row2) => { return String(row2.fieldId) === String(row.fieldId) })
            //     } else {
            //       tempField = []
            //     }
            //     let convertTextField = ''
            //     if (tempField.length > 0) {
            //       if (row.fieldType === 'Selects' || row.fieldType === 'Autocompletes' || row.fieldType === 'Radio') {
            //         if (tempField[0].fieldValue) {
            //           // console.log('7088', JSON.parse(row.optionField).filter(el => { return el.value === tempField[0].fieldValue }))
            //           if (JSON.parse(row.optionField).filter(el => { return el.value === tempField[0].fieldValue }).length === 0) {
            //             convertTextField = tempField[0].fieldValue || ''
            //           } else {
            //             convertTextField = JSON.parse(row.optionField).filter(el => { return el.value === tempField[0].fieldValue })[0].text
            //           }
            //         } else {
            //           convertTextField = tempField[0].fieldValue || ''
            //         }
            //       } else {
            //         convertTextField = tempField[0].fieldValue || ''
            //       }
            //     }
            //     serviceDetail += (tempField.length > 0 ? convertTextField + ' ' : '')
            //   })
            // }
            // // serviceDetail = serviceDetail.trim() || t.flowName
            // serviceDetail = serviceDetail.trim() ? t.flowName + ' : ' + serviceDetail.trim() : t.flowName
            // t.flowNameShow = serviceDetail
            // t.flowNameShow = t.displayFlowName || t.flowName
            t.flowNameShow = t.displayFlowName
              ? t.flowName + ' : ' + t.displayFlowName
              : t.flowName

            this.dataItemSelect.push(t)
          }
          console.log('Time 5', new Date())
        } else {
          this.dataItemSelect = []
        }
        console.log('text >>>>>>>> ', text)
        if (text === 'cancel') {
          if (
            this.$session.getAll().data.category === 'ธุรกิจรถยนต์' ||
            this.$session.getAll().data.category === '7'
          ) {
            this.columnsSelected = [
              // { text: 'Booking Id', value: 'bookNo' },
              { text: 'ชื่อลูกค้า', value: 'cusName', width: '150' },
              { text: 'วันที่/เวลา', value: 'dueDate', sortable: false },
              // { text: 'วันและเวลานัดหมาย', value: 'dueDate' },
              { text: 'บริการ', value: 'flowNameShow', width: '200' },
              { text: 'เลขทะเบียน', value: 'cusReg', width: '120' },
              { text: 'เบอร์โทร', value: 'tel' },
              {
                text: 'หมายเหตุที่ยกเลิก',
                value: 'remarkRemove',
                sortable: false,
                align: 'center'
              },
              { text: 'ชื่อพนักงาน', value: 'empFull_NameTH', align: 'center' },
              {
                text: 'หมายเหตุ',
                value: 'remark',
                align: 'center',
                width: '120'
              },
              {
                text: 'จัดการ',
                value: 'action',
                sortable: false,
                align: 'center'
              }
              // { text: 'คุณสมบัติเพิ่มเติม', value: 'action3', sortable: false, align: 'center' },
              // { text: 'Confirm นัดล่วงหน้า', value: 'action2', sortable: false, align: 'center' }
              // { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
            ]
          } else {
            if (this.$session.getAll().data.shopId === this.shopNameData.officeOmbudsman) {
              this.columnsSelected = [
                // { text: 'Booking Id', value: 'bookNo' },
                { text: 'ชื่อลูกค้า', value: 'cusName', width: '150' },
                { text: 'วันที่/เวลา', value: 'dueDate', sortable: false },
                // { text: 'วันและเวลานัดหมาย', value: 'dueDate' },
                { text: 'บริการ', value: 'flowNameShow' },
                { text: 'เบอร์โทร', value: 'tel' },
                {
                  text: 'หมายเหตุที่ยกเลิก',
                  value: 'remarkRemove',
                  sortable: false,
                  align: 'center'
                },
                {
                  text: 'ยกเลิกโดย',
                  value: 'cancelBy',
                  sortable: false,
                  align: 'center'
                },
                { text: 'ชื่อพนักงาน', value: 'empFull_NameTH', align: 'center' },
                {
                  text: 'หมายเหตุ',
                  value: 'remark',
                  align: 'center',
                  width: '120'
                },
                {
                  text: 'จัดการ',
                  value: 'action',
                  sortable: false,
                  align: 'center'
                }
                // { text: 'คุณสมบัติเพิ่มเติม', value: 'action3', sortable: false, align: 'center' },
                // { text: 'Confirm นัดล่วงหน้า', value: 'action2', sortable: false, align: 'center' }
                // { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
              ]
            } else {
              this.columnsSelected = [
                // { text: 'Booking Id', value: 'bookNo' },
                { text: 'ชื่อลูกค้า', value: 'cusName', width: '150' },
                { text: 'วันที่/เวลา', value: 'dueDate', sortable: false },
                // { text: 'วันและเวลานัดหมาย', value: 'dueDate' },
                { text: 'บริการ', value: 'flowNameShow' },
                { text: 'เบอร์โทร', value: 'tel' },
                {
                  text: 'หมายเหตุที่ยกเลิก',
                  value: 'remarkRemove',
                  sortable: false,
                  align: 'center'
                },
                { text: 'ชื่อพนักงาน', value: 'empFull_NameTH', align: 'center' },
                {
                  text: 'หมายเหตุ',
                  value: 'remark',
                  align: 'center',
                  width: '120'
                },
                {
                  text: 'จัดการ',
                  value: 'action',
                  sortable: false,
                  align: 'center'
                }
                // { text: 'คุณสมบัติเพิ่มเติม', value: 'action3', sortable: false, align: 'center' },
                // { text: 'Confirm นัดล่วงหน้า', value: 'action2', sortable: false, align: 'center' }
                // { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
              ]
            }
          }
        } else if (text === 'confirm') {
          if (
            this.$session.getAll().data.category === 'ธุรกิจรถยนต์' ||
            this.$session.getAll().data.category === '7'
          ) {
            this.columnsSelected = [
              // { text: 'Booking Id', value: 'bookNo' },
              {
                text: 'ชื่อลูกค้า',
                value: 'cusName',
                width: '120',
                sortable: false
              },
              { text: 'วันที่/เวลา', value: 'dueDate', sortable: false },
              // { text: 'วันและเวลานัดหมาย', value: 'dueDate' },
              {
                text: 'บริการ',
                value: 'flowNameShow',
                sortable: false,
                width: '200'
              },
              { text: 'เลขทะเบียน', value: 'cusReg', width: '120' },
              { text: 'เบอร์โทร', value: 'tel', sortable: false },
              {
                text: 'เงินมัดจำ',
                value: 'action40',
                sortable: false,
                align: 'center'
              },
              {
                text: 'ป้ายชื่อกำกับ',
                value: 'memberDataTagName',
                sortable: false,
                align: 'center',
                width: '150'
              },
              // { text: 'คุณสมบัติเพิ่มเติม', value: 'action3', sortable: false, align: 'center' },
              {
                text: 'Confirm นัดล่วงหน้า',
                value: 'action2',
                sortable: false,
                align: 'center'
              },
              // { text: 'หมายเหตุที่ยกเลิก', value: 'remarkRemove', sortable: false, align: 'center' },
              {
                text: 'ชื่อพนักงาน',
                value: 'empFull_NameTH',
                align: 'center',
                sortable: false
              },
              {
                text: 'หมายเหตุ',
                value: 'remark',
                align: 'center',
                sortable: false,
                width: '160'
              },
              {
                text: 'จัดการ',
                value: 'action',
                sortable: false,
                align: 'center',
                width: '120'
              }
            ]
          } else {
            console.log('DataFlowNameA => ', this.DataFlowNameA)
            let allFalse = false

            // ตรวจสอบว่ามีการเลือกสาขาหรือไม่
            const isBranchSelected = this.flowSelect !== 'AllFlow'

            // ถ้าเลือกสาขา ให้ตรวจสอบเฉพาะรายการที่ตรงกับสาขาที่เลือก
            if (isBranchSelected) {
              console.log('เลือกสาขา', this.flowSelect)

              const selectedFlow = this.DataFlowNameA.find(item => item.value === this.flowSelect && item.checkDeposit !== 'False') || 0
              console.log('selectedFlow ', selectedFlow)

              if (selectedFlow) {
                allFalse = true
                console.log('allFalse (เลือกสาขา)', allFalse)
              }
            } else {
              console.log('ไม่ได้เลือกสาขา ตรวจสอบทั้งหมด')

              const anyValidFlow = this.DataFlowNameA.some(item => item.checkDeposit !== 'False')
              console.log('anyValidFlow ', anyValidFlow)
              if (anyValidFlow) {
                allFalse = true
                console.log('allFalse (ทั้งหมด)', allFalse)
              }
            }

            // สร้าง columnsSelected
            if (this.$session.getAll().data.shopId === this.shopNameData.officeOmbudsman) {
              this.columnsSelected = [
                { text: 'ชื่อลูกค้า', value: 'cusName', width: '120', sortable: false },
                { text: 'วันที่/เวลา', value: 'dueDate', sortable: false },
                { text: 'บริการ', value: 'flowNameShow', sortable: false, width: '150' },
                { text: 'เบอร์โทร', value: 'tel', sortable: false },
                { text: 'ป้ายชื่อกำกับ', value: 'memberDataTagName', sortable: false, align: 'center', width: '150' },
                // { text: 'Confirm นัดล่วงหน้า', value: 'action2', sortable: false, align: 'center' },
                { text: 'ชื่อพนักงาน', value: 'empFull_NameTH', align: 'center', sortable: false },
                { text: 'หมายเหตุ', value: 'remark', align: 'center', sortable: false, width: '160' },
                { text: 'จัดการ', value: 'action', sortable: false, align: 'center', width: '120' }
              ]
            } else {
              this.columnsSelected = [
                { text: 'ชื่อลูกค้า', value: 'cusName', width: '120', sortable: false },
                { text: 'วันที่/เวลา', value: 'dueDate', sortable: false },
                { text: 'บริการ', value: 'flowNameShow', sortable: false, width: '150' },
                { text: 'เบอร์โทร', value: 'tel', sortable: false },
                { text: 'ป้ายชื่อกำกับ', value: 'memberDataTagName', sortable: false, align: 'center', width: '150' },
                { text: 'Confirm นัดล่วงหน้า', value: 'action2', sortable: false, align: 'center' },
                { text: 'ชื่อพนักงาน', value: 'empFull_NameTH', align: 'center', sortable: false },
                { text: 'หมายเหตุ', value: 'remark', align: 'center', sortable: false, width: '160' },
                { text: 'จัดการ', value: 'action', sortable: false, align: 'center', width: '120' }
              ]
            }

            // ถ้า allFalse เป็น true แทรกคอลัมน์ "เงินมัดจำ"
            if (allFalse && this.$session.getAll().data.shopId !== this.shopNameData.officeOmbudsman) {
              const telIndex = this.columnsSelected.findIndex(col => col.value === 'tel')

              if (telIndex !== -1) {
                this.columnsSelected.splice(telIndex + 1, 0, {
                  text: 'เงินมัดจำ',
                  value: 'action40',
                  sortable: false,
                  align: 'center'
                })
              }
            }
          }
        } else if (text === 'wait') {
          if (
            this.$session.getAll().data.category === 'ธุรกิจรถยนต์' ||
            this.$session.getAll().data.category === '7'
          ) {
            this.columnsSelected = [
              // { text: 'Booking Id', value: 'bookNo' },
              {
                text: 'ชื่อลูกค้า',
                value: 'cusName',
                width: '150',
                sortable: false
              },
              {
                text: 'วันที่/เวลา',
                value: 'dueDate',
                width: '150',
                sortable: false
              },
              // { text: 'วันและเวลานัดหมาย', value: 'dueDate' },
              {
                text: 'บริการ',
                value: 'flowNameShow',
                width: '150',
                sortable: false
              },
              { text: 'เลขทะเบียน', value: 'cusReg', width: '120' },
              { text: 'เบอร์โทร', value: 'tel', sortable: false, width: '120' },
              {
                text: 'เงินมัดจำ',
                value: 'action40',
                align: 'center',
                width: '120',
                sortable: false
              },
              {
                text: 'ป้ายชื่อกำกับ',
                value: 'memberDataTagName',
                sortable: false,
                align: 'center',
                width: '160'
              },
              {
                text: 'หมายเหตุ',
                value: 'remark',
                align: 'center',
                sortable: false,
                width: '150'
              },
              {
                text: 'จัดการ',
                value: 'action',
                sortable: false,
                align: 'center',
                width: '100'
              }
            ]
          } else {
            console.log('DataFlowNameA => ', this.DataFlowNameA)
            let allFalse = false

            // ตรวจสอบว่ามีการเลือกสาขาหรือไม่
            const isBranchSelected = this.flowSelect !== 'AllFlow'

            // ถ้าเลือกสาขา ให้ตรวจสอบเฉพาะรายการที่ตรงกับสาขาที่เลือก
            if (isBranchSelected) {
              console.log('เลือกบริการ', this.flowSelect)

              const selectedFlow = this.DataFlowNameA.find(item => item.value === this.flowSelect && item.checkDeposit !== 'False') || 0
              console.log('selectedFlow ', selectedFlow)

              if (selectedFlow) {
                allFalse = true
                console.log('allFalse (เลือกสาขา)', allFalse)
              }
            } else {
              console.log('ไม่ได้เลือกบริการ ตรวจสอบทั้งหมด')

              const anyValidFlow = this.DataFlowNameA.some(item => item.checkDeposit !== 'False')
              console.log('anyValidFlow ', anyValidFlow)

              if (anyValidFlow) {
                allFalse = true
                console.log('allFalse (ทั้งหมด)', allFalse)
              }
            }

            // สร้าง columnsSelected
            if (this.$session.getAll().data.shopId === this.shopNameData.officeOmbudsman) {
              this.columnsSelected = [
                { text: 'ชื่อลูกค้า', value: 'cusName', width: '120', sortable: false },
                { text: 'วันที่/เวลา', value: 'dueDate', sortable: false },
                { text: 'บริการ', value: 'flowNameShow', sortable: false, width: '150' },
                { text: 'เบอร์โทร', value: 'tel', sortable: false },
                { text: 'ป้ายชื่อกำกับ', value: 'memberDataTagName', sortable: false, align: 'center', width: '150' },
                // { text: 'Confirm นัดล่วงหน้า', value: 'action2', sortable: false, align: 'center' },
                { text: 'ชื่อพนักงาน', value: 'empFull_NameTH', align: 'center', sortable: false },
                { text: 'หมายเหตุ', value: 'remark', align: 'center', sortable: false, width: '160' },
                { text: 'จัดการ', value: 'action', sortable: false, align: 'center', width: '120' }
              ]
            } else {
              this.columnsSelected = [
                { text: 'ชื่อลูกค้า', value: 'cusName', width: '120', sortable: false },
                { text: 'วันที่/เวลา', value: 'dueDate', sortable: false },
                { text: 'บริการ', value: 'flowNameShow', sortable: false, width: '150' },
                { text: 'เบอร์โทร', value: 'tel', sortable: false },
                { text: 'ป้ายชื่อกำกับ', value: 'memberDataTagName', sortable: false, align: 'center', width: '150' },
                { text: 'Confirm นัดล่วงหน้า', value: 'action2', sortable: false, align: 'center' },
                { text: 'ชื่อพนักงาน', value: 'empFull_NameTH', align: 'center', sortable: false },
                { text: 'หมายเหตุ', value: 'remark', align: 'center', sortable: false, width: '160' },
                { text: 'จัดการ', value: 'action', sortable: false, align: 'center', width: '120' }
              ]
            }

            // ถ้า allFalse เป็น true แทรกคอลัมน์ "เงินมัดจำ"
            if (allFalse && this.$session.getAll().data.shopId !== this.shopNameData.officeOmbudsman) {
              const telIndex = this.columnsSelected.findIndex(col => col.value === 'tel')

              if (telIndex !== -1) {
                this.columnsSelected.splice(telIndex + 1, 0, {
                  text: 'เงินมัดจำ',
                  value: 'action40',
                  sortable: false,
                  align: 'center'
                })
              }
            }
          }
        } else if (text === 'confirmJob') {
          if (
            this.$session.getAll().data.shopId ===
            'U9f316c85400fd716ea8c80d7cd5b61f8'
          ) {
            this.columnsSelected = [
              // { text: 'Booking Id', value: 'bookNo' },
              {
                text: 'ชื่อลูกค้า',
                value: 'cusName',
                width: '150',
                sortable: false
              },
              { text: 'วันที่/เวลา', value: 'dueDate', sortable: false },
              // { text: 'วันและเวลานัดหมาย', value: 'dueDate' },
              {
                text: 'บริการ',
                value: 'flowNameShow',
                sortable: false,
                width: '150'
              },
              { text: 'เบอร์โทร', value: 'tel', sortable: false },
              // { text: 'คุณสมบัติเพิ่มเติม', value: 'action3', sortable: false, align: 'center' },
              {
                text: 'Confirm นัดล่วงหน้า',
                value: 'action2',
                sortable: false,
                align: 'center'
              },
              {
                text: 'หมายเหตุ',
                value: 'remark',
                align: 'center',
                sortable: false,
                width: '120'
              },
              // { text: 'หมายเหตุเรียกกลับ', value: 'remarkReturn', align: 'center', sortable: false },
              {
                text: 'จัดการ',
                value: 'action',
                sortable: false,
                align: 'center',
                width: '100'
              }
            ]
          } else {
            if (
              this.$session.getAll().data.category === 'ธุรกิจรถยนต์' ||
              this.$session.getAll().data.category === '7'
            ) {
              this.columnsSelected = [
                // { text: 'Booking Id', value: 'bookNo' },
                {
                  text: 'ชื่อลูกค้า',
                  value: 'cusName',
                  width: '150',
                  sortable: false
                },
                { text: 'วันที่/เวลา', value: 'dueDate', sortable: false },
                // { text: 'วันและเวลานัดหมาย', value: 'dueDate' },
                {
                  text: 'บริการ',
                  value: 'flowNameShow',
                  sortable: false,
                  width: '150'
                },
                { text: 'เลขทะเบียน', value: 'cusReg', width: '120' },
                { text: 'เบอร์โทร', value: 'tel', sortable: false },
                {
                  text: 'ป้ายชื่อกำกับ',
                  value: 'memberDataTagName',
                  sortable: false,
                  align: 'center',
                  width: '150'
                },
                {
                  text: 'คุณสมบัติเพิ่มเติม',
                  value: 'action3',
                  sortable: false,
                  align: 'center'
                },
                {
                  text: 'Confirm นัดล่วงหน้า',
                  value: 'action2',
                  sortable: false,
                  align: 'center'
                },
                {
                  text: 'หมายเหตุ',
                  value: 'remark',
                  align: 'center',
                  sortable: false,
                  width: '120'
                },
                // { text: 'หมายเหตุเรียกกลับ', value: 'remarkReturn', align: 'center', sortable: false },
                {
                  text: 'จัดการ',
                  value: 'action',
                  sortable: false,
                  align: 'center',
                  width: '100'
                }
              ]
            } else {
              if (this.$session.getAll().data.shopId === this.shopNameData.officeOmbudsman) {
                this.columnsSelected = [
                // { text: 'Booking Id', value: 'bookNo' },
                  {
                    text: 'ชื่อลูกค้า',
                    value: 'cusName',
                    width: '150',
                    sortable: false
                  },
                  { text: 'วันที่/เวลา', value: 'dueDate', sortable: false },
                  // { text: 'วันและเวลานัดหมาย', value: 'dueDate' },
                  {
                    text: 'บริการ',
                    value: 'flowNameShow',
                    sortable: false,
                    width: '150'
                  },
                  { text: 'เบอร์โทร', value: 'tel', sortable: false },
                  {
                    text: 'ป้ายชื่อกำกับ',
                    value: 'memberDataTagName',
                    sortable: false,
                    align: 'center',
                    width: '150'
                  },
                  { text: 'ชื่อพนักงาน', value: 'empFull_NameTH', align: 'center', sortable: false },
                  // {
                  //   text: 'Confirm นัดล่วงหน้า',
                  //   value: 'action2',
                  //   sortable: false,
                  //   align: 'center'
                  // },
                  {
                    text: 'หมายเหตุ',
                    value: 'remark',
                    align: 'center',
                    sortable: false,
                    width: '120'
                  },
                  // { text: 'หมายเหตุเรียกกลับ', value: 'remarkReturn', align: 'center', sortable: false },
                  {
                    text: 'จัดการ',
                    value: 'action',
                    sortable: false,
                    align: 'center',
                    width: '100'
                  }
                ]
              } else {
                this.columnsSelected = [
                // { text: 'Booking Id', value: 'bookNo' },
                  {
                    text: 'ชื่อลูกค้า',
                    value: 'cusName',
                    width: '150',
                    sortable: false
                  },
                  { text: 'วันที่/เวลา', value: 'dueDate', sortable: false },
                  // { text: 'วันและเวลานัดหมาย', value: 'dueDate' },
                  {
                    text: 'บริการ',
                    value: 'flowNameShow',
                    sortable: false,
                    width: '150'
                  },
                  { text: 'เบอร์โทร', value: 'tel', sortable: false },
                  {
                    text: 'ป้ายชื่อกำกับ',
                    value: 'memberDataTagName',
                    sortable: false,
                    align: 'center',
                    width: '150'
                  },
                  {
                    text: 'คุณสมบัติเพิ่มเติม',
                    value: 'action3',
                    sortable: false,
                    align: 'center'
                  },
                  {
                    text: 'Confirm นัดล่วงหน้า',
                    value: 'action2',
                    sortable: false,
                    align: 'center'
                  },
                  {
                    text: 'หมายเหตุ',
                    value: 'remark',
                    align: 'center',
                    sortable: false,
                    width: '120'
                  },
                  // { text: 'หมายเหตุเรียกกลับ', value: 'remarkReturn', align: 'center', sortable: false },
                  {
                    text: 'จัดการ',
                    value: 'action',
                    sortable: false,
                    align: 'center',
                    width: '100'
                  }
                ]
              }
            }
          }
        } else {
          console.log('Time 6', new Date())
          if (
            this.$session.getAll().data.shopId ===
            'U9f316c85400fd716ea8c80d7cd5b61f8'
          ) {
            this.columnsSelected = [
              // { text: 'Booking Id', value: 'bookNo' },
              {
                text: 'ชื่อลูกค้า',
                value: 'cusName',
                width: '150',
                sortable: false
              },
              { text: 'วันที่/เวลา', value: 'dueDate', sortable: false },
              // { text: 'วันและเวลานัดหมาย', value: 'dueDate' },
              {
                text: 'บริการ',
                value: 'flowNameShow',
                sortable: false,
                width: '150'
              },
              { text: 'เบอร์โทร', value: 'tel', sortable: false },
              // { text: 'คุณสมบัติเพิ่มเติม', value: 'action3', sortable: false, align: 'center', width: '120' },
              {
                text: 'Confirm นัดล่วงหน้า',
                value: 'action2',
                sortable: false,
                align: 'center'
              },
              {
                text: 'หมายเหตุ',
                value: 'remark',
                align: 'center',
                width: '170'
              },
              {
                text: 'จัดการ',
                value: 'action',
                sortable: false,
                align: 'center'
              }
            ]
          } else {
            if (
              this.$session.getAll().data.category === 'ธุรกิจรถยนต์' ||
              this.$session.getAll().data.category === '7'
            ) {
              this.columnsSelected = [
                // { text: 'Booking Id', value: 'bookNo' },
                {
                  text: 'ชื่อลูกค้า',
                  value: 'cusName',
                  width: '150',
                  sortable: false
                },
                { text: 'วันที่/เวลา', value: 'dueDate', sortable: false },
                // { text: 'วันและเวลานัดหมาย', value: 'dueDate' },
                {
                  text: 'บริการ',
                  value: 'flowNameShow',
                  sortable: false,
                  width: '150'
                },
                { text: 'เลขทะเบียน', value: 'cusReg', width: '120' },
                { text: 'เบอร์โทร', value: 'tel', sortable: false },
                {
                  text: 'คุณสมบัติเพิ่มเติม',
                  value: 'action3',
                  sortable: false,
                  align: 'center',
                  width: '120'
                },
                {
                  text: 'Confirm นัดล่วงหน้า',
                  value: 'action2',
                  sortable: false,
                  align: 'center'
                },
                {
                  text: 'หมายเหตุ',
                  value: 'remark',
                  align: 'center',
                  width: '170'
                },
                {
                  text: 'จัดการ',
                  value: 'action',
                  sortable: false,
                  align: 'center'
                }
              ]
            } else {
              console.log('Time 7', new Date())
              if (this.$session.getAll().data.shopId === this.shopNameData.officeOmbudsman) {
                this.columnsSelected = [
                // { text: 'Booking Id', value: 'bookNo' },
                  {
                    text: 'ชื่อลูกค้า',
                    value: 'cusName',
                    width: '150',
                    sortable: false
                  },
                  { text: 'วันที่/เวลา', value: 'dueDate', sortable: false },
                  // { text: 'วันและเวลานัดหมาย', value: 'dueDate' },
                  {
                    text: 'บริการ',
                    value: 'flowNameShow',
                    sortable: false,
                    width: '150'
                  },
                  { text: 'เบอร์โทร', value: 'tel', sortable: false },
                  { text: 'ชื่อพนักงาน', value: 'empFull_NameTH', align: 'center', sortable: false },
                  {
                    text: 'หมายเหตุ',
                    value: 'remark',
                    align: 'center',
                    width: '170'
                  },
                  {
                    text: 'จัดการ',
                    value: 'action',
                    sortable: false,
                    align: 'center'
                  }
                ]
              } else {
                this.columnsSelected = [
                // { text: 'Booking Id', value: 'bookNo' },
                  {
                    text: 'ชื่อลูกค้า',
                    value: 'cusName',
                    width: '150',
                    sortable: false
                  },
                  { text: 'วันที่/เวลา', value: 'dueDate', sortable: false },
                  // { text: 'วันและเวลานัดหมาย', value: 'dueDate' },
                  {
                    text: 'บริการ',
                    value: 'flowNameShow',
                    sortable: false,
                    width: '150'
                  },
                  { text: 'เบอร์โทร', value: 'tel', sortable: false },
                  {
                    text: 'คุณสมบัติเพิ่มเติม',
                    value: 'action3',
                    sortable: false,
                    align: 'center',
                    width: '120'
                  },
                  {
                    text: 'Confirm นัดล่วงหน้า',
                    value: 'action2',
                    sortable: false,
                    align: 'center'
                  },
                  {
                    text: 'หมายเหตุ',
                    value: 'remark',
                    align: 'center',
                    width: '170'
                  },
                  {
                    text: 'จัดการ',
                    value: 'action',
                    sortable: false,
                    align: 'center'
                  }
                ]
              }
            }
            console.log('Time 8', new Date())
          }
        }
      }
      // }
      this.FixHeaderByShopSelect()
      this.checkTypeSort()
    },
    FixHeaderByShopSelect () {
      if (this.$session.getAll().data.shopId === this.shopNameData.yara) { // custom herdar ร้าน ปุ่ยยาลา
        this.columnsSelected = [
          // { text: 'Booking Id', value: 'bookNo' },
          { text: 'ชื่อลูกค้า', value: 'cusName', width: '150' },
          { text: 'วันที่/เวลา', value: 'dueDate', width: '120', sortable: false },
          // { text: 'วันและเวลานัดหมาย', value: 'dueDate' },
          { text: 'บริการ', value: 'flowNameShow', width: '150' },
          { text: 'Zone', value: 'zone', width: '150' },
          { text: 'จังหวัดท้ายเลขทะเบียน', value: 'province', width: '140', sortable: false },
          { text: 'เลขทะเบียน', value: 'cusReg', width: '120' },
          { text: 'เบอร์โทร', value: 'tel', width: '100', sortable: false },
          { text: 'ชื่อบริษัทของลูกค้า', value: 'company', width: '150', sortable: false },
          { text: 'เลขคิว', value: 'remarkQueue', width: '90' },
          {
            text: 'หมายเหตุ',
            value: 'remark',
            align: 'center',
            sortable: false,
            width: '160'
          },
          { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
        ]
      }
    },
    updateTimeTablefromChild (timeTable) {
      this.timeTable = timeTable
    },
    async getTimesChange (text) {
      try {
        this.dataItemTimesChange = []
        this.dataRemoveExport = []
        if (text === 'all') {
          this.dataItemTimesChange = this.dataItem
          this.dataRemoveExport = this.dataItemTimesChange.filter(el => {
            return el.statusBt === 'cancel'
          })
          this.BookingDataListTimechange = this.BookingDataList
        } else {
          if (this.masBranchID) {
            this.masBranchID = this.masBranchID
          } else {
            if (this.branch.length > 0) {
              this.masBranchID = this.branch[0].value
            } else {
              this.masBranchID = ''
            }
          }
          this.dataItemCheck = []
          var dataItems = []
          if (this.timeTable !== '') {
            var dateStart = moment(
              moment(this.timeTable, 'YYYY-MM-DD').toDate()
            ).format('YYYY-MM-DD')
            console.log('dateStartxx', dateStart)
            console.log('timeTable', this.timeTable)
            await this.getBookingDataListTimechange(dateStart)

            // var dataItemTimes = []
            let urlApi = ''
            if (this.flowSelect === 'AllFlow') {
              urlApi =
                this.$DNS_IP +
                '/booking_view/get?shopId=' +
                this.session.data.shopId +
                '&masBranchID=' +
                this.masBranchID +
                '&dueDate=' +
                this.timeTable +
                this.selectOnsite
            } else {
              urlApi =
                this.$DNS_IP +
                '/booking_view/get?shopId=' +
                this.session.data.shopId +
                '&masBranchID=' +
                this.masBranchID +
                '&dueDate=' +
                this.timeTable +
                '&flowId=' +
                this.flowSelect +
                this.selectOnsite
            }
            await axios.get(urlApi).then(async response => {
              console.log('getData-------', response.data)
              if (response.data.length > 0) {
                for (let i = 0; i < response.data.length; i++) {
                  let d = response.data[i]
                  let s = {}
                  s.packageName = d.packageName
                  s.packageDetails = d.packageDetails
                  s.packageImage = d.packageImage
                  s.packagePrice = d.packagePrice
                  s.packageBalanceAmount = d.packageBalanceAmount
                  s.packageAmount = d.packageAmount
                  s.packagePoint = d.packagePoint
                  s.packageExpire = d.packageExpire
                  s.masBranchID = d.masBranchID
                  s.masBranchName = d.masBranchName
                  s.masBranchNameEn = d.masBranchNameEn
                  s.bookNo = d.bookNo
                  s.flowId = d.flowId
                  s.flowName = d.flowName
                  s.dueDate = d.dueDate
                  s.dueDateTimeStamp = d.dueDateTimeStamp
                  s.remarkRemove = d.remarkRemove
                  s.remark = d.remark
                  s.userId = d.userId
                  s.chkConfirm = false
                  s.chkCancel = false
                  s.jobNo = d.jobNo
                  s.statusUpload1 = d.statusUpload1 || 'False'
                  s.statusUpload2 = d.statusUpload2 || 'False'
                  s.fileUpload1 = d.fileUpload1 || '[]'
                  s.fileUpload2 = d.fileUpload2 || '[]'
                  s.empFull_NameTH = d.empFull_NameTH
                  s.extraJob = d.extraJob === 'true' || d.extraJob === 'True'
                  s.fastTrack =
                    d.fastTrack === 'true' || d.fastTrack === 'True'
                  s.remarkRemove = d.remarkRemove || ''
                  s.cancelBy = d.cancelBy || '-'
                  switch (d.cancelBy) {
                    case 'system':
                      s.cancelBy = 'ยกเลิกโดยระบบ'
                      break
                    case 'user':
                      s.cancelBy = 'ยกเลิกโดยประชาชน'
                      break
                    case 'admin':
                      s.cancelBy = 'ยกเลิกโดยเจ้าหน้าที่'
                      break
                  }
                  s.timeDueHtext = d.timeDueH + ':00'
                  s.timeDuetext = d.timeDue
                  if (d.statusUseBt === 'use' && d.statusBt === 'confirm') {
                    s.chkConfirm = true
                    s.chkCancel = false
                  }
                  if (d.statusUseBt === 'use' && d.statusBt === 'cancel') {
                    s.chkConfirm = false
                    s.chkCancel = true
                  }
                  s.statusBt = d.statusBt || 'wait'
                  switch (d.statusBt) {
                    case 'confirm':
                      s.statusBtText = 'ยืนยันแล้ว'
                      break
                    case 'cancel':
                      s.statusBtText = 'ยกเลิก'
                      break
                    case 'confirmJob':
                      s.statusBtText = 'รับรถแล้ว'
                      break
                    default:
                      s.statusBtText = 'รายการนัดหมายใหม่'
                      break
                  }
                  s.cusName = this.getDataFromFieldName(
                    this.BookingDataListTimechange[d.bookNo],
                    'ชื่อ'
                  )
                  s.cusReg = this.getDataFromFieldName(
                    this.BookingDataListTimechange[d.bookNo],
                    'เลขทะเบียน'
                  )
                  s.tel = this.getDataFromFieldName(
                    this.BookingDataListTimechange[d.bookNo],
                    'เบอร์โทร'
                  )
                  s.cusName =
                    s.cusName.length > 0 ? s.cusName[0].fieldValue : ''
                  s.cusReg = s.cusReg.length > 0 ? s.cusReg[0].fieldValue : ''
                  s.tel = s.tel.length > 0 ? s.tel[0].fieldValue : ''

                  s.memberDataTag = JSON.parse(d.memberDataTag) || []
                  if (s.memberDataTag.length > 0) {
                    s.tagDataShow = []
                    let memberDataTag = s.memberDataTag
                    for (let i = 0; i < memberDataTag.length; i++) {
                      let d = memberDataTag[i]
                      let x = {}
                      let checkTagItem = this.tagItem.filter(el => {
                        return el.value === d
                      })
                      if (checkTagItem.length > 0) {
                        x.text = checkTagItem[0].text
                        x.value = checkTagItem[0].value
                        s.tagDataShow.push(x)
                      }
                    }
                  }
                  dataItems.push(s)
                }
              }
              if (dataItems.length === 0 || dataItems.status === false) {
                this.dataItemCheck = []
                // this.dataItemTime = []
                // this.dataReady = true
                // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
              } else {
                // console.log('month new if')
                console.log('month new if', dataItems)
                this.dataItemCheck = dataItems
                this.dataItemTimesChange = this.dataItemCheck.sort((a, b) => {
                  if (a.timeDuetext < b.timeDuetext) return -1
                  return a.timeDuetext > b.timeDuetext ? 1 : 0
                })
                // this.dataItemTimesChange = this.dataItemCheck.filter(el => {
                //   let dueDate = moment(moment(el.dueDate, 'YYYY-MM-DD').toDate()).format('YYYY-MM-DD')
                //   return dueDate === this.timeTable
                //   // return new Date(el.dueDate).toISOString().substr(0, 10) === this.timeTable
                // }).sort((a, b) => {
                //   if (a.timeDuetext < b.timeDuetext) return -1
                //   return a.timeDuetext > b.timeDuetext ? 1 : 0
                // })
                this.dataRemoveExport = this.dataItemTimesChange.filter(el => {
                  return el.statusBt === 'cancel'
                })
                // console.log('this.dataRemoveExport', this.dataRemoveExport)
              }
            })
          }
          // } else {
          //   console.log('month new else')
          //   this.dataItemTimesChange = this.dataItemCheck.filter(el => {
          //     let dueDate = moment(moment(el.dueDate, 'YYYY-MM-DD').toDate()).format('YYYY-MM-DD')
          //     return dueDate === this.timeTable
          //     // return new Date(el.dueDate).toISOString().substr(0, 10) === this.timeTable
          //   }).sort((a, b) => {
          //     if (a.timeDuetext < b.timeDuetext) return -1
          //     return a.timeDuetext > b.timeDuetext ? 1 : 0
          //   })
          // }
        }
        // this.dataRemoveExport = this.dataItemTimesChange.filter(el => { return el.statusBt === 'cancel' })
        // console.log('this.dataRemoveExport', this.dataRemoveExport)
      } catch (err) {
        console.log(err)
      }
    },
    async getBookingDataListTimechange (dateStart) {
      this.BookingDataListTimechange = []
      if (this.masBranchID) {
        this.masBranchID = this.masBranchID
      } else {
        if (this.branch.length > 0) {
          this.masBranchID = this.branch[0].value
        } else {
          this.masBranchID = ''
        }
      }
      let url = `${this.$DNS_IP}/BookingData/getView?shopId=${this.session.data.shopId}&masBranchID=${this.masBranchID}&dueDate=${dateStart}`
      await axios.get(url).then(async response => {
        if (response.data.status !== false) {
          response.data.forEach(row => {
            // console.log('row', row)
            if (row.fieldType === 'Checkbox') {
              // console.log('row.value ', row.fieldValue)

              try {
                // ตรวจสอบและแปลงจากสตริงที่เหมือนอาร์เรย์ให้เป็นอาร์เรย์จริง ๆ
                const arrayValue = typeof row.fieldValue === 'string' ? JSON.parse(row.fieldValue) : row.fieldValue

                // ถ้าแปลงสำเร็จและเป็นอาร์เรย์จริง
                if (Array.isArray(arrayValue)) {
                  row.fieldValue = arrayValue.join(',') // แปลงเป็นสตริงคั่นด้วยจุลภาค
                } else {
                  console.warn('row.fieldValue is not an array:', row.fieldValue)
                }
              } catch (error) {
                console.error('Error parsing row.fieldValue:', error)
              }
            }
            if (
              typeof this.BookingDataListTimechange[row.bookNo] === 'undefined'
            ) {
              this.BookingDataListTimechange[row.bookNo] = []
            }
            this.BookingDataListTimechange[row.bookNo].push(row)
          })
        }
      })
      console.log('อะไรครับเนี่ย', this.BookingDataListTimechange)
    },
    async getBookingDataList (dateStart, searchOther, flowSelect) {
      console.log('dateStart', dateStart)
      this.BookingDataList = []
      if (this.masBranchID) {
        this.masBranchID = this.masBranchID
      } else {
        if (this.branch.length > 0) {
          this.masBranchID = this.branch[0].value
        } else {
          this.masBranchID = ''
        }
      }
      let categoryUser = ''
      if (
        this.$session.getAll().data.category === 'ธุรกิจรถยนต์' ||
        this.$session.getAll().data.category === '7'
      ) {
        categoryUser = 'ธุรกิจรถยนต์'
      } else {
        categoryUser = this.$session.getAll().data.category
      }
      let url = ''
      if (dateStart === 'no') {
        url = `${this.$DNS_IP}/BookingData/getsearchName?shopId=${this.session.data.shopId}&fieldValue=${searchOther}&category=${categoryUser}&masBranchID=${this.masBranchID}`
        // url = `${this.$DNS_IP}/BookingData/getsearchOther?shopId=${this.session.data.shopId}&fieldValue=${searchOther}`
      } else {
        if (flowSelect === 'AllFlow') {
          url = `${this.$DNS_IP}/BookingData/getView?shopId=${this.session.data.shopId}&masBranchID=${this.masBranchID}&dueDate=${dateStart}`
        } else {
          url = `${this.$DNS_IP}/BookingData/getView?shopId=${this.session.data.shopId}&masBranchID=${this.masBranchID}&dueDate=${dateStart}}&flowId=${flowSelect}`
        }
      }
      await axios
        .get(url)
        .then(async response => {
          if (response.data.status !== false) {
            response.data.forEach(row => {
              if (typeof this.BookingDataList[row.bookNo] === 'undefined') {
                this.BookingDataList[row.bookNo] = []
              }
              this.BookingDataList[row.bookNo].push(row)
            })
          }
        })
        .catch(error => {
          // this.dataEditReady = true
          setTimeout(
            () => this.getBookingDataList(dateStart, searchOther, flowSelect),
            3000
          )
          console.log('catch getBookingDataList : ', error)
        })
      console.log('this.BookingDataList1', this.BookingDataList)
    },
    async getBookingList () {
      await this.getTagData()
      clearInterval(this.setTimerCalendar)
      this.setTimerCalendar = null

      if (
        this.session.data.masBranchID === '' ||
        this.session.data.masBranchID === null
      ) {
        this.statusBranchReadonly = false
        if (this.masBranchID) {
          this.masBranchID = this.masBranchID
        } else {
          if (this.branch.length > 0) {
            this.masBranchID = this.branch[0].value
          } else {
            await this.getDataBranch()
            if (this.branch.length > 0) {
              this.masBranchID = this.branch[0].value
            } else {
              this.masBranchID = ''
              this.$swal(
                'ผิดพลาด',
                'กรุณาตรวจสอบสาขาของท่าน เนื่องจากระบบตรวจหาสาขาไม่พบ',
                'error'
              )
            }
            // this.getBookingList()
          }
        }
      } else {
        this.statusBranchReadonly = true
        if (
          this.branch.filter(el => {
            return el.value === this.session.data.masBranchID
          }).length > 0
        ) {
          this.masBranchID = this.session.data.masBranchID
        } else {
          await this.getDataBranch()
          if (
            this.branch.filter(el => {
              return el.value === this.session.data.masBranchID
            }).length > 0
          ) {
            this.masBranchID = this.session.data.masBranchID
          } else {
            this.masBranchID = ''
            this.$swal(
              'ผิดพลาด',
              'กรุณาตรวจสอบสาขาของท่าน เนื่องจากระบบตรวจหาสาขาไม่พบ',
              'error'
            )
          }
          // this.getBookingList()
        }
      }
      // console.log('getDataFlow', result)
      console.log('masBranchID', this.masBranchID)
      // if (this.masBranchID !== '') {
      //   this.DataFlowName = result.filter(el => { return el.masBranchID === this.masBranchID })
      // } else {
      //   this.DataFlowName = result
      // }
      if (this.flowSelect !== '') {
        this.flowSelect = this.flowSelect
      } else {
        this.DataFlowName = this.DataFlowNameDefault.filter(el => {
          return (
            parseInt(el.masBranchID) === this.masBranchID ||
            el.value === 'AllFlow' ||
            el.value === 'All'
          )
        })
        if (this.DataFlowName.length > 0) {
          console.log('masBranchID', this.DataFlowName)
          this.flowSelect = this.DataFlowName[0].value
        } else {
          this.flowSelect = ''
          await this.getDataFlow()
          console.log('masBranchID', this.DataFlowName)
          // this.flowSelect = this.DataFlowName[0].value
          // this.getBookingList()
        }
      }
      console.log('this.flowSelect1', this.flowSelect)
      // this.dataReady = false
      this.selectedStatus = true
      // this.getSelectText = ''
      this.dataItem = []
      this.countWaiting = 0
      this.countConfirm = 0
      this.countCancel = 0
      this.countJob = 0
      this.countAll = 0
      // Clear ช่องค้นหา
      // this.searchAll2 = ''
      var dataItemTimes = []
      var dataItems = []
      // await this.getShowMap()
      let urlApi = ''
      if (this.flowSelect === 'AllFlow') {
        // await this.getBookingDataList(this.dateStart, '', 'AllFlow')
        urlApi =
          this.$DNS_IP +
          '/booking_view/get?shopId=' +
          this.session.data.shopId +
          '&masBranchID=' +
          this.masBranchID +
          '&dueDate=' +
          this.dateStart +
          this.selectOnsite
      } else {
        // await this.getBookingDataList(this.dateStart, '', this.flowSelect)
        urlApi =
          this.$DNS_IP +
          '/booking_view/get?shopId=' +
          this.session.data.shopId +
          '&masBranchID=' +
          this.masBranchID +
          '&dueDate=' +
          this.dateStart +
          '&flowId=' +
          this.flowSelect +
          this.selectOnsite
      }
      await axios
        .get(urlApi)
        .then(async response => {
          console.log('getData12123123123123', response.data)
          if (response.data.length > 0) {
            for (let i = 0; i < response.data.length; i++) {
              let d = response.data[i]
              let s = {}
              // if (this.BookingDataList[d.bookNo] !== undefined) {
              // console.log('branch no flow', d.masBranchID, d.flowId)
              s.bookNo = d.bookNo
              s.flowId = d.flowId
              let checkDeposit = this.DataFlowNameDefault.filter(el => {
                return el.value === parseInt(d.flowId)
              })
              if (checkDeposit.length > 0) {
                s.depositCheckStatus =
                  checkDeposit[0].allData.checkDeposit || 'False'
              } else {
                s.depositCheckStatus = 'False'
              }
              s.flowName = d.flowName
              s.dueDate = d.dueDate || ''
              if (d.timeText === null || d.timeText === '') {
                d.timeText = d.timeDue
              }
              if (s.dueDate === '') {
                s.dueDateText = 'ไม่มีเวลานัดหมาย'
              } else {
                s.dueDateText = d.dueDateTextDay + ' ' + d.timeText
              }
              s.cusName = d.bookingDataCustomerName || ''
              s.cusReg = d.bookingDataCustomerRegisNumber || ''
              s.tel = d.bookingDataCustomerTel || ''
              s.displayFlowName = d.displayFlowName || ''
              s.company = d.bookingDataCustomerCompany || ''
              s.province = d.bookingDataCustomerProvince || ''
              s.remarkQueue = d.remarkQueue || ''
              s.shopId = d.shopId
              s.dueDateDay = d.dueDateDay
              s.statusVIP = d.statusVIP
              s.checkDateConfirmJob = d.checkDateConfirmJob
              s.bookingLanguage = d.bookingLanguage
              s.zone = d.bookingDataCustomerZone
              s.packageName = d.packageName
              s.packageDetails = d.packageDetails
              s.packageImage = d.packageImage
              s.packagePrice = d.packagePrice
              s.packageBalanceAmount = d.packageBalanceAmount
              s.packageAmount = d.packageAmount
              s.packagePoint = d.packagePoint
              s.packageExpire = d.packageExpire
              s.depositTextTH = d.depositTextTH
              s.CREATE_DATE_Status = d.CREATE_DATE_Status
              s.CREATE_DATE = d.CREATE_DATE
              s.menuShowStatus = d.menuShowStatus
              s.dueDateTextDay = d.dueDateTextDay
              s.remark = d.remark || ''
              s.masBranchID = d.masBranchID
              s.limitBookingCheck = d.limitBookingCheck
              s.memberId = d.memberId || ''
              s.countHourLimit = d.countHourLimit
              s.empSelect = d.empSelect
              s.empFull_NameTH = d.empFull_NameTH || ''
              s.empFull_NameTH = s.empFull_NameTH.replace('นางสาว', '')
              s.empFull_NameTH = s.empFull_NameTH.replace('นาย', '')
              s.empFull_NameTH = s.empFull_NameTH.replace('นาง', '')
              s.userId = d.userId
              s.chkConfirm = false
              s.chkCancel = false
              s.address = d.address
              s.addressLatLong = d.addressLatLong
              s.jobNo = d.jobNo
              s.timeText = d.timeText
              s.remarkRemove = d.remarkRemove || ''
              s.cancelBy = d.cancelBy || '-'
              switch (d.cancelBy) {
                case 'system':
                  s.cancelBy = 'ยกเลิกโดยระบบ'
                  break
                case 'user':
                  s.cancelBy = 'ยกเลิกโดยประชาชน'
                  break
                case 'admin':
                  s.cancelBy = 'ยกเลิกโดยเจ้าหน้าที่'
                  break
              }
              s.remarkConfirm1 =
                d.remarkConfirm1 === 'true' || d.remarkConfirm1 === 'True'
              s.remarkConfirm2 =
                d.remarkConfirm2 === 'true' || d.remarkConfirm2 === 'True'
              s.extraJob = d.extraJob === 'true' || d.extraJob === 'True'
              s.fastTrack = d.fastTrack === 'true' || d.fastTrack === 'True'
              s.depositStatus = d.depositStatus || 'False'
              s.paymentType = d.paymentType || ''
              s.depositImge = d.depositImge || ''
              s.depositReturnImge = d.depositReturnImge || ''
              s.depositPrice = d.depositPrice || ''
              s.remarkDepositLinked = d.remarkDepositLinked || ''
              s.lineUserId = d.lineUserId
              s.checkDeposit = d.checkDeposit
              s.memberPicture = d.memberPicture
              s.memberName = d.memberName
              s.timeDueHtext = d.timeDueH + ':00'
              s.timeDuetext = d.timeDue
              s.countChangeTime = d.countChangeTime || 0
              s.remarkReturn = d.remarkReturn || ''
              s.dateReturn = d.dateReturn || ''
              s.packageId = d.packageId || ''
              s.tokenPackage = d.tokenPackage || ''
              s.RECORD_STATUS_Job = d.RECORD_STATUS_Job || ''
              s.menuItem = d.menuItem || []
              s.menuPrice = d.menuPrice || ''
              s.memberDataTagName = []
              try {
                s.memberDataTag = JSON.parse(d.memberDataTag) || []
                if (s.memberDataTag.length > 0) {
                  s.tagDataShow = []
                  let memberDataTag = s.memberDataTag
                  for (let i = 0; i < memberDataTag.length; i++) {
                    let d = memberDataTag[i]
                    let x = {}
                    let checkTagItem = this.tagItem.filter(el => {
                      return el.value === d
                    })
                    if (checkTagItem.length > 0) {
                      x.text = checkTagItem[0].text
                      x.value = checkTagItem[0].value
                      s.tagDataShow.push(x)
                      s.memberDataTagName.push(x.text)
                    }
                  }
                }
                s.memberDataTagName = s.memberDataTagName.join(', ')
              } catch (error) {
                s.tagDataShow = []
                console.log(error)
              }
              this.countAll = this.countAll + 1
              if (d.statusUseBt === 'use' && d.statusBt === 'confirm') {
                s.chkConfirm = true
                s.chkCancel = false
              }
              if (d.statusUseBt === 'use' && d.statusBt === 'cancel') {
                s.chkConfirm = false
                s.chkCancel = true
              }
              s.statusBt = d.statusBt || 'wait'
              switch (d.statusBt) {
                case 'confirm':
                  s.statusBtText = 'ยืนยันแล้ว'
                  this.countConfirm = this.countConfirm + 1
                  break
                case 'cancel':
                  s.statusBtText = 'ยกเลิก'
                  this.countCancel = this.countCancel + 1
                  break
                case 'confirmJob':
                  s.statusBtText = 'รับรถแล้ว'
                  this.countJob = this.countJob + 1
                  break
                // default:
                //   s.statusBtText = 'รายการนัดหมายใหม่'
                //   this.countWaiting = this.countWaiting + 1
                //   break
              }
              var chkTime = this.dataItemTime.filter(el => {
                return el.timeDueHtext === s.timeDueHtext
              })
              if (chkTime.length === 0) {
                dataItemTimes.push(s)
              }
              // s.cusName = this.getDataFromFieldName(this.BookingDataList[d.bookNo], 'ชื่อ')
              // s.cusReg = this.getDataFromFieldName(this.BookingDataList[d.bookNo], 'เลขทะเบียน')
              // s.tel = this.getDataFromFieldName(this.BookingDataList[d.bookNo], 'เบอร์โทร')
              // s.cusName = (s.cusName.length > 0) ? s.cusName[0].fieldValue : ''
              // s.cusReg = (s.cusReg.length > 0) ? s.cusReg[0].fieldValue : ''
              // s.tel = (s.tel.length > 0) ? s.tel[0].fieldValue : ''
              if (s.statusBt !== 'wait') {
                dataItems.push(s)
              }
              // } else {
              //   console.log('BookingNo no bookingData', d.bookNo)
              // }
            }
            console.log('dataItemsnn', dataItems)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.dataReady = true
          //   this.$router.push('/system/Errorpage?returnLink=' + returnLink)
        })
      let urlApiwait = ''
      if (this.flowSelect === 'AllFlow') {
        urlApiwait =
          this.$DNS_IP +
          '/booking_view/get?shopId=' +
          this.session.data.shopId +
          '&masBranchID=' +
          this.masBranchID +
          '&statusBt=null' +
          this.selectOnsite
      } else {
        urlApiwait =
          this.$DNS_IP +
          '/booking_view/get?shopId=' +
          this.session.data.shopId +
          '&masBranchID=' +
          this.masBranchID +
          '&statusBt=null&flowId=' +
          this.flowSelect +
          this.selectOnsite
      }
      console.log('aaaaaaaaa')
      await axios.get(urlApiwait).then(async responses => {
        if (responses.data.length > 0) {
          console.log('length!@#!@#!@#!@#!@#!@#!@#!@#!@#', responses.data)
          for (let i = 0; i < responses.data.length; i++) {
            let d = responses.data[i]
            let s = {}
            // if (this.BookingDataList[d.bookNo] !== undefined) {
            // console.log('branch no flow', d.masBranchID, d.flowId)
            s.bookNo = d.bookNo
            s.flowId = d.flowId
            let checkDeposit = this.DataFlowNameDefault.filter(el => {
              return el.value === parseInt(d.flowId)
            })
            if (checkDeposit.length > 0) {
              s.depositCheckStatus =
                checkDeposit[0].allData.checkDeposit || 'False'
            } else {
              s.depositCheckStatus = 'False'
            }
            s.flowName = d.flowName
            s.dueDate = d.dueDate || ''
            if (d.timeText === null || d.timeText === '') {
              d.timeText = d.timeDue
            }
            if (s.dueDate === '') {
              s.dueDateText = 'ไม่มีเวลานัดหมาย'
            } else {
              s.dueDateText = d.dueDateTextDay + ' ' + d.timeText
            }
            s.statusUpload1 = d.statusUpload1 || 'False'
            s.statusUpload2 = d.statusUpload2 || 'False'
            s.fileUpload1 = d.fileUpload1 || '[]'
            s.fileUpload2 = d.fileUpload2 || '[]'
            s.shopId = d.shopId
            s.dueDateDay = d.dueDateDay
            s.statusVIP = d.statusVIP
            s.checkDateConfirmJob = d.checkDateConfirmJob
            s.bookingLanguage = d.bookingLanguage
            s.zone = d.bookingDataCustomerZone
            s.packageName = d.packageName
            s.packageDetails = d.packageDetails
            s.packageImage = d.packageImage
            s.packagePrice = d.packagePrice
            s.packageBalanceAmount = d.packageBalanceAmount
            s.packageAmount = d.packageAmount
            s.packagePoint = d.packagePoint
            s.packageExpire = d.packageExpire
            s.depositTextTH = d.depositTextTH
            s.CREATE_DATE_Status = d.CREATE_DATE_Status
            s.CREATE_DATE = d.CREATE_DATE
            s.menuShowStatus = d.menuShowStatus
            s.dueDateTextDay = d.dueDateTextDay
            s.checkDeposit = d.checkDeposit
            s.remark = d.remark || ''
            s.masBranchID = d.masBranchID
            s.limitBookingCheck = d.limitBookingCheck
            s.memberId = d.memberId || ''
            s.countHourLimit = d.countHourLimit
            s.empSelect = d.empSelect
            s.empFull_NameTH = d.empFull_NameTH || ''
            s.empFull_NameTH = s.empFull_NameTH.replace('นางสาว', '')
            s.empFull_NameTH = s.empFull_NameTH.replace('นาย', '')
            s.empFull_NameTH = s.empFull_NameTH.replace('นาง', '')
            s.userId = d.userId
            s.chkConfirm = false
            s.chkCancel = false
            s.address = d.address
            s.addressLatLong = d.addressLatLong
            s.jobNo = d.jobNo
            s.timeText = d.timeText
            s.remarkRemove = d.remarkRemove || ''
            s.cancelBy = d.cancelBy || '-'
            switch (d.cancelBy) {
              case 'system':
                s.cancelBy = 'ยกเลิกโดยระบบ'
                break
              case 'user':
                s.cancelBy = 'ยกเลิกโดยประชาชน'
                break
              case 'admin':
                s.cancelBy = 'ยกเลิกโดยเจ้าหน้าที่'
                break
            }
            s.remarkConfirm1 =
              d.remarkConfirm1 === 'true' || d.remarkConfirm1 === 'True'
            s.remarkConfirm2 =
              d.remarkConfirm2 === 'true' || d.remarkConfirm2 === 'True'
            s.extraJob = d.extraJob === 'true' || d.extraJob === 'True'
            s.fastTrack = d.fastTrack === 'true' || d.fastTrack === 'True'
            s.depositStatus = d.depositStatus || 'False'
            s.paymentType = d.paymentType || ''
            s.depositImge = d.depositImge || ''
            s.depositReturnImge = d.depositReturnImge || ''
            s.depositPrice = d.depositPrice || ''
            s.remarkDepositLinked = d.remarkDepositLinked || ''
            s.lineUserId = d.lineUserId
            s.memberPicture = d.memberPicture
            s.memberName = d.memberName
            s.timeDueHtext = d.timeDueH + ':00'
            s.timeDuetext = d.timeDue
            s.countChangeTime = d.countChangeTime || 0
            s.remarkReturn = d.remarkReturn || ''
            s.dateReturn = d.dateReturn || ''
            s.packageId = d.packageId || ''
            s.tokenPackage = d.tokenPackage || ''
            s.RECORD_STATUS_Job = d.RECORD_STATUS_Job || ''
            s.menuItem = d.menuItem || []
            s.menuPrice = d.menuPrice || ''
            this.countAll = this.countAll + 1
            if (d.statusUseBt === 'use' && d.statusBt === 'confirm') {
              s.chkConfirm = true
              s.chkCancel = false
            }
            if (d.statusUseBt === 'use' && d.statusBt === 'cancel') {
              s.chkConfirm = false
              s.chkCancel = true
            }
            s.statusBt = d.statusBt || 'wait'
            switch (s.statusBt) {
              case 'wait':
                s.statusBtText = 'รายการนัดหมายใหม่'
                this.countWaiting = this.countWaiting + 1
                break
            }
            var chkTime = this.dataItemTime.filter(el => {
              return el.timeDueHtext === s.timeDueHtext
            })
            if (chkTime.length === 0) {
              dataItemTimes.push(s)
            }
            s.cusName = d.bookingDataCustomerName || ''
            s.cusReg = d.bookingDataCustomerRegisNumber || ''
            s.tel = d.bookingDataCustomerTel || ''
            s.displayFlowName = d.displayFlowName || ''
            s.company = d.bookingDataCustomerCompany || ''
            s.province = d.bookingDataCustomerProvince || ''
            s.remarkQueue = d.remarkQueue || ''
            // s.remarkQueue = d.remarkQueue || ''
            // s.cusName = this.getDataFromFieldName(this.BookingDataList[d.bookNo], 'ชื่อ')
            // s.cusReg = this.getDataFromFieldName(this.BookingDataList[d.bookNo], 'เลขทะเบียน')
            // s.tel = this.getDataFromFieldName(this.BookingDataList[d.bookNo], 'เบอร์โทร')
            // s.cusName = (s.cusName.length > 0) ? s.cusName[0].fieldValue : ''
            // s.cusReg = (s.cusReg.length > 0) ? s.cusReg[0].fieldValue : ''
            // s.tel = (s.tel.length > 0) ? s.tel[0].fieldValue : ''
            s.memberDataTagName = []
            s.memberDataTag = JSON.parse(d.memberDataTag) || []
            if (s.memberDataTag.length > 0) {
              s.tagDataShow = []
              let memberDataTag = s.memberDataTag
              for (let i = 0; i < memberDataTag.length; i++) {
                let d = memberDataTag[i]
                let x = {}
                let checkTagItem = this.tagItem.filter(el => {
                  return el.value === d
                })
                if (checkTagItem.length > 0) {
                  x.text = checkTagItem[0].text
                  x.value = checkTagItem[0].value
                  s.tagDataShow.push(x)
                  s.memberDataTagName.push(x.text)
                }
              }
            }
            s.memberDataTagName = s.memberDataTagName.join(', ')
            dataItems.push(s)
            // console.log('this.countWaiting', this.countWaiting)
            // } else {
            //   console.log('BookingNo no bookingData', d.bookNo)
            // }
          }
        }
      })
      if (dataItems.length === 0 || dataItems.status === false) {
        this.dataItem = []
        this.dataItemTime = []
        // await this.getTimesChange('update')
        if (this.getSelectText) {
          this.getSelect(this.getSelectText, 0, this.filterCloseJobValue)
        } else {
          this.getSelect('wait', this.countWaiting, this.filterCloseJobValue)
        }
        this.dataReady = true
        // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
      } else {
        this.dataItem = dataItems
        var datause = dataItemTimes.sort((a, b) => {
          if (a.timeDueHtext < b.timeDueHtext) return -1
          return a.timeDueHtext > b.timeDueHtext ? 1 : 0
        })
        for (var k = 0; k < datause.length; k++) {
          var t = datause[k]
          var h = {}
          h.timeDueHtext = t.timeDueHtext
          let chkTimes = this.dataItemTime.filter(el => {
            return el.timeDueHtext === t.timeDueHtext
          })
          // console.log('chkTimes', chkTimes)
          if (chkTimes.length === 0) {
            // console.log('datause(H)', h)
            this.dataItemTime.push(h)
          }
        }
        console.log('dataItemTime', this.dataItemTime)
        // await this.getTimesChange('update')
        if (this.$route.query.bookNoNoti) {
          let checkBook = dataItems.filter(el => {
            return el.bookNo === this.$route.query.bookNoNoti
          })
          if (checkBook.length > 0) {
            this.getSelectText = checkBook[0].statusBt
            this.searchAll2 = checkBook[0].cusName
          }
        }
        if (this.getSelectText) {
          this.getSelect(this.getSelectText, 0, this.filterCloseJobValue)
        } else {
          this.getSelect('wait', this.countWaiting, this.filterCloseJobValue)
        }
        this.dataReady = true
      }
    },
    async getBookingField () {
      // this.bookingField = []
      let itemIncustomField = []
      await axios
        .get(
          this.$DNS_IP + '/BookingField/get?shopId=' + this.session.data.shopId
        )
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            this.formAdd.bookingId = rs[0].bookingId
            let bookingData = []
            bookingData = JSON.parse(rs[0].flowfieldName)
            for (let i = 0; i < bookingData.length; i++) {
              let d = bookingData[i]
              itemIncustomField.push(d.fieldId)
            }
            await this.getCustomField(itemIncustomField)
          } else {
            this.$swal(
              'พบความผิดพลาดระหว่างดำเนินการ',
              'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่',
              'info'
            )
              .then(result => {
                this.dialogAdd = false
                this.clearDataAdd()
              })
              .catch(error => {
                console.log('error function addData : ', error)
                this.dialogAdd = false
                this.clearDataAdd()
              })
          }
        })
        .catch(error => {
          this.$swal(
            'พบความผิดพลาดระหว่างดำเนินการ',
            'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่',
            'info'
          )
            .then(result => {
              this.dialogAdd = false
              this.clearDataAdd()
            })
            .catch(error => {
              console.log('error function addData : ', error)
              this.dialogAdd = false
              this.clearDataAdd()
            })
          console.log('error function addData : ', error)
        })
    },
    async getCustomField (item) {
      this.fieldNameItem = []
      await axios
        .get(this.$DNS_IP + '/customField/fieldId?fieldId=' + item)
        .then(async response => {
          let rs = response.data
          // let aa = []
          if (rs.length > 0) {
            let sortrs = rs.sort((a, b) => a.sortNoField - b.sortNoField)
            for (let i = 0; i < sortrs.length; i++) {
              let d = sortrs[i]
              let s = {}
              s.fieldId = d.fieldId
              s.fieldName = d.fieldName
              s.fieldType = d.fieldType
              s.optionField = d.optionField
              s.conditionField = d.conditionField
              s.conditionValue = d.conditionValue
              s.shopId = d.shopId
              s.fieldValue = s.fieldType === 'Checkbox' ? '[]' : ''
              s.requiredField = d.requiredField
              this.fieldNameItem.push(s)
            }
            var data1 = this.fieldNameItem.filter(
              el => parseInt(el.conditionField || 0) > 0
            )
            // var data2 = []
            for (var i = 0; i < data1.length; i++) {
              var d = data1[i]
              var indexC = this.fieldNameItem.findIndex(function (o) {
                return o.fieldId === d.fieldId
              })
              var indexF = this.fieldNameItem.findIndex(function (o) {
                return o.fieldId === parseInt(d.conditionField)
              })
              this.fieldNameItem.splice(
                indexF + 1,
                0,
                this.fieldNameItem.splice(indexC, 1)[0]
              )
              // data2.push({'indexC': indexC, 'indexF': indexF})
            }
            // setTimeout(() => this.validate('ADD'), 500)
          } else {
            this.$swal(
              'พบความผิดพลาดระหว่างดำเนินการ',
              'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่',
              'info'
            )
              .then(result => {
                this.dialogAdd = false
                this.clearDataAdd()
              })
              .catch(error => {
                console.log('error function addData : ', error)
                this.dialogAdd = false
                this.clearDataAdd()
              })
          }
        })
        .catch(error => {
          this.$swal(
            'พบความผิดพลาดระหว่างดำเนินการ',
            'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่',
            'info'
          )
            .then(result => {
              this.dialogAdd = false
              this.clearDataAdd()
            })
            .catch(error => {
              console.log('error function addData : ', error)
              this.dialogAdd = false
              this.clearDataAdd()
            })
          console.log('error function addData : ', error)
        })
    },
    async getflowfield (item) {
      this.flowfieldNameitem = []
      let itemIncustomField = []
      await axios
        .get(
          this.$DNS_IP +
            '/flowField/get?flowId=' +
            item.flowId +
            '&shopId=' +
            this.session.data.shopId
        )
        .then(response => {
          let tt = response.data
          console.log('tt', tt)
          if (tt.length > 0) {
            let flowId = tt[0].flowId
            let flowfieldName = []
            flowfieldName = JSON.parse(tt[0].flowfieldName)
            console.log('!@_!@_!@_!@_!@_!@_!@_!@_!@_!@_!@_!@_', flowfieldName)
            if (flowfieldName.length > 0) {
              for (let a = 0; a < flowfieldName.length; a++) {
                let d = flowfieldName[a]
                itemIncustomField.push(d.fieldId)
              }
              this.getCustomfieldFlow(itemIncustomField, flowId)
            }
          }
          // console.log('itemIncustomField', itemIncustomField)
        })
    },
    async getCustomfieldFlow (item, flowId) {
      let flowfieldNameitems = []
      this.flowfieldNameitem = []
      await axios
        .get(this.$DNS_IP + '/customField/fieldId?fieldId=' + item)
        .then(async response => {
          let rs = response.data
          console.log('rs', rs)
          let sortrs = rs.sort((a, b) => a.sortNoField - b.sortNoField)
          for (var i = 0; i < sortrs.length; i++) {
            let d = sortrs[i]
            let s = {}
            s.fieldId = d.fieldId
            s.flowId = flowId
            s.fieldName = d.fieldName
            s.optionField = d.optionField
            s.conditionField = d.conditionField || ''
            s.fieldType = d.fieldType
            s.fieldValue = s.fieldType === 'Checkbox' ? '[]' : ''
            s.CREATE_USER = ''
            s.LAST_USER = ''
            s.showCard = d.showCard
            s.shopId = this.$session.getAll().data.shopId
            s.endDate = ''
            s.endTime = ''
            s.checkCar = 'False'
            s.conditionValue = d.conditionValue
            s.requiredField = d.requiredField
            flowfieldNameitems.push(s)
          }
          var data1 = flowfieldNameitems.filter(
            el => parseInt(el.conditionField || 0) > 0
          )
          // var data2 = []
          for (let i = 0; i < data1.length; i++) {
            let d = data1[i]
            let indexC = flowfieldNameitems.findIndex(function (o) {
              return o.fieldId === d.fieldId
            })
            let indexF = flowfieldNameitems.findIndex(function (o) {
              return o.fieldId === parseInt(d.conditionField)
            })
            flowfieldNameitems.splice(
              indexF + 1,
              0,
              flowfieldNameitems.splice(indexC, 1)[0]
            )
            // data2.push({'indexC': indexC, 'indexF': indexF})
          }
          // console.log('data1', data1)
          // console.log('data2', data2)
          for (var x = 0; x < flowfieldNameitems.length; x++) {
            var s = flowfieldNameitems[x]
            var chk = this.BookingDataItem.filter(el => {
              return parseInt(el.fieldId) === s.fieldId
            })
            console.log('cccxxx', s)
            console.log('chk', chk)
            if (chk.length === 0) {
              this.flowfieldNameitem.push(s)
            }
          }
          // console.log('flowfieldNameitems', this.flowfieldNameitem)
          // console.log('flowfieldNameitems', flowfieldNameitems)
          // console.log('BookingDataItem', this.BookingDataItem)
          // setTimeout(() => this.validate('ADD'), 500)
        })
        .catch(error => {
          console.log('error function addData : ', error)
        })
    },
    addData () {
      this.loadingAdd = true
      let dtTime = this.dataFlowSelectAdd.filter(item => {
        return item.value === this.formAdd.flowId
      })
      if (dtTime.length > 0) {
        if (
          dtTime[0].menuShowStatus === 'True' &&
          this.dataMenuAdd.filter(el => {
            return parseInt(el.qty) > 0
          }).length === 0
        ) {
          this.loadingAdd = false
          this.$swal('แจ้งเตือน', 'กรุณาเลือกเมนู', 'info')
        } else {
          this.validate('ADD')
          setTimeout(() => this.addDataSubmit(), 500)
        }
      } else {
        this.validate('ADD')
        setTimeout(() => this.addDataSubmit(), 500)
      }
    },
    async addDataInsert () {
      // this.swalConfig.title = 'ต้องการ บันทึกข้อมูล ใช่หรือไม่?'
      // this.$swal(this.swalConfig)
      //   .then(async result => {
      if (this.$session.id() !== undefined) {
        this.dataReadyAdd = false
        var fastTrack = 'False'
        var extraJob = 'False'
        switch (this.formAdd.radiosRemark) {
          case 'ซ่อมปกติ':
            fastTrack = 'False'
            extraJob = 'False'
            break
          case 'ExtraJob':
            fastTrack = 'False'
            extraJob = 'True'
            break
          case 'FastTrack':
            fastTrack = 'True'
            extraJob = 'False'
            break
        }
        let flowIdData = this.formAdd.flowId
        let rs = this.fieldNameItem
        let Add = []
        let fielditem = this.fieldNameItem
        if (this.checkDepositAdd === 'False') {
          this.formAdd.depositStatus = ''
          this.formAdd.depositImge = ''
          this.formAdd.depositPrice = ''
        } else {
          if (this.dataDepositAdd === 'มี') {
            console.log('this.dataDepositAdd-if', this.dataDepositAdd)
            if (this.formAdd.depositPrice === null) {
              this.formAdd.depositPrice = ''
            }
            this.formAdd.depositStatus = 'True'
            if (this.filesDepositAdd) {
              const _this = this
              let configDepositUpload = {
                headers: {
                  bookNo: 'BK' + moment().unix()
                }
              }
              let params = new FormData()
              params.append('file', this.filesDepositAdd)
              await axios
                .post(
                  this.$DNS_IP + `/file/upload/deposit`,
                  params,
                  configDepositUpload
                )
                .then(function (response) {
                  _this.formAdd.depositImge = response.data
                  console.log('url Pic', response.data)
                })
            } else {
              this.formAdd.depositImge = this.pictureUrlPreviewDeposit
            }
          } else {
            console.log('this.dataDepositAdd-else', this.dataDepositAdd)
            if (this.formAdd.depositPrice === null) {
              this.formAdd.depositPrice = ''
            }
            this.formAdd.depositStatus = 'False'
            this.formAdd.depositImge = ''
          }
        }
        console.log('this.fieldNameItem', this.fieldNameItem)
        let limitBookingCheck = ''
        if (this.checkLimitBooking.limitCheck === 'true' || null) {
          limitBookingCheck = 'True'
        } else {
          limitBookingCheck = 'False'
        }
        let storeFront = this.DataFlowNameDefault.filter(item => {
          return item.value === this.formAdd.flowId
        })
        let storeFrontCheck = ''
        if (storeFront.length > 0) {
          storeFrontCheck = storeFront[0].allData.storeFrontCheck || 'False'
        } else {
          storeFrontCheck = 'False'
        }
        let timeValue = ''
        let timeTime = ''
        if (this.time.value) {
          timeValue = this.time.value
          timeTime = this.time.text
        } else {
          timeValue = ''
          timeTime = ''
        }
        for (let i = 0; i < rs.length; i++) {
          let d = rs[i]
          let update = {}
          if (d.conditionField === '' || d.conditionField === null) {
            update.masBranchID = this.formAdd.masBranchID
            update.bookingFieldId = d.bookingFieldId
            update.remark = this.remark
            update.flowId = this.formAdd.flowId
            update.fieldId = d.fieldId
            update.fieldValue = (d.fieldValue || '').replace(/\\/g, '\\\\').replace(/'/g, "\\'")
            update.shopId = d.shopId
            update.dueDate = this.date + ' ' + timeValue
            update.dateSelect = this.date
            update.timeSelect = timeValue
            update.timeText = timeTime
            update.userId = 'user-skip'
            update.pageName = 'BookingList'
            update.sourceLink = 'direct'
            update.fastTrack = fastTrack
            update.extraJob = extraJob
            update.depositStatus = this.formAdd.depositStatus
            update.depositImge = this.formAdd.depositImge
            update.empSelect = this.empSelectAdd
            update.adminLogin = this.session.data.userName
            update.limitBookingCheck = limitBookingCheck
            update.limitBookingId = this.checkLimitBooking.ID
            update.limitBookingCount = this.checkLimitBooking.countBooking
            update.getLimitBooking = this.checkLimitBooking.limitBooking
            update.depositPrice = this.formAdd.depositPrice
            update.storeFrontCheck = storeFrontCheck
            if (this.statusVIP === 'True') {
              update.statusVIP = 'True'
            } else {
              update.statusVIP = 'False'
            }
            update.statusBookingForm = 'BookingForm'
            update.address = (this.address || '')
              .replace(/%/g, '%%')
              .replace(/'/g, "\\'")
            update.addressLatLong = JSON.stringify(this.center)
            if (this.dataMenuAdd.filter(i => parseInt(i.qty) > 0).length > 0) {
              update.menuItem = JSON.stringify(
                this.dataMenuAdd.filter(i => parseInt(i.qty) > 0)
              )
              update.menuPrice = this.priceMenuAdd
            }
            Add.push(update)
          } else {
            if (
              fielditem.filter(row => {
                return row.fieldId === parseInt(d.conditionField)
              }).length > 0
            ) {
              if (
                d.conditionValue ===
                fielditem.filter(row => {
                  return row.fieldId === parseInt(d.conditionField)
                })[0].fieldValue
              ) {
                update.masBranchID = this.formAdd.masBranchID
                update.bookingFieldId = d.bookingFieldId
                update.remark = this.remark
                update.flowId = this.formAdd.flowId
                update.fieldId = d.fieldId
                update.fieldValue = (d.fieldValue || '').replace(/\\/g, '\\\\').replace(/'/g, "\\'")
                update.shopId = d.shopId
                update.dueDate = this.date + ' ' + timeValue
                update.dateSelect = this.date
                update.timeSelect = timeValue
                update.timeText = timeTime
                update.sourceLink = 'direct'
                update.userId = 'user-skip'
                update.pageName = 'BookingList'
                update.fastTrack = fastTrack
                update.extraJob = extraJob
                update.depositStatus = this.formAdd.depositStatus
                update.depositImge = this.formAdd.depositImge
                update.empSelect = this.empSelectAdd
                update.adminLogin = this.session.data.userName
                update.limitBookingCheck = limitBookingCheck
                update.limitBookingId = this.checkLimitBooking.ID
                update.limitBookingCount = this.checkLimitBooking.countBooking
                update.getLimitBooking = this.checkLimitBooking.limitBooking
                update.depositPrice = this.formAdd.depositPrice
                update.storeFrontCheck = storeFrontCheck
                if (this.statusVIP === 'True') {
                  update.statusVIP = 'True'
                } else {
                  update.statusVIP = 'False'
                }
                update.statusBookingForm = 'BookingForm'
                update.address = (this.address || '')
                  .replace(/%/g, '%%')
                  .replace(/'/g, "\\'")
                update.addressLatLong = JSON.stringify(this.center)
                if (
                  this.dataMenuAdd.filter(i => parseInt(i.qty) > 0).length > 0
                ) {
                  update.menuItem = JSON.stringify(
                    this.dataMenuAdd.filter(i => parseInt(i.qty) > 0)
                  )
                  update.menuPrice = this.priceMenuAdd
                }
                update.limitBookingCheck = limitBookingCheck
                update.limitBookingId = this.checkLimitBooking.ID
                update.limitBookingCount = this.checkLimitBooking.countBooking
                update.getLimitBooking = this.checkLimitBooking.limitBooking
                Add.push(update)
              }
            } else if (d.conditionField === 'flow') {
              if (
                parseInt(d.conditionValue) === parseInt(this.formAdd.flowId)
              ) {
                update.masBranchID = this.formAdd.masBranchID
                update.bookingFieldId = d.bookingFieldId
                update.remark = this.remark
                update.flowId = this.formAdd.flowId
                update.fieldId = d.fieldId
                update.fieldValue = (d.fieldValue || '').replace(/\\/g, '\\\\').replace(/'/g, "\\'")
                update.shopId = d.shopId
                update.dueDate = this.date + ' ' + timeValue
                update.dateSelect = this.date
                update.timeSelect = timeValue
                update.timeText = timeTime
                update.sourceLink = 'direct'
                update.userId = 'user-skip'
                update.pageName = 'BookingList'
                update.fastTrack = fastTrack
                update.extraJob = extraJob
                update.depositStatus = this.formAdd.depositStatus
                update.depositImge = this.formAdd.depositImge
                update.empSelect = this.empSelectAdd
                update.adminLogin = this.session.data.userName
                update.limitBookingCheck = limitBookingCheck
                update.limitBookingId = this.checkLimitBooking.ID
                update.limitBookingCount = this.checkLimitBooking.countBooking
                update.getLimitBooking = this.checkLimitBooking.limitBooking
                update.depositPrice = this.formAdd.depositPrice
                update.storeFrontCheck = storeFrontCheck
                if (this.statusVIP === 'True') {
                  update.statusVIP = 'True'
                } else {
                  update.statusVIP = 'False'
                }
                update.statusBookingForm = 'BookingForm'
                update.address = (this.address || '')
                  .replace(/%/g, '%%')
                  .replace(/'/g, "\\'")
                update.addressLatLong = JSON.stringify(this.center)
                if (
                  this.dataMenuAdd.filter(i => parseInt(i.qty) > 0).length > 0
                ) {
                  update.menuItem = JSON.stringify(
                    this.dataMenuAdd.filter(i => parseInt(i.qty) > 0)
                  )
                  update.menuPrice = this.priceMenuAdd
                }
                update.limitBookingCheck = limitBookingCheck
                update.limitBookingId = this.checkLimitBooking.ID
                update.limitBookingCount = this.checkLimitBooking.countBooking
                update.getLimitBooking = this.checkLimitBooking.limitBooking
                Add.push(update)
              }
            }
          }
        }
        console.log('Add', Add)
        axios
          .post(this.$DNS_IP + '/Booking/add', Add)
          .then(async response => {
            // this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
            if (response.data.message === 'LimitBooking_Full') {
              this.$swal(
                'คิวเต็มแล้ว',
                'กรุณาเลือกวันที่และเวลาใหม่อีกครั้ง',
                'error'
              )
              this.date = ''
              this.time = ''
            } else {
              let checkDeposit = this.DataFlowNameDefault.filter(el => {
                return el.value === parseInt(this.formAdd.flowId)
              })
              let depositCheckStatus = ''
              if (checkDeposit.length > 0) {
                depositCheckStatus =
                  checkDeposit[0].allData.checkDeposit || 'False'
              } else {
                depositCheckStatus = 'False'
              }
              if (depositCheckStatus === 'True') {
                if (this.dataDepositAdd === 'มี') {
                  await this.confirmChkAdd(response.data)
                } else {
                  this.clearDataAdd()
                  this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                }
                this.dialogShowDeposit = true
                this.bookNo = response.data.bookNo

                this.depositPrice = this.formAdd.depositPrice
                this.depositLink =
                  'https://betask-linked.web.app/Thank?shopId=' +
                  this.$session.getAll().data.shopId +
                  '&redirectBy=BookingAdmin&flowId=' +
                  flowIdData +
                  '&bookNo=' +
                  response.data.bookNo
              } else {
                await this.confirmChkAdd(response.data)
              }
            }
            if (
              this.$session.getAll().data.shopId ===
              'Ue388ea246b5b4b4419a714516b5ae54a'
            ) {
              await this.pushMsgLineNotifyGroup(response.data.bookNo)
            }
            // console.log('addDataGlobal DNS_IP + /job/add', response)

            console.log('response.data.bookNo chk', response.data.bookNo)
            if (this.checkShopSigneture[this.$session.getAll().data.shopId]) {
              let body = [{
                shopId: this.$session.getAll().data.shopId,
                bookNo: response.data.bookNo,
                jobNo: '',
                beforeAir: '',
                checkBox1: '',
                checkBox2: '',
                remarkCheckbox1: '',
                remarkCheckbox2: '',
                remarkDetail: '',
                redio1: '',
                afterAir: '',
                remark: '',
                CREATE_USER: this.$session.getAll().data.userName,
                LAST_USER: this.$session.getAll().data.userName,
                processNow: ''
              }]
              console.log('body shopId', body)
              await axios.post(this.$DNS_IP + '/formpdf/insert', body)
              // await axios.post(this.$DNS_IP + 'http://localhost:5002/formpdf/insert', body)
            }
          })
          .catch(error => {
            console.log('error function addData : ', error)
            setTimeout(() => this.addDataInsert(), 3000)
          })
        // })
        // .catch(error => {
        //   console.log('Cencel : ', error)
        //   this.closeSetTimeGetCalenda()
        // })
      } else {
        this.$swal('ผิดพลาด', 'กรุณาลองอีกครั้ง', 'error')
        clearInterval(this.setTimerCalendar)
        this.setTimerCalendar = null
        this.$router.push('/Core/Login')
      }
    },
    async addDataSubmit () {
      if (this.validAdd === true) {
        if (this.$session.id() !== undefined) {
          if (this.formAdd.radiosRemark === 'FastTrack') {
            let getcount = await this.getCountFastTrack(
              this.date,
              this.formAdd.flowId,
              this.formAdd.masBranchID
            )
            let setCountFast = this.branch.filter(el => {
              return el.value === this.formAdd.masBranchID
            })[0].allData.countFastTrack
            if (getcount < setCountFast) {
              if (
                this.DataFlowNameDefault.filter(item => {
                  return item.value === this.formAdd.flowId
                })[0].allData.limitBookingCheck === 'True'
              ) {
                await this.checkLimit()
                // console.log('test', this.branchData.filter(item => { return item.masBranchID === this.formAdd.masBranchID })[0].setTime)
                if (this.checkLimitBooking.limitCheck === 'true') {
                  this.dialogAddCon = true
                } else if (this.checkLimitBooking.limitCheck === 'false') {
                  console.log('else1402')
                  this.$swal(
                    'คิวเต็มแล้ว',
                    'กรุณาเลือกวันที่ใหม่อีกครั้ง',
                    'error'
                  )
                  this.date = ''
                  this.time = ''
                } else {
                  this.checkLimitBooking.limitCheck = 'true'
                  this.dialogAddCon = true
                  console.log('else1407')
                }
              } else {
                this.checkLimitBooking.limitCheck = 'false'
                this.dialogAddCon = true
                console.log('else1407')
              }
            } else {
              this.textError = 'จำนวนงานด่วนต่อวัน เกินกว่าที่ตั้งไว้'
              this.dialogError = true
              this.loadingAdd = false
            }
          } else {
            if (
              this.DataFlowNameDefault.filter(item => {
                return item.value === this.formAdd.flowId
              })[0].allData.limitBookingCheck === 'True'
            ) {
              await this.checkLimit()
              // console.log('test', this.branchData.filter(item => { return item.masBranchID === this.formAdd.masBranchID })[0].setTime)
              if (this.checkLimitBooking.limitCheck === 'true') {
                this.dialogAddCon = true
              } else if (this.checkLimitBooking.limitCheck === 'false') {
                console.log('else1402')
                this.$swal(
                  'คิวเต็มแล้ว',
                  'กรุณาเลือกวันที่ใหม่อีกครั้ง',
                  'error'
                )
                this.date = ''
                this.time = ''
              } else {
                this.dialogAddCon = true
                this.checkLimitBooking.limitCheck = 'true'
                console.log('else1407')
              }
            } else {
              this.dialogAddCon = true
              this.checkLimitBooking.limitCheck = 'false'
            }
          }
        } else {
          this.$swal('ผิดพลาด', 'กรุณาลองอีกครั้ง', 'error')
          clearInterval(this.setTimerCalendar)
          this.setTimerCalendar = null
          this.$router.push('/Core/Login')
        }
      } else {
        this.loadingAdd = false
      }
    },
    async pushMsglineGroup (bookNo) {
      await axios
        .post(this.$DNS_IP + '/Booking/pushMsgLineGroup/' + bookNo)
        .then(response => {
          this.clearData()
        })
    },
    async confirmChkAdd (item) {
      var dt = {
        bookNo: item.bookNo,
        contactDate: moment().format('YYYY-MM-DD HH:mm:ss'),
        status: 'confirm',
        statusUse: 'use',
        shopId: this.$session.getAll().data.shopId,
        CREATE_USER: this.session.data.userName,
        LAST_USER: this.session.data.userName
      }
      await axios
        .post(this.$DNS_IP + '/booking_transaction/add', dt)
        .then(async response => {
          // this.getDataCalendaBooking()
          this.sendEmailConfirm(dt.bookNo)
          if (this.statusGoogleCalendar === 'True') {
            this.connectGoogleCalendar('Add', dt.bookNo)
          }
          this.clearDataAdd()
          const dataNo = await axios
            .get(
              // eslint-disable-next-line quotes
              this.$DNS_IP + "/Booking/getID?bookNo=" + item.bookNo
            )
          console.log('dataNo', dataNo)
          if (dataNo.status === 200) {
            this.$swal({
              title: `<span style="font-size: 60px;">${dataNo.data.storeFrontQueue !== null ? ' ' + dataNo.data.storeFrontQueue + ' ' : ''}</span>`,
              text: 'เพิ่มข้อมูลเรียบร้อย',
              type: 'success'
            })
          } else {
            this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
          }
          // this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
          await this.updateProcessShopNew()
          // await this.getBookingList()
          // this.getTimesChange('update')
        })
        .catch(error => {
          console.log('error function addData : ', error)
          setTimeout(() => this.confirmChkAdd(), 3000)
        })
    },
    async clearDataAdd () {
      this.showMenu = 'False'
      this.dataMenuAdd = []
      this.dataReady = true
      this.date = ''
      this.time = ''
      this.empSelectAdd = ''
      this.remark = ''
      this.formAdd.radiosRemark = ''
      this.formAdd.depositStatus = ''
      this.formAdd.depositImge = ''
      this.formAdd.pictureUrlPreviewDeposit = ''
      this.filesDepositAdd = null
      this.dataDepositAdd = 'ไม่มี'
      this.DataflowId = ''
      this.formAdd.bookingId = null
      this.formAdd.fieldId = ''
      this.formAdd.fieldValue = ''
      this.formAdd.flowId = null
      this.formAdd.masBranchID = null
      this.formAdd.dueDate = ''
      this.formAdd.shopId = this.$session.getAll().data.shopId
      this.dialogAdd = false
      this.dialogAddCon = false
      this.loadingAdd = false
      Object.keys(this.selected).forEach(key => {
        this.selected[key] = []
      })
      this.address = ''
      this.center = null
      this.dataReadyAdd = true
      clearInterval(this.setTimerCalendar)
      this.setTimerCalendar = null
      if (this.statusSearch === 'no') {
        this.getBookingList()
      } else {
        this.searchAny()
      }
      if (this.getSelectText) {
        this.getSelect(
          this.getSelectText,
          this.getSelectCount,
          this.filterCloseJobValue
        )
      }
      this.getDataCalendaBooking()
    },
    async getDataById (dt) {
      console.log('dt', dt)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.$DNS_IP + "/Booking/getID?bookNo=" + dt.bookNo
        )
        .then(async response => {
          this.dataReady = true
          if (response.data) {
            Object.assign(this.formUpdate, response.data)
            delete this.formUpdate['RECORD_STATUS']
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          this.dataReady = true
          console.log('error function getDataById : ', error)
          //   this.$router.push('/system/Errorpage?returnLink=' + returnLink)
        })
    },
    async deleteData () {
      this.swalConfig.title = 'ต้องการ ลบข้อมูล ใช่หรือไม่?'
      this.$swal(this.swalConfig)
        .then(async result => {
          this.formUpdate.LAST_USER = this.$session.getAll().data.userName
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.$DNS_IP + "/Booking/delete/" + this.formUpdate.bookNo,
              this.formUpdate
            )
            .then(async response => {
              // Debug response
              console.log('DNS_IP + PATH + "delete/"', response)

              this.$swal('เรียบร้อย', 'ลบข้อมูลเรียบร้อย', 'success')
              // Close Dialog

              // Load Data
              if (this.statusSearch === 'no') {
                await this.getBookingList()
              } else {
                await this.searchAny()
              }
              // this.getTimesChange('update')
              if (this.getSelectText) {
                this.getSelect(
                  this.getSelectText,
                  this.getSelectCount,
                  this.filterCloseJobValue
                )
              }
              this.getDataCalendaBooking()
              this.dialogDelete = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.dataReady = true
              this.$swal('ผิดพลาด', 'ผิดพลาด -1', 'error')
              console.log('error function deleteDataGlobal : ', error)
              //   this.$router.push('/system/Errorpage?returnLink=' + returnLink)
            })
        })
        .catch(error => {
          this.dataReady = true
          this.$swal('ผิดพลาด', 'ผิดพลาด -2', 'error')
          console.log('error function deleteDataGlobal : ', error)
        })
    },
    async getBookingDataJob (dt, text) {
      this.masBranchIDAddJob = dt.masBranchID
      this.dataEmpOnsite = dt
      this.dueDateText = dt.dueDateText
      let dateCurrent = moment().format('YYYY-MM-DD')
      let dueDate = dt.dueDateDay
      if (this.$session.getAll().data.shopId === this.shopNameData.yara && this.$session.getAll().data.USER_ROLE === 'user') {
        this.empSelectJob = parseInt(this.$session.getAll().data.empId)
      }
      if (dt.checkDateConfirmJob === 'True') {
        this.statusConfirmJob = true
      } else {
        if (dateCurrent >= dueDate) {
          this.statusConfirmJob = true
        } else {
          this.statusConfirmJob = false
        }
      }
      // console.log('this.statusConfirmJob', this.statusConfirmJob)
      let checkStep = await axios.get(
        this.$DNS_IP + '/flowStep/get?flowId=' + dt.flowId
      )
      console.log('checkStep', checkStep)
      if (checkStep.data.status === false) {
        this.endDate = moment().format('YYYY-MM-DD')
        this.endTime = moment().format('HH:mm')
        this.statusShowDateConfiremjob = false
      } else {
        this.statusShowDateConfiremjob = true
      }
      this.dueDate = dt.dueDateTextDay
      if (this.statusConfirmJob && this.showOnsite === 'แสดง') {
        this.jobCheckPackage = false
        console.log('dt', dt)
        this.dateTimestamp = moment().unix()
        this.remark = dt.remark
        this.userId = dt.userId
        this.lineUserId = dt.lineUserId
        console.log(this.userId, this.lineUserId)
        if (dt.packageId !== '') {
          this.dataPackageDefault = true
        } else {
          this.dataPackageDefault = false
        }
        await this.getPackage(dt)
        if (this.dataPackage.length > 0) {
          console.log(
            'dataPackage',
            this.dataPackage.filter(el => {
              return el.packageId === dt.packageId
            })
          )
          if (
            this.dataPackage.filter(el => {
              return el.packageId === dt.packageId
            }).length > 0
          ) {
            let dataPack = this.dataPackage.filter(el => {
              return el.packageId === dt.packageId
            })
            this.dataPackageDefault = true
            // this.packageId = dataPack[0].value
            this.UpdatePackage(
              dataPack[0].value,
              'ตกลง',
              dataPack[0].text,
              dataPack[0],
              dt.tokenPackage
            )
          } else {
            this.UpdatePackage('', 'ยกเลิก', '', '', '')
            this.dataPackageDefault = false
          }
        }
        this.checkTimeFlow(dt)
        this.BookingDataItem = []
        let itemIncustomField = []

        await axios
          .get(
            this.$DNS_IP + '/BookingField/get?shopId=' + this.session.data.shopId
          )
          .then(async response1 => {
            let rs2 = response1.data
            console.log('BookingField', rs2)
            if (rs2.length > 0) {
              let bookingData = []
              bookingData = JSON.parse(rs2[0].flowfieldName)
              for (let i = 0; i < bookingData.length; i++) {
                let d = bookingData[i]
                itemIncustomField.push(d.fieldId)
              }
              await axios
                .get(
                  this.$DNS_IP +
                    '/customField/fieldId?fieldId=' +
                    itemIncustomField
                )
                .then(async responses => {
                  let rs1 = responses.data
                  await axios
                    .get(
                      this.$DNS_IP + '/BookingDataSelect/get?bookNo=' + dt.bookNo
                    )
                    .then(async response => {
                      let rs = response.data
                      if (rs.length > 0) {
                        console.log('BookingDataSelect', rs)
                        console.log('customField', rs1)
                        let sortrs = rs1.sort(
                          (a, b) => a.sortNoField - b.sortNoField
                        )
                        for (let i = 0; i < sortrs.length; i++) {
                          let d = sortrs[i]
                          // var s = {}
                          var dataBD = rs.filter(el => {
                            return parseInt(el.fieldId) === parseInt(d.fieldId)
                          })
                          if (dataBD.length > 0) {
                            if (dt.flowId === dataBD[0].flowId) {
                              d.bookNo = dataBD[0].bookNo
                              d.bookingFieldId = rs2[0].bookingFieldId
                              d.bookingDataId = dataBD[0].bookingDataId
                              d.flowId = dataBD[0].flowId
                              d.masBranchID = dataBD[0].masBranchID
                              // d.dueDate = dt.dueDate
                              // d.conditionField = d.conditionField
                              // d.fieldId = d.fieldId
                              // d.fieldType = d.fieldType
                              d.fieldValue = dataBD[0].fieldValue
                              d.packageId = dataBD[0].packageId
                              // d.fieldName = d.fieldName
                              // d.conditionField = d.conditionField
                              // d.conditionValue = d.conditionValue
                              // d.requiredField = d.requiredField
                              // d.optionField = d.optionField
                              // d.userId = d.userId
                              if (rs[0].userId === 'user-skip') {
                                d.userId = ''
                              } else {
                                d.userId = rs[0].userId
                              }
                              d.shopId = this.session.data.shopId
                              d.userName = this.$session.getAll().data.userName
                              this.BookingDataItem.push(d)
                            }
                          }
                        }
                        if (text === 'qrcode') {
                          this.dataQrcode = dt
                        }
                        // await this.getBookingField()
                        await this.getflowfield(dt)
                      }
                    })
                })
            }
          })
      }
      if (this.showOnsite === 'ไม่แสดง') {
        this.jobCheckPackage = false
        console.log('dt', dt)
        this.dateTimestamp = moment().unix()
        this.remark = dt.remark
        this.userId = dt.userId
        this.lineUserId = dt.lineUserId
        console.log(this.userId, this.lineUserId)
        if (dt.packageId !== '') {
          this.dataPackageDefault = true
        } else {
          this.dataPackageDefault = false
        }
        await this.getPackage(dt)
        if (this.dataPackage.length > 0) {
          console.log(
            'dataPackage',
            this.dataPackage.filter(el => {
              return el.packageId === dt.packageId
            })
          )
          if (
            this.dataPackage.filter(el => {
              return el.packageId === dt.packageId
            }).length > 0
          ) {
            let dataPack = this.dataPackage.filter(el => {
              return el.packageId === dt.packageId
            })
            this.dataPackageDefault = true
            // this.packageId = dataPack[0].value
            this.UpdatePackage(
              dataPack[0].value,
              'ตกลง',
              dataPack[0].text,
              dataPack[0],
              dt.tokenPackage
            )
          } else {
            this.UpdatePackage('', 'ยกเลิก', '', '', '')
            this.dataPackageDefault = false
          }
        }
        this.checkTimeFlow(dt)
        this.BookingDataItem = []
        let itemIncustomField = []

        await axios
          .get(
            this.$DNS_IP + '/BookingField/get?shopId=' + this.session.data.shopId
          )
          .then(async response1 => {
            let rs2 = response1.data
            console.log('BookingField', rs2)
            if (rs2.length > 0) {
              let bookingData = []
              bookingData = JSON.parse(rs2[0].flowfieldName)
              for (let i = 0; i < bookingData.length; i++) {
                let d = bookingData[i]
                itemIncustomField.push(d.fieldId)
              }
              await axios
                .get(
                  this.$DNS_IP +
                    '/customField/fieldId?fieldId=' +
                    itemIncustomField
                )
                .then(async responses => {
                  let rs1 = responses.data
                  await axios
                    .get(
                      this.$DNS_IP + '/BookingDataSelect/get?bookNo=' + dt.bookNo
                    )
                    .then(async response => {
                      let rs = response.data
                      if (rs.length > 0) {
                        console.log('BookingDataSelect', rs)
                        console.log('customField', rs1)
                        let sortrs = rs1.sort(
                          (a, b) => a.sortNoField - b.sortNoField
                        )
                        for (let i = 0; i < sortrs.length; i++) {
                          let d = sortrs[i]
                          // var s = {}
                          let dataBD = rs.filter(el => {
                            return parseInt(el.fieldId) === parseInt(d.fieldId)
                          })
                          if (dataBD.length > 0) {
                            if (dt.flowId === dataBD[0].flowId) {
                              d.bookNo = dataBD[0].bookNo
                              d.bookingFieldId = rs2[0].bookingFieldId
                              d.bookingDataId = dataBD[0].bookingDataId
                              d.flowId = dataBD[0].flowId
                              d.masBranchID = dataBD[0].masBranchID
                              // d.dueDate = dt.dueDate
                              // d.conditionField = d.conditionField
                              // d.fieldId = d.fieldId
                              // d.fieldType = d.fieldType
                              d.fieldValue = dataBD[0].fieldValue
                              d.packageId = dataBD[0].packageId
                              // d.fieldName = d.fieldName
                              // d.conditionField = d.conditionField
                              // d.conditionValue = d.conditionValue
                              // d.requiredField = d.requiredField
                              // d.optionField = d.optionField
                              // d.userId = d.userId
                              if (rs[0].userId === 'user-skip') {
                                d.userId = ''
                              } else {
                                d.userId = rs[0].userId
                              }
                              d.shopId = this.session.data.shopId
                              d.userName = this.$session.getAll().data.userName
                              this.BookingDataItem.push(d)
                            }
                          }
                        }
                        if (text === 'qrcode') {
                          this.dataQrcode = dt
                        }
                        // await this.getBookingField()
                        await this.getflowfield(dt)
                      }
                    })
                })
            }
          })
      }
      this.queueJobFixShop = null // เคลียค่าเลขคิว Fix Shop ร้าน ยารา
      this.$refs.form_update.resetValidation()
      console.log('this.$refs.form_update--------2------------', this.$refs.form_update)
    },
    async getBookingData (dt, text) {
      this.BookingDataItem = []
      await axios
        .get(this.$DNS_IP + '/BookingDataSelect/get?bookNo=' + dt.bookNo)
        .then(async response => {
          let rs = response.data
          console.log('BookingDataSelect', rs)
          if (response.data) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              if (d.userId === 'user-skip') {
                d.userId = ''
              }
              d.shopId = this.session.data.shopId
              d.userName = this.$session.getAll().data.userName
              this.BookingDataItem.push(d)
            }
            if (text === 'qrcode') {
              this.dataQrcode = dt
            }
            await this.getflowfield(dt)
          }
        })
    },
    addDataJob () {
      this.validate('UPDATE')
      setTimeout(() => this.addDataJobSubmit(), 500)
    },
    async addDataJobSubmit () {
      if (this.$session.id() !== undefined) {
        if (
          this.dataItem.filter(
            row => row.bookNo === this.BookingDataItem[0].bookNo
          ).length > 0
        ) {
          if (this.validUpdate === true) {
            let checkJobno = ''
            let dataCheck = []
            await axios
              .get(
                this.$DNS_IP +
                  '/booking_view/get?bookNo=' +
                  this.BookingDataItem[0].bookNo
              )
              .then(async response => {
                let rs = response.data
                console.log('checkJobNoInBooking', rs)
                if (rs.status === false) {
                  checkJobno = 'ไม่มีข้อมูล'
                  dataCheck = []
                } else {
                  checkJobno = rs[0].jobNo || ''
                  dataCheck = rs
                }
              })
            if (checkJobno === '') {
              console.log('this.BookingDataItem', this.BookingDataItem)
              let Add = []
              let fielditem = this.flowfieldNameitem
              console.log('fielditem', fielditem)
              for (var i = 0; i < this.BookingDataItem.length; i++) {
                var d = this.BookingDataItem[i]
                let update = {}
                let addData = false
                var dataField = this.editedItemSeleteField.filter(el => {
                  return parseInt(el.fieldId) === parseInt(d.fieldId)
                })
                if (
                  dataField[0].conditionField === '' ||
                  dataField[0].conditionField === null
                ) {
                  addData = true
                } else {
                  if (
                    fielditem.filter(row => {
                      return row.fieldId === parseInt(d.conditionField)
                    }).length > 0
                  ) {
                    console.log('this', fielditem)
                    if (
                      d.conditionValue ===
                      fielditem.filter(row => {
                        return row.fieldId === parseInt(d.conditionField)
                      })[0].fieldValue
                    ) {
                      addData = true
                    } else if (d.conditionField === 'flow') {
                      addData = true
                    }
                  } else if (d.conditionField === 'flow') {
                    addData = true
                  }
                }
                if (addData) {
                  if (d.fieldValue !== '') {
                    update.masBranchID =
                      this.BookingDataItem[0].masBranchID || ''
                    update.CREATE_USER = d.userName
                    update.LAST_USER = d.userName
                    update.packageId = d.packageId
                    update.checkCar = ''
                    // update.userId = d.userId
                    update.endDate = this.endDate
                    update.endTime = this.endTime.value
                    update.fieldId = d.fieldId
                    update.fieldName = d.fieldName
                    update.fieldType = dataField[0].fieldType || ''
                    update.fieldValue = (d.fieldValue || '').replace(/\\/g, '\\\\').replace(/'/g, "\\'")
                    update.flowId = d.flowId
                    update.empSelect = this.empSelectJob
                    update.conditionField = dataField[0].conditionField || ''
                    update.conditionValue = dataField[0].conditionValue || ''
                    update.optionField = dataField[0].optionField || ''
                    update.shopId = dataField[0].shopId || ''
                    update.showCard = dataField[0].showCard || ''
                    update.bookNo = this.BookingDataItem[0].bookNo || ''
                    update.tokenPackage = this.tokenPackage || ''
                    // queueJobFixShop ร้าน ปุ๋ยยาลา
                    if (dataField[0].shopId === this.shopNameData.yara && this.queueJobFixShop !== null) {
                      update.remarkQueue = this.queueJobFixShop
                    }
                    Add.push(update)
                  }
                }
              }
              for (var x = 0; x < fielditem.length; x++) {
                var t = fielditem[x]
                if (
                  Add.filter(row => {
                    return row.fieldId === t.fieldId
                  }).length === 0
                ) {
                  let update = {}
                  let dataField = this.editedItemSeleteField.filter(el => {
                    return parseInt(el.fieldId) === parseInt(t.fieldId)
                  })
                  update.masBranchID =
                    this.BookingDataItem[0].masBranchID || ''
                  update.CREATE_USER = Add[0].CREATE_USER
                  update.LAST_USER = Add[0].CREATE_USER
                  update.packageId = Add[0].packageId
                  update.checkCar = ''
                  // update.userId = Add[0].userId
                  update.endDate = this.endDate
                  update.endTime = this.endTime.value
                  update.fieldId = t.fieldId
                  update.fieldName = t.fieldName
                  update.fieldType = dataField[0].fieldType || ''
                  update.fieldValue = (t.fieldValue || '').replace(/\\/g, '\\\\').replace(/'/g, "\\'")
                  update.flowId = d.flowId
                  update.empSelect = this.empSelectJob
                  update.conditionField = dataField[0].conditionField || ''
                  update.conditionValue = dataField[0].conditionValue || ''
                  update.optionField = dataField[0].optionField || ''
                  update.shopId = dataField[0].shopId || ''
                  update.showCard = dataField[0].showCard || ''
                  update.bookNo = this.BookingDataItem[0].bookNo || ''
                  update.tokenPackage = this.tokenPackage || ''
                  // queueJobFixShop ร้าน ปุ๋ยยาลา
                  if (dataField[0].shopId === this.shopNameData.yara && this.queueJobFixShop !== null) {
                    update.remarkQueue = this.queueJobFixShop
                  }
                  Add.push(update)
                }
              }
              console.log('this.Add', Add)
              console.log(this.packageId, this.tokenPackage)
              this.swalConfig.title = 'ต้องการนำรายการนี้ เข้าตารางใช่หรือไม่?'
              this.$swal(this.swalConfig).then(async result => {
                this.dataEditJobReady = false
                await axios
                  .post(this.$DNS_IP + '/job/addOneStep', Add)
                  .then(async response => {
                    this.endDate = ''
                    this.endTime = ''
                    this.empSelectJob = ''
                    this.statusShowDateConfiremjob = true
                    if (response.data.status) {
                      if (Add[0].shopId === this.shopNameData.yara) {
                        let remarkQueue = {
                          'remarkQueue': Add[0].remarkQueue
                        }
                        let bookNo = Add[0].bookNo
                        await this.updateRemarkQueueBooking(bookNo, remarkQueue)
                      }
                      await this.pushMsg(response.data.jobNo)
                      if (this.jobCheckPackage) {
                        await this.usePackage(
                          this.dataQrcode.bookNo,
                          this.BookingDataItem[0].masBranchID
                        )
                      }
                      this.$swal('เรียบร้อย', 'นำเข้าสำเร็จ', 'success')
                      if (this.statusSearch === 'no') {
                        await this.getBookingList()
                      } else {
                        await this.searchAny()
                      }
                      this.dialogEdit = false
                      this.dataEditJobReady = true
                      var dataJob = this.dataItem.filter(el => {
                        return el.bookNo === this.dataQrcode.bookNo
                      })
                      this.getjob(dataJob[0])
                      this.dialogJob = true
                      //     })
                      // })
                    } else {
                      this.$swal('ผิดพลาด', 'กรุณาทำรายการใหม่', 'error')
                      this.dialogEdit = false
                      if (this.statusSearch === 'no') {
                        await this.getBookingList()
                      } else {
                        await this.searchAny()
                      }
                      // this.getTimesChange('update')
                      if (this.getSelectText) {
                        this.getSelect(
                          this.getSelectText,
                          this.getSelectCount,
                          this.filterCloseJobValue
                        )
                      }
                    }
                  })
                  .catch(error => {
                    setTimeout(() => this.addDataJobSubmit(), 3000)
                    console.log('error function addData : ', error)
                  })
              })
            } else {
              if (dataCheck[0].statusBt === 'confirm') {
                let dt = {
                  // pageStatus: 'cancel',
                  // limitBookingCount: dtint,
                  bookNo: dataCheck[0].bookNo,
                  contactDate: moment().format('YYYY-MM-DD HH:mm:ss'),
                  status: 'confirmJob',
                  statusUse: 'use',
                  shopId: this.$session.getAll().data.shopId,
                  CREATE_USER: this.$session.getAll().data.userName,
                  LAST_USER: this.$session.getAll().data.userName
                }
                axios
                  .post(this.$DNS_IP + '/booking_transaction/add', dt)
                  .then(async response => {
                    this.endDate = ''
                    this.endTime = ''
                    this.empSelectJob = ''
                    this.statusShowDateConfiremjob = true
                    await this.pushMsg(response.data.jobNo)
                    if (this.jobCheckPackage) {
                      await this.usePackage(
                        this.dataQrcode.bookNo,
                        this.BookingDataItem[0].masBranchID
                      )
                    }
                    this.$swal('เรียบร้อย', 'นำเข้าสำเร็จ', 'success')
                    if (this.statusSearch === 'no') {
                      await this.getBookingList()
                    } else {
                      await this.searchAny()
                    }
                    this.dialogEdit = false
                    this.dataEditJobReady = true
                    var dataJob = this.dataItem.filter(el => {
                      return el.bookNo === this.dataQrcode.bookNo
                    })
                    this.getjob(dataJob[0])
                    this.dialogJob = true
                  })
                  .catch(error => {
                    console.log('error function addData : ', error)
                  })
              } else {
                this.$swal(
                  'ผิดพลาด',
                  'รายการนี้ได้นำเข้ากระดานการทำงานแล้ว',
                  'error'
                )
                  .then(async response => {
                    this.dialogEdit = false
                    if (this.statusSearch === 'no') {
                      await this.getBookingList()
                    } else {
                      await this.searchAny()
                    }
                    // this.getTimesChange('update')
                    if (this.getSelectText) {
                      this.getSelect(
                        this.getSelectText,
                        this.getSelectCount,
                        this.filterCloseJobValue
                      )
                    }
                  })
                  .catch(error => {
                    console.log('error function addData : ', error)
                    this.dialogEdit = false
                    if (this.statusSearch === 'no') {
                      this.getBookingList()
                    } else {
                      this.searchAny()
                    }
                    // this.getTimesChange('update')
                    if (this.getSelectText) {
                      this.getSelect(
                        this.getSelectText,
                        this.getSelectCount,
                        this.filterCloseJobValue
                      )
                    }
                  })
              }
            }
          }
        } else {
          this.$swal('ผิดพลาด', 'ไม่มีนัดหมายเข้ารับบริการนี้', 'error')
            .then(async response => {
              this.dialogEdit = false
              if (this.statusSearch === 'no') {
                await this.getBookingList()
              } else {
                await this.searchAny()
              }
              // this.getTimesChange('update')
              if (this.getSelectText) {
                this.getSelect(
                  this.getSelectText,
                  this.getSelectCount,
                  this.filterCloseJobValue
                )
              }
            })
            .catch(error => {
              console.log('error function addData : ', error)
              this.dialogEdit = false
              if (this.statusSearch === 'no') {
                this.getBookingList()
              } else {
                this.searchAny()
              }
              // this.getTimesChange('update')
              if (this.getSelectText) {
                this.getSelect(
                  this.getSelectText,
                  this.getSelectCount,
                  this.filterCloseJobValue
                )
              }
            })
        }
      } else {
        this.$swal('ผิดพลาด', 'กรุณาลองอีกครั้ง', 'error')
        clearInterval(this.setTimerCalendar)
        this.setTimerCalendar = null
        this.$router.push('/Core/Login')
      }
    },
    async updateRemarkQueueBooking (bookNo, remarkQueue) {
      try {
        await axios
          .post(this.$DNS_IP + '/Booking/edit/' + bookNo, remarkQueue)
          .catch(error => {
            console.log('error function addDataGlobal : ', error)
          })
      } catch (error) {
        console.log('error', error)
      }
    },
    async pushMsg (jobNo) {
      const result = await axios
        .get(
          this.$DNS_IP +
            '/member/get?shopId=' +
            this.session.data.shopId +
            '&liffUserId=' +
            this.BookingDataItem[0].userId
        )
        .catch(error => {
          console.log('error function addData : ', error)
        })
      console.log('result', result.data.status)
      if (result.data.status === false) {
        let statusSend = {
          statusSend: 'false'
        }
        await axios.post(this.$DNS_IP + '/job/updateJobNo/' + jobNo, statusSend)
        console.log('statusSend', 'false')
      }
      let updateStatusSend = {
        updateStatusSend: 'false'
      }
      await axios
        .post(this.$DNS_IP + '/job/NotifyQrcode/' + jobNo, updateStatusSend)
        .then(
          this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
          // this.clearData()
          // this.$router.push('/Master/FlowStep')
        )
        .catch(error => {
          console.log('error function addDataGlobal : ', error)
        })
      // this.clearData()
    },
    async getEmpSelect (item) {
      console.log('item!!!getEmpSelect!!!', item)
      this.empSelectStep = []
      await axios
        .get(
          this.$DNS_IP +
            '/empSelect/getUse?privacyPage=booking&shopId=' +
            item.shopId
        )
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              // console.log('d', d)
              if (d.masBranchID === item.masBranchID) {
                var s = {}
                s.text = d.empFirst_NameTH + ' ' + d.empLast_NameTH
                s.value = d.empId
                this.empSelectStep.push(s)
              } else if (d.masBranchID === null || d.masBranchID === '') {
                let s = {}
                s.text = d.empFirst_NameTH + ' ' + d.empLast_NameTH
                s.value = d.empId
                this.empSelectStep.push(s)
              }
            }
            this.empSelect = this.empSelectStep[0].value
          }
        })
    },
    async getEmpSelectAddJob () {
      this.empSelectStepAdd = []
      await axios
        .get(
          this.$DNS_IP +
            '/empSelect/getUse?USER_ROLE=onsite&shopId=' +
            this.$session.getAll().data.shopId
        )
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              console.log('DDDDDSFDSDFSDF', d)
              var s = {}
              s.text = d.empFull_NameTH
              s.value = d.empId
              this.empSelectStepAdd.push(s)
            }
          }
        })
    },
    filterEmpAdd () {},
    filterEmpEdit () {},
    filterEmpCancel () {},
    filterEmpConfirm () {},
    async getEmpSelectAdd () {
      this.empSelectStepAdd = []
      await axios
        .get(
          this.$DNS_IP +
            '/empSelect/getUse?privacyPage=booking&shopId=' +
            this.$session.getAll().data.shopId
        )
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              d.masBranchID = d.masBranchID || ''
              if (
                this.$session.getAll().data.masBranchID === '' ||
                this.$session.getAll().data.masBranchID === null
              ) {
                // console.log('D', d)
                let s = {}
                s.text = d.empFirst_NameTH + ' ' + d.empLast_NameTH
                s.value = d.empId
                s.masBranchID = d.masBranchID
                this.empSelectStepAdd.push(s)
              } else {
                if (
                  this.$session.getAll().data.masBranchID === d.masBranchID ||
                  d.masBranchID === ''
                ) {
                  let s = {}
                  s.text = d.empFirst_NameTH + ' ' + d.empLast_NameTH
                  s.value = d.empId
                  s.masBranchID = d.masBranchID
                  this.empSelectStepAdd.push(s)
                }
              }
            }
            console.log(
              '>>>>>>this.$session.getAll().data.empId',
              this.$session.getAll().data.empId
            )
            if (
              this.$session.getAll().data.empId !== '' &&
              this.$session.getAll().data.empId !== null
            ) {
              try {
                this.empSelectAdd = this.empSelectStepAdd.filter(
                  item =>
                    item.value === parseInt(this.$session.getAll().data.empId)
                )[0].value
              } catch (err) {}
            }
            console.log('this.empSelectStepAdd', this.empSelectStepAdd)
          }
        })
    },
    async assignEmp (item) {
      await this.getEmpSelect(item)
      this.dataConfirm = item
      this.dialogAssignEmp = true
    },
    async confirmChk (item) {
      this.dateTimestamp = moment().unix()
      this.dataConfirm = item
      this.remark = item.remark
      this.userId = item.userId
      this.lineUserId = item.lineUserId
      console.log(this.userId, this.lineUserId)
      await this.getEmpSelect(item)
      await this.getPackage(item)
      if (this.dataPackage.length > 0) {
        if (
          this.dataPackage.filter(el => {
            return el.packageId === item.packageId
          }).length > 0
        ) {
          var dataPack = this.dataPackage.filter(el => {
            return el.packageId === item.packageId
          })
          // this.packageId = dataPack[0].value
          this.UpdatePackage(
            dataPack[0].value,
            'ตกลง',
            dataPack[0].text,
            dataPack[0],
            item.tokenPackage
          )
        } else {
          this.UpdatePackage('', 'ยกเลิก', '', '', '')
        }
      }
      if (item.shopId === this.shopNameData.officeOmbudsman) {
        if (item.empSelect !== null && item.empSelect !== '') {
          this.empSelect = parseInt(item.empSelect)
        }
      }
      this.statusPushEndConfirm = false
      this.dialogConfirm = true
    },
    async updateCodeTheMall (item, status) {
      let statusCheck = true
      if (item.shopId === this.shopNameData.themall) {
        await axios
          .get(
            this.$DNS_IP + '/the_mall_code/get_filter_admin?bookNo=' + item.bookNo
          )
          .then(async response => {
            let rs = response.data
            if (rs.length > 0) {
              let dt = {}
              if (status === 'used') {
                dt = {
                  bookNo: item.bookNo,
                  date_use: moment().format('YYYY-MM-DD HH:mm'),
                  status_code: 'used',
                  LAST_USER: this.session.data.userName
                }
              } else {
                dt = {
                  flowId: '',
                  masBranchId: '',
                  date_use: moment().format('YYYY-MM-DD HH:mm'),
                  bookNo: item.bookNo,
                  status_code: 'free',
                  id_card: '',
                  LAST_USER: this.session.data.userName
                }
              }
              await axios
                .post(
                  this.$DNS_IP + '/the_mall_code/edit/' + rs[0].the_mall_code_id, dt
                )
                .then(response => {
                  statusCheck = true
                }).catch(error => {
                  statusCheck = false
                  this.$swal(this.languageSelect === 0 ? 'แจ้งเตือน' : 'Alert', this.languageSelect === 0 ? 'ผิดพลาด กรุณาลองอีกครั้ง' : 'Error. Please try again.', 'warning')
                  console.log('checkCardNoTheMall : ', error)
                })
            } else {
              statusCheck = false
              this.$swal(this.languageSelect === 0 ? 'แจ้งเตือน' : 'Alert', this.languageSelect === 0 ? 'รหัสที่ใช้ถูกใช้งานไปแล้ว' : 'The code has already been used.', 'warning')
            }
          }).catch(error => {
            statusCheck = false
            console.log('checkCardNoTheMall : ', error)
          })
      } else {
        statusCheck = true
        return statusCheck
      }
    },
    async onConfirmSelectEmp (item) {
      this.loadingConfirm = true
      if (this.$session.id() !== undefined) {
        await this.updateRemarkAndEmpSelect(item)
        if (this.$session.getAll().data.shopId === this.shopNameData.officeOmbudsman) {
          this.sendEmailConfirmOmbudsman(item.bookNo)
          // this.pushMsgWaitConfirm(item.bookNo)
        }
        let DTitem = item.userId
        console.log('DTITEM', DTitem)
        if (DTitem !== 'user-skip') {
          if (this.statusSearch === 'no') {
            await this.getBookingList()
          } else {
            await this.searchAny()
          }
          // this.getTimesChange('update')
          if (this.getSelectText) {
            this.getSelect(
              this.getSelectText,
              this.getSelectCount,
              this.filterCloseJobValue
            )
          }
        } else {
          if (this.statusSearch === 'no') {
            await this.getBookingList()
          } else {
            await this.searchAny()
          }
          // this.getTimesChange('update')
          if (this.getSelectText) {
            this.getSelect(
              this.getSelectText,
              this.getSelectCount,
              this.filterCloseJobValue
            )
          }
        }
        this.dataConfirmReady = true
        this.dialogAssignEmp = false
        this.loadingConfirm = false
      } else {
        this.$swal('ผิดพลาด', 'กรุณาลองอีกครั่ง', 'error')
        clearInterval(this.setTimerCalendar)
        this.setTimerCalendar = null
        this.$router.push('/Core/Login')
      }
    },
    pushMsgWaitConfirm (bookNo) {
      axios
        .post(this.$DNS_IP + '/Booking/pushMsgWaitConfirm/' + bookNo)
        .then(async response => {
          console.log('pushMsgWaitConfirm', response)
        })
        .catch(error => {
          console.log('pushMsgWaitConfirm error', error)
        })
    },
    onConfirm (item) {
      this.loadingConfirm = true
      if (this.$session.id() !== undefined) {
        this.dataConfirmReady = false
        let dtint = '0'
        if (
          this.DataFlowNameDefault.filter(el => {
            return el.value === item.flowId
          }).length > 0
        ) {
          let setTime = []
          // เช็คว่า เวลาในแต่ละวันเหมือนกันรึป่าว
          if (
            this.DataFlowNameDefault.filter(el => {
              return el.value === item.flowId
            })[0].allData.setTimebyday === 'True'
          ) {
            let timeJson = JSON.parse(
              this.DataFlowNameDefault.filter(el => {
                return el.value === item.flowId
              })[0].allData.setTime
            ).filter(items => items.value === new Date(item.dueDate).getDay())
            setTime = timeJson[0].setTime || []
          } else {
            setTime =
              JSON.parse(
                this.DataFlowNameDefault.filter(el => {
                  return el.value === item.flowId
                })[0].allData.setTime
              ) || []
          }
          console.log('setTimesetTime >>>', setTime.filter(el => el.value === item.timeDuetext))
          if (setTime.length > 0) {
            if (setTime.filter(el => el.value === item.timeDuetext).length > 0) {
              dtint = parseInt(
                setTime.filter(el => el.value === item.timeDuetext)[0]
                  .limitBooking || '0'
              )
            } else {
              dtint = '0'
            }
          } else {
            dtint = '0'
          }
          // let dts = JSON.parse(this.DataFlowName.filter(el => { return el.value === item.flowId })[0].allData.setTime) || []
          // console.log(dts.filter(el => el.value === item.timeDuetext))
          // if (dts.filter(el => el.value === item.timeDuetext).length > 0) {
          //   dtint = parseInt(dts.filter(el => el.value === item.timeDuetext)[0].limitBooking || '0')
          // } else {
          //   dtint = '0'
          // }
        } else {
          dtint = '0'
        }
        console.log('dtint', dtint)
        let statusCheck = this.updateCodeTheMall(item, 'used')
        if (statusCheck) {
          var dt = {
            bookNo: item.bookNo,
            contactDate: moment().format('YYYY-MM-DD HH:mm:ss'),
            status: 'confirm',
            statusUse: 'use',
            pageStatus: this.getSelectText,
            limitBookingCount: dtint,
            shopId: this.$session.getAll().data.shopId,
            CREATE_USER: this.session.data.userName,
            LAST_USER: this.session.data.userName,
            packageId: this.packageId,
            tokenPackage: this.tokenPackage
          }
          axios
            .post(this.$DNS_IP + '/booking_transaction/add', dt)
            .then(async response => {
              if (response.data.status === true) {
                await this.insertFormPDF(dt.bookNo)
                this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                console.log('statusGoogleCalendar', this.statusGoogleCalendar)
                this.sendEmailConfirm(dt.bookNo)
                if (this.statusGoogleCalendar === 'True') {
                  this.connectGoogleCalendar('Add', dt.bookNo)
                }
                await this.updateRemarkAndEmpSelect(item)
                // this.getDataCalendaBooking()
                if (this.packageId !== '') {
                  await this.usePackage(item.bookNo, item.masBranchID)
                }
                let DTitem = item.userId
                console.log('DTITEM', DTitem)
                if (DTitem !== 'user-skip') {
                  if (this.statusSearch === 'no') {
                    await this.getBookingList()
                  } else {
                    await this.searchAny()
                  }
                  // this.getTimesChange('update')
                  if (this.getSelectText) {
                    this.getSelect(
                      this.getSelectText,
                      this.getSelectCount,
                      this.filterCloseJobValue
                    )
                  }
                  // ของร้าน อุดรกระจก
                  if (this.statusPushEndConfirm === 'True' && (this.$session.getAll().data.shopId === this.shopNameData.udon1 || this.$session.getAll().data.shopId === this.shopNameData.udon2)
                  ) {
                    this.pushmessagePriceConfirm(item.bookNo)
                  } else {
                    this.pushMsgConfirm(item.bookNo)
                  }
                } else {
                  if (this.statusSearch === 'no') {
                    await this.getBookingList()
                  } else {
                    await this.searchAny()
                  }
                  // this.getTimesChange('update')
                  if (this.getSelectText) {
                    this.getSelect(
                      this.getSelectText,
                      this.getSelectCount,
                      this.filterCloseJobValue
                    )
                  }
                }
                this.dataConfirmReady = true
                this.dialogConfirm = false
                this.loadingConfirm = false
              } else {
                this.loadingConfirm = false
                this.dataConfirmReady = true
                this.$swal('ผิดพลาด', response.data.message, 'error')
              }
            })
            .catch(error => {
              this.loadingConfirm = false
              console.log('error function addData : ', error)
            })
        }
      } else {
        this.$swal('ผิดพลาด', 'กรุณาลองอีกครั่ง', 'error')
        clearInterval(this.setTimerCalendar)
        this.setTimerCalendar = null
        this.$router.push('/Core/Login')
      }
    },
    async usePackage (bookNo, masBranchID) {
      let params = {
        amountOf: 1
      }
      await axios({
        method: 'post',
        headers: {
          shopId: this.$session.getAll().data.shopId,
          lineUserId: this.lineUserId,
          lineId: this.userId
        },
        url:
          this.$DNS_IP_Loyalty +
          '/use_package/edit?shopId=' +
          this.$session.getAll().data.shopId +
          '&token=' +
          this.StatusPackage.token,
        // url: this.$DNS_IP_Loyalty + '/use_package/edit?shopId=' + this.$session.getAll().data.shopId + '&token=' + this.StatusPackage.token + '&branchBeLinked=' + masBranchID,
        data: params
      }).then(response => {})
      await this.updatePackageInBooking(
        this.$session.getAll().data.shopId,
        this.StatusPackage.token,
        this.packageId,
        bookNo
      )
    },
    async updatePackageInBooking (shopId, token, packageId, bookNo) {
      console.log(shopId, token, packageId, bookNo)
      await axios
        .get(
          this.$DNS_IP_Loyalty +
            '/PackageLog/get?shopId=' +
            shopId +
            '&token=' +
            token +
            '&packageId=' +
            packageId
        )
        .then(async response => {
          console.log('updatePackageInBooking', response.data)
          let rs = response.data
          if (rs.status !== false) {
            var dt = {
              packageName: rs[0].packageName,
              packageDetails: rs[0].packageDetail,
              packageImage: rs[0].packageImg,
              packagePrice: rs[0].packagePrice,
              packageBalanceAmount: rs[0].balanceAmount,
              packageAmount: rs[0].amount,
              packagePoint: rs[0].packagePoint,
              packageExpire: rs[0].packageExpire
            }
            await axios
              .post(
                // eslint-disable-next-line quotes
                this.$DNS_IP + "/Booking/edit/" + bookNo,
                dt
              )
              .then(async response => {})
              .catch(error => {
                console.log(error)
              })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    async updateRemarkAndEmpSelect (item) {
      var dt = {
        LAST_USER: this.session.data.userName,
        empSelect: this.empSelect,
        remark: (this.remark || '').replace(/%/g, '%%')
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.$DNS_IP + "/Booking/edit/" + item.bookNo,
          dt
        )
        .then(async response => {})
    },
    async updateRemark (item) {
      var dt = {
        LAST_USER: this.session.data.userName,
        empSelect: this.empSelect
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.$DNS_IP + "/Booking/edit/" + item.bookNo,
          dt
        )
        .then(async response => {})
    },
    async setDataRemove (item) {
      // this.statusVIPRemove = item.statusVIP
      // console.log('this.statusVIPRemove', this.statusVIPRemove)
      // this.bookNoRemove = item
      // this.dueDateOld = item.dueDateDay
      // this.dueDateTimeOld = item.timeDuetext
      // await this.getEmpSelect(item)
      // this.dialogRemove = true
      let checkCancle = true
      if (this.checkShopSigneture[this.session.data.shopId]) {
      // if (this.session.data.shopId === this.shopNameData.onsitebBetaskSignatureairmate || this.session.data.shopId === this.shopNameData.ayasan) {
      // if (this.session.data.shopId === this.shopNameData.airmate || this.session.data.shopId === this.shopNameData.onsitebBetaskSignatureairmate || this.session.data.shopId === this.shopNameData.ayasan) {
        const stepData = await axios
          .get(
          // eslint-disable-next-line quotes
            this.$DNS_IP + "/job_log/get?jobNo=" + item.jobNo
          )
        console.log('stepData >>', stepData)
        if (stepData && stepData.data.length) {
          let idLast = 0
          let stepTitle = ''
          for (const x of stepData.data) {
            if (parseInt(x.jobLogId) > idLast) {
              stepTitle = x.stepTitle
              idLast = parseInt(x.jobLogId)
            }
          }
          console.log('stepTitle : ', stepTitle, ' ---- ', idLast)
          if (stepTitle === 'รอ') {
            checkCancle = true
          } else {
            if (this.checkShopSigneture[this.session.data.shopId]) {
              checkCancle = true
            } else {
              checkCancle = false
            }
          }
        }
      }
      if (checkCancle) {
        this.statusVIPRemove = item.statusVIP
        // console.log('this.statusVIPRemove', this.statusVIPRemove)
        this.bookNoRemove = item
        this.dueDateOld = item.dueDateDay
        this.dueDateTimeOld = item.timeDuetext
        await this.getEmpSelect(item)
        this.dialogRemove = true
      } else {
        this.$swal('ไม่สามารถยกเลิกได้', 'ช่างได้เริ่มงานหรือปิดงานเรียบร้อยแล้ว', 'error')
      }
    },
    cancelChk () {
      this.validate('REMOVE')
      console.log('this.bookNoRemove', this.bookNoRemove)
      setTimeout(() => this.onCancelChk(), 500)
    },
    async updateLimitBookingCancel (item, dueDateOld, dueDateTimeOld) {
      console.log('------------', item, dueDateOld, dueDateTimeOld)
      let result = []
      let dt = {
        bookNo: item.bookNo,
        flowId: item.flowId,
        dateSelect: dueDateOld,
        timeSelect: dueDateTimeOld,
        shopId: item.shopId,
        userId: this.$session.getAll().data.userName || 'admin'
      }
      await axios
        .post(this.$DNS_IP + '/Booking/updateLimitBookingCancel', dt)
        .then(async response => {
          result = response.data
        })
      return result
    },
    async onCancelChk () {
      if (this.validRemove === true) {
        if (this.$session.id() !== undefined) {
          let chkStatLimit = this.DataFlowNameDefault.filter(el => {
            return el.value === this.bookNoRemove.flowId
          })
          if (chkStatLimit.length > 0) {
            if (chkStatLimit[0].allData.limitBookingCheck === 'True') {
              // let dueOld = this.dueDateOld + this.dueDateTimeOld
              // let limitBookingCount = this.timeavailable.filter(el => { return el.value === this.formChange.time.value })
              // console.log('limitBookingCount', limitBookingCount)
              // let limitBookingCounts = 0
              // if (limitBookingCount.length > 0) {
              //   limitBookingCounts = parseInt(limitBookingCount[0].limitBooking)
              // } else {
              //   limitBookingCounts = 0
              // }
              if (this.statusVIPRemove === 'False') {
                let chkStatus = await this.updateLimitBookingCancel(
                  this.bookNoRemove,
                  this.dueDateOld,
                  this.dueDateTimeOld
                )
                console.log('chkStatus', chkStatus)
                if (chkStatus.status) {
                  this.onCancelChkSubmit()
                } else {
                  this.onCancelChkSubmit()
                }
              } else {
                this.onCancelChkSubmit()
              }
            } else {
              this.onCancelChkSubmit()
            }
          } else {
            this.onCancelChkSubmit()
          }
        } else {
          this.$swal('ผิดพลาด', 'กรุณาลองอีกครั้ง', 'error')
          clearInterval(this.setTimerCalendar)
          this.setTimerCalendar = null
          this.$router.push('/Core/Login')
        }
      }
    },
    onCancelChkSubmit () {
      this.dataCancelReady = false
      console.log('----------------------------------------------->>>>>', this.bookNoRemove)
      // let statusCheck = this.updateCodeTheMall(this.bookNoRemove, 'free')
      var dt = {
        bookNo: this.bookNoRemove.bookNo,
        contactDate: moment().format('YYYY-MM-DD HH:mm:ss'),
        status: 'cancel',
        statusUse: 'use',
        shopId: this.$session.getAll().data.shopId,
        CREATE_USER: this.session.data.userName,
        LAST_USER: this.session.data.userName,
        remarkRemove: (this.remarkRemove || '').replace(/%/g, '%%')
      }
      axios
        .post(this.$DNS_IP + '/booking_transaction/add', dt)
        .then(async response => {
          await this.updateRemark(this.bookNoRemove)
          this.pushMsglineCancel(this.bookNoRemove)
          console.log('statusGoogleCalendar', this.statusGoogleCalendar)
          if (this.statusGoogleCalendar === 'True') {
            this.connectGoogleCalendar('Delete', dt.bookNo)
          }
          this.$swal('เรียบร้อย', 'ยกเลิกเรียบร้อย', 'success')
          console.log('addDataGlobal', response)
          if (this.statusSearch === 'no') {
            await this.getBookingList()
          } else {
            await this.searchAny()
          }
          if (this.getSelectText) {
            this.getSelect(
              this.getSelectText,
              this.getSelectCount,
              this.filterCloseJobValue
            )
          }
          // this.bookNoRemove.jobNo
          const resJobId = await axios
            .get(this.$DNS_IP + '/job/getJobNo?jobNo=' + this.bookNoRemove.jobNo)
          if (resJobId.data.length > 0) {
            if (resJobId.data[0]['RECORD_STATUS'] !== 'D') {
              const datax = await axios.post(this.$DNS_IP + '/job/delete/' + resJobId.data[0].jobId, {
                'LAST_USER': this.$session.getAll().data.userName
              })
              console.log('>>>>>> datax : ', datax)
            }
          }

          this.dataCancelReady = true
          this.dialogRemove = false
          this.sendRemarkRemove = false
          this.remarkRemove = ''
          this.bookNo = ''
        })
        .catch(error => {
          console.log('error function addData : ', error)
          this.dataCancelReady = true
        })
      this.dataCancelReady = true
    },
    pushMsglineCancel (item) {
      let lineUserId = item.lineUserId || ''
      if (lineUserId !== '') {
        var dt = {
          bookNo: item.bookNo,
          lineUserId: lineUserId,
          dueDate: item.dueDateText,
          flowName: item.flowName,
          shopId: this.$session.getAll().data.shopId,
          tell: this.$session.getAll().data.contactTel,
          sendRemarkRemove: this.sendRemarkRemove
        }
        axios
          .post(this.$DNS_IP + '/Booking/pushMsgCancelBook', dt)
          .then(async response => {})
      }
    },
    async changeChk (item, changeStatus) {
      this.dataChangeReady = false
      // if (this.formChange.time !== '') {
      if (item.statusBt === 'confirm') {
        if (this.remark !== '') {
          var dt = {
            LAST_USER: this.session.data.userName,
            remark: (this.remark || '').replace(/%/g, '%%')
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.$DNS_IP + "/Booking/edit/" + item.bookNo,
              dt
            )
            .then(async response => {
              this.onChangeChk(item, changeStatus)
            })
        } else {
          this.$swal('ผิดพลาด', 'กรุณาใส่ หมายเหตุเพิ่มเติม', 'error')
          this.dataChangeReady = true
        }
      } else {
        this.onChangeChk(item, changeStatus)
      }
      // } else {
      //   this.dataChangeReady = true
      //   this.$swal('ผิดพลาด', 'กรุณาเลือกเวลา', 'error')
      // }
    },
    onChangeChk (item, changeStatus) {
      console.log('item', item)
      console.log('formChange', this.formChange)
      this.swalConfig.title = 'ต้องการ เปลี่ยนเวลานัดหมาย ใช่หรือไม่?'
      this.$swal(this.swalConfig)
        .then(async result => {
          if (this.$session.id() !== undefined) {
            let checkCountTime = await axios.get(
              this.$DNS_IP + '/booking_view/get?bookNo=' + item.bookNo
            )
            if (checkCountTime.data.status === false) {
              this.onChangeChk(item, changeStatus)
            } else {
              if (this.getSelectText === 'cancel') {
                this.onChangeChkSubmit(item, changeStatus, checkCountTime)
              } else {
                let chkStatLimit = this.DataFlowNameDefault.filter(el => {
                  return el.value === item.flowId
                })
                console.log('chkStatLimit', chkStatLimit)
                if (chkStatLimit.length > 0) {
                  console.log(
                    'chkStatLimit',
                    chkStatLimit[0].allData.limitBookingCheck
                  )
                  if (chkStatLimit[0].allData.limitBookingCheck === 'True') {
                    let dueOld = this.dueDateOld + this.dueDateTimeOld
                    let dueNew =
                      this.formChange.date + this.formChange.time.value
                    let limitBookingCount = this.timeavailable.filter(el => {
                      return el.value === this.formChange.time.value
                    })
                    let limitBookingCounts = 0
                    if (limitBookingCount.length > 0) {
                      limitBookingCounts = parseInt(
                        limitBookingCount[0].limitBooking
                      )
                    } else {
                      limitBookingCounts = 0
                    }
                    if (dueOld !== dueNew) {
                      if (this.statusVIPChang === 'False') {
                        let chkStatus = await this.updateLimitBookingChange(
                          item,
                          this.dueDateOld,
                          this.dueDateTimeOld,
                          this.formChange.date,
                          this.formChange.time.value,
                          limitBookingCounts
                        )
                        console.log('chkStatus', chkStatus)
                        if (chkStatus.status) {
                          this.onChangeChkSubmit(
                            item,
                            changeStatus,
                            checkCountTime
                          )
                        } else {
                          this.$swal(
                            'ผิดพลาด',
                            'เวลาที่ท่านเลือกคิวเต็มแล้ว',
                            'error'
                          )
                          this.dataChangeReady = true
                        }
                      } else {
                        this.onChangeChkSubmit(
                          item,
                          changeStatus,
                          checkCountTime
                        )
                      }
                    } else {
                      this.onChangeChkSubmit(
                        item,
                        changeStatus,
                        checkCountTime
                      )
                    }
                  } else {
                    this.onChangeChkSubmit(item, changeStatus, checkCountTime)
                  }
                } else {
                  this.onChangeChkSubmit(item, changeStatus, checkCountTime)
                }
              }
            }
          } else {
            this.$swal('ผิดพลาด', 'กรุณาลองอีกครั้ง', 'error')
            clearInterval(this.setTimerCalendar)
            this.setTimerCalendar = null
            this.$router.push('/Core/Login')
          }
        })
        .catch(error => {
          this.dataChangeReady = true
          console.log('catch alear : ', error)
        })
    },
    async onChangeChkSubmit (item, changeStatus, checkCountTime) {
      let countTime = 0
      if (checkCountTime) {
        countTime = checkCountTime.data[0].countChangeTime || 0
      }
      let dueOld = this.dueDateOld + this.dueDateTimeOld
      let dueNew = this.formChange.date + this.formChange.time.value
      console.log('dueNew', dueNew)
      console.log('dueOld', dueOld)
      if (dueOld === dueNew) {
        countTime = countTime + 0
      } else {
        countTime = countTime + 1
      }
      let storeFront = this.DataFlowNameDefault.filter(item => {
        return item.value === this.flowIDLimit
      })
      let storeFrontCheck = ''
      if (storeFront.length > 0) {
        storeFrontCheck = storeFront[0].allData.storeFrontCheck || 'False'
      } else {
        storeFrontCheck = 'False'
      }
      let timeValue = ''
      let timeText = ''
      if (this.formChange.time.value) {
        timeValue = this.formChange.time.value
        timeText = this.formChange.time.text
      } else {
        timeValue = ''
        timeText = ''
      }
      var dtChange = {
        countChangeTime: countTime,
        changeDueDate: 'change',
        dueDate: this.formChange.date + ' ' + timeValue,
        timeText: timeText,
        LAST_USER: this.session.data.userName,
        countHourLimit: this.selectCountBookingLimit,
        storeFrontCheck: storeFrontCheck,
        statusBookingForm: 'BookingForm',
        timeSelect: timeValue,
        flowId: this.flowIDLimit,
        bookNo: item.bookNo
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.$DNS_IP + "/BookingData/edit/" + item.bookNo,
          dtChange
        )
        .then(async response => {
          var dt = {
            bookNo: item.bookNo,
            contactDate: moment().format('YYYY-MM-DD HH:mm:ss'),
            status: changeStatus,
            statusUse: 'use',
            shopId: this.$session.getAll().data.shopId,
            CREATE_USER: this.session.data.userName,
            LAST_USER: this.session.data.userName,
            changDate: this.formChange.date + ' ' + timeValue
          }
          await axios
            .post(this.$DNS_IP + '/booking_transaction/add', dt)
            .then(async response => {
              console.log('*****', item.statusBt, changeStatus)
              if (
                (item.statusBt === 'confirm' ||
                  item.statusBt === 'confirmJob') &&
                (changeStatus === 'change' || changeStatus === 'confirm')
              ) {
                console.log('*****Edit')
                // edit
                if (this.statusGoogleCalendar === 'True') {
                  this.connectGoogleCalendar('Edit', dt.bookNo)
                }
              }
              if (item.statusBt === 'wait' && changeStatus === 'confirm') {
                console.log('*****Add')
                // create
                this.sendEmailConfirm(dt.bookNo)
                if (this.statusGoogleCalendar === 'True') {
                  this.connectGoogleCalendar('Add', dt.bookNo)
                }
              }
              if (
                item.statusBt === 'confirm' ||
                item.statusBt === 'confirmJob'
              ) {
                if (item.userId !== 'user-skip') {
                  if (this.statusSearch === 'no') {
                    await this.getBookingList()
                  } else {
                    await this.searchAny()
                  }
                  // this.getTimesChange('update')
                  if (this.getSelectText) {
                    this.getSelect(
                      this.getSelectText,
                      this.getSelectCount,
                      this.filterCloseJobValue
                    )
                  }
                  this.pushMsgConfirmChangeTime(item.bookNo)
                } else {
                  if (this.statusSearch === 'no') {
                    await this.getBookingList()
                  } else {
                    await this.searchAny()
                  }
                  // this.getTimesChange('update')
                  if (this.getSelectText) {
                    this.getSelect(
                      this.getSelectText,
                      this.getSelectCount,
                      this.filterCloseJobValue
                    )
                  }
                }
              } else {
                if (this.statusSearch === 'no') {
                  await this.getBookingList()
                } else {
                  await this.searchAny()
                }
                // this.getTimesChange('update')
                if (this.getSelectText) {
                  this.getSelect(
                    this.getSelectText,
                    this.getSelectCount,
                    this.filterCloseJobValue
                  )
                }
              }
              this.$swal(
                'เรียบร้อย',
                'เปลี่ยนเวลานัดหมาย เรียบร้อย',
                'success'
              )
              this.dataChangeReady = true
              this.dialogChange = false
            })
            .catch(error => {
              console.log('error function addData : ', error)
            })
        })
    },
    async updateLimitBookingChange (
      item,
      dueDateOld,
      dueDateTimeOld,
      dueDateNew,
      dueDateTimeNew,
      limitBookingCount
    ) {
      console.log('item--------------', item)
      let result = []
      let dt = {
        dueDateOld: dueDateOld,
        dueDateTimeOld: dueDateTimeOld,
        dueDateNew: dueDateNew,
        dueDateTimeNew: dueDateTimeNew,
        flowId: item.flowId,
        masBranchID: item.masBranchID,
        dateSelect: dueDateNew,
        timeSelect: dueDateTimeNew,
        shopId: item.shopId,
        userId: this.$session.getAll().data.userName || 'admin',
        bookNo: item.bookNo,
        limitBookingCount: limitBookingCount
      }
      await axios
        .post(this.$DNS_IP + '/Booking/updateLimitBookingChangeTime', dt)
        .then(async response => {
          result = response.data
        })
      return result
    },
    async updateLimitBookingEdit (
      item,
      dueDateOld,
      dueDateTimeOld,
      dueDateNew,
      dueDateTimeNew,
      limitBookingCount
    ) {
      let result = []
      console.log('!@#!@#!@#!@#!@#', this.dataEdit)
      let dt = {
        dueDateOld: dueDateOld,
        dueDateTimeOld: dueDateTimeOld,
        dueDateNew: dueDateNew,
        dueDateTimeNew: dueDateTimeNew,
        flowId: item.flowId,
        flowIdOld: this.flowIdOldEdit,
        masBranchIDOld: this.masBranchIDOldEdit,
        masBranchID: item.masBranchID,
        dateSelect: dueDateNew,
        timeSelect: dueDateTimeNew,
        shopId: item.shopId,
        userId: this.$session.getAll().data.userName || 'Admin',
        limitBookingCount: limitBookingCount,
        bookNo: this.dataEdit.bookNo
      }
      await axios
        .post(this.$DNS_IP + '/Booking/updateLimitBookingEdit', dt)
        .then(async response => {
          result = response.data
        })
      return result
    },
    async manageLimitBooking () {
      var dt = {
        dataLimit: this.limitCountBranch,
        dataLimitOld: this.limitCountBranchOld,
        dueDateNew: this.formChange.date,
        dueDateOld: this.dueDateOld,
        masBranchIDLimit: this.masBranchIDLimit,
        flowId: this.flowIDLimit,
        shopId: this.$session.getAll().data.shopId,
        CREATE_USER: this.session.data.userName,
        LAST_USER: this.session.data.userName
      }
      console.log('manageLimitBooking', dt)
      await axios
        .post(this.$DNS_IP + '/LimitBookingDate/manage', dt)
        .then(async response => {})
    },
    async getChangeOnsite (item) {
      await this.getEmpSelectAddJob()
      this.jobitem = []
      console.log(item)
      console.log(this.empSelectStepAdd)
      if (item.jobNo !== '') {
        await axios
          .get(this.$DNS_IP + '/job/getJobNo?jobNo=' + item.jobNo)
          .then(response => {
            let rs = response.data
            console.log('getJobNo', rs)
            if (rs.status === false) {
            } else {
              this.jobitem = rs
              this.sortNo = rs[0].sortNo
              this.empSelectJob = parseInt(rs[0].empStepId)
              this.flowId = rs[0].flowId
              console.log('this.flowId', this.flowId)
              if (this.sortNo === 1) {
                this.checkEmpJob()
              }
            }
          })
      }
    },
    async getjob (item) {
      console.log(item)
      this.bookNo = item.bookNo
      this.dataGetJob = item
      this.jobitem = []
      if (item.jobNo !== '') {
        this.getCoin(item)
        // var lineUserId = ''
        // if (item.lineUserId === null || item.lineUserId === '' || item.lineUserId === 'user-skip' || item.lineUserId === undefined) {
        //   lineUserId = ''
        // } else {
        //   lineUserId = item.lineUserId
        // }
        // this.lineUserId = lineUserId
        let checkBookingMember = ''
        const result = await axios
          .get(
            this.$DNS_IP +
              '/member/get?shopId=' +
              this.session.data.shopId +
              '&liffUserId=' +
              item.userId
          )
          .catch(error => {
            console.log('error function addData : ', error)
          })
        console.log('result', result.data)
        if (result.data.status === false) {
          checkBookingMember = ''
        } else {
          checkBookingMember = result.data[0]
        }
        await axios
          .get(this.$DNS_IP + '/job/getJobNo?jobNo=' + item.jobNo)
          .then(response => {
            let rs = response.data
            let Id = ''
            let memberPicture = ''
            console.log('getJobNo', rs)
            if (rs.length > 0) {
              for (var i = 0; i < rs.length; i++) {
                let d = rs[i]
                let s = {
                  Id: d.jobId,
                  value: d.fieldValue,
                  name: d.fieldName,
                  showCard: d.showCard,
                  jobNo: d.jobNo,
                  checkPayment: d.checkPayment,
                  recordStatus: d.RECORD_STATUS
                }
                Id = d.userId || ''
                memberPicture = d.memberPicture || ''
                this.jobitem.push(s)
              }
              this.userId = Id
              this.memberPicture = memberPicture
              if (checkBookingMember !== '' && this.memberPicture === '') {
                this.checkShowSelectUser = true
                this.dataSelectUser = checkBookingMember
              } else {
                this.checkShowSelectUser = false
                this.dataSelectUser = ''
              }
              this.value =
                this.pathToweb +
                this.jobitem[0].Id +
                '&shopId=' +
                this.$session.getAll().data.shopId
              this.recordStatusJob = this.jobitem[0].recordStatus
              this.checkPayment = this.jobitem[0].checkPayment
              this.formCloseJob.jobNo = this.jobitem[0].jobNo
              this.formCloseJob.jobId = this.jobitem[0].Id
              console.log('this.value', this.value)
              // this.getUserId()
            }
          })
      }
    },
    async getCoin (dt) {
      if (dt.lineUserId !== '') {
        let checkLine = await this.getDataLineConfig(dt.shopId)
        let urlLoyalty = ''
        if (checkLine.checkLineConfig === false) {
          urlLoyalty =
            this.$DNS_IP_Loyalty +
            '/member/get?shopId=' +
            dt.shopId +
            '&lineUserId=' +
            dt.lineUserId
        } else {
          urlLoyalty =
            this.$DNS_IP_Loyalty +
            '/member/get?shopId=' +
            dt.shopId +
            '&liffUserId=' +
            dt.lineUserId
        }
        await axios
          .get(urlLoyalty)
          .then(response => {
            let rs = response.data
            if (rs.status !== false) {
              if (checkLine.checkLineConfig === false) {
                this.lineUserId = rs[0].lineUserId || ''
              } else {
                this.lineUserId = rs[0].liffUserId || ''
              }
              this.memberTel = rs[0].tel || ''
            } else {
              this.lineUserId = ''
              this.memberTel = ''
            }
          })
          .catch(error => {
            this.lineUserId = ''
            this.memberTel = ''
            console.log('error function member : ', error)
          })
        if (this.lineUserId !== '') {
          this.dataCoin = []
          await axios
            .get(
              this.$DNS_IP_Loyalty +
                '/productExchangeRate/get?shopId=' +
                dt.shopId +
                '&flowId=' +
                dt.flowId
            )
            .then(response => {
              console.log('productExchangeRate', response.data)
              let rs = response.data
              if (rs.status !== false) {
                for (var i = 0; i < rs.length; i++) {
                  let d = rs[i]
                  d.text = d.name
                  d.value = d.productExchangeRateId
                  this.dataCoin.push(d)
                  // console.log('this.DataFlowName', this.DataFlowName)
                }
              } else {
                this.dataCoin = []
              }
            })
            .catch(error => {
              this.dataCoin = []
              console.log('error function productExchangeRate : ', error)
            })
        }
      }
    },
    async jobConfirm () {
      this.swalConfig.title = 'ต้องการ ยืนยันข้อมูล ใช่หรือไม่?'
      this.$swal(this.swalConfig).then(async () => {
        if (this.$session.id() !== undefined) {
          await axios
            .post(this.$DNS_IP + '/job/update/' + this.jobitem[0].Id, this.skip)
            .then(async response => {
              console.log(response)
              if (response.data.status) {
                this.getDataCalendaBooking()
                this.$swal('เรียบร้อย', 'ปรับปรุงเรียบร้อย', 'success')
                this.dialogJob = false
              } else {
                this.$swal(
                  'ผิดพลาด',
                  'เนื่องจากรายการนี้มีคนนำเข้าแล้ว',
                  'error'
                )
                this.dialogJob = false
              }
            })
        } else {
          this.$swal('ผิดพลาด', 'กรุณาลองอีกครั้ง', 'error')
          clearInterval(this.setTimerCalendar)
          this.setTimerCalendar = null
          this.$router.push('/Core/Login')
        }
      })
    },
    async jobConfirmUser () {
      console.log('this.jobitem', this.jobitem)
      console.log('this.BookingDataItem', this.BookingDataItem)
      this.swalConfig.title = 'ต้องการ ยืนยันข้อมูล ใช่หรือไม่?'
      this.$swal(this.swalConfig).then(async () => {
        if (this.$session.id() !== undefined) {
          let dt = {
            userId: this.dataSelectUser.liffUserId
          }
          await axios
            .post(this.$DNS_IP + '/job/update/' + this.jobitem[0].Id, dt)
            .then(async response => {
              console.log(response)
              if (response.data.status) {
                let statusSend = {
                  statusSend: 'true'
                }
                await axios
                  .post(
                    this.$DNS_IP + '/job/updateJobNo/' + this.jobitem[0].jobNo,
                    statusSend
                  )
                  .then(async response => {
                    // let lineUserId = result.data[0].lineUserId
                    console.log('statusSend', 'true')
                    let updateStatusSend = {
                      updateStatusSend: 'false'
                    }
                    await axios
                      .post(
                        this.$DNS_IP + '/job/pushMsg/' + response.data.jobId,
                        updateStatusSend
                      )
                      .catch(error => {
                        console.log('error function addData : ', error)
                      })
                  })
                this.getDataCalendaBooking()
                this.$swal('เรียบร้อย', 'ปรับปรุงเรียบร้อย', 'success')
                this.dialogJob = false
              } else {
                this.$swal(
                  'ผิดพลาด',
                  'เนื่องจากรายการนี้มีคนนำเข้าแล้ว',
                  'error'
                )
                this.dialogJob = false
              }
            })
        } else {
          this.$swal('ผิดพลาด', 'กรุณาลองอีกครั้ง', 'error')
          clearInterval(this.setTimerCalendar)
          this.setTimerCalendar = null
          this.$router.push('/Core/Login')
        }
      })
    },
    async pushMsgSelectUser () {
      let statusSend = {
        statusSend: 'false'
      }
      await axios.post(
        this.$DNS_IP + '/job/updateJobNo/' + this.jobitem[0].jobNo,
        statusSend
      )
      console.log('statusSend', 'false')
      let updateStatusSend = {
        updateStatusSend: 'false'
      }
      await axios
        .post(
          this.$DNS_IP + '/job/NotifyQrcode/' + this.jobitem[0].jobNo,
          updateStatusSend
        )
        .then(async response => {
          this.$swal(
            'เรียบร้อย',
            'ส่ง QR Code กลุ่มของท่านเรียบร้อย',
            'success'
          )
          this.dialogJob = false
          // this.clearData()
          // this.$router.push('/Master/FlowStep')
        })
        .catch(error => {
          console.log('error function addDataGlobal : ', error)
        })
    },
    async setBookingAgain (dt) {
      this.checkSelectText = dt.statusBt
      // นัดหมายอีกครั้ง = สร้างการจองใหม่ ต้องเช็ค limit เสมอ ไม่อิงสถานะ VIP ที่ค้างมาจากหน้าเพิ่ม
      this.statusVIP = 'False'
      // this.dialogEditData = true
      await this.getBookingField()
      // await this.getBookingData(dt, 'edit')
      console.log('setBookingAgain', dt)
      this.dataEdit = dt
      this.userId = dt.userId || ''
      this.BookingDataItemEdit = []
      this.formEdit.masBranchID = dt.masBranchID
      this.formEdit.bookingLanguage = dt.bookingLanguage
      this.masBranchIDOldEdit = dt.masBranchID
      this.formEdit.flowId = dt.flowId
      this.flowIdOldEdit = dt.flowId
      this.empSelectEdit = parseInt(dt.empSelect)
      this.dueDateOld = dt.dueDateDay
      this.dueDateTimeOld = dt.timeDuetext

      this.address = dt.address
      this.center = JSON.parse(dt.addressLatLong) || null

      // this.SetallowedDatesEdit()
      this.dateEdit = ''
      // this.dateEdit = dt.dueDateDay
      // console.log('dataFlowSelectEdit', this.dataFlowSelectEdit)
      this.timeavailable = []
      // let dtTime = await this.branch.filter(item => { return item.value === this.formEdit.masBranchID })
      let dtTime =
        this.dataFlowSelectEdit.filter(item => {
          return item.value === this.formEdit.flowId
        }) || []
      // console.log('dtTime', dtTime)
      // this.checkTimeEdit()
      await this.setLimitBookingEdit(dt.dueDateDay)
      let setTime = []
      if (
        this.DataFlowNameDefault.filter(el => {
          return el.value === parseInt(this.formEdit.flowId)
        })[0].allData.setTimebyday === 'True'
      ) {
        let timeJson = JSON.parse(
          this.DataFlowNameDefault.filter(el => {
            return el.value === parseInt(this.formEdit.flowId)
          })[0].allData.setTime
        ).filter(items => items.value === new Date(dt.dueDateDay).getDay())
        setTime = timeJson[0].setTime || []
        // console.log('IF')
      } else {
        // console.log('ELSE')
        setTime =
          JSON.parse(
            this.DataFlowNameDefault.filter(el => {
              return el.value === parseInt(this.formEdit.flowId)
            })[0].allData.setTime
          ) || []
      }
      if (dtTime.length > 0) {
        console.log('dtTime-----------------', dtTime)
        if (dtTime[0].menuShowStatus === 'True') {
          this.showMenu = 'True'
          this.dataMenuEdit = JSON.parse(dtTime[0].allData.menuItem) || []
        } else {
          this.showMenu = 'False'
          this.dataMenuEdit = []
        }
        let dataCheckmenu = dt.menuItem
        if (dataCheckmenu.length > 0) {
          if (
            dataCheckmenu && dataCheckmenu.length > 1
          ) {
            let dataMenu = JSON.parse(dataCheckmenu)
            for (let i = 0; i < dataMenu.length; i++) {
              let d = dataMenu[i]
              if (
                this.dataMenuEdit.filter(el => {
                  return el.name === d.name
                }).length > 0
              ) {
                let index = this.dataMenuEdit.findIndex(it => {
                  return it.name === d.name
                })
                console.log(index)
                this.dataMenuEdit[index].price = d.price
                this.dataMenuEdit[index].qty = d.qty
                this.dataMenuEdit[index].remark = d.remark
              }
            }
            if (this.dataMenuEdit.length > 0) {
              this.dataMenu = this.dataMenuEdit
            } else {
              if (
                dataCheckmenu &&
                dataCheckmenu.length > 1
              ) {
                this.dataMenu = JSON.parse(dataCheckmenu)
              }
            }
            this.priceMenu = parseInt(dataCheckmenu.menuPrice)
          }
        } else {
          if (
            dataCheckmenu && dataCheckmenu.length > 1
          ) {
            this.dataMenu = JSON.parse(dataCheckmenu)
            this.priceMenu = parseInt(dataCheckmenu.menuPrice)
          }
        }
        this.statusShowMap = dtTime[0].allData.checkOnsite || 'False'
        // console.log('test', JSON.parse(dtTime.map(item => item.allData.setTime)))
        // console.log('timeavailable', dtTime.map(item => item.allData.setTime))
        if (
          dtTime.map(item => item.allData.setTime)[0] === null ||
          dtTime.map(item => item.allData.setTime)[0] === ''
        ) {
          this.timeavailable = []
          this.timeEdit = ''
        } else {
          this.timeavailable = setTime
          this.timeEdit = ''
          // if (this.timeavailable.filter(el => { return el.text === dt.timeText }).length > 0) {
          //   if (dt.timeText) {
          //     this.timeEdit = { text: dt.timeText, value: dt.dueDate.slice(-5) }
          //   } else {
          //     this.timeEdit = { text: dt.dueDate.slice(-5), value: dt.dueDate.slice(-5) }
          //   }
          // } else {
          //   this.timeEdit = { text: dt.dueDate.slice(-5), value: dt.dueDate.slice(-5) }
          // }
        }
      } else {
        this.statusShowMap = 'False'
      }
      console.log('setDataEdit', dt)
      await this.getPackage(dt)
      if (this.dataPackage.length > 0) {
        // console.log('dataPackage', this.dataPackage.filter(el => { return el.packageId === dt.packageId }))
        if (
          this.dataPackage.filter(el => {
            return el.packageId === dt.packageId
          }).length > 0
        ) {
          var dataPack = this.dataPackage.filter(el => {
            return el.packageId === dt.packageId
          })
          this.dataPackageDefault = true
          // this.packageId = dataPack[0].value
          this.UpdatePackage(
            dataPack[0].value,
            'ตกลง',
            dataPack[0].text,
            dataPack[0],
            dt.tokenPackage
          )
        } else {
          this.UpdatePackage('', 'ยกเลิก', '', '', '')
          this.dataPackageDefault = false
        }
      }
      console.log('setDataEdit', dt)
      var extraJob = ''
      var fastTrack = ''
      if (dt.extraJob === null) {
        extraJob = false
      } else {
        extraJob = dt.extraJob
      }
      if (dt.fastTrack === null) {
        fastTrack = false
      } else {
        fastTrack = dt.fastTrack
      }

      if (!extraJob && !fastTrack) {
        this.formEdit.radiosRemark = 'ซ่อมปกติ'
      } else if (extraJob && !fastTrack) {
        this.formEdit.radiosRemark = 'ExtraJob'
      } else if (!extraJob && fastTrack) {
        this.formEdit.radiosRemark = 'FastTrack'
      }

      let itemIncustomField = []
      await axios
        .get(
          this.$DNS_IP + '/BookingField/get?shopId=' + this.session.data.shopId
        )
        .then(async response1 => {
          let rs2 = response1.data
          console.log('BookingField', rs2)
          if (rs2.length > 0) {
            let bookingData = []
            bookingData = JSON.parse(rs2[0].flowfieldName)
            for (let i = 0; i < bookingData.length; i++) {
              let d = bookingData[i]
              itemIncustomField.push(d.fieldId)
            }
            await axios
              .get(
                this.$DNS_IP +
                  '/customField/fieldId?fieldId=' +
                  itemIncustomField
              )
              .then(async responses => {
                let rs1 = responses.data
                console.log('customField', rs1)
                await axios
                  .get(
                    this.$DNS_IP + '/BookingDataSelect/get?bookNo=' + dt.bookNo
                  )
                  .then(async response => {
                    let rs = response.data
                    console.log('BookingDataSelect', rs)
                    if (rs.length > 0) {
                      let sortrs = rs1.sort(
                        (a, b) => a.sortNoField - b.sortNoField
                      )
                      for (var i = 0; i < sortrs.length; i++) {
                        var d = sortrs[i]
                        var s = {}
                        var dataBD = rs.filter(el => {
                          return parseInt(el.fieldId) === parseInt(d.fieldId)
                        })
                        // console.log('dataBD', dataBD)
                        if (dataBD.length > 0) {
                          s.bookNo = dataBD[0].bookNo
                          s.bookingFieldId = rs2[0].bookingFieldId
                          s.bookingDataId = dataBD[0].bookingDataId
                          s.conditionField = d.conditionField
                          s.fieldId = d.fieldId
                          s.fieldType = d.fieldType
                          if (d.fieldType === 'Checkbox') {
                            console.log('checkbox')
                            this.selected[d.fieldId] = this.parseCheckboxValue(dataBD[0].fieldValue)
                          }
                          s.fieldValue = dataBD[0].fieldValue
                          s.fieldName = d.fieldName
                          s.conditionField = d.conditionField
                          s.conditionValue = d.conditionValue
                          s.requiredField = d.requiredField
                          s.optionField = d.optionField
                          this.BookingDataItemEdit.push(s)
                        } else {
                          s.bookNo = rs[0].bookNo
                          s.bookingFieldId = rs2[0].bookingFieldId
                          s.bookingDataId = 'newDataBooking'
                          s.conditionField = d.conditionField
                          s.fieldId = d.fieldId
                          s.fieldType = d.fieldType
                          s.fieldValue = s.fieldType === 'Checkbox' ? '[]' : ''
                          s.fieldName = d.fieldName
                          s.conditionField = d.conditionField
                          s.conditionValue = d.conditionValue
                          s.requiredField = d.requiredField
                          s.optionField = d.optionField
                          this.BookingDataItemEdit.push(s)
                        }
                      }
                    } else {
                      this.$swal(
                        'พบความผิดพลาดระหว่างดำเนินการ',
                        'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่',
                        'info'
                      )
                        .then(result => {
                          this.dialogBookingAgain = false
                        })
                        .catch(error => {
                          console.log('error function setDataEdit : ', error)
                          this.dialogBookingAgain = false
                        })
                    }
                  })
                  .catch(error => {
                    this.$swal(
                      'พบความผิดพลาดระหว่างดำเนินการ',
                      'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่',
                      'info'
                    )
                      .then(result => {
                        this.dialogBookingAgain = false
                      })
                      .catch(error => {
                        console.log('error function setDataEdit : ', error)
                        this.dialogBookingAgain = false
                      })
                    console.log('error function setDataEdit : ', error)
                  })
              })
          } else {
            this.$swal(
              'พบความผิดพลาดระหว่างดำเนินการ',
              'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่',
              'info'
            )
              .then(result => {
                this.dialogBookingAgain = false
              })
              .catch(error => {
                console.log('error function setDataEdit : ', error)
                this.dialogBookingAgain = false
              })
          }
        })
        .catch(error => {
          this.$swal(
            'พบความผิดพลาดระหว่างดำเนินการ',
            'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่',
            'info'
          )
            .then(result => {
              this.dialogBookingAgain = false
            })
            .catch(error => {
              console.log('error function setDataEdit : ', error)
              this.dialogBookingAgain = false
            })
          console.log('error function setDataEdit : ', error)
        })
      console.log('this.BookingDataItemEdit', this.BookingDataItemEdit)
      this.dialogBookingAgain = true
      this.SetallowedDatesEdit()
    },
    addBookingAgain () {
      this.loadingBookingAgain = true
      this.validate('BOOKAGAIN')
      setTimeout(() => this.checkDuplicateBookingAgain(), 500)
    },
    // ตรวจสอบ limit ของคิวใหม่ที่เลือกก่อน "นัดหมายอีกครั้ง" (เป็นการจองใหม่ ไม่ใช่การย้ายคิวเดิม)
    async checkLimitAndSubmitBookingAgain () {
      let chkStatLimit = this.dataFlowSelectEdit.filter(el => {
        return el.value === this.formEdit.flowId
      })
      if (
        chkStatLimit.length > 0 &&
        chkStatLimit[0].allData.limitBookingCheck === 'True'
      ) {
        await this.checkLimitBookingAgain()
        if (this.checkLimitBooking.limitCheck === 'true') {
          this.addBookingAgainSubmit()
        } else if (this.checkLimitBooking.limitCheck === 'false') {
          this.$swal(
            'คิวเต็มแล้ว',
            'กรุณาเลือกวันที่และเวลาใหม่อีกครั้ง',
            'error'
          )
          this.loadingEdit = false
        } else {
          this.checkLimitBooking.limitCheck = 'true'
          this.addBookingAgainSubmit()
        }
      } else {
        this.checkLimitBooking.limitCheck = 'false'
        this.addBookingAgainSubmit()
      }
    },
    async checkDuplicateBookingAgain () {
      if (this.validBookingAgain !== false) {
        console.log('this.BookingDataItemEdit', this.BookingDataItemEdit)
        this.loadingEdit = true
        this.swalConfig.title = 'ต้องการ นัดหมายอีกครั้ง ใช่หรือไม่?'
        this.$swal(this.swalConfig)
          .then(async result => {
            if (this.getSelectText === 'cancel') {
              this.addBookingAgainSubmit()
            } else {
              if (this.formEdit.radiosRemark === 'FastTrack') {
                let getcount = await this.getCountFastTrack(
                  this.dateEdit,
                  this.formEdit.flowId,
                  this.formEdit.masBranchID
                )
                let setCountFast = this.branch.filter(el => {
                  return el.value === this.formEdit.masBranchID
                })[0].allData.countFastTrack
                if (getcount < setCountFast) {
                  await this.checkLimitAndSubmitBookingAgain()
                } else {
                  this.textError = 'จำนวนงานด่วนต่อวัน เกินกว่าที่ตั้งไว้'
                  this.dialogError = true
                  this.loadingEdit = false
                }
              } else {
                await this.checkLimitAndSubmitBookingAgain()
              }
            }
          })
          .catch(error => {
            this.loadingEdit = false
            console.log('addBookingAgainSubmit error', error)
          })
      } else {
        this.loadingEdit = false
      }
    },
    async addBookingAgainSubmit () {
      if (this.$session.id() !== undefined) {
        this.dataEditReady = false
        let rs = this.BookingDataItemEdit
        let Add = []
        let fielditem = this.BookingDataItemEdit
        console.log('this.BookingDataItemEdit', this.BookingDataItemEdit)
        var fastTrack = 'False'
        var extraJob = 'False'
        switch (this.formEdit.radiosRemark) {
          case 'ซ่อมปกติ':
            fastTrack = 'False'
            extraJob = 'False'
            break
          case 'ExtraJob':
            fastTrack = 'False'
            extraJob = 'True'
            break
          case 'FastTrack':
            fastTrack = 'True'
            extraJob = 'False'
            break
        }
        let storeFront = this.DataFlowNameDefault.filter(item => {
          return item.value === this.formEdit.flowId
        })
        let storeFrontCheck = ''
        if (storeFront.length > 0) {
          storeFrontCheck = storeFront[0].allData.storeFrontCheck || 'False'
        } else {
          storeFrontCheck = 'False'
        }
        let limitBookingCheck = ''
        if (this.checkLimitBooking.limitCheck === 'true' || null) {
          limitBookingCheck = 'True'
        } else {
          limitBookingCheck = 'False'
        }
        for (let i = 0; i < rs.length; i++) {
          let d = rs[i]
          let update = {}
          if (d.conditionField === '' || d.conditionField === null) {
            update.remark = this.remark
            update.fieldId = d.fieldId //
            update.bookingFieldId = d.bookingFieldId //
            update.fieldValue = (d.fieldValue || '')
              .replace(/\\/g, '\\\\').replace(/%/g, '%%')
              .replace(/'/g, "\\'") //
            update.dueDate = this.dateEdit + ' ' + this.timeEdit.value //
            update.dateSelect = this.dateEdit //
            update.timeText = this.timeEdit.text //
            update.flowId = this.formEdit.flowId //
            update.masBranchID = this.formEdit.masBranchID //
            update.bookingLanguage = this.formEdit.bookingLanguage //
            update.fastTrack = fastTrack //
            update.extraJob = extraJob //
            update.empSelect = this.empSelectEdit //
            update.shopId = this.session.data.shopId //
            update.address = (this.address || '')
              .replace(/%/g, '%%')
              .replace(/'/g, "\\'") //
            update.addressLatLong = JSON.stringify(this.center) //
            update.storeFrontCheck = storeFrontCheck //
            update.statusBookingForm = 'BookingForm' //
            update.timeSelect = this.timeEdit.value //
            update.userId = this.userId || 'user-skip' //
            update.pageName = 'BookingList' //
            update.sourceLink = 'direct' //
            update.adminLogin = this.session.data.userName //
            if (this.dataMenuEdit.filter(i => parseInt(i.qty) > 0).length > 0) {
              update.menuItem = JSON.stringify(
                this.dataMenuEdit.filter(i => parseInt(i.qty) > 0)
              )
              update.menuPrice = this.priceMenuAdd
            }
            update.limitBookingCheck = limitBookingCheck
            update.limitBookingId = this.checkLimitBooking.ID
            update.limitBookingCount = this.checkLimitBooking.countBooking
            update.getLimitBooking = this.checkLimitBooking.limitBooking
            // update.depositStatus = this.formAdd.depositStatus
            // update.depositImge = this.formAdd.depositImge
            // update.depositPrice = this.formAdd.depositPrice
            Add.push(update)
          } else {
            if (
              fielditem.filter(row => {
                return row.fieldId === parseInt(d.conditionField)
              }).length > 0
            ) {
              if (
                d.conditionValue ===
                fielditem.filter(row => {
                  return row.fieldId === parseInt(d.conditionField)
                })[0].fieldValue
              ) {
                // update.fieldId = d.fieldId
                // update.bookingDataId = d.bookingDataId
                // update.bookingFieldId = d.bookingFieldId
                // update.bookNo = d.bookNo
                // update.fieldValue = (d.fieldValue || '').replace(/\\/g, '\\\\').replace(/%/g, '%%').replace(/'/g, "\\'")
                // update.dueDate = this.dateEdit + ' ' + this.timeEdit.value
                // update.timeText = this.timeEdit.text
                // update.flowId = this.formEdit.flowId
                // update.masBranchID = this.formEdit.masBranchID
                // update.fastTrack = fastTrack
                // update.extraJob = extraJob
                // update.LAST_USER = this.$session.getAll().data.userName
                // update.empSelect = this.empSelectEdit
                // update.shopId = this.session.data.shopId
                // update.address = (this.address || '').replace(/%/g, '%%').replace(/'/g, "\\'")
                // update.addressLatLong = JSON.stringify(this.center)
                // update.storeFrontCheck = storeFrontCheck
                // update.statusBookingForm = 'BookingForm'
                // update.timeSelect = this.timeEdit.value
                update.remark = this.remark
                update.fieldId = d.fieldId //
                update.bookingFieldId = d.bookingFieldId //
                update.fieldValue = (d.fieldValue || '')
                  .replace(/\\/g, '\\\\').replace(/%/g, '%%')
                  .replace(/'/g, "\\'") //
                update.dueDate = this.dateEdit + ' ' + this.timeEdit.value //
                update.dateSelect = this.dateEdit //
                update.timeText = this.timeEdit.text //
                update.flowId = this.formEdit.flowId //
                update.masBranchID = this.formEdit.masBranchID //
                update.bookingLanguage = this.formEdit.bookingLanguage //
                update.fastTrack = fastTrack //
                update.extraJob = extraJob //
                update.empSelect = this.empSelectEdit //
                update.shopId = this.session.data.shopId //
                update.address = (this.address || '')
                  .replace(/%/g, '%%')
                  .replace(/'/g, "\\'") //
                update.addressLatLong = JSON.stringify(this.center) //
                update.storeFrontCheck = storeFrontCheck //
                update.statusBookingForm = 'BookingForm' //
                update.timeSelect = this.timeEdit.value //
                update.userId = this.userId || 'user-skip' //
                update.pageName = 'BookingList' //
                update.sourceLink = 'direct' //
                update.adminLogin = this.session.data.userName //
                if (this.dataMenuEdit.filter(i => parseInt(i.qty) > 0).length > 0) {
                  update.menuItem = JSON.stringify(this.dataMenuEdit.filter(i => parseInt(i.qty) > 0))
                  update.menuPrice = this.priceMenuAdd
                }
                update.limitBookingCheck = limitBookingCheck
                update.limitBookingId = this.checkLimitBooking.ID
                update.limitBookingCount = this.checkLimitBooking.countBooking
                update.getLimitBooking = this.checkLimitBooking.limitBooking
                Add.push(update)
              }
            } else if (d.conditionField === 'flow') {
              if (
                parseInt(d.conditionValue) === parseInt(this.formEdit.flowId)
              ) {
                // update.fieldId = d.fieldId
                // update.bookingDataId = d.bookingDataId
                // update.bookingFieldId = d.bookingFieldId
                // update.bookNo = d.bookNo
                // update.fieldValue = (d.fieldValue || '').replace(/\\/g, '\\\\').replace(/%/g, '%%').replace(/'/g, "\\'")
                // update.dueDate = this.dateEdit + ' ' + this.timeEdit.value
                // update.timeText = this.timeEdit.text
                // update.flowId = this.formEdit.flowId
                // update.masBranchID = this.formEdit.masBranchID
                // update.fastTrack = fastTrack
                // update.extraJob = extraJob
                // update.LAST_USER = this.$session.getAll().data.userName
                // update.empSelect = this.empSelectEdit
                // update.shopId = this.session.data.shopId
                // update.address = (this.address || '').replace(/%/g, '%%').replace(/'/g, "\\'")
                // update.addressLatLong = JSON.stringify(this.center)
                // update.storeFrontCheck = storeFrontCheck
                // update.statusBookingForm = 'BookingForm'
                // update.timeSelect = this.timeEdit.value
                update.remark = this.remark
                update.fieldId = d.fieldId //
                update.bookingFieldId = d.bookingFieldId //
                update.fieldValue = (d.fieldValue || '')
                  .replace(/\\/g, '\\\\').replace(/%/g, '%%')
                  .replace(/'/g, "\\'") //
                update.dueDate = this.dateEdit + ' ' + this.timeEdit.value //
                update.dateSelect = this.dateEdit //
                update.timeText = this.timeEdit.text //
                update.flowId = this.formEdit.flowId //
                update.masBranchID = this.formEdit.masBranchID //
                update.bookingLanguage = this.formEdit.bookingLanguage //
                update.fastTrack = fastTrack //
                update.extraJob = extraJob //
                update.empSelect = this.empSelectEdit //
                update.shopId = this.session.data.shopId //
                update.address = (this.address || '')
                  .replace(/%/g, '%%')
                  .replace(/'/g, "\\'") //
                update.addressLatLong = JSON.stringify(this.center) //
                update.storeFrontCheck = storeFrontCheck //
                update.statusBookingForm = 'BookingForm' //
                update.timeSelect = this.timeEdit.value //
                update.userId = this.userId || 'user-skip' //
                update.pageName = 'BookingList' //
                update.sourceLink = 'direct' //
                update.adminLogin = this.session.data.userName //
                if (this.dataMenuEdit.filter(i => parseInt(i.qty) > 0).length > 0) {
                  update.menuItem = JSON.stringify(
                    this.dataMenuEdit.filter(i => parseInt(i.qty) > 0)
                  )
                  update.menuPrice = this.priceMenuAdd
                }
                update.limitBookingCheck = limitBookingCheck
                update.limitBookingId = this.checkLimitBooking.ID
                update.limitBookingCount = this.checkLimitBooking.countBooking
                update.getLimitBooking = this.checkLimitBooking.limitBooking
                Add.push(update)
              }
            }
          }
        }
        console.log('Add', Add)
        await axios
          .post(
            // eslint-disable-next-line quotes
            this.$DNS_IP + "/Booking/add",
            Add
          )
          .then(async response => {
            if (response.data.message === 'LimitBooking_Full') {
              this.$swal(
                'คิวเต็มแล้ว',
                'กรุณาเลือกวันที่และเวลาใหม่อีกครั้ง',
                'error'
              )
              this.date = ''
              this.time = ''
            } else {
              console.log('------------', response)
              console.log('shop ', Add[0].shopId) // เป็นการอัพเดตสถานะจาก null เป็น confirm
              if (this.checkShopSigneture[Add[0].shopId]) {
                console.log('ยืนยันแล้ว')
                await this.confirmChkAddBookingAgain(response.data)
                let body = [{
                  shopId: this.$session.getAll().data.shopId,
                  bookNo: response.data.bookNo,
                  jobNo: '',
                  beforeAir: '',
                  checkBox1: '',
                  checkBox2: '',
                  remarkCheckbox1: '',
                  remarkCheckbox2: '',
                  remarkDetail: '',
                  redio1: '',
                  afterAir: '',
                  remark: '',
                  CREATE_USER: this.$session.getAll().data.userName,
                  LAST_USER: this.$session.getAll().data.userName,
                  processNow: ''
                }]
                console.log('body shopId', body)
                await axios.post(this.$DNS_IP + '/formpdf/insert', body)
                // await axios.post(this.$DNS_IP + 'http://localhost:5002/formpdf/insert', body)
              }
              if (this.statusSearch === 'no') {
                await this.getBookingList()
              } else {
                await this.searchAny()
              }
              // this.getTimesChange('update')
              this.formEdit.radiosRemark = ''
              this.remark = ''
              if (this.getSelectText) {
                this.getSelect(
                  this.getSelectText,
                  this.getSelectCount,
                  this.filterCloseJobValue
                )
              }
              this.dialogBookingAgain = false
              this.$swal('เรียบร้อย', 'นัดหมายอีกครั้ง เรียบร้อย', 'success')
              this.dataEditReady = true
              this.loadingEdit = false
            }
          })
          .catch(error => {
            // this.dataEditReady = true
            setTimeout(() => this.addBookingAgainSubmit(), 3000)
            console.log('close alert : ', error)
          })
      } else {
        this.$swal('ผิดพลาด', 'กรุณาลองอีกครั้ง', 'error')
        clearInterval(this.setTimerCalendar)
        this.setTimerCalendar = null
        this.$router.push('/Core/Login')
      }
    },
    async confirmChkAddBookingAgain (item) {
      var dt = {
        bookNo: item.bookNo,
        contactDate: moment().format('YYYY-MM-DD HH:mm:ss'),
        status: 'confirm',
        statusUse: 'use',
        shopId: this.$session.getAll().data.shopId,
        CREATE_USER: this.session.data.userName,
        LAST_USER: this.session.data.userName
      }
      await axios
        .post(this.$DNS_IP + '/booking_transaction/add', dt)
        .then(async response => {
          // this.getDataCalendaBooking()
          this.sendEmailConfirm(dt.bookNo)
          this.pushMsgConfirm(item.bookNo)
          // this.clearDataAdd()
          // this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
          // await this.getBookingList()
          // this.getTimesChange('update')
        })
        .catch(error => {
          console.log('error function confirmChkAddBookingAgain : ', error)
          setTimeout(() => this.confirmChkAddBookingAgain(), 3000)
        })
    },
    async sendEmailConfirm (bookNo) {
      let obj = {
        'bookNo': bookNo
      }
      await axios
        .post(this.$DNS_IP + '/email_booking/confirm_noLine', obj)
        .then(response => {})
        .catch((error) => {
          console.log(error)
        })
    },
    async sendEmailConfirmOmbudsman (bookNo) {
      let obj = {
        'bookNo': bookNo
      }
      await axios
        .post(this.$DNS_IP + '/email_booking/confirm_office_ombudsman', obj)
        .then(response => {})
        .catch((error) => {
          console.log(error)
        })
    },
    async checkJobLog (item) {
      try {
        console.log('call checkJobLog')
        if (this.checkShopSigneture[this.session.data.shopId]) {
          if (item.jobNo) {
            const resdata = await axios.get(this.$DNS_IP + '/job_log/get?jobNo=' + item.jobNo)
            console.log('resdata.data', resdata.data)
            if (resdata.data.length <= 1) {
              console.log('รอช่างกดเริ่มงาน')
              return true
            } else if (resdata.data.length > 1) {
              console.log('ช่างกดเริ่มงานไปแล้ว')
              return false
            } else {
              return true
            }
          } else {
            console.log('ยังไม่ได้มอบหมายงานให้ช่าง')
            return true
          }
        } else {
          return true
        }
      } catch (error) {
        console.log('error checkJobLog', error)
        return true
      }
    },
    async setDataChang (item) {
      try {
        if (await this.checkJobLog(item)) {
        // clear Limit
          console.log('setDataChang', item)
          this.statusVIPChang = item.statusVIP
          this.limitCountBranch = []
          this.limitCountBranchOld = []
          this.masBranchIDLimit = ''
          this.flowIDLimit = ''
          this.countBookingLimit = 0
          this.selectCountBookingLimit = 1
          this.limitBookingCheck = 'False'
          this.limitBookingSelect = 'False'
          /// /////////////////////
          this.userId = item.userId || ''
          this.limitBookingCheck = item.limitBookingCheck || 'False'
          item.countHourLimit = item.countHourLimit || 0
          this.countBookingLimit = 0
          this.dueDateOld = item.dueDateDay
          this.dueDateTimeOld = item.timeDuetext
          this.masBranchIDLimit = item.masBranchID
          this.flowIDLimit = item.flowId
          this.checkSelectText = item.statusBt
          this.checkTimeFlow(item)
          this.dataChange = item
          this.remark = item.remark
          this.formChange.date = item.dueDateDay
          this.setLimitBookingChange(item.dueDateDay)
          console.log('this.timeavailable', this.timeavailable)
          // if (this.timeavailable.length > 0) {
          //   if (this.timeavailable.filter(el => { return el.text === item.timeText }).length > 0) {
          //     if (item.timeText) {
          //       this.formChange.time = { text: item.timeText, value: item.timeDuetext }
          //     } else {
          //       this.formChange.time = { text: item.timeDuetext, value: item.timeDuetext }
          //     }
          //   } else {
          //     this.formChange.time = { text: item.timeDuetext, value: item.timeDuetext }
          //   }
          // } else {
          //   this.formChange.time = ''
          // }

          let limitCountBranchOld = 0
          if (
            this.DataFlowNameDefault.filter(el => {
              return el.value === parseInt(item.flowId)
            }).length > 0
          ) {
            let setTimeOld = JSON.parse(
              this.DataFlowNameDefault.filter(el => {
                return el.value === parseInt(item.flowId)
              })[0].allData.setTime
            )
            console.log('setTimeOld', setTimeOld)
            if (setTimeOld === '' || setTimeOld === null) {
              this.limitCountBranchOld = []
            } else {
            // let setTimeOld = JSON.parse(this.branch.filter(el => { return el.value === parseInt(item.masBranchID) })[0].allData.setTime)
              let indexOld = setTimeOld.findIndex(
                element => element.value === item.timeDuetext
              )
              limitCountBranchOld = setTimeOld.slice(
                indexOld,
                indexOld + item.countHourLimit
              )
              this.limitCountBranchOld = limitCountBranchOld
            }
          }

          // checkSelectText จะเป็น confirm หรือ !confirm จะเปิด dialogChange เปลี่ยนเวลานัดหมาย แล้วจะเช็คการโชว์ปุ่มอีกที
          this.dialogChange = true
          console.log(this.formChange)
          if (this.formChange.time !== '') {
            this.setCountTime(item)
          }
          this.SetallowedDatesChange(item.flowId)
        } else {
          this.$swal('คำเตือน', 'รายการนี้ได้เริ่มงานไปแล้ว', 'warning')
        }
      } catch (error) {
        console.log('error setDataChang', error)
      }
    },
    async setCountTime (dt) {
      console.log('this.formChange.time', this.formChange.time)
      let limitCountBranch = 0
      if (
        this.DataFlowNameDefault.filter(el => {
          return el.value === parseInt(dt.flowId)
        }).length > 0
      ) {
        // let setTime = JSON.parse(this.branch.filter(el => { return el.value === parseInt(this.masBranchIDLimit) })[0].allData.setTime)
        let setTime = JSON.parse(
          this.DataFlowNameDefault.filter(el => {
            return el.value === parseInt(dt.flowId)
          })[0].allData.setTime
        )
        let index = setTime.findIndex(
          element => element.value === this.formChange.time.value
        )
        limitCountBranch = setTime.slice(
          index,
          index + this.selectCountBookingLimit
        )
        this.limitCountBranch = limitCountBranch
        await this.getDataLimitBooking(dt)
      }
    },
    async getDataLimitBooking (dt) {
      this.dataLimitBookingDate = []
      // let setTime = JSON.parse(this.branch.filter(el => { return el.value === parseInt(this.masBranchIDLimit) })[0].allData.setTime)
      let setTime = JSON.parse(
        this.DataFlowNameDefault.filter(el => {
          return el.value === parseInt(dt.flowId)
        })[0].allData.setTime
      )
      let limitBooking = 0
      if (setTime.length > 0) {
        if (
          setTime.filter(el => {
            return el.value === this.formChange.time.value
          }).length > 0
        ) {
          limitBooking = setTime.filter(el => {
            return el.value === this.formChange.time.value
          })[0].limitBooking
        } else {
          limitBooking = 0
        }
      } else {
        limitBooking = 0
      }
      if (limitBooking !== 0) {
        await axios
          .get(
            this.$DNS_IP +
              '/LimitBookingDate/get?shopId=' +
              this.session.data.shopId +
              '&bookingDate=' +
              this.formChange.date
          )
          .then(async response => {
            let rs = response.data
            if (rs.status === false) {
              this.dataLimitBookingDate = []
            } else {
              for (let i = 0; i < rs.length; i++) {
                let d = rs[i]
                let s = {}
                s.bookingTime = d.bookingTime
                s.countBookingLimit = d.countBooking + '/' + limitBooking
                s.countBooking = d.countBooking
                // if (d.countBooking === parseInt(limitBooking)) {
                //   s.color = 'orange darken-1'
                // } else
                if (d.countBooking > parseInt(limitBooking)) {
                  s.color = 'red darken-1'
                } else if (d.countBooking <= parseInt(limitBooking)) {
                  s.color = 'blue darken-1'
                }
                this.dataLimitBookingDate.push(s)
              }
              for (let i = 0; i < this.limitCountBranch.length; i++) {
                let s = {}
                let d = this.limitCountBranch[i]
                if (
                  this.dataLimitBookingDate.filter(el => {
                    return el.bookingTime === d.value
                  }).length > 0
                ) {
                  let index = this.dataLimitBookingDate.findIndex(
                    element => element.bookingTime === d.value
                  )
                  this.dataLimitBookingDate[index].countBooking =
                    this.dataLimitBookingDate[index].countBooking + 1
                  this.dataLimitBookingDate[index].countBookingLimit =
                    this.dataLimitBookingDate[index].countBooking +
                    '/' +
                    limitBooking
                  // if (this.dataLimitBookingDate[index].countBooking === parseInt(limitBooking)) {
                  //   this.dataLimitBookingDate[index].color = 'orange darken-1'
                  // } else
                  if (
                    this.dataLimitBookingDate[index].countBooking >
                    parseInt(limitBooking)
                  ) {
                    this.dataLimitBookingDate[index].color = 'red darken-1'
                  } else if (
                    this.dataLimitBookingDate[index].countBooking <=
                    parseInt(limitBooking)
                  ) {
                    this.dataLimitBookingDate[index].color = 'blue darken-1'
                  }
                } else {
                  s.bookingTime = d.value
                  s.countBooking = 1
                  s.countBookingLimit = 1 + '/' + limitBooking
                  s.color = 'blue darken-1'
                  this.dataLimitBookingDate.push(s)
                }
              }
              this.dataLimitBookingDate = this.dataLimitBookingDate.sort(
                (a, b) => {
                  if (a.bookingTime < b.bookingTime) return -1
                  return a.bookingTime > b.bookingTime ? 1 : 0
                }
              )
              console.log(
                ' this.dataLimitBookingDate',
                this.dataLimitBookingDate
              )
              console.log('limitBooking', limitBooking)
            }
          })
      }
    },
    async openInfo (item) {
      this.detailInfo = await this.getBookingData(item)
      this.dataInfo = item
      this.dialogInfo = true
    },
    testStyleInputGoogleMap (item) {
      console.log('item ', item)
      const divTest = document.getElementById(item)
      console.log('divTest ', divTest)
      const divTestVal = divTest.getBoundingClientRect()
      const poc = document.getElementsByClassName('pac-container pac-logo')
      divTest.appendChild(poc[0])
      poc[0].style.setProperty('position', 'initial', 'important')
      poc[0].style.display = 'inline'
      console.log('divTestVal : ', divTestVal)
      console.log('pocVal : ', poc[0])
    },
    async geolocate () {
      await navigator.geolocation.getCurrentPosition(
        async position => {
          const center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          if (center) {
            this.center = center
            this.shopLat = center.lat
            this.shopLong = center.lng
          }
        },
        error => {
          this.center = null
          this.shopLat = ''
          this.shopLong = ''
          // this.center.lat = null
          // this.center.lng = null
          console.log('error map :', error.message)
        }
      )
    }
    // async getFirestore () {
    //   try {
    //     console.log('getFirestore -> ', this.unsubscribe)
    //     if (this.unsubscribe) {
    //       this.unsubscribe()
    //     }
    //     this.firestore = this.$firebase.firestore()
    //     this.unsubscribe = this.firestore.collection(`QueueOnline/shopId/${this.$session.getAll().data.shopId}`).doc(this.$session.getAll().data.userName)
    //       .onSnapshot(async (snapshot) => {
    //         if (!snapshot.exists) {
    //           await this.createProcessShopNew()
    //         } else {
    //           console.log('getFirestore -> data', snapshot.data())
    //           if (snapshot.data().active === '1') {
    //             console.log('active [start] is updateProcessShopUpdate')
    //             await this.updateProcessShopUpdate()
    //             console.log('active [end] is updateProcessShopUpdate')
    //             console.log('snapshot data -> active is 1')
    //             console.log('active [start] is get booking')
    //             await this.searchBooking()
    //             console.log('active [end] is get booking')
    //           } else {
    //             console.log('snapshot data -> active is 0')
    //           }
    //         }
    //       })
    //   } catch (error) {
    //     console.log('Error getFirestore', error)
    //   }
    // },
    // async createProcessShopNew () { // set active = 1
    //   try {
    //     let body = {
    //       userName: this.$session.getAll().data.userName,
    //       shopId: this.$session.getAll().data.shopId
    //     }
    //     await axios.post('https://asia-southeast1-be-linked-a7cdc.cloudfunctions.net/QueueOnline-CreateProcessNew', body)
    //   } catch (error) {
    //     console.log('createProcessShopNew error-> ', error)
    //   }
    // },
    // async updateProcessShopNew () { // update active = 1
    //   try {
    //     let body = {
    //       userName: this.$session.getAll().data.userName,
    //       shopId: this.$session.getAll().data.shopId
    //     }
    //     await axios.post('https://asia-southeast1-be-linked-a7cdc.cloudfunctions.net/QueueOnline-ProcessNewV1', body)
    //   } catch (error) {
    //     console.log('updateProcessShopNew error-> ', error)
    //   }
    // },
    // async updateProcessShopUpdate () { // update active = 0
    //   try {
    //     let body = {
    //       userName: this.$session.getAll().data.userName,
    //       shopId: this.$session.getAll().data.shopId
    //     }
    //     await axios.post('https://asia-southeast1-be-linked-a7cdc.cloudfunctions.net/QueueOnline-ProcessUseNewV1', body)
    //   } catch (error) {
    //     console.log('updateProcessShopUpdate error-> ', error)
    //   }
    // }
  }
}
</script>

<style scoped>
.flex-container {
  display: flex;
  height: 100%;
}
iframe {
  flex: 1;
}
.sendOrder {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;

  width: 100%;
  height: 112px;

  flex: none;
  order: 2;
  align-self: stretch;
  flex-grow: 0;
  justify-content: flex-end;
}
.buttomMenuplusminus {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;

  width: 32px;
  height: 32px;
  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}
.buttomMenu {
  /* display: flex;
  flex-direction: row;
  align-items: flex-end; */
  padding: 0px;
  gap: 10px;

  display: flex;
  flex-direction: column;
  align-items: center;

  width: 32px;
  height: 100px;
  /* Inside auto layout */

  flex: none;
  order: 2;
  flex-grow: 0;
}
.textTitelMenu {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
}
.textSubTitelMenu {
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
  line-height: 22px;
}
.cardTextMenu {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 15px;

  width: 147px;
  height: 104px;
  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 1;
}
.textOneBox {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;

  width: 147px;
  height: 64px;
  /* Inside auto layout */

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}
#autocompleteMap {
  border: 1px solid rgba(0, 60, 255, 0.329);
  background: #fff;
  font-size: 18px;
  height: 35px;
  /* left: 40%; */
  padding: 0 10px;
  /* position: absolute; */
  top: 0;
  width: 90%;
  z-index: 1;
}
.videoWrapper {
  position: relative;
  padding-bottom: 56.25%;
  /* 16:9 */
  padding-top: 25px;
  height: 0;
}

.videoWrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.border-active {
  border-style: solid;
  border-color: red;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

.slidein {
  max-width: 40%;
  padding: 2em 1em;
  position: fixed;
  z-index: 100;
  top: 0;
  right: 0;
  background: #fff;
  height: 100%;
  overflow: scroll;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.5);
  transition: all 0.5s ease-in-out;
}
button {
  padding: 0.5em 1em;
  /* border-radius: 3em; */
  font-size: 1.1em;
}
/* before the element is shown, start off the screen to the right */

/* General styles unrelated to slide in */
body {
  font-family: "Mulish", sans-serif;
}

.toggle {
  margin: 1em;
}
.InputData {
  margin: 0px !important;
  padding: 0px !important;
}
.v-card--link:focus::before {
  opacity: 0;
}
.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  background-color: white !important;
}
.v-list-item__title {
  color: #73777b !important;
  /* font-family: KittithadaBold;
  font-size: 22px !important; */
  font-family: "Kanit", sans-serif;
  font-weight: 400;
}
.bottomAdd {
  background: linear-gradient(3.82deg, #1093ff 0.25%, #66baff 99.75%);
}
.v-data-table__wrapper {
  min-height: 400px !important;
}
.textPriceMenu {
  /* Price/Small */
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;

  color: #ff7b2c;
}
.textTitelPriceMenu {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
}
.textTitelMenu {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
}
.textSubTitelMenu {
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
  line-height: 22px;
}
.pictureMenu {
  width: 40px;
  height: 40px;

  filter: drop-shadow(0px 0px 8px rgba(255, 255, 255, 0.7));

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}
.pictureMenuEdit {
  width: 100px;
  height: 100px;

  filter: drop-shadow(0px 0px 8px rgba(255, 255, 255, 0.7));

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}
.cardMenu {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 12px;
  gap: 12px;

  width: 327px;
  height: 70px;

  background: #ffffff;
  box-shadow: 0px 0px 1px rgba(12, 26, 75, 0.03),
    0px 4px 20px -2px rgba(50, 50, 71, 0.04);
  border-radius: 16px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 1;
}
.cardMenuEdit {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  padding: 20px 10px 20px 10px;
  width: 327px;
  min-height: auto;

  background: #ffffff;
  box-shadow: 0px 0px 1px rgba(12, 26, 75, 0.03),
    0px 4px 20px -2px rgba(50, 50, 71, 0.04);
  border-radius: 16px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 1;
}
.v-input--selection-controls {
  margin-top: 0px !important;
}
.div-img-for-save {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
}
.v-btn:not(.v-btn--round).v-size--large {
  min-width: 100%
}
</style>
<style>
.pac-container {
  position: initial !important;
  /* ค่าเริ่มต้นเป็น relative เลยกำหนด style ของ pac-container เป็น initial ไม่งั้นการแสดงผลมันจะแปลกไป*/
  /* position: static !important; */
}
</style>



// WEBPACK FOOTER //
// src/components/Master/BookingListBeauty.vue